<template>
    <a-layout class="futures" :data-theme="userTheme" :class="{ 'prevent-flash': true }">
      <a-layout-header>
        <PageNav></PageNav>
      </a-layout-header>
        <a-layout-content class="futures_content">
            <!-- 热门期权币种 -->
            <div class="hotCoin">
                <img src="@/assets/hot.png" alt="">
                <div class="ticker-scroll">
                    <div class="scroll-content">
                        <div class="item" 
                             v-for="(item,index) in (currencies.slice(0,15))"
                             :key="'option-hot-' + (item?.id || index)" 
                             @click="selectCurrency(item)">
                            <span class="coin-name" :class="activeHotIndex === index ? 'font-bold' : ''">
                                {{ item.symbol || '' }}/USDT
                            </span>
                            <span 
                                class="coin-price"
                                :class="{
                                    'color-green': parseFloat(item.change_rate || 0) > 0,
                                    'color-red': parseFloat(item.change_rate || 0) < 0,
                                    'color-gray': parseFloat(item.change_rate || 0) === 0
                                }">
                                {{ $util.thousandSeparator(item.new_price || 0, item.decimals || 2) }}
                            </span>
                            <span 
                                class="coin-change"
                                :class="{
                                    'color-green': parseFloat(item.change_rate || 0) > 0,
                                    'color-red': parseFloat(item.change_rate || 0) < 0,
                                    'color-gray': parseFloat(item.change_rate || 0) === 0
                                }">
                                {{ (parseFloat(item.change_rate || 0) > 0 ? '+' : '') + $util.float(item.change_rate || 0, 2) }}%
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 币种选择和价格信息条 - 真正仿合约界面 -->
            <div class="content_head">
                <div class="content_head_left flex flex-column align-center jus-center">
                    <!-- 仿合约页面的币种选择器 -->
                    <a-trigger trigger="hover" :popup-translate="[100, 10]">
                        <div class="flex flex-row align-center coinSelectBox">
                            <img class="mr-12 coinImage" :src="currentCurrency?.icon || '/favicon.ico'" alt="">
                            <div class="coinInfo">
                                <div class="row flex align-center">
                                    <span class="mr-10 font-bold color-black">
                                        {{ currentCurrency?.symbol || 'ADA' }}USDT
                                    </span>
                                    <div class="caretDown">
                                        <icon-caret-down size="14"/>
                                    </div>
                                </div>
                                <span class="desc">{{ $t('flash_option.option_trading') }}</span>
                            </div>
                        </div>
                        <template #content>
                            <div class="market-wrap">
                                <a-input class="input" :placeholder="$t('common.search')" v-model="searchVal" allow-clear>
                                    <template #suffix>
                                        <icon-search size="18"/>
                                    </template>
                                </a-input>
                                <!--               -->
                                <div class="market_tab flex align-center">
                                    <div class="pad-lr-15 flex align-center jus-center pointer active">
                                        <span class="font-12 color-gray">{{ $t('flash_option.option_trading') }}</span>
                                    </div>
                                </div>
                                <!--                -->
                                <div class="market_tab_main">
                                    <div class="sub_tab flex align-center jus-bet">
                                        <div class="flex align-center pointer">
                                            <span class="font-12 color-gray">{{ $t('flash_option.option_underlying') }}</span>
                                        </div>
                                        <div class="flex align-center jus-end pointer">
                                            <span class="font-12 color-gray">{{ $t('flash_option.latest_price') }}</span>
                                            <img src="@/assets/images/ranking.svg">
                                        </div>
                                        <div class="flex align-center jus-end pointer">
                                            <span class="font-12 color-gray">{{ $t('flash_option.twenty_four_hour_change') }}</span>
                                            <img src="@/assets/images/ranking.svg">
                                        </div>
                                    </div>
                                    <a-scrollbar outer-class="scrollbar">
                                        <div class="sub_cell flex align-center jus-bet"
                                             v-for="(item,index) in filteredCurrencies"
                                             :key="'option-coin-'+item.currency_id"
                                             @click="selectCurrency(item)">
                                            <div class="flex align-center">
                                                <img class="mr-5" src="@/assets/images/spot/unlike.svg" alt="">
                                                <span class="font-12 color-black mr-5">{{ item.symbol }}</span>
                                                <span class="font-12 color-gray">{{ $t('flash_option.option_trading') }}</span>
                                            </div>
                                            <div class="flex align-center jus-end">
                                                <span class="font-12"
                                                      :class="{'color-green':item.change_rate >= 0,'color-red':item.change_rate < 0}">
                                                    {{ $util.thousandSeparator(item.new_price || 0, item.decimals || 2) }}
                                                </span>
                                            </div>
                                            <div class="flex align-center jus-end">
                                                <span class="font-12"
                                                      :class="{'color-green':item.change_rate >= 0,'color-red':item.change_rate < 0}">
                                                    {{ (parseFloat(item.change_rate || 0) > 0 ? '+' : '') + $util.float(item.change_rate || 0, 2) }}%
                                                </span>
                                            </div>
                                        </div>
                                    </a-scrollbar>
                                </div>
                            </div>
                        </template>
                    </a-trigger>
                </div>
                <div class="content_head_right flex flex-row align-center">
                    <div class="content_head_right_info">
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-18 font-bold"
                                  :class="{'color-green':currentCurrency?.change_rate >= 0,'color-red':currentCurrency?.change_rate < 0}">
                                {{ formatKlinePrice(currentPrice) }}
                            </span>
                        </div>
                        <!--          24h涨跌幅-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray pointer">{{ $t('flash_option.twenty_four_hour_change') }}</span>
                            <span class="font-12 mt-5"
                                  :class="{'color-green':currentCurrency?.change_rate >= 0,'color-red':currentCurrency?.change_rate < 0}">
                                {{ formatPercent(currentCurrency?.change_rate) }}
                            </span>
                        </div>
                        <!--          标记价格-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                <span class="font-12 color-gray dotted pointer">{{ $t('flash_option.mark_price') }}</span>
                                <template #content>
                                    <p class="font-12 color-always-white">
                                        {{ $t('flash_option.mark_price_settlement_description') }}</p>
                                </template>
                            </a-tooltip>
                            <span class="font-12 color-black mt-5">
                                {{ formatKlinePrice(currentPrice) }}
                            </span>
                        </div>
                        <!--          指数价格-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                <span class="font-12 color-gray dotted pointer">{{ $t('flash_option.index_price') }}</span>
                                <template #content>
                                    <p class="font-12 color-always-white">{{ $t('futures.fair_spot_price') }}</p>
                                </template>
                            </a-tooltip>
                            <span class="font-12 color-black mt-5">
                                {{ formatKlinePrice(currentPrice) }}
                            </span>
                        </div>

                        <!--          24H最高价-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray">{{ $t('flash_option.twenty_four_hour_high') }}</span>
                            <span class="font-12 color-black mt-5">
                                {{ formatKlinePrice(high24h) }}
                            </span>
                        </div>
                        <!--          24H最低价-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray">{{ $t('flash_option.twenty_four_hour_low') }}</span>
                            <span class="font-12 color-black mt-5">
                                {{ formatKlinePrice(low24h) }}
                            </span>
                        </div>
                        <!--          24H成交量（币种）-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray">{{ $t('flash_option.twenty_four_hour_volume') }}（{{ currentCurrency?.symbol || 'ADA' }}）</span>
                            <span class="font-12 color-black mt-5">
                                {{ formatVolume(volume24h) }}
                            </span>
                        </div>
                        <!--          24H成交额（USDT）-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray">{{ $t('flash_option.twenty_four_hour_turnover') }}（USDT）</span>
                            <span class="font-12 color-black mt-5">
                                {{ $util.thousandSeparator(currentCurrency?.quota || 0, 2) }}
                            </span>
                        </div>
                    </div>

                </div>
            </div>

            <!-- 主要内容区域 - 上下分层布局 -->
            <div class="content_main mt-10">
                <!-- 上层：K线图和期权交易 -->
                <div class="content_main_top">
                    <!-- 左侧：K线图表 (70%) -->
                <div class="content_main_left">
                        <div class="block_kline">
                            <div class="kline_box flex align-center jus-center">
                                <div class="chartBox" id="optionChartBox" style="width: 100%;height:100%"></div>
                        </div>
                    </div>
                </div>

                    <!-- 右侧：期权交易 (30%) -->
                <div class="content_main_right">
                    <div class="option-trading-panel">
                        <div class="option-header">
                            <div class="header-title">
                                <h2>{{ $t('flash_option.option_trading') }}</h2>
                            </div>
                                            <div class="balance-display">
                    <span class="balance-label">{{ $t('flash_option.option_balance') }}:</span>
                    <span class="balance-amount">{{ formatKlinePrice(userBalance) }} USDT</span>
                    <div class="transfer-icon" @click="transfeShow = true">{{ $t('flash_option.transfer') }}</div>
                </div>
                        </div>
                        <div class="option-content">
                            <!-- 看涨/看跌按钮 -->
                            <div class="direction-buttons">
                                                                <div class="direction-btn call-btn" 
                                     :class="{ active: direction === 1 }" 
                                     @click="selectDirection(1)">
                                    <div class="btn-content">
                                        <div class="btn-icon">
                                            ▲
                                        </div>
                                        <div class="btn-text">{{ $t('flash_option.call') }}</div>
                                        <div class="btn-rate" v-if="currentDepConfig">{{ formatPercent(currentDepConfig.up) }}</div>
                                    </div>
                                </div>
                                <div class="direction-btn put-btn" 
                                     :class="{ active: direction === 0 }" 
                                     @click="selectDirection(0)">
                                    <div class="btn-content">
                                        <div class="btn-icon">
                                            ▼
                                        </div>
                                        <div class="btn-text">{{ $t('flash_option.put') }}</div>
                                        <div class="btn-rate" v-if="currentDepConfig">{{ formatPercent(currentDepConfig.down) }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- 期权配置选择 -->
                            <div class="config-section" v-if="depConfigs.length > 0">
                                <div class="config-label">{{ $t('flash_option.option_config') }}</div>
                                <a-select v-model="selectedDepConfig" @change="onDepConfigChange" 
                                         class="config-select" :placeholder="$t('flash_option.select_option_config')">
                                    <a-option v-for="config in depConfigs" :key="config.id" :value="config.id">
                                        {{ config.interval }}{{ $t('flash_option.minute') }} | {{ $t('flash_option.profit') }}: {{ (config.up * 100).toFixed(2) }}% | {{ $t('flash_option.fee_rate') }}: {{ (config.charge * 100).toFixed(2) }}%
                                    </a-option>
                                </a-select>
                            </div>

                            <!-- 投资金额输入 -->
                            <div class="amount-section">
                                <div class="amount-label">
                                    <span>{{ $t('flash_option.investment_amount') }}</span>
                                    <span class="available">{{ $t('flash_option.available') }}: {{ formatKlinePrice(userBalance) }} USDT</span>
                                </div>
                                <div class="amount-input-wrapper">
                                    <input 
                                        type="number" 
                                        v-model="amount" 
                                        placeholder="0.00"
                                        class="amount-input"
                                        @input="calculateProfit">
                                            <span class="input-suffix">USDT</span>
                                </div>
                                
                                <!-- 百分比选择 -->
                                <div class="percentage-row">
                                    <div class="percentage-btn" 
                                         v-for="percentage in [0, 25, 50, 75, 100]" 
                                         :key="percentage"
                                         :class="{ 'active': selectedPercentage === percentage }"
                                         @click="setPercentageAmount(percentage)">
                                        {{ percentage }}%
                                    </div>
                                </div>
                            </div>

                            <!-- 预期收益 - 紧凑版本 -->
                            <div class="profit-info-compact" v-if="currentDepConfig && amount">
                                <div class="profit-item">
                                    <span class="label">{{ $t('flash_option.investment') }}:</span>
                                        <span class="value">{{ formatKlinePrice(amount) }} USDT</span>
                                    </div>
                                <div class="profit-item">
                                    <span class="label">{{ $t('flash_option.fee') }}:</span>
                                    <span class="value fee">-{{ formatKlinePrice(calculatedFee) }}</span>
                                    </div>
                                <div class="profit-item">
                                    <span class="label">{{ $t('flash_option.profit') }}:</span>
                                        <span class="value profit" :class="direction === 1 ? 'color-green' : 'color-red'">
                                        +{{ formatKlinePrice(expectedProfit) }}
                                        </span>
                                    </div>
                                <div class="profit-item total">
                                    <span class="label">{{ $t('flash_option.total') }}:</span>
                                    <span class="value">{{ formatKlinePrice(totalReturn) }} USDT</span>
                                </div>
                            </div>

                            <!-- 交易倒计时 - 已移除 -->
                            <!-- <div class="_row countdown-display" v-if="currentDepConfig">
                                <div class="countdown-card">
                                    <div class="countdown-label">{{ $t('flash_option.option_expiry_countdown') }}</div>
                                    <div class="countdown-time">{{ formatCountdown(tradeCountdown) }}</div>
                                </div>
                            </div> -->

                            <!-- 提交订单按钮 -->
                            <div class="_row submit-section">
                                <a-button 
                                    class="submit-btn" 
                                    :class="direction === 1 ? 'call-submit' : 'put-submit'"
                                    :loading="submitting"
                                    :disabled="!canSubmitOrder"
                                    @click="submitOrder"
                                    size="large">
                                    <template v-if="!submitting">
                                        {{ direction === 1 ? $t('flash_option.buy_call_option') + ' 📈' : $t('flash_option.buy_put_option') + ' 📉' }}
                                    </template>
                                    <template v-else>
                                        {{ $t('flash_option.submitting') }}
                                    </template>
                                </a-button>
                            </div>


                            </div>
                        </div>
                    </div>
                </div>

                <!-- 下层：订单管理 -->
                <div class="content_main_bottom">
                    <div class="content_main_orders">
                    <div class="block_list">
                            <a-tabs default-active-key="1" @change="onTabChange">
                                <a-tab-pane key="1" :title="$t('flash_option.active_orders')">
                                    <div class="active-orders">
                                        <div class="order-header">
                                            <span class="font-12 color-gray">{{ $t('flash_option.coin') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.direction') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.amount') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.open_price') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.yield_rate') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.expected_profit') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.fee') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.order_time') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.countdown') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.status') }}</span>
                                        </div>
                                        <div class="order-list-native">
                                            <notlog v-if="!isLogin" style="height: 200px"></notlog>
                                            <notdate v-else-if="activeOrders.length === 0" :msg="$t('flash_option.no_active_orders')"></notdate>
                                            <div class="order-item flex align-center jus-bet"
                                                 v-for="order in activeOrders"
                                                 :key="order.id">
                                                <div class="order-symbol">
                                                    <span class="font-12 color-black">{{ order.symbol || getCurrencySymbol(order.currency_id) }}</span>
                                                </div>
                                                <div class="order-direction">
                                                    <a-tag :color="order.direction === 1 ? 'var(--opacity-buy)' : 'var(--opacity-sell)'">
                                                        <span :class="order.direction === 1 ? 'color-green' : 'color-red'">
                                                            {{ order.direction === 1 ? $t('flash_option.call') : $t('flash_option.put') }}
                                                        </span>
                                                    </a-tag>
                                                </div>
                                                <div class="order-amount">
                                                    <span class="font-12 color-blue">{{ formatOrderAmount(order) }} USDT</span>
                                                </div>
                                                <div class="order-price">
                                                    <span class="font-12 color-orange">{{ formatOrderPrice(order) }}</span>
                                                </div>
                                                        <div class="order-yield">
          <span class="font-12" :class="getActiveYieldColor(order)">{{ formatPercent(order.dep?.down || order.down) }}</span>
        </div>
        <div class="order-expected-profit">
          <span class="font-12" :class="getActiveProfitColor(order)">{{ formatKlinePrice(parseFloat(order.amount || 0) * parseFloat(order.dep?.down || 0)) }} USDT</span>
        </div>
        <div class="order-fee">
          <span class="font-12" :class="getActiveFeeColor(order)">{{ formatPercent(order.dep?.charge || order.charge) }}</span>
        </div>
                                                <div class="order-time">
                                                    <span class="font-12 color-gray">{{ formatOrderTime(order.created_at) }}</span>
                                                </div>
                                                <div class="order-countdown">
                                                    <span class="font-12 countdown-text" :class="getCountdownClass(order)">
                                                        {{ formatOrderCountdown(order) }}
                                                    </span>
                                                </div>
                                                <div class="order-status">
                                                    <span class="font-12" :class="getOrderStatusClass(order)">
                                                        {{ getOrderStatusText(order) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a-tab-pane>
                                <a-tab-pane key="2" :title="$t('flash_option.history_orders')">
                                    <div class="history-orders">
                                        <div class="order-header">
                                            <span class="font-12 color-gray">{{ $t('flash_option.coin') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.direction') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.open_price') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.settlement_price') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.yield_rate') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.result') }}</span>
                                            <span class="font-12 color-gray">{{ $t('flash_option.time') }}</span>
                                        </div>
                                        <div class="order-list-native">
                                            <notlog v-if="!isLogin" style="height: 200px"></notlog>
                                            <div v-else-if="historyLoading" class="loading-state">
                                                <icon-loading class="loading-icon"/>
                                                <span class="font-12 color-gray">{{ $t('flash_option.loading_history_orders') }}</span>
                                            </div>
                                            <notdate v-else-if="historyOrders.length === 0" :msg="$t('flash_option.no_history_orders')"></notdate>
                                            <div class="order-item flex align-center jus-bet"
                                                 v-for="order in historyOrders"
                                                 :key="order.id">
                                                <div class="order-symbol">
                                                    <span class="font-12 color-black">{{ order.symbol || getCurrencySymbol(order.currency_id) }}</span>
                                                </div>
                                                <div class="order-direction">
                                                    <a-tag :color="order.direction === 1 ? 'var(--opacity-buy)' : 'var(--opacity-sell)'">
                                                        <span :class="order.direction === 1 ? 'color-green' : 'color-red'">
                                                            {{ order.direction === 1 ? $t('flash_option.call') : $t('flash_option.put') }}
                                                        </span>
                                                    </a-tag>
                                                </div>
                                                <div class="order-open-price">
                                                    <span class="font-12" :class="getPriceColor(order.open, order.close, order.direction)">
                                                        {{ formatKlinePrice(order.open) }}
                                                    </span>
                                                </div>
                                                <div class="order-close-price">
                                                    <span class="font-12" :class="getPriceColor(order.close, order.open, order.direction)">
                                                        {{ formatKlinePrice(order.close) }}
                                                    </span>
                                                </div>
                                                <div class="order-yield">
                                                    <span class="font-12" :class="getYieldColor(order)">
                                                        {{ formatYield(order) }}
                                                    </span>
                                                </div>
                                                <div class="order-result">
                                                    <span class="font-12" :class="getProfitColor(order.profit)">
                                                        {{ formatProfit(order.profit) }}
                                                    </span>
                                                </div>
                                                <div class="order-time">
                                                    <span class="font-12 color-gray">{{ formatOrderTime(order.created_at) }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a-tab-pane>
                            </a-tabs>
                        </div>
                    </div>
          </div>
        </div>

        <!-- 期权订单成功弹窗 -->
        <a-modal
            v-model:visible="showSuccessModal"
            :footer="false"
            :closable="false"
            :mask-closable="false"
            :width="400"
            class="option-success-modal"
            :wrap-class-name="'option-success-modal-wrap'"
        >
            <div class="success-content">
                <div class="success-icon">
                    <icon-check-circle-fill size="48" color="#52c41a" />
                </div>
                                                <div class="success-title">{{ $t('flash_option.order_success') }}</div>
                <div class="success-details">
                    <div class="detail-item">
                        <span class="label">{{ $t('flash_option.currency') }}：</span>
                        <span class="value">{{ orderSuccessInfo?.currency || 'Unknown' }}/USDT</span>
                    </div>
                    <div class="detail-item">
                                                        <span class="label">{{ $t('flash_option.direction') }}：</span>
                                                        <span class="value" :class="orderSuccessInfo?.direction === 1 ? 'color-green' : 'color-red'">
                                    {{ orderSuccessInfo?.direction === 1 ? $t('flash_option.call') : $t('flash_option.put') }}
                                </span>
                    </div>
                    <div class="detail-item">
                        <span class="label">{{ $t('flash_option.order_price') }}：</span>
                        <span class="value">{{ formatKlinePrice(orderSuccessInfo?.currentPrice) }} USDT</span>
                    </div>
                    <div class="detail-item">
                                                        <span class="label">{{ $t('flash_option.investment_amount') }}：</span>
                        <span class="value">{{ formatKlinePrice(orderSuccessInfo?.amount) }} USDT</span>
                    </div>
                    <div class="detail-item">
                                                        <span class="label">{{ $t('flash_option.expected_profit') }}：</span>
                        <span class="value color-green">+{{ formatKlinePrice(orderSuccessInfo?.expectedProfit) }} USDT</span>
                    </div>
                </div>
                <div class="success-actions">
                    <a-button type="primary" size="large" @click="closeSuccessModal" class="confirm-btn">
                        {{ $t('common.confirm') }}
                    </a-button>
                </div>
            </div>
        </a-modal>

        <!-- 期权订单失败弹窗 -->
        <a-modal
            v-model:visible="showErrorModal"
            :footer="false"
            :closable="false"
            :mask-closable="false"
            :width="400"
            class="option-error-modal"
            :wrap-class-name="'option-error-modal-wrap'"
        >
            <div class="error-content">
                <div class="error-icon">
                    <icon-close-circle-fill size="48" color="#ff4d4f" />
                </div>
                <div class="error-title">{{ $t('flash_option.order_failed') }}</div>
                <div class="error-message">{{ errorMessage }}</div>
                <div class="error-actions">
                    <a-button type="primary" size="large" @click="closeErrorModal" class="confirm-btn">
                        {{ $t('common.confirm') }}
                    </a-button>
                </div>
            </div>
        </a-modal>
      </a-layout-content>
    </a-layout>
    
    <!-- 资金划转 -->
    <funds-transfe :visible="transfeShow" @close="transfeShow = false" @success="onTransferSuccess"></funds-transfe>
</template>

<script>
import PageNav from '@/components/PageNav/PageNav.vue'
import notlog from '@/components/notlog/notlog.vue'
import notdate from '@/components/notdate/notdate.vue'
import fundsTransfe from '@/components/fundsTransfe/fundsTransfe.vue'
import currencyApi from '@/common/api/currency'
import userApi from '@/common/api/user'
import { mapState, mapGetters } from 'vuex'
import {KLineChartPro} from "@klinecharts/pro"
import '@klinecharts/pro/dist/klinecharts-pro.css'
import config from "@/common/api/config"
import { applyKlineProTheme } from '@/common/util/klineTheme'

// K线图表相关变量
let klineCharts = false
let _ticker = false
let upset = false
let klineChartSession = 0
let klineSubscriptionToken = 0
let chartPeriod = false
let firstPrice
let last

const time = {
  '1s': 0,
  '1m': 1,
  '5m': 5,
  '15m': 15,
  '30m': 30,
  '1H': 60,
  '4H': 240,
  '12H': 720,
  '1D': 1440,
  '1W': 10080
}

function invalidateKlineSession() {
  klineChartSession += 1
  klineSubscriptionToken += 1
  last = undefined

  if (upset !== false) {
    clearInterval(upset)
    upset = false
  }
}

export default {
  name: 'FlashOption',
  components: {
    PageNav,
    notlog,
    notdate,
    fundsTransfe
  },
  

  
  computed: {
    ...mapGetters(['userTheme']),
    ...mapState(['userinfo']),
    
    isLogin() {
      return this.userinfo && this.userinfo.id
    },
    
    canSubmitOrder() {
      return this.isLogin &&
             !this.submitting && 
             this.currentCurrency && 
             this.currentCurrency.currency_id &&
             this.selectedDepConfig && 
             this.currentDepConfig &&
             (this.direction === 0 || this.direction === 1) && // 确保direction是有效的（0或1）
             this.amount > 0 && 
             this.amount <= this.userBalance
    },
    
    filteredCurrencies() {
      if (!this.searchVal) return this.currencies
      return this.currencies.filter(currency => 
        currency.symbol.toLowerCase().includes(this.searchVal.toLowerCase())
      )
    },
    
    calculatedFee() {
      if (!this.amount || !this.currentDepConfig) return 0
      // 直接使用charge，不需要除以100，因为charge已经是0.01这样的值
      return this.amount * this.currentDepConfig.charge
    },
    
    expectedProfit() {
      if (!this.amount || !this.currentDepConfig) return 0
      const rate = this.direction === 1 ? this.currentDepConfig.up : this.currentDepConfig.down
      // 直接使用rate，不需要除以100，因为rate已经是0.05这样的值
      return this.amount * rate
    },
    
    totalReturn() {
      return parseFloat(this.amount || 0) + this.expectedProfit
    },
    

  },
  
  data() {
    return {
      // 基础数据
      currencies: [],
      currentCurrency: null,
      depConfigs: [],
      selectedDepConfig: '',
      currentDepConfig: null,
      activeHotIndex: 0,
      searchVal: '',
      
      // 交易数据
      direction: 1, // 1=看涨, 0=看跌
      amount: '',
      userBalance: 0,
      selectedPercentage: null, // 选中的百分比
      
      // 价格数据
      currentPrice: 0,
      lastPrice: 0,
      high24h: 0,
      low24h: 0,
      volume24h: '0.00',
      
      // K线图表
      klineCharts: null,
      
      // 订单数据
      activeOrders: [],
      historyOrders: [],
      historyLoading: false,
      
      // 倒计时相关
      orderCountdowns: {}, // 存储每个订单的倒计时
      orderCountdownInterval: null, // 订单倒计时定时器
      
      // 状态管理
      currencyLoading: false,
      ordersLoading: false,
      submitting: false,
      
      // WebSocket连接
      ws: null,
      wsInterval: null,
      diagnosticInterval: null,
      backgroundMonitorInterval: null,
      
      // 主题监控器
      themeWatcher: null,
      
      // Portal组件监听器
      portalObserver: null,
      
      // 定时器
      refreshInterval: null,
      countdownInterval: null,
      
      // 交易倒计时（秒）
      tradeCountdown: 60,
      
      // 弹窗状态
      showSuccessModal: false,
      showErrorModal: false,
      errorMessage: '',
      
      // 订单成功信息
      orderSuccessInfo: null,

      // 资金划转相关
      transfeShow: false,
      
      // 余额监控


    }
    },

  beforeMount() {
    // 🚨 在组件挂载前就预设防闪动样式
    console.log('🚨 beforeMount: 预设防闪动样式')
    this.$nextTick(() => {
      this.preventThemeFlashing()
      
      // 🚨 短时间后移除防闪动保护，让正常主题生效
      setTimeout(() => {
        const futures = document.querySelector('.futures')
        if (futures && this.userTheme) {
          futures.classList.remove('prevent-flash')
          console.log('🚨 Early: 防闪动保护已移除，当前主题:', this.userTheme)
        }
      }, 500)
    })
  },

  async mounted() {
      // 🚨 立即防止主题闪动
      this.preventThemeFlashing()
      
    // 添加全局错误处理器，捕获所有"用户未登录"错误
    window.addEventListener('unhandledrejection', this.handleUnhandledRejection)
    
    console.log('🚀 期权交易页面初始化...')
    console.log('🎨 期权页面背景色统一修复已应用 - 与合约和现货页面保持一致')
    
    // 立即显示余额（不等待DOM渲染）
    this.loadUserBalanceFromVuex();
    

    
    // 强制刷新余额显示
    this.forceRefreshBalance();
    
    // 等待DOM完全渲染
    await this.$nextTick()
    
    // 延迟一点时间确保DOM元素完全可用
    setTimeout(async () => {
      try {
        await this.initializeData()
        
        // 验证背景色修复效果
        setTimeout(() => {
          const futures = document.querySelector('.futures')
          const futuresContent = document.querySelector('.futures_content')
          
          if (futures && futuresContent) {
            const futuresStyle = getComputedStyle(futures)
            const contentStyle = getComputedStyle(futuresContent)
            
            console.log('🔧 期权页面背景色终极修复验证:')
            console.log('  主容器(.futures):', futuresStyle.backgroundColor)
            console.log('  内容区域(.futures_content):', contentStyle.backgroundColor)
            
            // 检查内联样式是否被清除
            if (futures.style.background && futures.style.background.includes('#0a0c10')) {
              console.warn('⚠️ .futures 仍有内联样式:', futures.style.background)
            }
            if (futuresContent.style.background && futuresContent.style.background.includes('#0a0c10')) {
              console.warn('⚠️ .futures_content 仍有内联样式:', futuresContent.style.background)
            }
            
            console.log('  ✅ 期权页面背景色现在应该与合约页面完全一致！')
          }
        }, 1500)
        
        console.log('🎯 期权页面已加载，使用内联样式修复看涨看跌按钮颜色');
        
        // 🔍 添加调试功能 - 检查按钮状态
        setTimeout(() => {
          console.log('🔍 当前按钮状态检查:');
          console.log('  direction:', this.direction);
          console.log('  选中状态:', this.direction === 1 ? '看涨' : '看跌');
          
          const callBtn = document.querySelector('.direction-btn.call-btn');
          const putBtn = document.querySelector('.direction-btn.put-btn');
          
          if (callBtn) {
            console.log('  看涨按钮 classes:', callBtn.className);
            console.log('  看涨按钮 style:', callBtn.getAttribute('style'));
          }
          
          if (putBtn) {
            console.log('  看跌按钮 classes:', putBtn.className);
            console.log('  看跌按钮 style:', putBtn.getAttribute('style'));
          }
          
          // 提供手动修复功能
          window.checkButtonColors = () => {
            console.log('🎯 手动检查按钮颜色');
            const callActive = document.querySelector('.direction-btn.call-btn.active');
            const putActive = document.querySelector('.direction-btn.put-btn.active');
            
            if (callActive) {
              const style = window.getComputedStyle(callActive);
              console.log('✅ 看涨按钮 computed style:');
              console.log('  background:', style.background);
              console.log('  background-color:', style.backgroundColor);
              console.log('  color:', style.color);
            }
            
            if (putActive) {
              const style = window.getComputedStyle(putActive);
              console.log('🔴 看跌按钮 computed style:');
              console.log('  background:', style.background);
              console.log('  background-color:', style.backgroundColor);
              console.log('  color:', style.color);
            }
          };
          
          console.log('💡 提示: 可以在控制台执行 window.checkButtonColors() 来检查按钮颜色');
        }, 2000);
        
        // 🚨 禁用延迟执行，避免主题闪动
        // setTimeout(() => {
        //   this.performBackgroundFix()
        //   this.performNavFix()  // 只在这里执行一次导航栏修复
        //   console.log('✅ 期权页面加载完成，主题状态:', this.userTheme)
        // 
        //   // 🚨 防止主题闪动：确保页面元素使用正确的初始样式
        //   this.preventThemeFlashing()
        // }, 2000)
        
        console.log('✅ 期权页面加载完成，主题状态:', this.userTheme)
        
        // 🚨 延迟移除防闪动类，允许正常主题应用
        setTimeout(() => {
          const futures = document.querySelector('.futures')
          if (futures) {
            futures.classList.remove('prevent-flash')
            console.log('🚨 防闪动保护已移除，正常主题生效')
          }
        }, 1000)
        
        // 🔥 确保在币种数据加载完成后再初始化K线图表
        // 等待DOM完全渲染和币种数据加载
        await this.$nextTick()
        setTimeout(() => {
          this.createCharts()
        }, 200)
        
        // 启动默认倒计时
        this.startTradeCountdown()
        
        // 应用主题样式
        this.$nextTick(() => {
          // 🚨 禁用所有主题相关的强制修复，避免闪动
          // this.checkTheme()
          // this.forceContentHeadTheme() // 立即强制设置content_head主题背景
          // this.optimizeTextColors() // 立即优化文字颜色
          // 币种选择器初始化完成
          // this.forceRefreshNavigation(this.userTheme) // 禁用导航栏主题刷新
          // 🚨 禁用Portal组件刷新，避免主题闪动
          // setTimeout(() => {
          //   this.forceRefreshPortalComponents(this.userTheme)
          // }, 300)
        })
      } catch (error) {
        console.error('❌ 组件初始化失败:', error)
      }
    }, 100)
    
    // 主题检测和强制样式应用
              // 🚨 禁用主题监听器，避免频繁修改主题
          // this.initThemeWatcher()
      },
    
    beforeUnmount() {
    try {
      console.log("期权页面组件卸载")
      invalidateKlineSession()
      
      // 清理全局错误处理器
      window.removeEventListener('unhandledrejection', this.handleUnhandledRejection)
      
      this.disconnectWebSocket()
      
      // 清理Portal组件监听器
      if (this.portalObserver) {
        this.portalObserver.disconnect()
        console.log('👁️ Portal组件监听器已清理')
      }
      
      // 清理定时器
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval)
        this.refreshInterval = null
      }
      
      // 清理WebSocket定时器
      if (this.wsInterval) {
        clearInterval(this.wsInterval)
        this.wsInterval = null
      }
      
      // 清理诊断定时器
      if (this.diagnosticInterval) {
        clearInterval(this.diagnosticInterval)
        this.diagnosticInterval = null
      }
      
      // 清理背景色监控定时器
      if (this.backgroundMonitorInterval) {
        clearInterval(this.backgroundMonitorInterval)
        this.backgroundMonitorInterval = null
      }
      
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval)
        this.countdownInterval = null
      }
      
      if (this.orderCountdownInterval) {
        clearInterval(this.orderCountdownInterval)
        this.orderCountdownInterval = null
      }
      
      // 清理主题监控器
      if (this.themeWatcher) {
        clearInterval(this.themeWatcher)
        this.themeWatcher = null
      }
      
      
      
      if (klineCharts) {
        klineCharts.destroy()
      }
      
      klineCharts = false
      _ticker = false
    } catch (e) {
      console.log(e)
    }
  },
  
  methods: {
    // 将Vue i18n语言代码映射到KLineChartPro语言代码
    // KLineChartPro默认只支持 en-US 和 zh-CN，其他语言需要注册
    getKlineLocale() {
      const vueLocale = this.$i18n?.locale || 'en-US';
      // KLineChartPro实际支持的语言代码（默认只支持这两种）
      // 其他语言会回退到 en-US
      const localeMap = {
        'en-US': 'en-US',
        'zh_CN': 'zh-CN',
        'zh_Hant': 'zh-CN', // 繁体中文也使用简体中文
        'ru': 'en-US', // 俄语回退到英文
        'th': 'en-US', // 泰语回退到英文
        'ja': 'en-US', // 日语回退到英文
        'ko': 'en-US', // 韩语回退到英文
        'au': 'en-US', // 澳大利亚英语使用英文
        'gm': 'en-US'  // 德语回退到英文
      };
      const klineLocale = localeMap[vueLocale] || 'en-US';
      console.log('🌐 K线图语言映射:', { vueLocale, klineLocale });
      return klineLocale;
    },
    // 资金划转成功回调
    async onTransferSuccess() {
      // 显示成功提示
      this.$message.success('资金划转成功');
      
      // 立即刷新一次余额
      await this.loadUserBalance();
      
      // 同时更新全局账户信息
      if (this.$root && this.$root.getAccountInfo) {
        this.$root.getAccountInfo();
      }
      
      // 强制刷新Vuex数据
      this.loadUserBalanceFromVuex();
      
      // 延迟500ms后再刷新一次，确保后端数据完全更新
      setTimeout(async () => {
        await this.loadUserBalance();
        this.loadUserBalanceFromVuex();
      }, 500);
    },
    
    // 订单过期后强制刷新余额
    async forceRefreshBalanceAfterOrderExpired() {
      try {
        // 优先使用期权专用余额API
        let response = null;
        
        try {
          response = await userApi.getUBalance();
        } catch (uBalanceError) {
          response = await userApi.getBalance();
        }
        
        if (response.code === 200 && response.data) {
          let futureBalance = 0;
          
          // 处理期权专用API返回的数据
          if (typeof response.data === 'object' && response.data !== null) {
            // 期权专用API可能返回直接的余额数据
            futureBalance = parseFloat(
              response.data.future_balance || 
              response.data.futures_balance || 
              response.data.option_balance ||
              response.data.balance ||
              response.data.amount ||
              response.data.total ||
              0
            );
          } else if (Array.isArray(response.data)) { // 处理数组格式的数据（通用余额API）
            const usdtData = response.data.find(item => 
              item.currency_symbol === 'USDT' || 
              item.symbol === 'USDT' ||
              item.currency_id === 10 ||
              item.currency_name === 'USDT'
            );
            
            if (usdtData) {
              futureBalance = parseFloat(usdtData.future_balance || 0);
            }
          } else if (typeof response.data === 'object') { // 处理对象格式的数据（通用余额API）
            futureBalance = parseFloat(response.data.future_balance || 0);
          }
          
          // 强制更新余额
          this.userBalance = futureBalance;
          
          // 同时更新Vuex
          this.loadUserBalanceFromVuex();
          
          // 强制刷新全局账户信息
          if (this.$root && this.$root.getAccountInfo) {
            this.$root.getAccountInfo();
          }
        }
      } catch (error) {
        console.error('❌ 订单过期后刷新余额失败:', error);
      }
    },
    

    
    // 获取盈亏颜色
    getProfitColor(profit) {
      if (profit === undefined || profit === null) return 'color-gray'
      const profitValue = parseFloat(profit)
      if (isNaN(profitValue)) return 'color-gray'
      if (profitValue > 0) {
        return 'color-green'
      } else if (profitValue < 0) {
        return 'color-red'
      } else {
        return 'color-gray'
      }
    },
    // 格式化盈亏显示
    formatProfit(profit) {
      if (profit === undefined || profit === null) return '--'
      const profitValue = parseFloat(profit)
      if (isNaN(profitValue)) return '--'
      if (profitValue > 0) {
        return `+${this.formatKlinePrice(profitValue)}`
      } else if (profitValue < 0) {
        return `-${this.formatKlinePrice(Math.abs(profitValue))}`
      } else {
        return '0.00'
      }
    },
    // 格式化收益率
    formatYield(order) {
      if (!order) return '--'
      
      // 调试嵌套的down字段
      console.log('🔍 formatYield调试 - 嵌套字段详情:', {
        'order.dep存在': order.hasOwnProperty('dep'),
        'order.dep值': order.dep,
        'order.dep.down存在': order.dep && order.dep.hasOwnProperty('down'),
        'order.dep.down值': order.dep ? order.dep.down : 'dep不存在',
        'order完整数据': order
      })
      
      // 检查嵌套的down字段
      if (!order.dep || !order.dep.down || order.dep.down === null || order.dep.down === undefined || order.dep.down === '') {
        console.log('❌ order.dep.down字段不存在或为空')
        return '--'
      }
      
      const rate = parseFloat(order.dep.down)
      if (isNaN(rate)) {
        console.log('❌ order.dep.down字段无法转换为数字:', order.dep.down)
        return '--'
      }
      
      // 将0.05转换为5% (乘以100)
      const percentageRate = rate * 100
      const sign = percentageRate < 0 ? '-' : ''
      const result = `${sign}${Math.abs(percentageRate).toFixed(2)}%`
      console.log('✅ 收益率格式化成功:', result, '(原始值:', rate, '转换为:', percentageRate, ')')
      return result
    },
    // 获取价格颜色
    getPriceColor(currentPrice, comparePrice, direction) {
      if (!currentPrice || !comparePrice) return 'color-black'
      
      const current = parseFloat(currentPrice)
      const compare = parseFloat(comparePrice)
      
      if (isNaN(current) || isNaN(compare)) return 'color-black'
      
      if (current > compare) {
        return 'color-green'
      } else if (current < compare) {
        return 'color-red'
      } else {
        return 'color-black'
      }
    },
    // 获取收益率颜色
    getYieldColor(order) {
      if (!order || !order.dep || !order.dep.down) return 'color-black'
      
      const rate = parseFloat(order.dep.down)
      if (isNaN(rate)) return 'color-black'
      
      if (rate > 0) {
        return 'color-green'
      } else if (rate < 0) {
        return 'color-red'
      } else {
        return 'color-black'
      }
    },
    // 获取订单状态文本
    getOrderStatusText(order) {
      const remaining = this.orderCountdowns[order.id] || 0;
      if (remaining <= 0) {
        return this.$t('flash_option.settled');
      }
      return this.$t('flash_option.pending');
    },
    // 获取订单状态样式类
    getOrderStatusClass(order) {
      const remaining = this.orderCountdowns[order.id] || 0;
      if (remaining <= 0) {
        return 'color-gray'; // 已结算的样式
      }
      return 'color-blue'; // 进行中的样式
    },
    // 获取倒计时样式类
    getCountdownClass(order) {
      const remaining = this.orderCountdowns[order.id] || 0;
      if (remaining <= 0) {
        return 'color-gray';
      }
      if (remaining <= 60 * 1000) { // 小于1分钟
        return 'color-red';
      }
      return 'color-blue';
    },
    
    // 获取活跃订单收益率颜色
    getActiveYieldColor(order) {
      if (!order || !order.dep || !order.dep.down) return 'color-black'
      
      const rate = parseFloat(order.dep.down)
      if (isNaN(rate)) return 'color-black'
      
      if (rate > 0) {
        return 'color-green'
      } else if (rate < 0) {
        return 'color-red'
      } else {
        return 'color-black'
      }
    },
    
    // 获取活跃订单预期收益颜色
    getActiveProfitColor(order) {
      if (!order.amount || !order.dep?.down) return 'color-gray'
      const amount = parseFloat(order.amount)
      const rate = parseFloat(order.dep.down)
      if (isNaN(amount) || isNaN(rate)) return 'color-gray'
      const profit = amount * rate
      return profit > 0 ? 'color-green' : profit < 0 ? 'color-red' : 'color-gray'
    },
    
    // 获取活跃订单手续费颜色
    getActiveFeeColor(order) {
      if (!order.dep?.charge) return 'color-gray'
      const fee = parseFloat(order.dep.charge)
      if (isNaN(fee)) return 'color-gray'
      return fee > 0 ? 'color-orange' : 'color-gray'
    },
    
    // 安全调用需要登录的API的包装方法
    async safeApiCall(apiFunction, defaultReturn = null, description = 'API调用') {
      try {
        if (!this.isLogin) {
          console.log(`👤 用户未登录，跳过${description}`)
          return defaultReturn
        }
        return await apiFunction()
      } catch (error) {
        if (error.message === '用户未登录') {
          console.log(`👤 ${description}时检测到未登录，返回默认值`)
          return defaultReturn
        }
        throw error // 重新抛出其他错误
      }
    },
    
    // 全局错误处理器
    handleUnhandledRejection(event) {
      if (event.reason && event.reason.message === '用户未登录') {
        console.log('🛡️ 全局捕获到"用户未登录"错误，已阻止抛出到控制台')
        console.log('🔍 错误详情:', {
          reason: event.reason,
          stack: event.reason.stack,
          isLogin: this.isLogin,
          userinfo: !!this.userinfo
        })
        event.preventDefault() // 阻止错误显示在控制台
        
        // 可以在这里添加用户友好的提示
        // this.$message.info('请先登录以使用完整功能')
      }
    },
    // 选择看涨/看跌方向
    selectDirection(dir) {
      this.direction = dir
      console.log('🎯 选择交易方向:', dir === 1 ? '看涨' : '看跌')
      
      // 调试信息
      console.log('📊 按钮状态调试信息:', {
        direction: this.direction,
        看涨激活: this.direction === 1,
        看跌激活: this.direction === 0
      })
      
      // 添加视觉反馈和强制样式更新
      this.$nextTick(() => {
        const callBtn = document.querySelector('.direction-btn.call-btn')
        const putBtn = document.querySelector('.direction-btn.put-btn')
        
        if (callBtn && putBtn) {
          // 强制移除所有active类
          callBtn.classList.remove('active')
          putBtn.classList.remove('active')
          
          // 重置所有背景样式
          callBtn.style.background = ''
          callBtn.style.backgroundColor = ''
          callBtn.style.backgroundImage = ''
          putBtn.style.background = ''
          putBtn.style.backgroundColor = ''
          putBtn.style.backgroundImage = ''
          
          // 添加对应的active类
          if (dir === 1) {
            callBtn.classList.add('active')
            // 强制设置看涨按钮背景
            callBtn.style.background = 'linear-gradient(135deg, #00ff88 0%, #00d470 100%)'
            callBtn.style.backgroundColor = '#00ff88'
            callBtn.style.borderColor = '#00ff88'
            console.log('✅ 看涨按钮激活')
          } else {
            putBtn.classList.add('active')
            // 强制设置看跌按钮背景
            putBtn.style.background = 'linear-gradient(135deg, #ff4757 0%, #ff3742 100%)'
            putBtn.style.backgroundColor = '#ff4757'
            putBtn.style.borderColor = '#ff4757'
            console.log('✅ 看跌按钮激活')
          }
          
          // 添加点击动画
          const buttons = document.querySelectorAll('.direction-btn')
          buttons.forEach(btn => {
            btn.style.transform = 'scale(0.95)'
            setTimeout(() => {
              btn.style.transform = 'scale(1)'
            }, 150)
          })
          
          // 输出当前按钮状态
          setTimeout(() => {
            console.log('🔍 按钮DOM状态:', {
              看涨按钮classes: callBtn.className,
              看跌按钮classes: putBtn.className,
              看涨按钮样式: window.getComputedStyle(callBtn).background.slice(0, 50),
              看跌按钮样式: window.getComputedStyle(putBtn).background.slice(0, 50)
            })
          }, 200)
        }
      })
    },
    
    // 初始化数据
    async initializeData() {
      try {
        console.log('📊 开始初始化期权数据...')
        
        // 立即显示余额（从Vuex获取）
        this.loadUserBalanceFromVuex();
        
        // 并行加载基础数据，但余额加载优先
        await Promise.all([
          this.loadCurrencies(),
          this.loadActiveOrders(),
          this.loadHistoryOrders()
        ])
        
        // 单独加载余额，确保优先级
        await this.loadUserBalance();
        
        // 选择默认币种
        if (this.currencies.length > 0) {
          // 始终设置默认币种（用于显示K线等）
          const defaultCurrency = this.currencies[0]
          this.currentCurrency = defaultCurrency
          this.currentPrice = parseFloat(defaultCurrency.new_price || 0)
          
          // 初始化24小时统计数据
          if (defaultCurrency.high_price) this.high24h = parseFloat(defaultCurrency.high_price)
          if (defaultCurrency.low_price) this.low24h = parseFloat(defaultCurrency.low_price)
          if (defaultCurrency.quantity) this.volume24h = `${this.truncateToDecimals(parseFloat(defaultCurrency.quantity), 2)} ${defaultCurrency.symbol}`
          
          console.log('🎯 设置默认币种:', defaultCurrency.symbol, '登录状态:', this.isLogin)
          
          // 只有在登录时才加载配置
          if (this.isLogin) {
            await this.loadDepConfigs(defaultCurrency.currency_id)
          }
          
          // 🔥 确保在币种设置后创建K线图表（如果还未创建）
          await this.$nextTick()
          if (!klineCharts) {
            setTimeout(() => {
              this.createCharts()
            }, 100)
          }
        }
        
        // 调试：输出当前24小时统计数据
        setTimeout(() => {
          console.log('🔍 当前24小时统计数据状态:', {
            high24h: this.high24h,
            low24h: this.low24h,
            volume24h: this.volume24h,
            currentPrice: this.currentPrice,
            currencies: this.currencies.length
          })
        }, 3000)
        
        // 连接WebSocket
        this.connectWebSocket()
        
        // 🎯 验证颜色显示效果
        this.$nextTick(() => {
          setTimeout(() => {
            console.log('🎨 验证币种颜色显示效果完成')
          }, 1000)
        })
        
        console.log('✅ 期权数据初始化完成')
        
        // 🔍 启动诊断监控器
        this.startDiagnosticMonitor()
        
        // 🚨 禁用强制主题修复，避免中途闪动深色
        // this.forceApplyTheme()
      } catch (error) {
        console.error('❌ 期权数据初始化失败:', error)
      }
    },
    
    // 启动诊断监控器
    startDiagnosticMonitor() {
      if (this.diagnosticInterval) {
        clearInterval(this.diagnosticInterval)
      }
      
      this.diagnosticInterval = setInterval(() => {
        console.log('🔍 期权页面状态诊断报告:', {
          wsConnected: this.ws && this.ws.readyState === WebSocket.OPEN,
          wsReadyState: this.ws ? this.ws.readyState : 'null',
          currentCurrency: this.currentCurrency?.symbol,
          currencyId: this.currentCurrency?.currency_id || this.currentCurrency?.id,
          hasGlobalTicker: !!_ticker,
          globalTickerKeys: _ticker ? Object.keys(_ticker) : null,
          currentPrice: this.currentPrice,
          high24h: this.high24h,
          low24h: this.low24h,
          volume24h: this.volume24h,
          klineChartsExists: !!klineCharts,
          timestamp: new Date().toLocaleTimeString(),
          theme: this.userTheme,
          htmlTheme: document.documentElement.getAttribute('data-theme')
        })
      }, 10000) // 每10秒输出一次状态
    },
    
    // 强制应用主题修复
    forceApplyTheme() {
      console.log('🎨 强制应用主题修复:', this.userTheme)
      
      // 确保HTML元素有正确的主题属性
      const html = document.documentElement
      const body = document.body
      
      html.setAttribute('data-theme', this.userTheme)
      body.setAttribute('data-theme', this.userTheme)
      
      // 如果是深色主题，强制修复所有可能的黑色文字
      if (this.userTheme === 'dark') {
        this.$nextTick(() => {
          // 查找所有硬编码黑色文字的元素
          const blackTextSelectors = [
            '[style*="color: #000"]',
            '[style*="color: black"]', 
            '[style*="color:#000"]',
            '[style*="color:black"]',
            '[style*="color: #000000"]',
            '[style*="color:#000000"]'
          ]
          
          let fixedCount = 0
          blackTextSelectors.forEach(selector => {
            const elements = document.querySelectorAll(selector)
            elements.forEach(el => {
              el.style.color = 'var(--content-primary)'
              fixedCount++
            })
          })
          
          // 确保所有重要容器都有正确的文字颜色
          const containers = [
            '.futures', '.option-trading-panel', '.option-content', 
            '.trade-panel', '.content_head', '.hotCoin', '.contract-coin-selector',
            '.arco-input', '.arco-select', '.arco-button', '.arco-table',
            '.arco-tabs', '.arco-dropdown', 'span', 'div', 'p', 'label'
          ]
          
          containers.forEach(selector => {
            const elements = document.querySelectorAll(selector)
            elements.forEach(el => {
              // 检查计算样式
              const computedStyle = getComputedStyle(el)
              if (computedStyle.color === 'rgb(0, 0, 0)' || 
                  computedStyle.color === 'black' || 
                  computedStyle.color === '#000' ||
                  computedStyle.color === '#000000') {
                el.style.color = 'var(--content-primary)'
                fixedCount++
              }
            })
          })
          
          console.log(`✅ 主题修复完成，共修复 ${fixedCount} 个元素`)
          
          // 创建全局修复函数，用户可以在控制台中调用
          window.fixDarkTheme = () => {
            console.log('🔧 手动修复深色主题文字可见性...')
            this.forceApplyTheme()
            
            // 额外的强制修复
            setTimeout(() => {
              const allElements = document.querySelectorAll('*')
              let manualFixCount = 0
              allElements.forEach(el => {
                const style = getComputedStyle(el)
                if (style.color === 'rgb(0, 0, 0)' || style.color === 'black') {
                  el.style.color = '#ffffff'
                  manualFixCount++
                }
              })
              console.log(`🔧 手动修复完成，额外修复 ${manualFixCount} 个元素`)
              console.log('💡 如果还有文字看不清，请刷新页面或切换主题')
            }, 500)
          }
          
          console.log('💡 提示：如果还有文字看不清，可以在控制台执行 window.fixDarkTheme() 进行手动修复')
        })
      }
    },
    
    // 加载期权币种列表
    async loadCurrencies() {
      this.currencyLoading = true
      try {
        console.log('📋 加载期权币种列表...')
        
        const response = await currencyApi.futuresCurrency()
        console.log('🔍 期权币种API响应:', response)
        
        if (response.code === 200 && Array.isArray(response.data)) {
          this.currencies = response.data
          
          // 🔍 检查涨跌幅数据
          console.log('🔍 期权币种涨跌幅数据检查:')
          this.currencies.forEach((currency, index) => {
            console.log(`${currency.symbol}: ${currency.change_rate}%`)
          })
          
          console.log('✅ 期权币种加载成功:', this.currencies.length, '个币种')
          
          // 强制刷新DOM以应用颜色类名
          this.$nextTick(() => {
            this.forceRefreshColors()
          })
        } else {
          throw new Error('期权币种数据格式错误')
        }
      } catch (error) {
        console.error('❌ 期权币种加载失败:', error)
        this.currencies = []
      } finally {
        this.currencyLoading = false
      }
    },
    
    // 立即从Vuex加载用户余额（快速显示）
    loadUserBalanceFromVuex() {
      console.log('🔍 开始加载Vuex余额...');
      console.log('👤 用户登录状态:', this.isLogin);
      
      if (!this.isLogin) {
        // 只有在当前余额为0时才重置，避免在登录状态变化时重置已有余额
        if (this.userBalance === 0) {
          this.userBalance = 0;
          console.log('⚡ 用户未登录，设置余额为0');
        } else {
          console.log('⚡ 用户未登录，但保持当前余额:', this.userBalance);
        }
        return;
      }
      
      const accounts = this.$store.getters.accounts;
      console.log('📊 Vuex账户数据:', accounts);
      
      if (accounts && accounts.future_balance) {
        this.userBalance = parseFloat(accounts.future_balance);
        console.log('⚡ 立即显示期权余额:', this.userBalance, 'USDT');
      } else {
        // 如果Vuex中没有数据，但当前余额大于0，保持当前值
        if (this.userBalance > 0) {
          console.log('⚡ Vuex中没有期权余额数据，但当前余额为:', this.userBalance, '保持当前值');
        } else {
          this.userBalance = 0;
          console.log('⚡ Vuex中没有期权余额数据，显示默认值: 0 USDT');
        }
        console.log('📊 可用的账户字段:', accounts ? Object.keys(accounts) : 'accounts为null');
      }
    },
    

    
    // 强制刷新余额显示
    forceRefreshBalance() {
      console.log('🔄 强制刷新余额显示...');
      
      // 1. 立即从Vuex加载
      this.loadUserBalanceFromVuex();
      
      // 2. 强制更新全局账户信息
      if (this.$root && this.$root.getAccountInfo) {
        this.$root.getAccountInfo();
      }
      
      // 3. 延迟加载API数据（使用期权专用API）
      setTimeout(async () => {
        await this.loadUserBalance();
      }, 100);
      
      // 4. 再次延迟刷新Vuex数据
      setTimeout(() => {
        this.loadUserBalanceFromVuex();
      }, 500);
      

    },
    

    

    
    // 加载用户余额
    async loadUserBalance() {
      try {
        // 检查用户是否已登录
        if (!this.isLogin) {
          console.log('👤 用户未登录，跳过余额加载')
          // 只有在当前余额为0时才重置，避免在登录状态变化时重置已有余额
          if (this.userBalance === 0) {
            this.userBalance = 0
          }
          return
        }
        
        console.log('💰 加载用户期权余额...')
        
        // 保存当前余额，避免被重置
        const currentBalance = this.userBalance;
        
        // 立即尝试从Vuex获取账户数据（快速显示）
        const accounts = this.$store.getters.accounts;
        if (accounts && accounts.future_balance) {
          this.userBalance = parseFloat(accounts.future_balance);
          console.log('✅ 从Vuex获取期权余额成功:', this.userBalance, 'USDT');
        } else if (currentBalance > 0) {
          // 如果Vuex中没有数据但当前余额大于0，保持当前余额
          console.log('⏳ 从Vuex未找到余额，但当前余额为:', currentBalance, '保持当前值');
        } else {
          // 如果Vuex中没有数据且当前余额为0，设置默认值
          this.userBalance = 0;
          console.log('⏳ 从Vuex未找到余额，设置默认值0');
        }
        
        // 无论Vuex是否有数据，都尝试API加载以确保数据最新
        console.log('🔄 开始API加载最新余额数据...');
        
        // 异步加载API数据
        try {
          // 优先使用期权专用余额API
          let response = null;
          
          try {
            response = await userApi.getUBalance();
            console.log('🔍 期权专用余额API响应:', response);
          } catch (uBalanceError) {
            console.warn('⚠️ 期权专用余额API失败，尝试通用余额API:', uBalanceError.message);
            response = await userApi.getBalance();
            console.log('🔍 通用余额API响应:', response);
          }
          
          if (response.code === 200 && response.data) {
            let futureBalance = 0;
            
            // 处理期权专用API返回的数据
            if (typeof response.data === 'object' && response.data !== null) {
              // 期权专用API可能返回直接的余额数据
              futureBalance = parseFloat(
                response.data.future_balance || 
                response.data.futures_balance || 
                response.data.option_balance ||
                response.data.balance ||
                response.data.amount ||
                response.data.total ||
                0
              );
            }
            // 处理数组格式的数据（通用余额API）
            else if (Array.isArray(response.data)) {
              const usdtData = response.data.find(item => 
                item.currency_symbol === 'USDT' || 
                item.symbol === 'USDT' ||
                item.currency_id === 10 ||
                item.currency_name === 'USDT'
              );
              
              if (usdtData) {
                futureBalance = parseFloat(
                  usdtData.future_balance || 
                  usdtData.futures_balance || 
                  usdtData.option_balance ||
                  0
                );
              }
            }
            // 处理对象格式的数据（通用余额API）
            else if (typeof response.data === 'object') {
              futureBalance = parseFloat(
                response.data.future_balance || 
                response.data.futures_balance || 
                response.data.option_balance ||
                0
              );
            }
            
            this.userBalance = futureBalance;
            console.log('✅ API获取期权余额成功:', this.userBalance, 'USDT');
          } else {
            console.warn('⚠️ API返回数据格式错误，保持默认值0');
          }
        } catch (error) {
          console.error('❌ 余额API调用失败:', error);
          // 保持默认值0，不抛出错误
        }
        
      } catch (error) {
        console.error('❌ 用户期权余额加载失败:', error);
        this.userBalance = 0;
      }
    },
    
    // 选择币种
    async selectCurrency(currency) {
      console.log('🎯 选择币种:', currency.symbol);
      this.setCurrentCurrency(currency);
      this.currentCurrency = currency;
      this.lastPrice = this.currentPrice;
      
      // 更新当前价格和初始化24小时统计
      this.currentPrice = parseFloat(currency.new_price || 0);
      
      // 初始化24小时统计数据（从币种数据中获取）
      if (currency.high_price) this.high24h = parseFloat(currency.high_price);
      if (currency.low_price) this.low24h = parseFloat(currency.low_price);
      if (currency.quantity) this.volume24h = `${this.truncateToDecimals(parseFloat(currency.quantity), 2)} ${currency.symbol}`;
      
      console.log('📊 初始化24小时统计:', {
        high24h: this.high24h,
        low24h: this.low24h,
        volume24h: this.volume24h,
        currentPrice: this.currentPrice
      });
      
      // 币种切换成功
      
      // 只有在登录时才加载期权配置
      if (this.isLogin) {
        await this.loadDepConfigs(currency.currency_id);
      } else {
        console.log('👤 用户未登录，跳过期权配置加载');
        this.depConfigs = [];
        this.selectedDepConfig = null;
      }
      
      // 重新订阅新币种的数据
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.subscribeToData();
      }
      
    },
    
    // 加载期权配置
    async loadDepConfigs(currency_id) {
      try {
        // 检查用户是否已登录
        if (!this.isLogin) {
          console.log('👤 用户未登录，跳过期权配置加载')
          this.depConfigs = []
          this.selectedDepConfig = null
          return
        }
        
        console.log('⚙️ 加载期权配置...', currency_id);
        
        const response = await currencyApi.futuresDep({ currency_id });
        console.log('🔍 期权配置API响应:', response);
        
        if (response.code === 200 && Array.isArray(response.data)) {
          this.depConfigs = response.data;
          console.log('✅ 期权配置加载成功:', this.depConfigs.length, '个配置');
          
          // 默认选择第一个配置
          if (this.depConfigs.length > 0) {
            this.selectedDepConfig = this.depConfigs[0].id;
            this.onDepConfigChange();
          }
        }
      } catch (error) {
        console.error('❌ 期权配置加载失败:', error);
        this.depConfigs = [];
      }
    },
    
    // 期权配置改变
    onDepConfigChange() {
      this.currentDepConfig = this.depConfigs.find(dep => dep.id == this.selectedDepConfig);
      console.log('🔧 期权配置已切换:', this.currentDepConfig);
      
      // 启动交易倒计时
      this.startTradeCountdown();
    },
    
    // 选择期权配置
    selectDepConfig(config) {
      this.selectedDepConfig = config.id;
      this.onDepConfigChange();
    },
    
    // 创建K线图表 - 使用专业K线图组件
    async createCharts() {
      if (klineCharts) {
        return false
      }
      
      // 🔥 检查DOM容器是否存在
      const container = document.getElementById('optionChartBox')
      if (!container) {
        console.warn('⚠️ K线图容器不存在，等待DOM渲染...')
        // 等待DOM渲染后重试
        await this.$nextTick()
        setTimeout(() => {
          this.createCharts()
        }, 100)
        return false
      }
      
      // 🔥 检查容器尺寸
      const rect = container.getBoundingClientRect()
      console.log('📐 K线图容器尺寸:', {
        width: rect.width,
        height: rect.height,
        container: container
      })
      
      if (rect.width === 0 || rect.height === 0) {
        console.warn('⚠️ K线图容器尺寸为0，等待布局完成...')
        setTimeout(() => {
          this.createCharts()
        }, 300)
        return false
      }
      
      // 🔥 确保容器有明确的高度
      if (!container.style.height || container.style.height === '100%') {
        const parent = container.parentElement
        if (parent) {
          const parentRect = parent.getBoundingClientRect()
          if (parentRect.height > 0) {
            container.style.height = parentRect.height + 'px'
            console.log('✅ 设置K线图容器高度:', parentRect.height + 'px')
          }
        }
      }
      
      // 🔥 检查currentCurrency是否存在
      if (!this.currentCurrency) {
        console.warn('⚠️ 当前币种未设置，等待币种数据加载...')
        // 等待币种数据加载后重试
        setTimeout(() => {
          this.createCharts()
        }, 500)
        return false
      }

      const session = ++klineChartSession
      const chartCurrency = {
        id: this.currentCurrency['currency_id'] || this.currentCurrency['id'],
        ticker: this.currentCurrency['symbol'] + 'USDT'
      }
      last = undefined
      
      // 获取K线图语言代码（在加载语言包之前）
      const klineLocale = this.getKlineLocale();
      
      let _this = this
      
      class CustomDatafeed {
        searchSymbols(search) {
        }
        
        async getHistoryKLineData(symbol, period, from, to) {
          const isActiveSession = () => {
            const activeSymbol = klineCharts?.getSymbol?.()
            const activePeriod = klineCharts?.getPeriod?.()

            return session === klineChartSession
              && (!activeSymbol || activeSymbol.ticker === chartCurrency.ticker)
              && (!activePeriod || activePeriod.text === period.text)
          }

          if (!isActiveSession() || symbol?.ticker !== chartCurrency.ticker) {
            return []
          }
          
          console.log('📊 请求期权K线数据:', {
            symbol,
            period: period.text,
            currency_id: chartCurrency.id,
            currentCurrency: chartCurrency
          })
          
          let res = null
          
          try {
            // 🔥 修复：参考现货成功模式，不传cm_id参数，从Redis获取数据
            res = await currencyApi.contractLine({
              interval: period.text,
              currency_id: chartCurrency.id,
              limit: 1000
              // 不传cm_id，让后端从Redis获取数据（type=0路径）
            })
            
            console.log('📊 期权K线数据响应 (Redis路径):', {
              code: res?.code,
              dataLength: res?.data?.length,
              firstItem: res?.data?.[0],
              fullResponse: res
            })

            if (!isActiveSession() || symbol?.ticker !== chartCurrency.ticker) {
              return []
            }
            
            // 更新24小时统计数据
            if (res.data && res.data.length > 0) {
              _this.update24hStats(res.data)
            } else {
              console.warn('⚠️ Redis中无K线数据，尝试外部API')
              
              // 如果Redis没有数据，尝试外部API
              res = await currencyApi.contractLine({
                interval: period.text,
                currency_id: chartCurrency.id,
                cm_id: 5, // 期权的cm_id为5，调用外部API
                limit: 1000
              })
              
              console.log('📊 期权K线数据响应 (外部API):', res)

              if (!isActiveSession() || symbol?.ticker !== chartCurrency.ticker) {
                return []
              }
              
              if (res.data && res.data.length > 0) {
                _this.update24hStats(res.data)
              }
            }
          } catch (error) {
            console.error('❌ 期权K线数据获取失败:', error)
            // 返回空数组以避免后续错误
            return []
          }

          if (!isActiveSession() || symbol?.ticker !== chartCurrency.ticker) {
            return []
          }

          _this.$util.setCache('local-period', JSON.stringify(period))
          chartPeriod = {...period}
          
          // 如果API调用失败或没有数据，返回空数组
          if (!res || !res.data || !Array.isArray(res.data) || res.data.length === 0) {
            console.warn('⚠️ 没有可用的K线数据，返回空数组')
            return []
          }
          
          let type = 'candle_solid'
          if (period.text === '1s') {
            type = 'area'
          }
          
          // 🔥 确保klineCharts已创建
          if (klineCharts && klineCharts.setStyles) {
            try {
              klineCharts.setStyles({
                candle: {
                  type: type
                }
              })
            } catch (error) {
              console.warn('⚠️ 设置K线样式失败:', error)
            }
          }
          
          // 🔥 数据格式转换 - 参考现货页面的简单实现
          let data = res.data.map((item) => {
            return {
              timestamp: item['time'],
              open: item['open'],
              high: item['high'],
              low: item['low'],
              close: item['close'],
              volume: item['vol'],
              turnover: item['amount'],
            }
          })
          
          console.log('📊 转换后的K线数据:', {
            count: data.length,
            first: data[0],
            last: data[data.length - 1],
            sample: data.slice(0, 3)
          })
          
          const latest = data[data.length - 1]
          if (!last || (latest && latest.timestamp >= last.timestamp)) {
            last = latest
          }
          if (latest) {
            console.log('✅ K线数据准备完成，最后一条数据:', last)
          } else {
            console.warn('⚠️ 转换后的K线数据为空')
          }
          
          return data
        }
        
        subscribe(symbol, period, callback) {
          const subscriptionToken = ++klineSubscriptionToken
          console.log('📡 K线图订阅请求:', { 
            symbol, 
            period: period.text, 
            _ticker: !!_ticker,
            tickerKeys: _ticker ? Object.keys(_ticker) : null
          })
          
          // 🔥 修改检查逻辑：不阻塞订阅，而是在定时器中检查
          console.log('✅ 开始K线实时数据订阅（不等待ticker）:', symbol)
          if (upset !== false) {
            clearInterval(upset)
          }
          
          upset = setInterval(() => {
            const activeSymbol = klineCharts?.getSymbol?.()
            const activePeriod = klineCharts?.getPeriod?.()
            if (session !== klineChartSession
              || subscriptionToken !== klineSubscriptionToken
              || symbol?.ticker !== chartCurrency.ticker
              || (activeSymbol && activeSymbol.ticker !== chartCurrency.ticker)
              || (activePeriod && activePeriod.text !== period.text)) {
              return
            }

            // 🔥 每次执行时检查_ticker是否可用
            if (!_ticker || !_ticker.c) {
              console.log('⏳ 等待ticker数据...', {
                hasTicker: !!_ticker,
                tickerKeys: _ticker ? Object.keys(_ticker) : null,
                period: period.text
              })
              return
            }
            
            // 🔥 检查last是否存在
            if (!last) {
              console.log('⏳ 等待历史K线数据...')
              return
            }
            
            if (period.text === '1s') {
              firstPrice = parseFloat(_ticker['c'])
              const data = {
                timestamp: _ticker['E'],
                open: firstPrice,
                close: firstPrice,
                high: firstPrice,
                low: firstPrice,
                volume: parseInt(_ticker['Q'] || 0),
                turnover: parseInt(_ticker['Q'] || 0),
              }
              console.log('📊 K线1秒数据更新:', data)
              callback(data)
            } else {
              let minint = time[period.text] * 60 * 1000
              firstPrice = parseFloat(_ticker['c'])
              let data
              
              if (!last.timestamp || parseInt(_ticker['E']) - last['timestamp'] > minint) {
                data = {
                  timestamp: parseInt(_ticker['E']),
                  open: firstPrice,
                  close: firstPrice,
                  high: firstPrice,
                  low: firstPrice,
                  volume: parseInt(_ticker['Q'] || 0),
                  turnover: parseInt(_ticker['Q'] || 0),
                }
              } else {
                data = {
                  timestamp: last['timestamp'],
                  open: last['open'],
                  close: firstPrice,
                  high: last['high'] < firstPrice ? firstPrice : last['high'],
                  low: last['low'] > firstPrice ? firstPrice : last['low'],
                  volume: last['volume'] + parseInt(_ticker['Q'] || 0),
                  turnover: last['turnover'] + parseInt(_ticker['Q'] || 0),
                }
              }
              
              last = data
              console.log('📊 K线数据更新:', { 
                period: period.text, 
                ticker: _ticker,
                data 
              })
              callback(data)
            }
          }, 500)
        }
        
        unsubscribe(symbol, period) {
          klineSubscriptionToken += 1
          if (upset !== false) {
            clearInterval(upset)
            upset = false
          }
        }
      }
      
      // KLineChartPro已内置zh-CN和en-US语言包，无需手动加载
      // 只需在创建图表时设置locale参数即可
      console.log('🔧 K线图语言设置:', klineLocale);
      
      // 期权页面强制使用1秒作为默认周期，忽略缓存
      let localPeriod = chartPeriod || {
        multiplier: 0, timespan: 'second', text: '1s'
      }
      
      try {
        klineCharts = new KLineChartPro({
          container: container,
          watermark: "DBG Exchange",
          theme: this.userTheme,
          locale: klineLocale, // 使用当前语言设置（必须在创建时设置，后续无法更改）
          timezone: this.$util.getCache('time_zone'),
          // 初始化标的信息
          symbol: {
            ticker: chartCurrency.ticker,
            pricePrecision: this.currentCurrency['decimals'] || 2,
            logo: this.currentCurrency['icon'] || '',
            type: "OPTION"
          },
          // 初始化周期
          period: localPeriod,
          periods: [
            {multiplier: 0, timespan: 'second', text: '1s'},
            {multiplier: 1, timespan: 'minute', text: '1m'},
            {multiplier: 5, timespan: 'minute', text: '5m'},
            {multiplier: 15, timespan: 'minute', text: '15m'},
            {multiplier: 30, timespan: 'minute', text: '30m'},
            {multiplier: 60, timespan: 'minute', text: '1H'},
            {multiplier: 240, timespan: 'minute', text: '4H'},
            {multiplier: 720, timespan: 'minute', text: '12H'},
            {multiplier: 1440, timespan: 'minute', text: '1D'},
            {multiplier: 10080, timespan: 'minute', text: '1W'}
          ],
          subIndicators: [],
          datafeed: new CustomDatafeed()
        })
        
        // KLineChartPro支持setLocale方法，在创建后也可以设置语言
        // 但为了确保设置弹窗也使用正确语言，我们在创建后再次调用setLocale
        if (klineCharts && klineCharts.setLocale) {
          try {
            klineCharts.setLocale(klineLocale);
            console.log('✅ 期权K线图语言设置成功:', klineLocale);
          } catch (error) {
            console.warn('⚠️ 设置K线图语言失败:', error);
          }
        }
        
        // 通过CSS和DOM操作自定义时间显示格式：只显示小时和分钟
        this.$nextTick(() => {
          if (container) {
            // 添加自定义样式来修改时间显示
            const style = document.createElement('style');
            style.id = 'option-kline-time-format';
            style.textContent = `
              /* 期权K线图时间格式：只显示小时和分钟 */
              #optionChartBox .klinecharts-pro .x-axis .time-text,
              #optionChartBox .klinecharts-pro .time-axis .time-label,
              #optionChartBox .klinecharts-pro .x-axis text,
              #optionChartBox .klinecharts-pro .time-axis text {
                font-size: 12px !important;
              }
            `;
            // 如果样式已存在，先移除
            const existingStyle = document.getElementById('option-kline-time-format');
            if (existingStyle) {
              existingStyle.remove();
            }
            document.head.appendChild(style);
            
            // 通过MutationObserver监听DOM变化，修改时间显示格式
            const observer = new MutationObserver(() => {
              const timeElements = container.querySelectorAll('.klinecharts-pro .x-axis text, .klinecharts-pro .time-axis text');
              timeElements.forEach(el => {
                const text = el.textContent || '';
                // 如果包含日期格式（如 2025-11-25 22:53），只保留时间部分
                if (text.match(/\d{4}-\d{2}-\d{2}/)) {
                  // 匹配时间格式 HH:mm 或 HH:mm:ss
                  const timeMatch = text.match(/(\d{2}:\d{2})(?::\d{2})?/);
                  if (timeMatch) {
                    el.textContent = timeMatch[1]; // 只保留 HH:mm
                  }
                } else if (text.match(/\d{2}:\d{2}:\d{2}/)) {
                  // 如果只有时间格式 HH:mm:ss，去掉秒
                  el.textContent = text.replace(/:\d{2}$/, '');
                }
              });
            });
            
            // 开始观察容器内的变化
            observer.observe(container, {
              childList: true,
              subtree: true,
              characterData: true
            });
            
            // 立即执行一次格式化
            setTimeout(() => {
              const timeElements = container.querySelectorAll('.klinecharts-pro .x-axis text, .klinecharts-pro .time-axis text');
              timeElements.forEach(el => {
                const text = el.textContent || '';
                if (text.match(/\d{4}-\d{2}-\d{2}/)) {
                  const timeMatch = text.match(/(\d{2}:\d{2})(?::\d{2})?/);
                  if (timeMatch) {
                    el.textContent = timeMatch[1];
                  }
                } else if (text.match(/\d{2}:\d{2}:\d{2}/)) {
                  el.textContent = text.replace(/:\d{2}$/, '');
                }
              });
            }, 1000);
            
            console.log('✅ 期权K线图时间格式设置成功: 只显示 HH:mm');
          }
        });
        
        console.log('✅ 期权K线图表创建成功，语言:', klineLocale);
        console.log('✅ K线图表创建完成:', klineCharts)
        console.log('🌐 语言设置:', {
          i18nLocale: this.$i18n?.locale,
          cacheLang: this.$util.getCache('lang'),
          finalLang: this.$i18n?.locale || this.$util.getCache('lang') || 'en-US',
          klineLocale: klineLocale
        })
        
        // 🔥 强制设置容器背景透明，确保K线可见
        this.$nextTick(() => {
          if (container) {
            container.style.background = 'transparent'
            container.style.backgroundColor = 'transparent'
            container.style.backgroundImage = 'none'
            console.log('✅ K线图容器背景已设置为透明')
            
            // 确保KLineChartPro内部元素也透明
            const klineElements = container.querySelectorAll('.klinecharts-pro, canvas')
            klineElements.forEach(el => {
              if (el.style) {
                el.style.background = 'transparent'
                el.style.backgroundColor = 'transparent'
              }
            })
          }
        })
      } catch (error) {
        console.error('❌ 创建K线图表失败:', error)
        klineCharts = false
      }
    },
    
    // 设置当前币种（用于K线图表）
    setCurrentCurrency(item) {
      const previousPeriod = klineCharts?.getPeriod?.()
      if (previousPeriod) {
        chartPeriod = {...previousPeriod}
      }
      invalidateKlineSession()
      _ticker = false
      this.currentCurrency = item
      
      if (klineCharts) {
        try {
          klineCharts.destroy()
        } catch (error) {
          console.warn('⚠️ 销毁旧K线图失败:', error)
        }
        klineCharts = false
        const container = document.getElementById('optionChartBox')
        if (container) {
          container.innerHTML = ''
        }
        this.$nextTick(() => this.createCharts())
      }
    },
    

    
    // 更新24小时统计数据
    update24hStats(klineData) {
      if (!klineData || klineData.length === 0) {
        console.warn('⚠️ K线数据为空，使用币种基础数据')
        // 如果没有K线数据，使用币种列表中的基础数据
        if (this.currentCurrency) {
          if (this.currentCurrency.high_price) this.high24h = parseFloat(this.currentCurrency.high_price)
          if (this.currentCurrency.low_price) this.low24h = parseFloat(this.currentCurrency.low_price)
          if (this.currentCurrency.quantity) this.volume24h = `${this.truncateToDecimals(parseFloat(this.currentCurrency.quantity), 2)} ${this.currentCurrency.symbol}`
        }
        return
      }
      
      // 计算24小时最高最低价
      const prices = klineData.flatMap(d => [
        parseFloat(d.high || d.close || 0), 
        parseFloat(d.low || d.close || 0)
      ]).filter(p => p > 0)
      
      if (prices.length > 0) {
        this.high24h = Math.max(...prices)
        this.low24h = Math.min(...prices)
      }
      
      // 计算24小时交易量
      const totalVolume = klineData.reduce((sum, d) => {
        const vol = parseFloat(d.vol || d.volume || 0)
        return sum + vol
      }, 0)
      
      this.volume24h = `${this.truncateToDecimals(totalVolume, 2).toString()} ${this.currentCurrency.symbol}`
      
      // 更新当前价格为最新收盘价
      const latestData = klineData[klineData.length - 1]
      if (latestData) {
        const newPrice = parseFloat(latestData.close || latestData.c || 0)
        if (newPrice > 0) {
          this.lastPrice = this.currentPrice
          this.currentPrice = newPrice
        }
      }
      
      console.log('📊 24小时统计数据更新:', {
        high24h: this.high24h,
        low24h: this.low24h,
        volume24h: this.volume24h,
        currentPrice: this.currentPrice
      })
    },
    
    // 加载活跃订单
    async loadActiveOrders() {
      console.log('🔄 开始加载活跃订单...')
      console.log('🔍 用户登录状态:', this.isLogin)
      
      // 检查用户是否已登录
      if (!this.isLogin) {
        console.log('👤 用户未登录，跳过活跃订单加载')
        this.activeOrders = []
        return
      }
      
      this.ordersLoading = true
      try {
        console.log('📝 加载活跃期权订单...')
        
        // 尝试多种API参数格式
        let response = null
        
        // 1. 尝试不带参数
        try {
          response = await currencyApi.futuresUlist({})
          console.log('🔍 活跃订单API响应(无参数):', response)
        } catch (error) {
          console.log('⚠️ 无参数API调用失败，尝试其他方式:', error.message)
        }
        
        // 2. 如果第一种失败，尝试传递当前币种ID
        if (!response || response.code !== 200) {
          try {
            const currency_id = this.currentCurrency?.currency_id || 0
            response = await currencyApi.futuresUlist({ currency_id })
            console.log('🔍 活跃订单API响应(带币种ID):', response)
          } catch (error) {
            console.log('⚠️ 带币种ID API调用失败:', error.message)
          }
        }
        
        // 处理响应数据
        if (response && response.code === 200) {
          let activeData = []
          
          // 检查不同的数据格式
          if (Array.isArray(response.data)) {
            activeData = response.data
          } else if (response.data && Array.isArray(response.data.list)) {
            activeData = response.data.list
          } else if (response.data && Array.isArray(response.data.data)) {
            activeData = response.data.data
          }
          

          
          this.activeOrders = activeData
          console.log('✅ 活跃订单加载成功:', this.activeOrders.length, '个订单')
          
          // 详细检查每个订单的interval字段
          this.activeOrders.forEach((order, index) => {
            console.log(`🔍 订单${index + 1}详情:`, {
              id: order.id,
              interval: order.interval,
              created_at: order.created_at,
              direction: order.direction,
              amount: order.amount
            })
          })
          
          // 启动订单倒计时
          if (this.activeOrders.length > 0) {
            this.startOrderCountdowns()
          }
        } else {
          console.warn('⚠️ 活跃订单API返回格式异常:', response)
          this.activeOrders = []
        }
      } catch (error) {
        console.error('❌ 活跃订单加载失败:', error)
        this.activeOrders = []
      } finally {
        this.ordersLoading = false
      }
    },
    
    // 加载历史订单
    async loadHistoryOrders() {
      // 检查用户是否已登录
      if (!this.isLogin) {
        console.log('👤 用户未登录，跳过历史订单加载')
        this.historyOrders = []
        return
      }
      
      this.historyLoading = true
      try {
        console.log('📚 加载历史期权订单...')
        
        // 使用正确的API接口和参数
        const currency_id = this.currentCurrency?.currency_id || 1
        const response = await currencyApi.futuresHistory({ currency_id })
        
        console.log('🔍 历史订单API响应:', response)
        
        // 处理响应数据
        if (response && response.code === 200) {
          let historyData = []
          
          // 检查不同的数据格式
          if (Array.isArray(response.data)) {
            historyData = response.data
          } else if (response.data && Array.isArray(response.data.list)) {
            historyData = response.data.list
          } else if (response.data && Array.isArray(response.data.data)) {
            historyData = response.data.data
          }
          
          // 详细打印第一个订单的数据结构用于调试
          if (historyData.length > 0) {
            console.log('🔍 历史订单数据结构示例:', historyData[0])
            console.log('🔍 订单字段详情:', {
              'profit字段(盈亏)': historyData[0].profit,
              'created_at字段(订单创建时间)': historyData[0].created_at,
              'updated_at字段(订单结束时间)': historyData[0].updated_at,
              'open字段(开单价格)': historyData[0].open,
              'close字段(结算价格)': historyData[0].close,
              'symbol字段(币种名称)': historyData[0].symbol,
              'direction字段(方向)': historyData[0].direction,
              'amount字段(金额)': historyData[0].amount
            })
          }
          
          this.historyOrders = historyData
          console.log('✅ 历史订单加载成功:', this.historyOrders.length, '个订单')
        } else {
          console.warn('⚠️ 历史订单API返回格式异常:', response)
          this.historyOrders = []
        }
      } catch (error) {
        console.error('❌ 历史订单加载失败:', error)
        this.historyOrders = []
      } finally {
        this.historyLoading = false
      }
    },
    
    // 启动订单倒计时
    startOrderCountdowns() {
      // 清除之前的定时器
      if (this.orderCountdownInterval) {
        clearInterval(this.orderCountdownInterval)
      }
      
      // 初始化倒计时数据
      this.updateOrderCountdowns()
      
      // 每秒更新倒计时
      this.orderCountdownInterval = setInterval(() => {
        this.updateOrderCountdowns()
      }, 1000)
    },
    
    // 更新订单倒计时 - 自动移除过期订单
    updateOrderCountdowns() {
      // 获取当前纽约时间
      const current = new Date()
      const currentNY = new Date(current.toLocaleString('en-US', { timeZone: 'America/New_York' }))
      const now = currentNY.getTime()
      
      // 创建新的订单列表，过滤掉过期的订单
      const updatedOrders = []
      let hasExpiredOrders = false
      
      this.activeOrders.forEach(order => {
        const endTime = this.getOrderEndTime(order)
        if (endTime === null) {
          this.orderCountdowns[order.id] = 0
          return
        }
        
        const remainingTime = Math.max(0, endTime - now)
        
        // 检查订单是否过期
        if (remainingTime <= 0) {
          // 订单已过期，从列表中移除
          console.log(`🔄 订单${order.id}已过期，从活跃订单列表中移除`)
          hasExpiredOrders = true
          // 清除该订单的倒计时数据
          delete this.orderCountdowns[order.id]
          return // 不添加到updatedOrders中
        }
        
        // 订单未过期，保留在列表中
        updatedOrders.push(order)
        this.orderCountdowns[order.id] = remainingTime
        
        // 调试信息 - 显示纽约时间倒计时
        const minutes = Math.floor(remainingTime / (1000 * 60))
        const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000)
        const usedInterval = order.dep?.interval || order.interval
        console.log(`🔍 订单${order.id}倒计时(使用dep.interval): ${minutes}:${seconds.toString().padStart(2, '0')} (dep.interval: ${order.dep?.interval}, order.interval: ${order.interval}, 使用: ${usedInterval}分钟)`)
      })
      
      // 更新活跃订单列表
      if (hasExpiredOrders) {
        this.activeOrders = updatedOrders
        console.log(`✅ 已移除过期订单，当前活跃订单数量: ${this.activeOrders.length}`)
        
        // 订单过期后自动刷新余额
        console.log('💰 订单过期，开始刷新余额...')
        
        // 立即强制刷新全局账户信息
        if (this.$root && this.$root.getAccountInfo) {
          this.$root.getAccountInfo();
        }
        
        // 立即刷新一次余额
        this.forceRefreshBalanceAfterOrderExpired();
        
        // 延迟500ms后再刷新一次，确保后端数据完全更新
        setTimeout(() => {
          this.forceRefreshBalanceAfterOrderExpired();
        }, 500);
        
        // 延迟1秒后第三次刷新，确保数据完全同步
        setTimeout(() => {
          this.forceRefreshBalanceAfterOrderExpired();
        }, 1000);
        
        // 延迟2秒后第四次刷新，最终确认
        setTimeout(() => {
          this.forceRefreshBalanceAfterOrderExpired();
        }, 2000);
      }
    },
    
    // 获取订单结束时间 - 使用dep.interval作为时长
    getOrderEndTime(order) {
      if (!order.created_at) {
        return null
      }
      
      // 获取正确的时长 - 优先使用dep.interval，如果没有则使用order.interval
      const interval = order.dep?.interval || order.interval
      if (!interval) {
        console.log('❌ 订单缺少interval字段:', order)
        return null
      }
      
      // 解析创建时间 - 修复时区处理
      let createTime
      try {
        // 处理不同的时间格式
        let timeString = order.created_at
        
        // 如果是 "MM-DD HH:mm:ss" 格式，需要添加年份
        if (timeString.match(/^\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
          const currentYear = new Date().getFullYear()
          timeString = `${currentYear}-${timeString}`
        }
        
        // 假设created_at是UTC时间，直接解析
        createTime = new Date(timeString).getTime()
        
        if (isNaN(createTime)) {
          console.log('❌ 时间解析失败:', timeString)
          return null
        }
      } catch (error) {
        console.log('❌ 时间解析异常:', error)
        return null
      }
      
      // 计算结束时间（使用dep.interval作为时长）
      const duration = parseInt(interval) * 60 * 1000 // 转换为毫秒
      const endTime = createTime + duration
      
      // 获取当前纽约时间
      const current = new Date()
      const currentNY = new Date(current.toLocaleString('en-US', { timeZone: 'America/New_York' }))
      
      console.log('🔍 订单倒计时计算(使用dep.interval):', {
        order_id: order.id,
        created_at: order.created_at,
        order_interval: order.interval,
        dep_interval: order.dep?.interval,
        used_interval: interval,
        createTime: createTime,
        duration: duration,
        endTime: endTime,
        createDateUTC: new Date(createTime).toISOString(),
        createDateNY: new Date(createTime).toLocaleString('en-US', { timeZone: 'America/New_York' }),
        endDateUTC: new Date(endTime).toISOString(),
        endDateNY: new Date(endTime).toLocaleString('en-US', { timeZone: 'America/New_York' }),
        currentDateNY: currentNY.toLocaleString('en-US', { timeZone: 'America/New_York' }),
        currentTimestamp: currentNY.getTime(),
        remainingMinutes: Math.max(0, (endTime - currentNY.getTime()) / (60 * 1000)),
        isExpired: (endTime - currentNY.getTime()) <= 0
      })
      
      return endTime
    },
    

    
    // 计算进度百分比 - 使用dep.interval
    getOrderRate(order) {
      const interval = order.dep?.interval || order.interval
      if (!interval) {
        return 0
      }
      
      const remaining = this.orderCountdowns[order.id] || 0
      const totalSeconds = parseInt(interval) * 60 * 1000 // 转换为毫秒
      return (1 - remaining / totalSeconds) * 100
    },
    
    // 格式化订单倒计时
    formatOrderCountdown(order) {
      const remaining = this.orderCountdowns[order.id] || 0
      
      if (remaining <= 0) {
        return '已结算'
      }
      
      const minutes = Math.floor(remaining / (1000 * 60))
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000)
      
      return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    
    // 获取倒计时样式类
    getCountdownClass(order) {
      const remaining = this.orderCountdowns[order.id] || 0
      const minutes = Math.floor(remaining / (1000 * 60))
      
      if (remaining <= 0) {
        return 'color-gray'
      } else if (minutes < 1) {
        return 'color-red' // 红色警告
      } else if (minutes < 3) {
        return 'color-orange' // 橙色提醒
      } else {
        return 'color-blue' // 正常蓝色
      }
    },
    
    // 获取订单结果文字 - 兼容多种状态值
    getOrderResultText(order) {
      console.log('🔍 订单结果分析:', {
        order_id: order.id,
        status: order.status,
        result: order.result,
        profit: order.profit,
        win: order.win
      })
      
      // 多种可能的状态字段
      const status = order.status || order.result || order.win
      const profit = parseFloat(order.profit || order.income || order.earn || 0)
      
      // 不同的状态值映射
      if (status === 1 || status === '1' || status === 'win' || profit > 0) {
        return this.$t('flash_option.profit')
      } else if (status === 2 || status === '2' || status === 'lose' || status === 'loss' || profit < 0) {
        return this.$t('flash_option.loss')
      } else if (status === 0 || status === '0' || status === 'draw' || profit === 0) {
        return this.$t('flash_option.draw')
      } else if (status === 3 || status === '3' || status === 'pending') {
        return this.$t('flash_option.pending')
      } else {
        return this.$t('flash_option.unknown', { status })
      }
    },
    
    // 获取订单结果颜色 - 兼容多种状态值
    getOrderResultColor(order) {
      const status = order.status || order.result || order.win
      const profit = parseFloat(order.profit || order.income || order.earn || 0)
      
      if (status === 1 || status === '1' || status === 'win' || profit > 0) {
        return 'color-green'
      } else if (status === 2 || status === '2' || status === 'lose' || status === 'loss' || profit < 0) {
        return 'color-red'
      } else {
        return 'color-gray'
      }
    },
    
    // 格式化订单时间 - 兼容多种时间格式，显示到秒
    formatOrderTime(timestamp) {
      if (!timestamp) return '--'
      
      try {
        // 尝试不同的时间格式
        let date
        if (typeof timestamp === 'string') {
          // 如果是字符串，可能是 ISO 格式或者其他格式
          date = new Date(timestamp.replace(' ', 'T')) // 处理 YYYY-MM-DD HH:mm:ss 格式
        } else {
          // 如果是数字，可能是时间戳
          date = new Date(timestamp * (timestamp < 10000000000 ? 1000 : 1)) // 处理秒/毫秒时间戳
        }
        
        if (isNaN(date.getTime())) {
          return timestamp.toString().substring(0, 19) // 如果解析失败，返回前19位（包含秒）
        }
        
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const day = date.getDate().toString().padStart(2, '0')
        const hour = date.getHours().toString().padStart(2, '0')
        const minute = date.getMinutes().toString().padStart(2, '0')
        const second = date.getSeconds().toString().padStart(2, '0')
        
        return `${month}-${day} ${hour}:${minute}:${second}`
      } catch (error) {
        console.error('时间格式化错误:', error, timestamp)
        return timestamp ? timestamp.toString().substring(0, 19) : '--'
      }
    },
    
    // 获取币种符号 - 兼容多种数据格式
    getCurrencySymbol(currency_id) {
      if (!currency_id && currency_id !== 0) return '--'
      
      // 直接从币种列表中查找
      const currency = this.currencies.find(c => 
        c.currency_id === currency_id || 
        c.id === currency_id || 
        c.currency_id === parseInt(currency_id)
      )
      
      if (currency) {
        return currency.symbol || currency.name || 'Unknown'
      }
      
      // 如果找不到，返回通用名称
      const symbolMap = {
        1: 'BTC',
        2: 'ETH',
        3: 'LTC',
        4: 'EOS',
        5: 'XRP',
        6: 'BCH',
        7: 'ADA',
        8: 'DOT',
        9: 'LINK',
        10: 'UNI'
      }
      
      return symbolMap[currency_id] || `ID${currency_id}`
    },
    
    // 格式化价格 - 交易所级别的精度显示（不四舍五入，只截断）
    formatPrice(value) {
      if (!value && value !== 0) return '--'
      
      const numValue = parseFloat(value)
      if (isNaN(numValue)) return '--'
      
      // 交易所级别的价格显示 - 使用截断而不是四舍五入
      if (numValue >= 100000) {
        // 大于10万显示为 118.4K（截断到1位小数）
        return this.truncateToDecimals(numValue / 1000, 1).toString() + 'K'
      } else if (numValue >= 10000) {
        // 1万-10万显示为整数（截断小数部分）
        return Math.floor(numValue).toString()
      } else if (numValue >= 1000) {
        // 1000-9999显示为1位小数（截断）
        return this.truncateToDecimals(numValue, 1).toString()
      } else if (numValue >= 1) {
        // 1-999显示为2位小数（截断）
        return this.truncateToDecimals(numValue, 2).toString()
      } else {
        // 小于1显示为4位小数（截断）
        return this.truncateToDecimals(numValue, 4).toString()
      }
    },
    
    // 截断到指定小数位数（不四舍五入）
    truncateToDecimals(num, decimals) {
      if (isNaN(num) || num === null || num === undefined) return 0
      const multiplier = Math.pow(10, decimals)
      const result = Math.floor(num * multiplier) / multiplier
      
      // 根据调用场景返回合适的格式
      if (decimals === 0) {
        return Math.floor(result)
      } else {
        return parseFloat(result.toString())
      }
    },
    
    // K线图专用价格格式化函数 - 保持完整精度
    formatKlinePrice(price) {
      if (!price && price !== 0) return '0'
      if (isNaN(price)) return '0'
      
      const num = parseFloat(price)
      
      // 交易所级别的价格精度标准
      if (num >= 1000) {
        // 大价格：保持至少2位小数，但如果原始有更多精度则保持
        const originalDecimals = this.getDecimalPlaces(num)
        const minDecimals = Math.max(2, originalDecimals)
        if (originalDecimals > 0) {
          // 有小数部分，保持原始精度
          return num.toString()
        } else {
          // 整数，显示2位小数
          return num.toFixed(2)
        }
      } else if (num >= 1) {
        // 中等价格（1-999）：保持至少4位小数
        const originalDecimals = this.getDecimalPlaces(num)
        const minDecimals = Math.max(4, originalDecimals)
        const formatted = num.toFixed(minDecimals)
        // 只有当小数位超过最小要求时才移除末尾零
        return minDecimals > originalDecimals ? formatted.replace(/0+$/, '').replace(/\.$/, '') : formatted
              } else if (num >= 0.01) {
          // 小价格（0.01-0.99）：保持至少4位小数
          const originalDecimals = this.getDecimalPlaces(num)
          const minDecimals = Math.max(4, originalDecimals)
          const formatted = num.toFixed(minDecimals)
          // 只有当小数位超过最小要求时才移除末尾零
          return minDecimals > originalDecimals ? formatted.replace(/0+$/, '').replace(/\.$/, '') : formatted
        } else if (num > 0) {
          // 微小价格（<0.01）：保持至少6位小数，最多8位
          const originalDecimals = this.getDecimalPlaces(num)
          const minDecimals = Math.max(6, Math.min(8, originalDecimals))
          const formatted = num.toFixed(minDecimals)
          // 保持原始精度，不移除重要的零
          return originalDecimals >= minDecimals ? formatted : formatted.replace(/0+$/, '').replace(/\.$/, '')
      } else {
        return '0'
      }
    },
    
    // 获取数字的小数位数
    getDecimalPlaces(num) {
      if (isNaN(num) || num === null || num === undefined) return 0
      
      const numStr = num.toString()
      
      // 处理科学记数法
      if (numStr.indexOf('e') !== -1) {
        const parts = numStr.split('e')
        const decimal = parts[0]
        const exponent = parseInt(parts[1])
        
        if (decimal.indexOf('.') === -1) {
          return Math.max(0, -exponent)
        } else {
          const decimalPlaces = decimal.split('.')[1].length
          return Math.max(0, decimalPlaces - exponent)
        }
      }
      
      // 普通数字
      if (numStr.indexOf('.') === -1) return 0
      return numStr.split('.')[1].length
    },
    
    // 价格精度测试函数（开发调试用）
    testPriceFormatting() {
      console.log('🧪 价格格式化测试结果:')
      console.log('0.85556 →', this.formatKlinePrice(0.85556))  // 应该显示完整精度
      console.log('0.85000 →', this.formatKlinePrice(0.85000))  // 应该显示0.8500
      console.log('1.2345 →', this.formatKlinePrice(1.2345))    // 应该显示1.2345
      console.log('1000.12 →', this.formatKlinePrice(1000.12))  // 应该显示1000.12
      console.log('50000 →', this.formatKlinePrice(50000))      // 应该显示50000.00
      console.log('0.000123 →', this.formatKlinePrice(0.000123)) // 应该显示0.000123
    },
    
    // 手动刷新K线图（调试用）
    manualRefreshChart() {
      console.log('🔄 手动刷新K线图...')
      if (klineCharts) {
        klineCharts.resize()
      }
    },
    
    // 诊断K线图状态
    diagnoseChart() {
      console.log('🔍 K线图诊断信息:')
      console.log('当前价格:', this.currentPrice)
      console.log('最后价格:', this.lastPrice)
      console.log('K线图容器:', document.getElementById('optionChartBox'))
      console.log('K线图表实例:', klineCharts)
      console.log('WebSocket状态:', this.ws?.readyState)
      console.log('Ticker数据:', _ticker)
    },
    
    // 格式化订单金额 - 使用正确的字段名
    formatOrderAmount(order) {
      // 使用正确的字段名：amount
      const amount = parseFloat(order.amount || 0)
      return this.formatKlinePrice(amount)
    },
    
    // 格式化订单开单价 - 使用正确的字段名
    formatOrderPrice(order) {
      // 使用正确的字段名：open
      const price = parseFloat(order.open || 0)
      return this.formatKlinePrice(price)
    },
    
    // 格式化结算价 - 扩大搜索范围
    formatClosePrice(order) {
      const allPossibleFields = Object.keys(order)
      
      // 先尝试明显的结算价字段
      for (const field of allPossibleFields) {
        if (field.toLowerCase().includes('close') || 
            field.toLowerCase().includes('end') ||
            field.toLowerCase().includes('settle') ||
            field.toLowerCase().includes('final')) {
          const value = parseFloat(order[field])
          if (!isNaN(value) && value > 1000 && value < 200000) {
            console.log(`✅ 使用结算价字段: ${field} = ${value}`)
            return this.formatKlinePrice(value)
          }
        }
      }
      
      // 如果历史订单，尝试查找与开单价不同的第二个价格
      const priceValues = []
      for (const field of allPossibleFields) {
        const value = parseFloat(order[field])
        if (!isNaN(value) && value > 10000 && value < 200000) {
          priceValues.push({field, value})
        }
      }
      
      // 如果有多个价格值，取第二个作为结算价
      if (priceValues.length >= 2) {
        console.log(`🎯 使用第二个价格字段作为结算价: ${priceValues[1].field} = ${priceValues[1].value}`)
        return this.formatKlinePrice(priceValues[1].value)
      }
      
      return '--'
    },

    // 手动调试数据结构
    debugOrderFields() {
      console.log('🔍 ========== 手动调试订单数据 ==========')
      
      if (this.historyOrders.length > 0) {
        console.log('📚 历史订单示例数据:')
        const sampleOrder = this.historyOrders[0]
        console.log('完整订单对象:', sampleOrder)
        console.log('所有字段名:', Object.keys(sampleOrder))
        
        // 显示所有包含价格相关关键词的字段
        console.log('价格相关字段:')
        for (const [key, value] of Object.entries(sampleOrder)) {
          if (key.toLowerCase().includes('price') || 
              key.toLowerCase().includes('open') || 
              key.toLowerCase().includes('close') || 
              key.toLowerCase().includes('settle')) {
            console.log(`  ${key}: ${value} (${typeof value})`)
          }
        }
        
        // 显示所有数值字段  
        console.log('所有数值字段:')
        for (const [key, value] of Object.entries(sampleOrder)) {
          const numValue = parseFloat(value)
          if (!isNaN(numValue) && numValue > 0) {
            console.log(`  ${key}: ${value} (${typeof value}) -> ${numValue}`)
          }
        }
      }
      
      console.log('🔍 ========== 调试完成 ==========')
    },
    
    // 标签切换处理
    onTabChange(activeKey) {
      console.log('🔄 标签切换:', activeKey)
      
      if (activeKey === '1') {
        // 切换到活跃订单标签时刷新活跃订单
        console.log('📝 自动刷新活跃订单')
        this.loadActiveOrders()
      } else if (activeKey === '2') {
        // 切换到历史订单标签时自动加载历史订单
        console.log('📚 自动加载历史订单')
        this.loadHistoryOrders()
      }
    },
    
    // WebSocket连接
    connectWebSocket() {
      try {
        const deviceId = this.$util.getCache('deviceId')
        
        // 🔥 完全按照现货页面的成功模式：使用trade频道
        const wsUrl = config['BASE_WSS'] + '/?token=' + deviceId + '$trade' + '&sub=trade'
        
        console.log('🔌 期权WebSocket连接URL (现货模式):', wsUrl)
        this.ws = new WebSocket(wsUrl)
        
        this.ws.onopen = () => {
          console.log('✅ 期权WebSocket连接成功 (trade频道 - 现货模式)')
          
          // 🔥 完全按现货模式：延迟设置用户ID定时器
          setTimeout(() => {
            if (this.wsInterval) {
              clearInterval(this.wsInterval)
            }
            this.wsInterval = setInterval(() => {
              if (this.isLogin && this.userinfo.id && this.ws && this.ws.readyState === WebSocket.OPEN) {
                try {
                  // 🔥 按现货模式发送updateUserId而不是updateCuserId
                  this.ws.send(JSON.stringify({
                    event: 'updateUserId',
                    uid: this.userinfo.id
                  }))
                  console.log('📡 定期发送期权用户ID (现货模式):', this.userinfo.id)
                } catch (e) {
                  console.error('❌ 发送用户ID失败:', e)
                  clearInterval(this.wsInterval)
                  this.ws = null
                  this.connectWebSocket()
                }
              }
            }, 5000)
          }, 1500)
          
          // 🔥 按现货模式调用订阅（但不发送特殊消息）
          this.subscribeToData()
        }
        
        this.ws.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data)
            console.log('📨 期权WebSocket收到消息 (现货模式):', {
              type: data.type,
              timestamp: data.timestamp,
              hasData: !!data.data,
              dataKeys: data.data ? Object.keys(data.data) : null,
              rawDataSize: event.data.length
            })
            // 🔥 完全按现货模式处理消息
            this.onMessage(data)
          } catch (error) {
            console.error('❌ WebSocket消息解析失败:', error, event.data)
          }
        }
        
        this.ws.onerror = (error) => {
          console.error('❌ 期权WebSocket连接错误:', error)
        }
        
        this.ws.onclose = () => {
          console.log('🔌 期权WebSocket连接关闭，3秒后重连...')
          
          // 清理定时器
          if (this.wsInterval) {
            clearInterval(this.wsInterval)
            this.wsInterval = null
          }
          
          // 重置WebSocket对象
          this.ws = null
          
          // 延迟重连
          setTimeout(() => {
            this.connectWebSocket()
          }, 3000)
        }
      } catch (error) {
        console.error('❌ 期权WebSocket连接失败:', error)
      }
    },
    
    // 🔥 完全按现货模式：简单的订阅方法（不发送特殊消息）
    subscribeToData() {
      // 现货页面的subscribe方法是空的或者只是设置内部状态
      // 关键是onMessage方法能正确处理type 100的数据
      console.log('📡 期权订阅 (现货模式) - 等待接收type 100数据')
      
      if (this.currentCurrency) {
        console.log('📡 当前期权币种:', {
          symbol: this.currentCurrency.symbol,
          id: this.currentCurrency.currency_id || this.currentCurrency.id
        })
      }
    },
    
    // 🔥 完全按现货页面模式的onMessage方法
    onMessage(data) {
      console.log('📨 期权onMessage (现货模式):', {
        type: data.type,
        currentCurrency: this.currentCurrency?.symbol,
        currencyId: this.currentCurrency?.currency_id || this.currentCurrency?.id
      })
      
      // 🔥 完全复制现货页面的成功逻辑：处理type 100
      if (data.type === 100 && this.currentCurrency) {
        console.log('🎯 收到type 100数据 (现货ticker):', data.data)
        
        try {
          // 🔥 关键：使用与现货页面完全相同的逻辑
          let ticker = this.$util.getCurrentTicker(this.currentCurrency.currency_id || this.currentCurrency.id, data.data.data)
          
          if (ticker && Object.keys(ticker).length > 0) {
            console.log('✅ 成功获取ticker数据:', ticker)
            
            // 🔥 完全按现货页面的赋值方式
            _ticker = ticker
            this.lastPrice = this.currentPrice
            
            // 更新当前币种数据（模仿现货页面的current对象更新）
            let current = this.currentCurrency
            current['new_price'] = ticker['c']
            current['change_rate'] = ticker['P']
            current['high_price'] = ticker['h']
            current['low_price'] = ticker['l']
            current['quantity'] = ticker['v']
            current['quota'] = ticker['q']
            this.currentCurrency = current
            
            // 更新页面显示的价格
            this.currentPrice = parseFloat(ticker['c'] || 0)
            
            // 更新24小时统计数据
            if (ticker.h) this.high24h = Math.max(this.high24h, parseFloat(ticker.h))
            if (ticker.l) this.low24h = Math.min(this.low24h === 0 ? parseFloat(ticker.l) : this.low24h, parseFloat(ticker.l))
            if (ticker.v) this.volume24h = `${this.truncateToDecimals(parseFloat(ticker.v), 2).toString()} ${this.currentCurrency.symbol}`
            
            console.log('📊 期权价格更新成功 (现货模式):', {
              symbol: this.currentCurrency.symbol,
              price: this.currentPrice,
              ticker: ticker,
              _ticker: !!_ticker,
              high24h: this.high24h,
              low24h: this.low24h,
              volume24h: this.volume24h
            })
          } else {
            console.warn('⚠️ getCurrentTicker返回空数据，当前币种ID:', this.currentCurrency.currency_id || this.currentCurrency.id)
            console.log('🔍 可用的ticker数据:', data.data.data ? Object.keys(data.data.data) : 'null')
          }
        } catch (error) {
          console.error('❌ 处理ticker数据失败:', error)
        }
      }
      
      // 处理成交记录（模仿现货页面）
      if (data.type === 102) {
        console.log('📊 收到成交记录数据 (type 102)')
        // 成交记录处理逻辑可以后续添加
      }
      
      // 记录其他消息类型
      if (![100, 102].includes(data.type)) {
        console.log('📝 其他消息类型:', {
          type: data.type,
          hasData: !!data.data
        })
      }
    },
    

    
    // 断开WebSocket
    disconnectWebSocket() {
      // 清理WebSocket定时器
      if (this.wsInterval) {
        clearInterval(this.wsInterval)
        this.wsInterval = null
      }
      
      // 清理诊断定时器
      if (this.diagnosticInterval) {
        clearInterval(this.diagnosticInterval)
        this.diagnosticInterval = null
      }
      
      // 关闭WebSocket连接
      if (this.ws) {
        this.ws.close()
        this.ws = null
      }
    },
    
    // 设置快速金额
    setQuickAmount(value) {
      this.amount = value
      this.calculateProfit()
    },
    
    // 设置百分比金额 - 仿合约界面
    setPercentageAmount(percentage) {
      this.selectedPercentage = percentage
      if (percentage === 0) {
        this.amount = ''
      } else {
        const maxAmount = this.userBalance || 1000 // 如果没有余额，使用默认值
        this.amount = this.truncateToDecimals((maxAmount * percentage) / 100, 2).toString()
      }
      this.calculateProfit()
    },
    
    // 计算盈亏
    calculateProfit() {
      // 触发计算属性更新
      this.$nextTick()
    },
    
    // 验证订单数据完整性
    validateOrderData() {
      const errors = []
      
      // 1. 检查币种信息
      if (!this.currentCurrency || !this.currentCurrency.currency_id) {
        errors.push(this.$t('flash_option.currency_required'))
      }
      
      // 2. 检查方向（direction）字段 - 必须为 0 或 1
      if (this.direction === undefined || this.direction === null) {
        errors.push(this.$t('flash_option.direction_required'))
      } else if (this.direction !== 0 && this.direction !== 1) {
        errors.push(this.$t('flash_option.direction_invalid'))
      }
      
      // 3. 检查期权配置（dep_id）
      if (!this.selectedDepConfig) {
        errors.push(this.$t('flash_option.dep_config_required'))
      }
      
      // 4. 检查当前配置对象
      if (!this.currentDepConfig) {
        errors.push(this.$t('flash_option.dep_config_invalid'))
      }
      
      // 5. 检查投资金额
      if (!this.amount || parseFloat(this.amount) <= 0) {
        errors.push(this.$t('flash_option.amount_required'))
      } else if (parseFloat(this.amount) > this.userBalance) {
        errors.push(this.$t('common.insufficient_balance'))
      }
      
      // 6. 检查收益配置（确保有收益数据）
      if (this.currentDepConfig) {
        const expectedRate = this.direction === 1 ? this.currentDepConfig.up : this.currentDepConfig.down
        if (expectedRate === undefined || expectedRate === null || parseFloat(expectedRate) === 0) {
          errors.push(this.$t('flash_option.profit_rate_invalid'))
        }
      }
      
      return {
        isValid: errors.length === 0,
        errors: errors
      }
    },
    
    // 提交订单
    async submitOrder() {
      if (!this.canSubmitOrder) return
      
      // 🔒 订单数据完整性验证
      const validation = this.validateOrderData()
      if (!validation.isValid) {
        const errorMsg = validation.errors.join('；')
        console.error('❌ 订单数据验证失败:', validation.errors)
        this.$message.error(errorMsg)
        return
      }
      
      this.submitting = true
      try {
        // 再次确认关键字段
        const orderData = {
          currency_id: this.currentCurrency.currency_id,
          dep_id: this.selectedDepConfig,
          direction: this.direction, // 确保是 0 或 1
          amount: this.amount
        }
        
        console.log('📤 提交期权订单（已验证）:', {
          currency_id: orderData.currency_id,
          dep_id: orderData.dep_id,
          direction: orderData.direction,
          direction_desc: orderData.direction === 1 ? '看涨' : '看跌',
          amount: orderData.amount,
          expected_profit_rate: this.direction === 1 ? this.currentDepConfig?.up : this.currentDepConfig?.down
        })
        
        const response = await currencyApi.futuresSubmit(orderData)
        
        console.log('🔍 期权订单提交响应:', response)
        
        if (response.code === 200) {
          console.log('✅ 期权订单提交成功！')
          
          // 保存订单信息用于弹窗显示
          this.orderSuccessInfo = {
            currency: this.currentCurrency?.symbol || 'Unknown',
            direction: this.direction,
            amount: this.amount,
            expectedProfit: this.expectedProfit,
            currentPrice: this.currentPrice
          }
          
          this.showSuccessModal = true
          
          // 刷新数据
          await Promise.all([
            this.loadUserBalance(),
            this.loadActiveOrders()
          ])
          
          // 重置表单
          this.amount = ''
        } else {
          throw new Error(response.message || '订单提交失败')
        }
      } catch (error) {
        console.error('❌ 期权订单提交失败:', error)
        
        // 处理API返回的错误信息，进行多语言适配
        let errorMessage = error.message || this.$t('flash_option.order_failed')
        
        // 🔧 识别并转换硬编码的中文错误消息为国际化翻译
        // 网络连接失败
        if (errorMessage.includes('网络连接失败') || errorMessage.includes('网络连接失败，请检查网络连接')) {
          errorMessage = this.$t('common.network_connection_failed')
        }
        // API错误
        else if (errorMessage.includes('API错误') || errorMessage.includes('API请求失败')) {
          errorMessage = this.$t('common.api_request_failed')
        }
        // 服务器错误
        else if (errorMessage.includes('服务器错误')) {
          errorMessage = this.$t('common.server_error')
        }
        // 401未登录错误
        else if (errorMessage.includes('401') || errorMessage.includes('未登錄') || errorMessage.includes('未登录')) {
          errorMessage = this.$t('common.not_logged_in_please_login')
        }
        // 最低下单金额错误（中文）
        else if (errorMessage.includes('最低下单金额')) {
          const amountMatch = errorMessage.match(/最低下单金额\s*(\d+(?:\.\d+)?)/);
          if (amountMatch) {
            const minAmount = amountMatch[1];
            errorMessage = this.$t('flash_option.minimum_order_amount', { amount: minAmount });
          } else {
            errorMessage = this.$t('flash_option.minimum_order_amount_generic');
          }
        }
        // 最低下单金额错误（英文）
        else if (errorMessage.includes('minimum order amount') || errorMessage.includes('Minimum order amount')) {
          const amountMatch = errorMessage.match(/minimum order amount.*?(\d+(?:\.\d+)?)/i);
          if (amountMatch) {
            const minAmount = amountMatch[1];
            errorMessage = this.$t('flash_option.minimum_order_amount', { amount: minAmount });
          } else {
            errorMessage = this.$t('flash_option.minimum_order_amount_generic');
          }
        }
        
        this.errorMessage = errorMessage
        this.showErrorModal = true
      } finally {
        this.submitting = false
      }
    },
    
    // 关闭成功弹窗
    closeSuccessModal() {
      this.showSuccessModal = false
      this.orderSuccessInfo = null
    },
    
    // 关闭错误弹窗
    closeErrorModal() {
      this.showErrorModal = false
      this.errorMessage = ''
    },
    

    
    getCurrencySymbol(currency_id) {
      const currency = this.currencies.find(c => c.currency_id === currency_id)
      return currency ? currency.symbol : 'Unknown'
    },
    
    formatPrice(price) {
      if (!price && price !== 0) return '0.00'
      const numValue = parseFloat(price)
      if (isNaN(numValue)) return '0.00'
      
      // 交易所级别的价格显示 - 保持原始精度，不四舍五入
      if (numValue >= 100000) {
        return this.truncateToDecimals(numValue / 1000, 1).toString() + 'K'
      } else if (numValue >= 10000) {
        return Math.floor(numValue).toString()
      } else if (numValue >= 1000) {
        return this.truncateToDecimals(numValue, 1).toString()
      } else if (numValue >= 1) {
        return this.truncateToDecimals(numValue, 2).toString()
      } else {
        return this.truncateToDecimals(numValue, 8).toString() // 小额价格保持8位精度
      }
    },

    applyKlineTheme(theme) {
      applyKlineProTheme(
        klineCharts,
        theme,
        document.getElementById('optionChartBox')
      )
    },
    
    // 强制移除所有深色样式（用于浅色主题）
    forceRemoveDarkStyles() {
      console.log('🧹 开始强制清理深色样式...')
      
      // 清理所有有深色背景的元素
      const elementsToClean = document.querySelectorAll('*')
      let cleanedCount = 0
      
      elementsToClean.forEach(element => {
        const style = element.style
        if (style.background && (
          style.background.includes('#1a1a1a') || 
          style.background.includes('#2a2a2a') || 
          style.background.includes('#0a0c10') || 
          style.background.includes('#0a0e1a') ||
          style.background.includes('linear-gradient') && style.background.includes('#')
        )) {
          // 替换为浅色背景
          if (element.id === 'optionChartBox') {
            // 对于K线图表容器，通过组件API来实现主题切换
            this.applyKlineTheme(this.userTheme)
            return // 跳过后续的style设置
          } else {
            style.background = '#ffffff'
          }
          style.backgroundImage = 'none'
          cleanedCount++
        }
        
        if (style.backgroundColor && (
          style.backgroundColor.includes('#1a1a1a') || 
          style.backgroundColor.includes('#2a2a2a') || 
          style.backgroundColor.includes('#0a0c10') || 
          style.backgroundColor.includes('#0a0e1a')
        )) {
          style.backgroundColor = '#ffffff'
          cleanedCount++
        }
        
        // 清理边框颜色
        if (style.borderColor && style.borderColor.includes('rgba(255, 255, 255')) {
          style.borderColor = '#dee2e6'
        }
        
        // 清理文字颜色
        if (style.color === '#ffffff' || style.color === 'rgb(255, 255, 255)') {
          style.color = '#1a1a1a'
        }
      })
      
      // 特殊处理导航栏和热门币种区域
      const specialElements = document.querySelectorAll('#nav, .arco-layout-header, .hotCoin')
      specialElements.forEach(element => {
        element.style.background = '#ffffff'
        element.style.backgroundColor = '#ffffff'
        element.style.color = '#1a1a1a'
        element.style.borderColor = '#e9ecef'
        element.style.borderBottom = '1px solid #e9ecef'
        
        // 强制设置CSS变量
        element.style.setProperty('--home-nav-transparent-bg', '#ffffff')
        element.style.setProperty('--content-primary', '#1a1a1a')
        element.style.setProperty('--hover-primary', '#f8f9fa')
        
        cleanedCount++
      })
      
      // 超强力清理：直接设置所有导航栏内部元素
      const navElements = document.querySelectorAll('#nav *, .arco-layout-header *, .hotCoin *')
      navElements.forEach(element => {
        if (element.style) {
          element.style.color = '#1a1a1a'
          element.style.backgroundColor = 'transparent'
          if (element.style.background && element.style.background.includes('#')) {
            element.style.background = 'transparent'
          }
        }
      })
      
      console.log(`🧹 已清理 ${cleanedCount} 个深色样式元素`)
    },
    
    // 强制应用深色样式（用于深色主题）
    forceApplyDarkStyles() {
      console.log('🌙 开始强制应用深色样式...')
      
      // 设置K线图表主题
      this.applyKlineTheme('dark')
      
      // 容器背景色由CSS主题变量控制，确保与合约和现货页面一致
      console.log('🎯 使用标准CSS主题变量，确保与其他页面背景一致')
      
      // 深色主题：设置所有导航栏内部元素
      const darkNavElements = document.querySelectorAll('#nav *, .arco-layout-header *, .hotCoin *')
      darkNavElements.forEach(element => {
        if (element.style) {
          element.style.color = '#ffffff'
          if (element.style.backgroundColor && element.style.backgroundColor.includes('#ffffff')) {
            element.style.backgroundColor = 'transparent'
          }
        }
      })
      
      console.log('🌙 深色样式应用完成')
    },
    
    // 强制刷新导航栏主题
    forceRefreshNavigation(theme) {
      console.log(`🔄 强制刷新导航栏主题为${theme === 'light' ? '浅色' : '深色'}模式`)
      
      const isLight = theme === 'light'
      
      // 导航栏和头部区域使用标准主题变量
      console.log('🎯 导航栏和头部使用标准主题变量，保持与其他页面一致')
      
      // 热门币种区域使用CSS主题变量，不需要强制设置
      console.log('🎯 热门币种区域使用CSS主题变量，保持一致性')
      
      // 调试：检查期权页面的背景色修复情况
      setTimeout(() => {
        const futures = document.querySelector('.futures')
        const futuresContent = document.querySelector('.futures_content')
        const hotCoin = document.querySelector('.hotCoin')
        
        console.log('🔧 期权页面背景色终极修复后检查:')
        
        if (futures) {
          const futuresStyle = getComputedStyle(futures)
          console.log('  .futures background:', futuresStyle.backgroundColor)
          console.log('  .futures 内联样式:', futures.style.background || '无')
        }
        
        if (futuresContent) {
          const contentStyle = getComputedStyle(futuresContent)
          console.log('  .futures_content background:', contentStyle.backgroundColor)
          console.log('  .futures_content 内联样式:', futuresContent.style.background || '无')
        }
        
        if (hotCoin) {
          const hotCoinStyle = getComputedStyle(hotCoin)
          console.log('  .hotCoin background:', hotCoinStyle.backgroundColor)
        }
        
        // 检查是否还有#0a0c10的元素
        const elementsWithDarkBg = document.querySelectorAll('*[style*="#0a0c10"]')
        if (elementsWithDarkBg.length > 0) {
          console.warn('⚠️ 仍有', elementsWithDarkBg.length, '个元素使用#0a0c10背景色')
          elementsWithDarkBg.forEach((el, index) => {
            console.log(`  元素${index + 1}:`, el.tagName, el.className, el.style.background)
          })
        } else {
          console.log('✅ 已成功清除所有#0a0c10背景色！')
        }
        
        // 🔧 执行简单背景色修复
        this.performBackgroundFix()
        
        // 🔧 立即执行背景色修复（不等待）
        const fixBgImmediately = () => {
          const futures = document.querySelector('.futures')
          const futuresContent = document.querySelector('.futures_content')
          const optionPanel = document.querySelector('.option-trading-panel')
          const nav = document.querySelector('#nav')
          const layoutHeader = document.querySelector('.arco-layout-header')
          
          if (futures) {
            futures.style.setProperty('background', 'var(--background-primary)', 'important')
            futures.style.setProperty('background-color', 'var(--background-primary)', 'important')
            futures.style.setProperty('background-image', 'none', 'important')
          }
          
          if (futuresContent) {
            futuresContent.style.setProperty('background', 'var(--background-secondary)', 'important')
            futuresContent.style.setProperty('background-color', 'var(--background-secondary)', 'important')
            futuresContent.style.setProperty('background-image', 'none', 'important')
          }
          

          
          if (nav) {
            // 重置并强制设置半透明背景
            nav.removeAttribute('style')
            nav.style.setProperty('background', 'var(--home-nav-transparent-bg)', 'important')
            nav.style.setProperty('backdrop-filter', 'blur(20px)', 'important')
            nav.style.setProperty('-webkit-backdrop-filter', 'blur(20px)', 'important')
          }
          
          if (layoutHeader) {
            // 重置并强制设置透明
            layoutHeader.removeAttribute('style')
            layoutHeader.style.setProperty('background', 'transparent', 'important')
            layoutHeader.style.setProperty('background-color', 'transparent', 'important')
          }
          
          console.log('🔧 立即背景色修复执行完成（包含期权交易面板和头部导航栏）')
        }
        
        fixBgImmediately()
      }, 1000)
      
      // 强制刷新所有导航栏内部元素
      const allNavElements = document.querySelectorAll('#nav *, .arco-layout-header *, .hotCoin *')
      let updatedCount = 0
      allNavElements.forEach(element => {
        if (element.style) {
          element.style.color = isLight ? '#1a1a1a' : '#ffffff'
          // 清除可能的背景色
          if (element.style.backgroundColor && 
              (element.style.backgroundColor.includes('#ffffff') && !isLight ||
               element.style.backgroundColor.includes('#0a0c10') && isLight)) {
            element.style.backgroundColor = 'transparent'
          }
          updatedCount++
        }
      })
      
      console.log(`🎯 已强制更新 ${updatedCount} 个导航栏内部元素`)
      
      // 延迟处理Portal组件，避免冲突
      setTimeout(() => {
        this.forceRefreshPortalComponents(theme)
      }, 200)
      
      // 延迟执行最终清理，确保所有异步渲染完成
      setTimeout(() => {
        this.performFinalCleanup(theme)
      }, 500)
    },
    
    // 执行最终的深度清理
    performFinalCleanup(theme) {
      console.log(`🔍 开始最终深度清理 - ${theme === 'light' ? '浅色' : '深色'}主题`)
      
      if (theme === 'light') {
        // 查找所有可能遗漏的深色元素
        const suspiciousElements = document.querySelectorAll('*')
        let finalCleanCount = 0
        
        suspiciousElements.forEach(element => {
          const style = getComputedStyle(element)
          const rect = element.getBoundingClientRect()
          
          // 只处理可见的元素
          if (rect.width > 0 && rect.height > 0) {
            const bgColor = style.backgroundColor
            const bg = style.background
            
            // 更精确的深色检测
            if (this.isDarkColor(bgColor) || this.isDarkColor(bg)) {
              element.style.background = '#ffffff'
              element.style.backgroundColor = '#ffffff'
              element.style.backgroundImage = 'none'
              finalCleanCount++
              console.log(`🎯 修复遗漏的深色元素:`, element.className || element.tagName)
            }
          }
        })
        
        console.log(`🧹 最终清理完成：修复了 ${finalCleanCount} 个遗漏的深色元素`)
      }
    },
    
    // 检测是否为深色
    isDarkColor(colorString) {
      if (!colorString || colorString === 'transparent' || colorString === 'none') return false
      
      // 检测常见的深色值
      const darkPatterns = [
        '#0', '#1', '#2', '#3',
        'rgb(0,', 'rgb(1,', 'rgb(2,', 'rgb(3,', 'rgb(4,', 'rgb(5,',
        'rgba(0,', 'rgba(1,', 'rgba(2,', 'rgba(3,', 'rgba(4,', 'rgba(5,',
        'linear-gradient', 'radial-gradient'
      ]
      
      return darkPatterns.some(pattern => colorString.includes(pattern))
    },
    
    // 强制刷新Portal组件（挂载到body外面的组件）
    forceRefreshPortalComponents(theme) {
      console.log(`🌐 开始强制刷新Portal组件 - ${theme === 'light' ? '浅色' : '深色'}主题`)
      
      const isLight = theme === 'light'
      
      // 查找所有可能的Portal组件（挂载到body下面的）
      const portalSelectors = [
        '.arco-dropdown',
        '.arco-trigger-popup',
        '.arco-select-dropdown',
        '.arco-menu',
        '.arco-popover',
        '.arco-tooltip',
        '.user-menu',
        '.user-dropdown',
        '.profile-menu',
        '.account-menu',
        'div[class*="dropdown"]',
        'div[class*="popup"]',
        'div[class*="menu"]',
        'div[class*="popover"]'
      ]
      
      let portalCount = 0
      
      portalSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector)
        elements.forEach(element => {
          // 检查是否是Portal组件（父元素是body或者是fixed定位）
          const computedStyle = getComputedStyle(element)
          const isPortal = element.parentElement === document.body || 
                          computedStyle.position === 'fixed' || 
                          computedStyle.position === 'absolute'
          
          if (isPortal) {
            // 使用CSS主题变量，不强制设置背景色
            element.style.background = ''
            element.style.backgroundColor = ''
            element.style.backgroundImage = 'none'
            element.style.color = isLight ? '#1a1a1a' : '#ffffff'
            element.style.borderColor = isLight ? '#dee2e6' : 'rgba(255, 255, 255, 0.1)'
            
            // 处理子元素
            const childElements = element.querySelectorAll('*')
            childElements.forEach(child => {
              if (child.style) {
                child.style.color = isLight ? '#1a1a1a' : '#ffffff'
                // 清除可能的背景色
                if (child.style.backgroundColor && 
                    ((child.style.backgroundColor.includes('#ffffff') && !isLight) ||
                     (child.style.backgroundColor.includes('#0a0c10') && isLight))) {
                  child.style.backgroundColor = 'transparent'
                }
              }
            })
            
            portalCount++
            console.log(`🎯 已更新Portal组件:`, element.className)
          }
        })
      })
      
             // 简化CSS变量设置，减少冲突
       const htmlElement = document.documentElement
       if (isLight) {
         htmlElement.style.setProperty('--arco-color-bg-popup', '#ffffff')
         htmlElement.style.setProperty('--arco-color-text-1', '#1a1a1a')
       } else {
         // 使用CSS主题变量，不强制设置Arco Design弹窗背景
        // htmlElement.style.setProperty('--arco-color-bg-popup', 'var(--background-secondary)')
         htmlElement.style.setProperty('--arco-color-text-1', '#ffffff')
       }
      
              console.log(`🌐 Portal组件刷新完成：处理了 ${portalCount} 个组件`)
        
                      // 暂时禁用DOM监听器，主要依靠CSS处理
        // setTimeout(() => {
        //   this.setupPortalObserver(theme)
        // }, 1000)
      },
      
      // 设置Portal组件监听器 - 优化版本，防止冲突
      setupPortalObserver(theme) {
        // 如果已经有监听器，先断开
        if (this.portalObserver) {
          this.portalObserver.disconnect()
        }
        
        // 防抖处理，避免频繁触发
        let debounceTimer = null
        
        // 创建新的监听器
        this.portalObserver = new MutationObserver((mutations) => {
          // 清除之前的定时器
          if (debounceTimer) {
            clearTimeout(debounceTimer)
          }
          
          // 延迟执行，避免频繁触发
          debounceTimer = setTimeout(() => {
            mutations.forEach((mutation) => {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  const element = node
                  
                  // 检查是否是ArcoDesign的Portal组件
                  if (element.classList && (
                    element.classList.contains('arco-dropdown') ||
                    element.classList.contains('arco-trigger-popup') ||
                    element.classList.contains('arco-select-dropdown') ||
                    element.classList.contains('arco-menu') ||
                    element.classList.contains('arco-popover') ||
                    element.classList.contains('arco-tooltip')
                  )) {
                    // 检查是否已经应用过主题，避免重复处理
                    if (!element.hasAttribute('data-theme-applied')) {
                      const isLight = this.userTheme === 'light'
                                  // 使用CSS主题变量，不强制设置背景色
            element.style.background = ''
            element.style.backgroundColor = ''
                      element.style.color = isLight ? '#1a1a1a' : '#ffffff'
                      element.style.borderColor = isLight ? '#dee2e6' : 'rgba(255, 255, 255, 0.1)'
                      element.style.transition = 'none' // 禁用过渡，避免闪动
                      
                      // 标记已处理
                      element.setAttribute('data-theme-applied', 'true')
                      
                      console.log(`🎯 应用Portal主题:`, element.className)
                    }
                  }
                }
              })
            })
          }, 100) // 100ms防抖
        })
        
        // 开始监听body的子元素变化
        this.portalObserver.observe(document.body, {
          childList: true,
          subtree: false // 只监听直接子元素，减少触发频率
        })
        
        console.log('👁️ Portal组件监听器已启动（优化版本）')
      },
    
    formatPercent(percent) {
      if (!percent && percent !== 0) return '0.00%'
      const num = parseFloat(percent)
      if (isNaN(num)) return '0.00%'
      
      // 将0.05转换为5% (乘以100)
      const percentageRate = num * 100
      const sign = percentageRate >= 0 ? '+' : ''
      return `${sign}${Math.abs(percentageRate).toFixed(2)}%`
    },
    
    // 格式化百分比但不包含%符号（用于期权配置显示）
    formatPercentNoSymbol(percent) {
      if (!percent && percent !== 0) return '0.00'
      const num = parseFloat(percent)
      if (isNaN(num)) return '0.00'
      
      // 将0.05转换为5 (乘以100)
      const percentageRate = num * 100
      const sign = percentageRate >= 0 ? '+' : ''
      return `${sign}${Math.abs(percentageRate).toFixed(2)}`
    },
    
    formatVolume(volume) {
      if (!volume && volume !== 0) return '0'
      const num = parseFloat(volume)
      if (isNaN(num)) return '0'
      if (num >= 1000000) return `${this.truncateToDecimals(num / 1000000, 1).toString()}M`
      if (num >= 1000) return `${this.truncateToDecimals(num / 1000, 1).toString()}K`
      return Math.floor(num).toString()
    },
    
    // 强制刷新币种颜色
    forceRefreshColors() {
      console.log('🎨 刷新币种颜色类名...')
      
      // 等待DOM更新
      setTimeout(() => {
        const hotCoinItems = document.querySelectorAll('.hotCoin .item')
        
        hotCoinItems.forEach((item, index) => {
          const currency = this.currencies[index]
          if (!currency) return
          
          const changeSpan = item.querySelector('span:last-child')
          if (!changeSpan) return
          
          // 清除现有类名
          changeSpan.classList.remove('color-green', 'color-red')
          
          // 重新添加正确的类名
          if (currency.change_rate >= 0) {
            changeSpan.classList.add('color-green')
          } else {
            changeSpan.classList.add('color-red')
          }
        })
        console.log('✅ 币种颜色类名刷新完成')
      }, 100)
    },
    
    // 格式化倒计时显示
    formatCountdown(seconds) {
      const mins = Math.floor(seconds / 60)
      const secs = seconds % 60
      return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    },
    
    // 🚨🚨🚨 专门修复头部导航栏的方法 - 使用Vue主题状态
    performNavFix() {
      try {
        console.log('🚨🚨🚨 执行头部导航栏修复...')
        
        const nav = document.querySelector('#nav')
        const layoutHeader = document.querySelector('.arco-layout-header')
        
        // 使用Vue的主题状态，而不是直接读取DOM避免冲突
        const isDarkTheme = this.userTheme === 'dark'
        const transparentBg = isDarkTheme ? 'rgba(31, 31, 31, 0.8)' : 'rgba(255, 255, 255, 0.8)'
        
        if (nav) {
          // 不要移除所有样式，只设置背景相关属性
          nav.style.setProperty('background', transparentBg, 'important')
          nav.style.setProperty('background-color', transparentBg, 'important')
          nav.style.setProperty('backdrop-filter', 'blur(20px)', 'important')
          nav.style.setProperty('-webkit-backdrop-filter', 'blur(20px)', 'important')
          nav.style.setProperty('background-image', 'none', 'important')
          console.log('✅ #nav背景已设置为:', transparentBg)
        }
        
        if (layoutHeader) {
          // 不要移除所有样式，只设置背景相关属性
          layoutHeader.style.setProperty('background', 'transparent', 'important')
          layoutHeader.style.setProperty('background-color', 'transparent', 'important')
          console.log('✅ .arco-layout-header已设置为透明')
        }
        
      } catch (error) {
        console.error('❌ 头部导航栏修复出错:', error)
      }
    },

    // 🚨 防止主题闪动的方法
    preventThemeFlashing() {
      try {
        console.log('🚨 防止主题闪动：设置正确的初始样式')
        
        // 添加全局CSS样式来确保平滑过渡
        const existingStyle = document.getElementById('prevent-theme-flash')
        if (!existingStyle) {
          const style = document.createElement('style')
          style.id = 'prevent-theme-flash'
          style.innerHTML = `
            /* 🚨 防闪动：强制初始状态为浅色主题 */
            .futures.prevent-flash {
              background-color: #ffffff !important;
              background: #ffffff !important;
            }
            
            .futures.prevent-flash .arco-layout-header,
            .futures.prevent-flash #nav {
              background: rgba(255, 255, 255, 0.8) !important;
              backdrop-filter: blur(20px) !important;
            }
            
                         .futures.prevent-flash .content_head {
               background: transparent !important;
               background-color: transparent !important;
             }
             
             .futures.prevent-flash .hotCoin {
               background: #f6f6f6 !important;
               background-color: #f6f6f6 !important;
               border: none !important;
             }
             
             [data-theme="dark"] .futures.prevent-flash .hotCoin {
               background: #2a2a2a !important;
               background-color: #2a2a2a !important;
             }
            

            
            /* 只有在主题完全加载后才应用主题变量 */
            .futures:not(.prevent-flash), .futures:not(.prevent-flash) * {
              transition: background-color 0.2s ease, color 0.2s ease, background 0.2s ease !important;
            }
            
                         /* 深色主题覆盖（仅在主题确定后应用） */
             [data-theme="dark"] .futures:not(.prevent-flash) {
               background-color: var(--background-primary, #1a1a1a) !important;
             }
             
             [data-theme="dark"] .futures:not(.prevent-flash) .arco-layout-header,
             [data-theme="dark"] .futures:not(.prevent-flash) #nav {
               background: var(--home-nav-transparent-bg, rgba(31, 31, 31, 0.8)) !important;
             }
             
             [data-theme="dark"] .futures:not(.prevent-flash) .hotCoin {
               background: var(--background-secondary, #2a2a2a) !important;
             }
             
             [data-theme="light"] .futures:not(.prevent-flash) .hotCoin {
               background: var(--background-secondary, #f6f6f6) !important;
             }
          `
          document.head.appendChild(style)
          console.log('✅ 防闪动样式已应用')
        }
        
      } catch (error) {
        console.error('❌ 防止主题闪动出错:', error)
      }
    },

    // 🔧 简单背景色修复方法
    performBackgroundFix() {
      try {
        console.log('🔧 执行期权页面背景色修复...')
        
        // 添加loaded类来触发CSS规则
        document.documentElement.classList.add('loaded')
        document.body.classList.add('loaded')
        
        // 简单直接地设置主要容器背景色
        const futures = document.querySelector('.futures')
        if (futures) {
          futures.style.setProperty('background', 'var(--background-primary)', 'important')
          futures.style.setProperty('background-color', 'var(--background-primary)', 'important')
          futures.style.setProperty('background-image', 'none', 'important')
        }
        
        const futuresContent = document.querySelector('.futures_content')
        if (futuresContent) {
          futuresContent.style.setProperty('background', 'var(--background-secondary)', 'important')
          futuresContent.style.setProperty('background-color', 'var(--background-secondary)', 'important')
          futuresContent.style.setProperty('background-image', 'none', 'important')
        }
        

        
        // 🚨🚨🚨 强力修复头部导航栏背景，确保半透明效果 🚨🚨🚨
        const nav = document.querySelector('#nav')
        const layoutHeader = document.querySelector('.arco-layout-header')
        
        if (nav) {
          // 删除所有内联样式
          nav.removeAttribute('style')
          
          // 强制设置半透明背景 - 使用Vue主题状态
          const isDarkTheme = this.userTheme === 'dark'
          const transparentBg = isDarkTheme ? 'rgba(31, 31, 31, 0.8)' : 'rgba(255, 255, 255, 0.8)'
          
          nav.style.setProperty('background', transparentBg, 'important')
          nav.style.setProperty('background-color', transparentBg, 'important')
          nav.style.setProperty('backdrop-filter', 'blur(20px)', 'important')
          nav.style.setProperty('-webkit-backdrop-filter', 'blur(20px)', 'important')
          nav.style.setProperty('background-image', 'none', 'important')
          nav.style.setProperty('opacity', '1', 'important')
          
          console.log('🚨🚨🚨 已强制设置#nav为半透明背景，与合约页面一致')
        }
        
        if (layoutHeader) {
          // 删除所有内联样式
          layoutHeader.removeAttribute('style')
          
          // 强制设置容器为透明
          layoutHeader.style.setProperty('background', 'transparent', 'important')
          layoutHeader.style.setProperty('background-color', 'transparent', 'important')
          layoutHeader.style.setProperty('background-image', 'none', 'important')
          layoutHeader.style.setProperty('backdrop-filter', 'none', 'important')
          layoutHeader.style.setProperty('-webkit-backdrop-filter', 'none', 'important')
          
          console.log('🚨🚨🚨 已强制设置.arco-layout-header为透明背景')
        }
        
        console.log('🚨🚨🚨 期权页面头部导航栏强力修复完成，现在应该有半透明效果')
        

        
        // 🔧 启动背景色监控器，确保持续修复
        this.startBackgroundMonitor()
        
        console.log('✅ 期权页面背景色修复完成')
        console.log('🎯 期权交易面板现在应该与合约页面保持完全一致的背景色')
        console.log('🚨🚨🚨 头部导航栏已强力修复，强制应用半透明背景')
        console.log('🚨🚨🚨 现在期权页面头部导航栏应该与合约页面完全一致')
        console.log('🚨🚨🚨 如果仍然不一致，请强制刷新浏览器 (Ctrl+F5)')
        
        // 🔍 Debug: 输出当前样式状态
        const debugNav = document.querySelector('#nav')
        const debugLayoutHeader = document.querySelector('.arco-layout-header')
        
        if (debugNav) {
          console.log('🔍 #nav当前内联样式:', debugNav.getAttribute('style'))
          console.log('🔍 #nav背景:', getComputedStyle(debugNav).background)
          console.log('🔍 #nav backdrop-filter:', getComputedStyle(debugNav).backdropFilter)
        }
        
        if (debugLayoutHeader) {
          console.log('🔍 .arco-layout-header当前内联样式:', debugLayoutHeader.getAttribute('style'))
          console.log('🔍 .arco-layout-header背景:', getComputedStyle(debugLayoutHeader).background)
        }
      } catch (error) {
        console.error('❌ 背景色修复出错:', error)
      }
    },
    
    // 🔧 背景色监控器 - 持续确保正确的背景色
    startBackgroundMonitor() {
      if (this.backgroundMonitorInterval) {
        clearInterval(this.backgroundMonitorInterval)
      }
      
      // 减少监控频率，从2秒改为5秒，避免频繁检查导致冲突
      this.backgroundMonitorInterval = setInterval(() => {
        const futures = document.querySelector('.futures')
        const futuresContent = document.querySelector('.futures_content')
        const optionPanel = document.querySelector('.option-trading-panel')
        const nav = document.querySelector('#nav')
        const layoutHeader = document.querySelector('.arco-layout-header')
        
        if (futures) {
          const computedStyle = getComputedStyle(futures)
          if (computedStyle.backgroundColor === 'rgb(10, 12, 16)' || 
              computedStyle.backgroundColor === 'rgb(26, 26, 26)' ||
              futures.style.background.includes('#0a0c10') ||
              futures.style.background.includes('#1a1a1a')) {
            console.log('🔧 检测到主容器深色背景，立即修复...')
            futures.style.setProperty('background', 'var(--background-primary)', 'important')
            futures.style.setProperty('background-color', 'var(--background-primary)', 'important')
            futures.style.setProperty('background-image', 'none', 'important')
          }
        }
        
        if (futuresContent) {
          const computedStyle = getComputedStyle(futuresContent)
          if (computedStyle.backgroundColor === 'rgb(10, 12, 16)' || 
              computedStyle.backgroundColor === 'rgb(26, 26, 26)') {
            console.log('🔧 检测到内容区域深色背景，立即修复...')
            futuresContent.style.setProperty('background', 'var(--background-secondary)', 'important')
            futuresContent.style.setProperty('background-color', 'var(--background-secondary)', 'important')
            futuresContent.style.setProperty('background-image', 'none', 'important')
          }
        }
        

        
        if (nav) {
          // 检查并修复背景 - 使用Vue主题状态
          const computedStyle = getComputedStyle(nav)
          const isDarkTheme = this.userTheme === 'dark'
          const expectedBg = isDarkTheme ? 'rgba(31, 31, 31, 0.8)' : 'rgba(255, 255, 255, 0.8)'
          
          if (!computedStyle.backdropFilter || computedStyle.backdropFilter === 'none' ||
              !computedStyle.backgroundColor.includes('0.8')) {
            console.log('🔧 检测到#nav背景异常，修复为半透明...')
            // 不要移除所有样式，只设置背景属性
            nav.style.setProperty('background', expectedBg, 'important')
            nav.style.setProperty('background-color', expectedBg, 'important')
            nav.style.setProperty('backdrop-filter', 'blur(20px)', 'important')
            nav.style.setProperty('-webkit-backdrop-filter', 'blur(20px)', 'important')
          }
        }
        
        if (layoutHeader) {
          // 强制检查并修复容器背景
          const computedStyle = getComputedStyle(layoutHeader)
          if (computedStyle.backgroundColor !== 'rgba(0, 0, 0, 0)' && 
              computedStyle.backgroundColor !== 'transparent') {
            console.log('🚨🚨🚨 检测到.arco-layout-header背景异常，立即强力修复为透明...')
            layoutHeader.removeAttribute('style')
            layoutHeader.style.setProperty('background', 'transparent', 'important')
            layoutHeader.style.setProperty('background-color', 'transparent', 'important')
          }
        }
              }, 5000) // 每5秒检查一次，减少频率避免冲突
    },
    
    // 启动交易倒计时
    startTradeCountdown() {
      // 清除现有定时器
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval)
      }
      
      // 根据当前选择的期权配置设置倒计时
      if (this.currentDepConfig && this.currentDepConfig.interval) {
        this.tradeCountdown = this.currentDepConfig.interval * 60 // 转换为秒
      } else {
        this.tradeCountdown = 60 // 默认1分钟
      }
      
      // 启动倒计时
      this.countdownInterval = setInterval(() => {
        if (this.tradeCountdown > 0) {
          this.tradeCountdown--
        } else {
          // 倒计时结束，重置倒计时
          this.tradeCountdown = this.currentDepConfig ? this.currentDepConfig.interval * 60 : 60
        }
      }, 1000)
      
      console.log('🕒 交易倒计时已启动:', this.tradeCountdown, '秒')
    },
    
    // 主题检测和强制样式应用
    initThemeWatcher() {
      // 🚨 禁用定期主题检查，避免频繁切换主题
      // this.checkTheme()
      
            // 🚨 禁用定期检查，避免主题闪动
      // this.themeWatcher = setInterval(() => {
      //   this.checkTheme()
      //   this.forceFixUserMenuTheme() // 每秒强制修复用户菜单主题
      // }, 1000)
    },
    
    // 专门针对用户菜单主题修复的函数
    forceFixUserMenuTheme() {
      const isLight = this.userTheme === 'light'
      
      // 查找所有可能的用户菜单元素，使用更广泛的选择器
      const menuSelectors = [
        // ArcoDesign下拉菜单
        '.arco-dropdown',
        '.arco-trigger-popup', 
        '.arco-select-dropdown',
        '.arco-menu',
        '.arco-popover',
        '.arco-tooltip',
        
        // 可能的用户菜单类名
        '.user-menu',
        '.user-dropdown', 
        '.profile-menu',
        '.account-menu',
        '.user-info-dropdown',
        '.header-user-menu',
        
        // 通用下拉菜单类名
        'div[class*="dropdown"]',
        'div[class*="popup"]', 
        'div[class*="menu"]',
        'div[class*="popover"]',
        'div[class*="user"]',
        
        // body下的Portal组件
        'body > div[class*="arco"]',
        'body > .arco-dropdown',
        'body > .arco-trigger-popup',
        'body > .arco-menu'
      ]
      
      let fixedCount = 0
      
      menuSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector)
        elements.forEach(element => {
          // 检查是否是Portal组件或者可见的菜单
          const rect = element.getBoundingClientRect()
          const isVisible = rect.width > 0 && rect.height > 0
          
          if (isVisible || element.parentElement === document.body) {
            // 使用CSS主题变量，不强制设置背景色
            element.style.background = ''
            element.style.backgroundColor = ''
            element.style.backgroundImage = 'none'
            element.style.color = isLight ? '#1a1a1a' : '#ffffff'
            element.style.borderColor = isLight ? '#dee2e6' : 'rgba(255, 255, 255, 0.1)'
            element.style.transition = 'none' // 防止闪动
            element.style.animation = 'none'
            
            // 处理所有子元素
            const children = element.querySelectorAll('*')
            children.forEach(child => {
              if (child.style) {
                child.style.color = isLight ? '#1a1a1a' : '#ffffff'
                child.style.transition = 'none'
                child.style.animation = 'none'
              }
            })
            
            fixedCount++
          }
        })
      })
      
      if (fixedCount > 0) {
        console.log(`🎯 强制修复了 ${fixedCount} 个用户菜单元素的主题`)
      }
      
      // 设置全局CSS变量，确保ArcoDesign组件使用正确的主题
      const root = document.documentElement
      if (isLight) {
        root.style.setProperty('--arco-color-bg-popup', '#ffffff')
        root.style.setProperty('--arco-color-text-1', '#1a1a1a')
        root.style.setProperty('--arco-color-border', '#dee2e6')
        root.style.setProperty('--arco-color-bg-2', '#f8f9fa')
        root.style.setProperty('--arco-color-fill-2', '#f8f9fa')
      } else {
        // 使用CSS主题变量，不强制设置Arco Design弹窗背景
        // root.style.setProperty('--arco-color-bg-popup', 'var(--background-secondary)')
        root.style.setProperty('--arco-color-text-1', '#ffffff')
        root.style.setProperty('--arco-color-border', 'rgba(255, 255, 255, 0.1)')
        root.style.setProperty('--arco-color-bg-2', 'rgba(255, 255, 255, 0.05)')
        root.style.setProperty('--arco-color-fill-2', 'rgba(255, 255, 255, 0.05)')
      }
    },
    
    forceContentHeadTheme() {
      // 根据主题强制设置背景色
      const isDark = this.userTheme === 'dark'
              const bgColor = 'transparent' // 使用透明背景让CSS主题变量生效
      const textColor = isDark ? '#ffffff' : '#000000'
      
      console.log('🔥 执行主题背景更新...', isDark ? '深色模式' : '浅色模式')
      
      // 方法1：直接设置所有相关元素的style
      const selectors = [
        '.content_head',
        '.content_head_left', 
        '.content_head_right',
        '.contract-coin-selector',
        '.main-price-display',
        '.stats-info',
        '.stat-item'
      ]
      
      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector)
        elements.forEach(element => {
          element.style.background = bgColor
          element.style.backgroundColor = bgColor
          element.style.backgroundImage = 'none'
          element.style.color = textColor
          if (selector === '.contract-coin-selector') {
            element.style.border = isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #d9d9d9'
          }
          if (selector === '.content_head') {
            element.style.borderBottom = isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid #e8e8e8'
          }
          console.log(`🎯 强制设置 ${selector} 为${isDark ? '深色' : '浅色'}背景`)
        })
      })
      
      // 强制优化所有文字颜色
      this.optimizeTextColors()
      
      // 方法2：添加内联样式覆盖
      const contentHead = document.querySelector('.content_head')
      if (contentHead) {
        const borderColor = isDark ? 'rgba(255, 255, 255, 0.1)' : '#e8e8e8'
        contentHead.setAttribute('style', 'background: ' + bgColor + ' !important; background-color: ' + bgColor + ' !important; border-bottom: 1px solid ' + borderColor + ' !important;')
        console.log('🚀 使用内联样式强制覆盖content_head为' + (isDark ? '深色' : '浅色'))
      }
      
      // 移除币种选择器操作 - 避免跳动，完全依赖CSS
      
              // 移除所有修复方法 - 完全依赖CSS
    },
    
    optimizeTextColors() {
      console.log('🎨 强制优化文字颜色对比度...')
      
      const isDarkTheme = this.userTheme === 'dark'
      
      // 1. 优化基础文字颜色 - 根据主题设置
      const textSelectors = isDarkTheme ? {
        '.color-black': '#ffffff',
        '.color-gray': '#8b949e', 
        '.color-white': '#ffffff',
        '.font-12': '#ffffff',
        '.font-14': '#ffffff',
        '.font-16': '#ffffff'
      } : {
        '.color-black': '#1a1a1a',
        '.color-gray': '#666666', 
        '.color-white': '#1a1a1a',
        '.font-12': '#666666',
        '.font-14': '#333333',
        '.font-16': '#1a1a1a'
      }
      
      Object.entries(textSelectors).forEach(([selector, color]) => {
        const elements = document.querySelectorAll(selector)
        elements.forEach(element => {
          element.style.color = color
          element.style.fontWeight = '500'
        })
      })
      
      // 移除币种选择器特殊处理 - 依赖CSS
      
      // 3. 优化期权配置区域
      const configElements = document.querySelectorAll('.config-header span, .config-item span, .order-header span, .order-item span')
      configElements.forEach(element => {
        element.style.color = '#1a1a1a'
        element.style.fontWeight = '500'
      })
      
      // 4. 优化价格显示
      const priceElements = document.querySelectorAll('.main-price-display .price-value')
      priceElements.forEach(element => {
        element.style.color = '#1a1a1a'
        element.style.fontWeight = '600'
      })
      
      const statLabels = document.querySelectorAll('.stats-info .stat-label')
      statLabels.forEach(element => {
        element.style.color = '#666666'
        element.style.fontWeight = '400'
      })
      
      const statValues = document.querySelectorAll('.stats-info .stat-value')
      statValues.forEach(element => {
        element.style.color = '#1a1a1a'
        element.style.fontWeight = '500'
      })
      
      // 5. 优化交易面板文字
      const tradingLabels = document.querySelectorAll('.content_main_right label, .trading-form label, .form-item label')
      tradingLabels.forEach(element => {
        element.style.color = '#333333'
        element.style.fontWeight = '500'
      })
      
      // 6. 优化输入框
      const inputs = document.querySelectorAll('.arco-input')
      inputs.forEach(element => {
        element.style.color = '#1a1a1a'
      })
      
      // 7. 优化按钮
      const buttons = document.querySelectorAll('.arco-btn:not(.arco-btn-primary)')
      buttons.forEach(element => {
        element.style.color = '#333333'
        element.style.fontWeight = '500'
      })
      
      // 8. 优化标签页
      const tabs = document.querySelectorAll('.arco-tabs-tab')
      tabs.forEach(element => {
        if (!element.classList.contains('arco-tabs-tab-active')) {
          element.style.color = '#666666'
        }
      })
      
      const activeTabs = document.querySelectorAll('.arco-tabs-tab-active')
      activeTabs.forEach(element => {
        element.style.color = '#1890ff'
        element.style.fontWeight = '600'
      })
      
            console.log('✅ 文字颜色优化完成')
      },
      
            // 移除所有修复方法，完全依赖CSS
      // 不再进行任何JavaScript干预
      

     
      checkTheme() {
      const html = document.documentElement
      const body = document.body
      // 简化主题检测逻辑 - 基于Vuex状态
      const isDarkMode = this.userTheme === 'dark'
      
      console.log('🔍 主题检测结果:', {
        userTheme: this.userTheme,
        finalResult: isDarkMode ? 'DARK' : 'LIGHT'
      })
      
      // 🚨 修复：根据真实主题状态设置类名，不强制设置
      html.classList.toggle('light', !isDarkMode)
      body.classList.toggle('light', !isDarkMode)
      html.classList.toggle('dark', isDarkMode)
      body.classList.toggle('dark', isDarkMode)
      html.setAttribute('data-theme', this.userTheme)
      body.setAttribute('data-theme', this.userTheme)
      
      if (!isDarkMode) {
        
        // 强制修改K线图canvas的内联样式为白天模式
        this.updateKlineCanvasStyle('light')
        
        // 强制设置content_head为白色背景
        this.forceContentHeadTheme()
        
        // 强制优化文字颜色
        this.optimizeTextColors()
        
        // 移除币种选择器修复 - 完全依赖CSS
        
        console.log('🌞 强制应用白天模式样式')
      } else {
        // 🚨 修复：不要强制设置深色主题，使用当前的主题状态
        const currentTheme = this.userTheme || 'light'
        html.classList.toggle('dark', currentTheme === 'dark')
        body.classList.toggle('dark', currentTheme === 'dark')
        html.classList.toggle('light', currentTheme === 'light')
        body.classList.toggle('light', currentTheme === 'light')
        html.setAttribute('data-theme', currentTheme)
        body.setAttribute('data-theme', currentTheme)
        
        // 恢复K线图canvas的深色模式样式
        this.updateKlineCanvasStyle('dark')
        
        // 强制设置content_head为深色背景
        this.forceContentHeadTheme()
        
        // 强制优化文字颜色
        this.optimizeTextColors()
        
        console.log('🌙 强制应用深色模式样式 - 已修复!')
      }
    },
    
    // 更新K线图主题
    updateKlineCanvasStyle(theme) {
      this.applyKlineTheme(theme)
      
      // 同时强制更新所有可能的容器
      // 强制刷新所有容器样式，让CSS主题选择器生效
      const containers = document.querySelectorAll('.block_kline, .kline_box, .kline-container, .hotCoin, .block_list, .futures_content, .content_main_right, .contract-dropdown, .content_head, .arco-input-wrapper, .arco-select, .amount-input, #nav, .arco-layout-header, .arco-layout, .arco-layout-content, .arco-card, .arco-card-body, .trade-panel, .trading-panel, .right-panel, .side-panel')
      containers.forEach(container => {
        // 添加过渡效果，其他样式交给CSS主题选择器处理
        container.style.transition = 'all 0.3s ease'
        // 强制触发重绘
        container.offsetHeight
        console.log(`🎯 容器${container.className || container.id}已设置主题过渡效果`)
      })
      
      // 终极清理：找到所有可能的深色元素
      const allElements = document.querySelectorAll('*')
      let ultimateCleanCount = 0
      allElements.forEach(element => {
        const computedStyle = getComputedStyle(element)
        const bgColor = computedStyle.backgroundColor
        const bg = computedStyle.background
        
        // 检测深色背景
        if (theme === 'light' && (
          bgColor.includes('rgb(0,') || bgColor.includes('rgb(1,') || bgColor.includes('rgb(2,') || bgColor.includes('rgb(3,') ||
          bgColor.includes('#0') || bgColor.includes('#1') || bgColor.includes('#2') || bgColor.includes('#3') ||
          bg.includes('rgb(0,') || bg.includes('rgb(1,') || bg.includes('rgb(2,') || bg.includes('rgb(3,') ||
          bg.includes('#0') || bg.includes('#1') || bg.includes('#2') || bg.includes('#3')
        )) {
          element.style.background = '#ffffff'
          element.style.backgroundColor = '#ffffff'
          element.style.backgroundImage = 'none'
          ultimateCleanCount++
        }
      })
      
      console.log(`🧹 终极清理：已强制修复 ${ultimateCleanCount} 个深色元素`)
      
      // 强制刷新ArcoDesign组件
      const arcoComponents = document.querySelectorAll('.arco-input-wrapper, .arco-select, .arco-layout, .arco-dropdown')
      arcoComponents.forEach(component => {
        // 强制重新渲染组件
        const display = component.style.display
        component.style.display = 'none'
        component.offsetHeight // 触发重排
        component.style.display = display
      })
      
      // 超强力清理：直接清除所有深色内联样式
      if (theme === 'light') {
        this.forceRemoveDarkStyles()
      } else {
        this.forceApplyDarkStyles()
      }
      
      // 设置K线图表主题
      this.$nextTick(() => {
        this.applyKlineTheme(theme)
        
        // 立即强制刷新导航栏主题
        this.forceRefreshNavigation(theme)
      })
      
      console.log(`🎨 已强制刷新${theme === 'light' ? '浅色' : '深色'}主题`)
      
      // 处理其他区域，移除币种选择器避免跳动
      const contentHeadElements = document.querySelectorAll('.content_head, .content_head_left, .content_head_right, .main-price-display, .stats-info')
      contentHeadElements.forEach(element => {
        const isDarkTheme = this.userTheme === 'dark'
        const bgColor = 'transparent' // 使用透明背景让CSS主题变量生效
        const textColor = isDarkTheme ? '#ffffff' : '#333333'
        
        element.style.background = bgColor
        element.style.backgroundColor = bgColor
        element.style.color = textColor
        console.log('🎯 强制更新content_head子元素为' + (isDarkTheme ? '深色' : '浅色') + ':', element.className)
      })
      
      // 特别处理ArcoDesign的下拉框内容
      const dropdownContents = document.querySelectorAll('.arco-dropdown-content, .arco-dropdown-content .contract-dropdown')
      dropdownContents.forEach(content => {
        const isDarkMode = this.userTheme === 'dark'
        const bgColor = 'transparent' // 使用透明背景让CSS主题变量生效
        const borderColor = isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#d9d9d9'
        
        content.style.background = bgColor
        content.style.border = '1px solid ' + borderColor
        content.style.boxShadow = isDarkMode ? '0 4px 15px rgba(0, 0, 0, 0.3)' : '0 4px 15px rgba(0, 0, 0, 0.1)'
      })
    }
  },
  
  // 监听器
  watch: {
    '$i18n.locale'(newLocale, oldLocale) {
      // 语言变化时重新创建K线图（因为locale只能在创建时设置）
      if (newLocale !== oldLocale && klineCharts) {
        console.log('🌐 期权页面语言变化:', { oldLocale, newLocale });
        const klineLocale = this.getKlineLocale();
        
        // KLineChartPro已内置zh-CN和en-US语言包，无需手动加载
        // 语言切换时重新创建图表即可，库会自动使用正确的语言包
        console.log('🔧 K线图语言已更新:', klineLocale);
        
        // KLineChartPro的locale只能在创建时设置，语言切换时需要重新创建图表
        this.$nextTick(async () => {
          if (klineCharts) {
            try {
              console.log('🔄 语言变化，重新创建K线图以应用新语言...');
              // 销毁旧图表
              invalidateKlineSession()
              klineCharts.destroy();
              klineCharts = false;
              // 无需等待，库已内置语言包
              // 重新创建图表
              await this.createCharts();
              console.log('✅ 期权K线图语言更新成功:', klineLocale);
            } catch (error) {
              console.error('❌ 期权K线图语言更新失败:', error);
            }
          }
        });
      }
      // 语言切换时强制重新渲染
      this.$forceUpdate();
    },
    // 监听主题变化，立即修复所有Portal组件
    userTheme: {
      handler(newTheme, oldTheme) {
        // 🚨 关键修复：只在真正切换主题时执行，避免初始化时的错误触发
        if (newTheme !== oldTheme && oldTheme !== undefined) {
          console.log(`🔄 主题从 ${oldTheme} 切换到 ${newTheme}，立即修复Portal组件`)
          
          // 立即执行修复，减少频繁调用避免闪动
          this.$nextTick(() => {
            this.forceFixUserMenuTheme()
            this.forceRefreshPortalComponents(newTheme)
            this.forceRefreshNavigation(newTheme)
            
            // 刷新K线图主题
            if (klineCharts) {
              console.log('🔄 主题变化，刷新期权K线图...')
              this.applyKlineTheme(newTheme)
            }
            
            // 延迟执行导航栏修复，只执行一次
            setTimeout(() => {
              this.performNavFix()  // 只在主题切换时执行一次
              this.forceFixUserMenuTheme()
              this.performFinalCleanup(newTheme)
            }, 300)
          })
        } else if (oldTheme === undefined) {
          // 初始化时只输出日志，不执行任何主题修改操作
          console.log(`📱 期权页面初始化，当前主题: ${newTheme}`)
        }
      },
      immediate: true // 组件初始化时也执行一次
    },
    

    

  }
}
</script>

<style lang="scss">
// 期权样式基础 - 强制使用主题变量
.futures {
  min-height: 100vh !important;
  background: var(--background-primary) !important;
  background-color: var(--background-primary) !important;
  background-image: none !important;
  
  .futures_content {
    width: 100% !important;
    height: auto !important;
    padding: 0 8px !important;
    box-sizing: border-box !important;
    background: var(--background-secondary) !important;
    background-color: var(--background-secondary) !important;
    background-image: none !important;
    
    // 热门币种条
    .hotCoin {
      width: 100%;
      height: 28px;
      padding: 2px 16px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      color: var(--content-primary);
      background: transparent !important;
      border: none !important;
      overflow: hidden;
      position: relative;
      
      img {
        width: 20px;
        height: 20px;
        margin-right: 15px;
      }
      
      .item {
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        height: 24px;
        font-size: 11px;
        margin-right: 20px;
        cursor: pointer;
        padding: 0;
        box-sizing: border-box;
        background: transparent;
        transition: opacity 0.2s ease;
        line-height: 1;
        white-space: nowrap;
        flex-shrink: 0;

        &:hover {
          opacity: 0.8;
        }
        
        span {
          line-height: 1;
          display: inline;
          vertical-align: baseline;
          font-size: 11px;
        }

        .coin-name {
          margin-right: 4px;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 400;
          font-size: 11px;
        }

        .coin-price {
          margin-right: 2px;
          font-weight: 500;
          font-size: 11px;
        }

        .coin-change {
          font-weight: 500;
          font-size: 10px;
          margin-left: 1px;
        }
        
        /* 涨跌颜色优化 - 适配深色背景 */
        .coin-price.color-green,
        .coin-change.color-green {
          color: #00ff88 !important;
        }

        .coin-price.color-red,
        .coin-change.color-red {
          color: #ff4444 !important;
        }

        .coin-price.color-gray,
        .coin-change.color-gray {
          color: rgba(255, 255, 255, 0.6) !important;
        }
      }
    }
    
    // 币种选择和价格信息条
    .content_head {
      display: flex;
      padding: 20px;
      background: var(--background-primary);
      border-bottom: 1px solid var(--border-strength-100);
      
      // 真正的合约风格币种选择器
      .content_head_left {
        .contract-coin-selector {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          background: linear-gradient(135deg, var(--background-primary) 0%, var(--background-secondary) 100%);
          border: 1px solid var(--border-strength-100);
          border-radius: 8px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
          position: relative;
          overflow: hidden;
          
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, rgba(0, 168, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
            opacity: 0;
            transition: opacity 0.3s ease;
          }
          
          &:hover {
            border-color: #00a8ff;
            box-shadow: 0 4px 16px rgba(0, 168, 255, 0.3) !important;
            transform: translateY(-1px);
            
            &::before {
              opacity: 1;
            }
          }
          
          .coin-logo {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            border: 2px solid var(--border-strength-100);
            background: var(--background-tertiary-1);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
            z-index: 2;
            position: relative;
          }
          
          .coin-pair {
            font-size: 16px;
            font-weight: 700;
            color: #ffffff;
            letter-spacing: 0.5px;
            z-index: 2;
            position: relative;
            background: linear-gradient(135deg, var(--content-primary) 0%, var(--content-secondary) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }
          
          .arrow-down {
            color: #999999;
            transition: all 0.3s ease;
            z-index: 2;
            position: relative;
          }
          
          &:hover .arrow-down {
            color: #00a8ff;
            transform: rotate(180deg);
          }
        }
        
        // ArcoDesign下拉菜单样式覆盖 - 主题适配版本
        :deep(.arco-dropdown-content) {
          .contract-dropdown {
            width: 320px !important;
            min-width: 320px !important;
            border-radius: 12px !important;
            overflow: hidden !important;
            padding: 16px !important;
            backdrop-filter: blur(10px) !important;
            
            .arco-input-wrapper {
              border-radius: 8px !important;
              margin-bottom: 16px !important;
              position: relative !important;
              overflow: hidden !important;
              
              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(90deg, transparent 0%, rgba(0, 168, 255, 0.1) 50%, transparent 100%);
                transform: translateX(-100%);
                transition: transform 0.6s ease;
              }
              
              .arco-input {
                background: transparent !important;
                color: #ffffff !important;
                font-size: 14px !important;
                height: 40px !important;
                font-weight: 500 !important;
                
                &::placeholder {
                  color: #888888 !important;
                  font-weight: 400 !important;
                }
              }
              
              &:focus-within {
                border-color: #00a8ff !important;
                box-shadow: 0 0 0 2px rgba(0, 168, 255, 0.2) !important, 0 4px 12px rgba(0, 168, 255, 0.1) !important;
                
                &::before {
                  transform: translateX(100%);
                }
              }
              
              .arco-input-prefix {
                color: #00a8ff !important;
              }
            }
            
            .coin-list {
              .arco-scrollbar-container {
                max-height: 280px !important;
              }
              
              .arco-scrollbar-track-bar {
                background: rgba(0, 168, 255, 0.2) !important;
                border-radius: 3px !important;
              }
              
              .coin-item {
                display: flex !important;
                align-items: center !important;
                gap: 14px !important;
                padding: 12px 10px !important;
                cursor: pointer !important;
                transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1) !important;
                border-radius: 8px !important;
                margin-bottom: 2px !important;
                position: relative !important;
                overflow: hidden !important;
                
                &::before {
                  content: '';
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  background: linear-gradient(135deg, rgba(0, 168, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
                  opacity: 0;
                  transition: all 0.3s ease;
                }
                
                &:hover {
                  transform: translateX(4px) !important;
                  
                  &::before {
                    opacity: 1;
                  }
                  
                  .item-logo {
                    transform: scale(1.1) !important;
                    box-shadow: 0 4px 16px rgba(0, 168, 255, 0.3) !important;
                  }
                  
                  .item-pair {
                    color: #00a8ff !important;
                  }
                }
                
                .item-logo {
                  width: 28px !important;
                  height: 28px !important;
                  border-radius: 50% !important;
                  flex-shrink: 0 !important;
                  border: 2px solid rgba(255, 255, 255, 0.1) !important;
                  background: var(--background-primary) !important;
                  transition: all 0.3s ease !important;
                  z-index: 2 !important;
                  position: relative !important;
                }
                
                .item-pair {
                  font-size: 16px !important;
                  font-weight: 600 !important;
                  color: #ffffff !important;
                  flex: 1 !important;
                  letter-spacing: 0.5px !important;
                  transition: all 0.3s ease !important;
                  z-index: 2 !important;
                  position: relative !important;
                }
              }
            }
          }
        }
      }
      
      
              .content_head_right {
          flex: 1;
          margin-left: 30px;
          display: flex;
          align-items: center;
          gap: 30px;
          
          // 主价格显示 - 仿合约风格
          .main-price-display {
            display: flex;
            flex-direction: column;
            gap: 2px;
            
            .price-value {
              font-size: 32px;
              font-weight: 700;
              font-family: 'DIN', monospace;
              line-height: 1;
              
              &.text-green {
                color: #00ff88;
              }
              
              &.text-red {
                color: #ff4757;
              }
            }
            
            .price-change {
              font-size: 16px;
              font-weight: 600;
              line-height: 1;
              
              &.text-green {
                color: #00ff88;
              }
              
              &.text-red {
                color: #ff4757;
              }
            }
          }
          
          // 统计信息
          .stats-info {
            display: flex;
            align-items: center;
            gap: 30px;
            
            .stat-item {
              display: flex;
              flex-direction: column;
              gap: 4px;
              
              .stat-label {
                font-size: 12px;
                color: #999999;
                font-weight: 500;
              }
              
              .stat-value {
                font-size: 14px;
                color: #ffffff;
                font-weight: 600;
                font-family: 'DIN', monospace;
                
                &.text-green {
                  color: #00ff88;
                }
                
                &.text-red {
                  color: #ff4757;
                }
              }
            }
          }
        
      }
    }
    
    // 主要内容区域 - 三列布局设计
    .content_main {
      display: flex;
      height: calc(100vh - 160px);
      gap: 15px;
      
      // 左侧：K线图 (70%宽度)
      .content_main_left {
        flex: 7 !important;
        min-width: 500px;
          
          .block_kline {
          height: 100%;
            border-radius: 10px;
            overflow: hidden;
            
            // 深色主题
            [data-theme="dark"] &,
            html[data-theme="dark"] & {
              background: #2a2a2a;
              border: 1px solid #3a3a3a;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
            }
            
            // 浅色主题
            [data-theme="light"] &,
            html[data-theme="light"] & {
              background: #ffffff;
              border: 1px solid #e8e8e8;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            }
            
            .kline_box {
              position: relative;
              height: 100%;
              padding: 15px;
              
              /* 🔥 确保K线图容器背景透明，让K线图表自己控制背景 */
              .chartBox,
              #optionChartBox {
                width: 100% !important;
                height: 100% !important;
                background: transparent !important;
                position: relative;
                z-index: 1;
                
                /* 确保K线图库的容器样式正确 */
                :deep(.klinecharts-pro) {
                  background: transparent !important;
                  width: 100% !important;
                  height: 100% !important;
                }
                
                /* 强制canvas背景透明 */
                canvas {
                  background: transparent !important;
                }
              }
              
              #optionKlineCanvas {
                border-radius: 10px;
                box-shadow: inset 0 2px 10px rgba(0, 0, 0, 0.3);
              }
              
              .chart-loading {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                
                .loading-spinner-custom {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  gap: 16px;
                  padding: 32px;
                  background: rgba(42, 42, 42, 0.95);
                  border-radius: 12px;
                  backdrop-filter: blur(10px);
                  border: 1px solid #3a3a3a;
                  
                  .spinner {
                    width: 40px;
                    height: 40px;
                    border: 3px solid #3a3a3a;
                    border-top: 3px solid #00a8ff;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                  }
                  
                  span {
                    color: #ffffff;
                    font-size: 14px;
                  }
                }
              }
            }
          }
          
      // 右侧：期权交易 (30%宽度)
      .content_main_right {
        flex: 3 !important;
        min-width: 300px;
        max-width: 400px;
        
        .option-trading-panel {
          height: 100%;
          border-radius: 10px;
          overflow: hidden;
        }
      }

      // 右侧：订单管理
      .content_main_right_orders {
        flex: 0.3;
        min-width: 300px;
        
          .block_list {
          height: 100%;
            border-radius: 10px;
            overflow: hidden;
            
            // 深色主题
            [data-theme="dark"] &,
            html[data-theme="dark"] & {
              background: #2a2a2a;
              border: 1px solid #3a3a3a;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
            }
            
            // 浅色主题
            [data-theme="light"] &,
            html[data-theme="light"] & {
              background: #ffffff;
              border: 1px solid #e8e8e8;
              box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
            }
            
            // ArcoDesign Tabs 样式优化 - 响应式主题
            :deep(.arco-tabs) {
              .arco-tabs-nav {
                padding: 0 16px;
                
                // 深色主题
                [data-theme="dark"] & {
                  background: #2a2a2a;
                  border-bottom: 1px solid #3a3a3a;
                }
                
                // 浅色主题
                [data-theme="light"] & {
                  background: #ffffff;
                  border-bottom: 1px solid #e8e8e8;
                }
                
                .arco-tabs-tab {
                  font-weight: 600;
                  padding: 16px 20px;
                  transition: all 0.3s ease;
                  
                  // 深色主题
                  [data-theme="dark"] & {
                    color: #888888;
                    
                    &:hover {
                      color: #ffffff;
                    }
                    
                    &.arco-tabs-tab-active {
                      color: #00a8ff;
                      background: rgba(0, 168, 255, 0.1);
                      border-radius: 8px 8px 0 0;
                    }
                  }
                  
                  // 浅色主题
                  [data-theme="light"] & {
                    color: #666666;
                    
                    &:hover {
                      color: #000000;
                    }
                    
                    &.arco-tabs-tab-active {
                      color: #1890ff;
                      background: rgba(24, 144, 255, 0.1);
                      border-radius: 8px 8px 0 0;
                    }
                  }
                }
                
                .arco-tabs-nav-ink {
                  height: 3px;
                  
                  // 深色主题
                  [data-theme="dark"] & {
                    background: #00a8ff;
                  }
                  
                  // 浅色主题
                  [data-theme="light"] & {
                    background: #1890ff;
                  }
                }
              }
              
              .arco-tabs-content {
                padding: 0;
                
                // 深色主题
                [data-theme="dark"] & {
                  background: #2a2a2a;
                }
                
                // 浅色主题
                [data-theme="light"] & {
                  background: #ffffff;
                }
              }
            }
            
            .option-configs {
              .config-header {
                display: flex;
                padding: 14px 16px;
                border-bottom: 1px solid #3a3a3a;
                
                // 深色主题
                [data-theme="dark"] & {
                  background: linear-gradient(135deg, #2d2d2d, #353535);
                  border-bottom: 1px solid #3a3a3a;
                }
                
                // 浅色主题
                [data-theme="light"] & {
                  background: linear-gradient(135deg, #f8f8f8, #f0f0f0);
                  border-bottom: 1px solid #e8e8e8;
                }
                
                span {
                  flex: 1;
                  font-size: 13px;
                  text-align: center;
                  font-weight: 700;
                  text-transform: uppercase;
                  letter-spacing: 0.5px;
                  
                  // 深色主题
                  [data-theme="dark"] & {
                    color: #ffffff;
                  }
                  
                  // 浅色主题
                  [data-theme="light"] & {
                    color: #333333;
                  }
                }
              }
              
              .config-list {
                max-height: 300px;
                
                :deep(.arco-scrollbar-container) {
                  max-height: 300px;
                }
                
                .config-item {
                  padding: 14px 18px;
                  cursor: pointer;
                  transition: all 0.3s ease;
                  position: relative;
                  
                  // 深色主题
                  [data-theme="dark"] & {
                    border-bottom: 1px solid #3a3a3a;
                    
                    &:hover {
                      background: rgba(255, 255, 255, 0.08);
                      transform: translateX(2px);
                    }
                    
                    &.active {
                      background: linear-gradient(90deg, rgba(0, 168, 255, 0.15), rgba(0, 168, 255, 0.25));
                      border-left: 4px solid #00a8ff;
                      box-shadow: inset 0 0 10px rgba(0, 168, 255, 0.2);
                      
                      &::before {
                        content: '';
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 8px;
                        height: 8px;
                        background: #00a8ff;
                        border-radius: 50%;
                        box-shadow: 0 0 8px rgba(0, 168, 255, 0.6);
                      }
                    }
                  }
                  
                  // 浅色主题
                  [data-theme="light"] & {
                    border-bottom: 1px solid #e8e8e8;
                    
                    &:hover {
                      background: rgba(0, 0, 0, 0.03);
                      transform: translateX(2px);
                    }
                    
                    &.active {
                      background: linear-gradient(90deg, rgba(24, 144, 255, 0.10), rgba(24, 144, 255, 0.15));
                      border-left: 4px solid #1890ff;
                      box-shadow: inset 0 0 10px rgba(24, 144, 255, 0.15);
                      
                      &::before {
                        content: '';
                        position: absolute;
                        right: 10px;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 8px;
                        height: 8px;
                        background: #1890ff;
                        border-radius: 50%;
                        box-shadow: 0 0 8px rgba(24, 144, 255, 0.4);
                      }
                    }
                  }
                  
                  .config-duration {
                    .font-14 {
                      font-weight: 700;
                      font-size: 15px;
                      
                      // 深色主题
                      [data-theme="dark"] & {
                        color: #ffffff;
                      }
                      
                      // 浅色主题
                      [data-theme="light"] & {
                        color: #000000;
                      }
                    }
                  }
                  
                  .config-profit {
                    display: flex;
                    gap: 10px;
                    font-weight: 600;
                    margin-top: 4px;
                    
                    // 深色主题
                    [data-theme="dark"] & {
                      color: #b0b0b0;
                    }
                    
                    // 浅色主题
                    [data-theme="light"] & {
                      color: #666666;
                    }
                  }
                }
              }
            }
            
            .active-orders {
              .order-header {
                display: flex;
                padding: 14px 16px;
                
                // 深色主题
                [data-theme="dark"] & {
                  background: linear-gradient(135deg, #2d2d2d, #353535);
                  border-bottom: 1px solid #3a3a3a;
                }
                
                // 浅色主题
                [data-theme="light"] & {
                  background: linear-gradient(135deg, #f8f8f8, #f0f0f0);
                  border-bottom: 1px solid #e8e8e8;
                }
                
                span {
                  flex: 1;
                  font-size: 13px;
                  text-align: center;
                  font-weight: 700;
                  text-transform: uppercase;
                  letter-spacing: 0.5px;
                  
                  // 深色主题
                  [data-theme="dark"] & {
                    color: #ffffff;
                  }
                  
                  // 浅色主题
                  [data-theme="light"] & {
                    color: #333333;
                  }
                }
              }
              
              .order-list {
                max-height: 300px;
                
                :deep(.arco-scrollbar-container) {
                  max-height: 300px;
                }
                
                .order-item {
                  padding: 14px 18px;
                  transition: all 0.3s ease;
                  
                  // 深色主题
                  [data-theme="dark"] & {
                    border-bottom: 1px solid #3a3a3a;
                    
                    &:hover {
                      background: rgba(255, 255, 255, 0.05);
                    }
                  }
                  
                  // 浅色主题
                  [data-theme="light"] & {
                    border-bottom: 1px solid #e8e8e8;
                    
                    &:hover {
                      background: rgba(0, 0, 0, 0.03);
                    }
                  }
                  
                  > div {
                    flex: 1;
                    text-align: center;
                    
                    .font-12 {
                      font-size: 13px;
                      font-weight: 600;
                      
                      // 深色主题
                      [data-theme="dark"] & {
                        color: #ffffff;
                      }
                      
                      // 浅色主题
                      [data-theme="light"] & {
                        color: #000000;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      
      .content_main_right {
        width: 350px;
        flex-shrink: 0;
        
        .content_main_right_top {
          border-radius: 10px;
          padding: 20px;
          
          // 深色主题
          [data-theme="dark"] &,
          html[data-theme="dark"] & {
            background: #2a2a2a;
            border: 1px solid #3a3a3a;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
          }
          
          // 浅色主题
          [data-theme="light"] &,
          html[data-theme="light"] & {
            background: #ffffff;
            border: 1px solid #e8e8e8;
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          }
          
          ._hd {
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            padding-bottom: 16px;
            margin-bottom: 20px;
            
            .balance-info {
              gap: 8px;
              
              .color-gray {
                color: #888888;
              }
              
              .color-primary {
                color: #00a8ff;
                font-weight: 600;
              }
            }
          }
          
          ._mn {
            // 看涨看跌按钮区域 - 保持原有的flex布局
            .direction-buttons {
              gap: 12px;
              margin-bottom: 20px;
              
                              .btn {
                flex: 1;
                height: 70px;
                border-radius: 8px;
                cursor: pointer;
                transition: all 0.3s ease;
                position: relative;
                overflow: hidden;
                border: 2px solid transparent;
                
                .btn-content {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  height: 100%;
                  gap: 6px;
                  
                  .direction-text {
                    font-size: 16px;
                    font-weight: 700;
                  }
                  
                  .profit-text {
                    font-size: 12px;
                    font-weight: 500;
                  }
                }
                
                &:hover {
                  transform: translateY(-1px);
                }
                
                &.call-btn {
                  // 看涨按钮 - 绿色主题 (深色模式)
                  background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.15));
                  border-color: rgba(76, 175, 80, 0.4);
                  
                  .btn-content {
                    .direction-text {
                      color: #4CAF50;
                    }
                    .profit-text {
                      color: #66BB6A;
                    }
                  }
                  
                  &:hover {
                    background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.15));
                    border-color: rgba(76, 175, 80, 0.4);
                  }
                  
                  &.active {
                    background: linear-gradient(135deg, rgba(76, 175, 80, 0.2), rgba(76, 175, 80, 0.3));
                    border-color: #4CAF50;
                    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4);
                    
                    .btn-content {
                      .direction-text {
                        color: #2E7D32;
                        font-weight: 800;
                      }
                      .profit-text {
                        color: #2E7D32;
                        font-weight: 600;
                      }
                    }
                  }
                }
                
                &.put-btn {
                  // 看跌按钮 - 红色主题
                  background: linear-gradient(135deg, rgba(244, 67, 54, 0.05), rgba(244, 67, 54, 0.1));
                  border-color: rgba(244, 67, 54, 0.2);
                  
                  .btn-content {
                    .direction-text {
                      color: #F44336;
                    }
                    .profit-text {
                      color: #EF5350;
                    }
                  }
                  
                  &:hover {
                    background: linear-gradient(135deg, rgba(244, 67, 54, 0.1), rgba(244, 67, 54, 0.15));
                    border-color: rgba(244, 67, 54, 0.4);
                  }
                  
                  &.active {
                    background: linear-gradient(135deg, rgba(244, 67, 54, 0.2), rgba(244, 67, 54, 0.3));
                    border-color: #F44336;
                    box-shadow: 0 4px 15px rgba(244, 67, 54, 0.4);
                    
                    .btn-content {
                      .direction-text {
                        color: #C62828;
                        font-weight: 800;
                      }
                      .profit-text {
                        color: #C62828;
                        font-weight: 600;
                      }
                    }
                  }
                }
              }
            }
            
            // 原有的 _row 样式系统
            ._row {
              margin-bottom: 18px;
              
              // 期权配置选择
              &.config-select {
                .font-12 {
                  margin-bottom: 8px;
                }
              }
              
              // 投资金额输入区域 - 保持原有的结构
              &.amount-input-section {
                .amount-label {
                  margin-bottom: 10px;
                  
                  .label-text {
                    font-size: 14px;
                    color: #ffffff;
                    font-weight: 600;
                  }
                  
                  .available-balance {
                    font-size: 12px;
                    color: #888888;
                    font-weight: 500;
                  }
                }
                
                .amount-input-wrapper {
                  margin-bottom: 12px;
                  
                  // ArcoDesign Input 深色主题样式
                  .amount-input {
                    :deep(.arco-input-wrapper) {
                      background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
                      border: 1px solid rgba(0, 168, 255, 0.3) !important;
                      border-radius: 8px !important;
                      transition: all 0.3s ease !important;
                      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
                      
                      &:hover {
                        border-color: rgba(0, 168, 255, 0.5) !important;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
                      }
                      
                      &:focus-within {
                        border-color: #00a8ff !important;
                        box-shadow: 0 0 0 2px rgba(0, 168, 255, 0.2) !important, 0 4px 16px rgba(0, 168, 255, 0.1) !important;
                      }
                      
                      .arco-input {
                        background: transparent !important;
                        color: #ffffff !important;
                        font-size: 16px !important;
                        font-weight: 600 !important;
                        height: 48px !important;
                        border: none !important;
                        
                        &::placeholder {
                          color: #888888 !important;
                          font-weight: 400 !important;
                        }
                        
                        &:focus {
                          box-shadow: none !important;
                        }
                      }
                      
                      .arco-input-suffix {
                        color: #00a8ff !important;
                        font-weight: 700 !important;
                        font-size: 14px !important;
                        padding-right: 12px !important;
                        background: rgba(0, 168, 255, 0.1) !important;
                        border-radius: 0 6px 6px 0 !important;
                        display: flex !important;
                        align-items: center !important;
                        height: calc(100% - 2px) !important;
                        margin: 1px !important;
                        
                        .input-suffix {
                          color: #00a8ff !important;
                          font-weight: 700 !important;
                          text-shadow: 0 0 6px rgba(0, 168, 255, 0.3) !important;
                        }
                      }
                    }
                  }
                }
                
                .percentage-buttons {
                  display: flex;
                  gap: 6px;
                  
                  .percentage-btn {
                    flex: 1;
                    height: 32px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 6px;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    font-size: 12px;
                    font-weight: 600;
                    
                    // 深色主题
                    [data-theme="dark"] & {
                      background: #1e1e1e;
                      border: 1px solid #3a3a3a;
                      color: #ffffff;
                    }
                    
                    // 浅色主题
                    [data-theme="light"] & {
                      background: #f5f5f5;
                      border: 1px solid #d9d9d9;
                      color: #000000;
                    }
                    
                    &:hover {
                      background: #2a2a2a;
                      border-color: #4a4a4a;
                    }
                    
                    &.active {
                      background: #00a8ff;
                      border-color: #00a8ff;
                      color: #000000;
                      font-weight: 700;
                    }
                  }
                }
              }
              
              // 预期收益信息
              &.profit-info {
                .profit-card {
                  background: linear-gradient(135deg, #2d2d2d, #353535);
                  border-radius: 8px;
                  padding: 16px;
                  border: 1px solid #505050;
                  
                  .profit-row {
                    margin-bottom: 12px;
                    
                    &:last-child {
                      margin-bottom: 0;
                    }
                    
                    &.main-profit {
                      padding-top: 12px;
                      border-top: 1px solid rgba(255, 255, 255, 0.1);
                      font-weight: 600;
                    }
                    
                    .label {
                      color: #cccccc;
                      font-size: 14px;
                      font-weight: 500;
                    }
                    
                    .value {
                      color: #ffffff;
                      font-size: 14px;
                      font-weight: 600;
                      
                      &.fee {
                        color: #f59e0b;
                      }
                      
                      &.profit {
                        font-weight: 700;
                        font-size: 15px;
                      }
                    }
                  }
                }
              }
              
              // 倒计时显示
              &.countdown-display {
                .countdown-card {
                  background: linear-gradient(135deg, rgba(0, 168, 255, 0.1), rgba(0, 168, 255, 0.2));
                  border-radius: 8px;
                  padding: 16px;
                  text-align: center;
                  border: 1px solid rgba(0, 168, 255, 0.3);
                  
                  .countdown-label {
                    font-size: 12px;
                    color: #cccccc;
                    margin-bottom: 8px;
                    font-weight: 600;
                  }
                  
                  .countdown-time {
                    font-size: 24px;
                    font-weight: 700;
                    color: #00a8ff;
                    font-family: 'Courier New', monospace;
                  }
                }
              }
              
              // 提交按钮
              &.submit-section {
                .submit-btn {
                  width: 100%;
                  height: 48px;
                  border-radius: 8px !important;
                  font-size: 16px !important;
                  font-weight: 700 !important;
                  border: none !important;
                  cursor: pointer;
                  transition: all 0.3s ease !important;
                  position: relative;
                  overflow: hidden;
                  
                  // 覆盖ArcoDesign默认样式
                  &.arco-btn {
                    border: none !important;
                    box-shadow: none;
                  }
                  
                  // 看涨期权买入按钮 - 绿色主题
                  &.call-submit {
                    background: linear-gradient(135deg, #4CAF50, #66BB6A) !important;
                    background-color: #4CAF50 !important;
                    color: #ffffff !important;
                    border: none !important;
                    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4) !important;
                    
                    &:hover:not(:disabled) {
                      background: linear-gradient(135deg, #388E3C, #4CAF50) !important;
                      background-color: #388E3C !important;
                      transform: translateY(-2px) !important;
                      box-shadow: 0 8px 25px rgba(76, 175, 80, 0.5) !important;
                    }
                    
                    &:active:not(:disabled) {
                      transform: translateY(0) !important;
                      box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4) !important;
                    }
                  }
                  
                  // 看跌期权买入按钮 - 红色主题  
                  &.put-submit {
                    background: linear-gradient(135deg, #F44336, #EF5350) !important;
                    background-color: #F44336 !important;
                    color: #ffffff !important;
                    border: none !important;
                    box-shadow: 0 4px 15px rgba(244, 67, 54, 0.4) !important;
                    
                    &:hover:not(:disabled) {
                      background: linear-gradient(135deg, #D32F2F, #F44336) !important;
                      background-color: #D32F2F !important;
                      transform: translateY(-2px) !important;
                      box-shadow: 0 8px 25px rgba(244, 67, 54, 0.5) !important;
                    }
                    
                    &:active:not(:disabled) {
                      transform: translateY(0) !important;
                      box-shadow: 0 4px 15px rgba(244, 67, 54, 0.4) !important;
                    }
                  }
                  
                  &:disabled {
                    opacity: 0.5 !important;
                    cursor: not-allowed !important;
                    transform: none !important;
                    box-shadow: none !important;
                  }
                }
              }
              
              // 风险提示
              &.risk-warning {
                .warning-text {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  padding: 12px;
                  background: linear-gradient(135deg, rgba(255, 193, 7, 0.1), rgba(255, 193, 7, 0.2));
                  border-radius: 6px;
                  border: 1px solid rgba(255, 193, 7, 0.3);
                  
                  .warning-icon {
                    color: #ffc107;
                    font-size: 16px;
                  }
                  
                  span {
                    color: #ffffff;
                    font-size: 12px;
                    font-weight: 500;
                  }
                }
              }
            }
          }
        }
      }
    }
    
    // 倒计时显示区域
    .countdown-display {
      .countdown-card {
        background: linear-gradient(135deg, rgba(0, 168, 255, 0.15), rgba(0, 168, 255, 0.25));
        border-radius: 12px;
        padding: 20px;
        text-align: center;
        border: 2px solid rgba(0, 168, 255, 0.4);
        box-shadow: 0 8px 25px rgba(0, 168, 255, 0.2);
        backdrop-filter: blur(10px);
        
        .countdown-label {
          font-size: 14px;
          color: #ffffff;
          margin-bottom: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        
        .countdown-time {
          font-size: 32px;
          font-weight: 900;
          color: #00a8ff;
          font-family: 'Courier New', monospace;
          text-shadow: 0 0 20px rgba(0, 168, 255, 0.6);
          animation: pulse 2s infinite;
        }
      }
    }
    
    // 提交按钮区域
    .submit-section {
      .submit-btn {
        width: 100%;
        height: 56px;
        border-radius: 12px;
        font-size: 18px;
        font-weight: 700;
        border: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        text-transform: uppercase;
        letter-spacing: 1px;
        position: relative;
        overflow: hidden;
        
        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
          transition: left 0.5s;
        }
        
        &:hover:not(:disabled)::before {
          left: 100%;
        }
        
        &.call-submit {
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          color: #ffffff;
          box-shadow: 0 6px 20px rgba(34, 197, 94, 0.4);
          
          &:hover:not(:disabled) {
            background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 30px rgba(34, 197, 94, 0.5);
          }
          
          &:active:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 15px rgba(34, 197, 94, 0.6);
          }
        }
        
        &.put-submit {
          background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
          color: #ffffff;
          box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4);
          
          &:hover:not(:disabled) {
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            transform: translateY(-2px);
            box-shadow: 0 8px 30px rgba(239, 68, 68, 0.5);
          }
          
          &:active:not(:disabled) {
            transform: translateY(-1px);
            box-shadow: 0 4px 15px rgba(239, 68, 68, 0.6);
          }
        }
        
        &:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
          
          &::before {
            display: none;
          }
        }
      }
    }
    
    // 风险提示区域
    .risk-warning {
      .warning-text {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 16px;
        background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(245, 158, 11, 0.25));
        border-radius: 10px;
        border: 1px solid rgba(245, 158, 11, 0.4);
        backdrop-filter: blur(10px);
        
        .warning-icon {
          color: #f59e0b;
          font-size: 20px;
          animation: pulse 2s infinite;
        }
        
        span {
          color: #ffffff;
          font-size: 13px;
          font-weight: 500;
          text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
          line-height: 1.4;
        }
      }
    }

    // 动画效果
    @keyframes pulse {
      0%, 100% {
        opacity: 1;
        transform: scale(1);
      }
      50% {
        opacity: 0.8;
        transform: scale(1.05);
      }
    }
    
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>

<style scoped>
/* 期权配置选择框自适应主题样式 */
.config-select {
  margin-bottom: 20px;
}

/* 深色主题样式 */
[data-theme="dark"] .config-select .arco-select,
html[data-theme="dark"] .config-select .arco-select {
  width: 100% !important;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

/* 白天主题样式 */
[data-theme="light"] .config-select .arco-select,
html[data-theme="light"] .config-select .arco-select,
body[data-theme="light"] .config-select .arco-select {
  background: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 6px !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
}

/* 深色主题选择框内容 */
[data-theme="dark"] .config-select :deep(.arco-select-view),
body.dark .config-select :deep(.arco-select-view),
.config-select :deep(.arco-select-view) {
  background: transparent !important;
  border: none !important;
  padding: 12px 16px !important;
  color: #ffffff !important;
}

/* 白天主题选择框内容 */
[data-theme="light"] .config-select :deep(.arco-select-view),
html[data-theme="light"] .config-select :deep(.arco-select-view),
body[data-theme="light"] .config-select :deep(.arco-select-view) {
  background: transparent !important;
  border: none !important;
  padding: 12px 16px !important;
  color: #333333 !important;
}

/* 深色主题选择框值 */
[data-theme="dark"] .config-select :deep(.arco-select-view-value),
body.dark .config-select :deep(.arco-select-view-value),
.config-select :deep(.arco-select-view-value) {
  color: #ffffff !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}

/* 白天主题选择框值 */
[data-theme="light"] .config-select :deep(.arco-select-view-value),
html[data-theme="light"] .config-select :deep(.arco-select-view-value),
body[data-theme="light"] .config-select :deep(.arco-select-view-value) {
  color: var(--content-primary) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

/* 确保深色主题也有对应样式 */
[data-theme="dark"] .config-select :deep(.arco-select-view-value),
html[data-theme="dark"] .config-select :deep(.arco-select-view-value),
body[data-theme="dark"] .config-select :deep(.arco-select-view-value) {
  color: var(--content-primary) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

/* 深色主题后缀图标 */
[data-theme="dark"] .config-select :deep(.arco-select-view-suffix),
body.dark .config-select :deep(.arco-select-view-suffix),
.config-select :deep(.arco-select-view-suffix) {
  color: #888888 !important;
}

/* 白天主题后缀图标 */
[data-theme="light"] .config-select :deep(.arco-select-view-suffix),
html[data-theme="light"] .config-select :deep(.arco-select-view-suffix),
body[data-theme="light"] .config-select :deep(.arco-select-view-suffix) {
  color: #999999 !important;
}

/* 深色主题悬停效果 */
[data-theme="dark"] .config-select :deep(.arco-select:hover),
body.dark .config-select :deep(.arco-select:hover),
.config-select :deep(.arco-select:hover) {
  border-color: #00a8ff !important;
  box-shadow: 0 4px 12px rgba(0, 168, 255, 0.1) !important;
}

/* 白天主题悬停效果 */
[data-theme="light"] .config-select :deep(.arco-select:hover),
html[data-theme="light"] .config-select :deep(.arco-select:hover),
body[data-theme="light"] .config-select :deep(.arco-select:hover) {
  border-color: #40a9ff !important;
  box-shadow: 0 4px 12px rgba(64, 169, 255, 0.15) !important;
}
</style>

<style>
/* 最高优先级全局样式 - 专门针对期权配置下拉选项 */
body .arco-select-dropdown {
  background: linear-gradient(145deg, #1e1e1e 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
  z-index: 9999 !important;
}

/* 🚫 移除通用ArcoDesign选择器选项的边框 - 避免双下划线 */
body .arco-select-dropdown .arco-select-option {
  background: transparent !important;
  color: #ffffff !important;
  padding: 12px 16px !important;
  transition: all 0.3s ease !important;
  border-bottom: none !important; /* 移除边框避免双下划线 */
}

body .arco-select-dropdown .arco-select-option:last-child {
  border-bottom: none !important;
}

/* 🎯 币种选择器专用样式 - 确保无边框 */
.contract-dropdown .arco-select-option,
.contract-dropdown .arco-dropdown-option,
.contract-dropdown .coin-item,
.contract-dropdown [class*="option"] {
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

body .arco-select-dropdown .arco-select-option:hover {
  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%) !important;
  color: #00a8ff !important;
}

body .arco-select-dropdown .arco-select-option.arco-select-option-selected {
  background: linear-gradient(135deg, rgba(0, 168, 255, 0.2) 0%, rgba(0, 168, 255, 0.1) 100%) !important;
  color: #00a8ff !important;
  font-weight: 600 !important;
}

body .arco-select-dropdown .arco-select-option.arco-select-option-selected:hover {
  background: linear-gradient(135deg, rgba(0, 168, 255, 0.3) 0%, rgba(0, 168, 255, 0.2) 100%) !important;
  color: #ffffff !important;
}

/* 确保所有ArcoDesign选择框都使用深色主题 */
html[data-theme="dark"] .arco-select,
.futures .arco-select,
[class*="futures"] .arco-select {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  border-radius: 8px !important;
}

html[data-theme="dark"] .arco-select-view,
.futures .arco-select-view,
[class*="futures"] .arco-select-view {
  background: transparent !important;
  border: none !important;
  color: #ffffff !important;
}

html[data-theme="dark"] .arco-select-view-value,
.futures .arco-select-view-value,
[class*="futures"] .arco-select-view-value {
  color: #ffffff !important;
  font-weight: 500 !important;
}
</style>

<style>
/* 币种选择器专用样式 - 使用更具体的选择器避免冲突 */
.contract-dropdown {
  width: 320px !important;
  min-width: 320px !important;
  background: linear-gradient(145deg, #1e1e1e 0%, #2a2a2a 100%) !important;
  border-radius: 12px !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  box-shadow: 
    0 16px 40px rgba(0, 0, 0, 0.7),
    0 0 20px rgba(0, 168, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
  overflow: hidden !important;
  padding: 16px !important;
  backdrop-filter: blur(10px) !important;
}

.contract-dropdown .arco-input-wrapper {
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.2) !important;
  border-radius: 8px !important;
  margin-bottom: 16px !important;
  position: relative !important;
  overflow: hidden !important;
}

.contract-dropdown .arco-input-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent 0%, rgba(0, 168, 255, 0.1) 50%, transparent 100%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.contract-dropdown .arco-input-wrapper:focus-within::before {
  transform: translateX(100%);
}

.contract-dropdown .arco-input {
  background: transparent !important;
  color: #ffffff !important;
  font-size: 14px !important;
  height: 40px !important;
  font-weight: 500 !important;
}

.contract-dropdown .arco-input::placeholder {
  color: #888888 !important;
  font-weight: 400 !important;
}

.contract-dropdown .arco-input-wrapper:focus-within {
  border-color: #00a8ff !important;
  box-shadow: 0 0 0 2px rgba(0, 168, 255, 0.2) !important, 0 4px 12px rgba(0, 168, 255, 0.1) !important;
}

.contract-dropdown .arco-input-prefix {
  color: #00a8ff !important;
}

.contract-dropdown .coin-list {
  max-height: 280px !important;
  overflow: hidden !important;
}

.contract-dropdown .coin-list-container {
  max-height: 280px !important;
  overflow-y: auto !important;
  padding-right: 4px !important;
}

/* 自定义滚动条样式 */
.contract-dropdown .coin-list-container::-webkit-scrollbar {
  width: 6px !important;
}

.contract-dropdown .coin-list-container::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1) !important;
  border-radius: 3px !important;
}

.contract-dropdown .coin-list-container::-webkit-scrollbar-thumb {
  background: rgba(0, 168, 255, 0.4) !important;
  border-radius: 3px !important;
  transition: all 0.3s ease !important;
}

.contract-dropdown .coin-list-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 168, 255, 0.6) !important;
}

/* 🎯 币种列表项样式 - 无边框设计避免双下划线 */
.contract-dropdown .coin-item {
  display: flex !important;
  align-items: center !important;
  gap: 14px !important;
  padding: 12px 10px !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1) !important;
  border-radius: 8px !important;
  margin-bottom: 2px !important;
  position: relative !important;
  overflow: hidden !important;
  background: transparent !important;
  color: #ffffff !important;
  border: none !important; /* 确保无边框 */
  border-bottom: none !important; /* 明确移除下边框 */
}

.contract-dropdown .coin-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(0, 168, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  opacity: 0;
  transition: all 0.3s ease;
}

.contract-dropdown .coin-item:hover {
  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%) !important;
  transform: translateX(4px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

.contract-dropdown .coin-item:hover::before {
  opacity: 1;
}

.contract-dropdown .coin-item:hover .item-logo {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 16px rgba(0, 168, 255, 0.3) !important;
}

.contract-dropdown .coin-item:hover .item-pair {
  color: #00a8ff !important;
}

.contract-dropdown .item-logo {
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  flex-shrink: 0 !important;
  border: 2px solid rgba(255, 255, 255, 0.1) !important;
  background: #1a1a1a !important;
  transition: all 0.3s ease !important;
  z-index: 2 !important;
  position: relative !important;
}

.contract-dropdown .item-pair {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  flex: 1 !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
  z-index: 2 !important;
  position: relative !important;
}

/* 确保期权配置选择框不受币种选择器样式影响 */
.config-select .arco-select-dropdown {
  background: linear-gradient(145deg, #1e1e1e 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

/* 🎯 期权配置选择器保留边框分隔线 */
.config-select .arco-select-dropdown .arco-select-option {
  background: transparent !important;
  color: #ffffff !important;
  padding: 12px 16px !important;
  transition: all 0.3s ease !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important; /* 保留期权配置的分隔线 */
}

/* 最后一个选项无边框 */
.config-select .arco-select-dropdown .arco-select-option:last-child {
  border-bottom: none !important;
}

.config-select .arco-select-dropdown .arco-select-option:hover {
  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%) !important;
  color: #00a8ff !important;
}

.config-select .arco-select-dropdown .arco-select-option.arco-select-option-selected {
  background: linear-gradient(135deg, rgba(0, 168, 255, 0.2) 0%, rgba(0, 168, 255, 0.1) 100%) !important;
  color: #00a8ff !important;
  font-weight: 600 !important;
}

/* 🎯 清理版本 - 仅保留基础样式，让内联样式发挥作用 */

</style>

<style>
/* 强制覆盖 ArcoDesign Input 组件样式 - 全局样式 */
.futures .amount-input .arco-input-wrapper,
[data-theme="dark"] .amount-input .arco-input-wrapper,
body .amount-input .arco-input-wrapper,
.amount-input-wrapper .arco-input-wrapper,
.amount-input-section .amount-input .arco-input-wrapper,
.arco-input-wrapper {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2) !important;
}

.futures .amount-input .arco-input-wrapper:hover,
[data-theme="dark"] .amount-input .arco-input-wrapper:hover,
body .amount-input .arco-input-wrapper:hover,
.amount-input-wrapper .arco-input-wrapper:hover,
.amount-input-section .amount-input .arco-input-wrapper:hover,
.arco-input-wrapper:hover {
  border-color: rgba(0, 168, 255, 0.5) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

.futures .amount-input .arco-input-wrapper:focus-within,
[data-theme="dark"] .amount-input .arco-input-wrapper:focus-within,
body .amount-input .arco-input-wrapper:focus-within,
.amount-input-wrapper .arco-input-wrapper:focus-within,
.amount-input-section .amount-input .arco-input-wrapper:focus-within,
.arco-input-wrapper:focus-within {
  border-color: #00a8ff !important;
  box-shadow: 0 0 0 2px rgba(0, 168, 255, 0.2) !important, 0 4px 16px rgba(0, 168, 255, 0.1) !important;
}

.futures .amount-input .arco-input,
[data-theme="dark"] .amount-input .arco-input,
body .amount-input .arco-input,
.amount-input-wrapper .arco-input,
.amount-input-section .amount-input .arco-input,
.arco-input {
  background: transparent !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  height: 48px !important;
  border: none !important;
}

.futures .amount-input .arco-input::placeholder,
[data-theme="dark"] .amount-input .arco-input::placeholder,
body .amount-input .arco-input::placeholder,
.amount-input-wrapper .arco-input::placeholder,
.amount-input-section .amount-input .arco-input::placeholder,
.arco-input::placeholder {
  color: #888888 !important;
  font-weight: 400 !important;
}

.futures .amount-input .arco-input:focus,
[data-theme="dark"] .amount-input .arco-input:focus,
body .amount-input .arco-input:focus {
  box-shadow: none !important;
}

.futures .amount-input .arco-input-suffix,
[data-theme="dark"] .amount-input .arco-input-suffix,
body .amount-input .arco-input-suffix {
  color: #00a8ff !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  padding-right: 12px !important;
  background: rgba(0, 168, 255, 0.1) !important;
  border-radius: 0 6px 6px 0 !important;
  display: flex !important;
  align-items: center !important;
  height: calc(100% - 2px) !important;
  margin: 1px !important;
}

.futures .amount-input .input-suffix,
[data-theme="dark"] .amount-input .input-suffix,
body .amount-input .input-suffix {
  color: #00a8ff !important;
  font-weight: 700 !important;
  text-shadow: 0 0 6px rgba(0, 168, 255, 0.3) !important;
}

/* 主题响应式样式 - 根据主题模式动态切换 */

/* 深色主题样式 */
[data-theme="dark"] .arco-input-wrapper,
html[data-theme="dark"] .arco-input-wrapper,
body[data-theme="dark"] .arco-input-wrapper,
.dark .arco-input-wrapper {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  border-radius: 8px !important;
}

[data-theme="dark"] .arco-input,
html[data-theme="dark"] .arco-input,
body[data-theme="dark"] .arco-input,
.dark .arco-input {
  background: transparent !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

[data-theme="dark"] .arco-input::placeholder,
html[data-theme="dark"] .arco-input::placeholder,
body[data-theme="dark"] .arco-input::placeholder,
.dark .arco-input::placeholder {
  color: #888888 !important;
}

/* 浅色主题样式 */
[data-theme="light"] .arco-input-wrapper,
html[data-theme="light"] .arco-input-wrapper,
body[data-theme="light"] .arco-input-wrapper,
.light .arco-input-wrapper {
  border: 1px solid #d9d9d9 !important;
  border-radius: 8px !important;
}

[data-theme="light"] .arco-input-wrapper:hover,
html[data-theme="light"] .arco-input-wrapper:hover,
body[data-theme="light"] .arco-input-wrapper:hover,
.light .arco-input-wrapper:hover {
  border-color: #40a9ff !important;
}

[data-theme="light"] .arco-input-wrapper:focus-within,
html[data-theme="light"] .arco-input-wrapper:focus-within,
body[data-theme="light"] .arco-input-wrapper:focus-within,
.light .arco-input-wrapper:focus-within {
  border-color: #1890ff !important;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
}

[data-theme="light"] .arco-input,
html[data-theme="light"] .arco-input,
body[data-theme="light"] .arco-input,
.light .arco-input {
  background: transparent !important;
  color: #000000 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
}

[data-theme="light"] .arco-input::placeholder,
html[data-theme="light"] .arco-input::placeholder,
body[data-theme="light"] .arco-input::placeholder,
.light .arco-input::placeholder {
  color: #bfbfbf !important;
}

[data-theme="light"] .arco-input-suffix,
html[data-theme="light"] .arco-input-suffix,
body[data-theme="light"] .arco-input-suffix,
.light .arco-input-suffix {
  background: rgba(24, 144, 255, 0.1) !important;
  color: #1890ff !important;
}
</style>

<style>
/* 期权页面主题响应式样式 */

/* 百分比按钮主题切换和布局 */
[data-theme="light"] .percentage-buttons,
html[data-theme="light"] .percentage-buttons {
  display: flex !important;
  gap: 8px !important;
  width: 100% !important;
  box-sizing: border-box !important;
}

[data-theme="light"] .percentage-btn,
html[data-theme="light"] .percentage-btn {
  flex: 1 !important;
  background: #f5f5f5 !important;
  border: 1px solid #d9d9d9 !important;
  color: #333333 !important;
  margin: 0 !important;
  padding: 8px 4px !important;
  font-size: 13px !important;
  text-align: center !important;
  white-space: nowrap !important;
  min-width: 0 !important;
}

[data-theme="light"] .percentage-btn:hover,
html[data-theme="light"] .percentage-btn:hover {
  background: #e6f7ff !important;
  border-color: #40a9ff !important;
  color: #1890ff !important;
}

[data-theme="light"] .percentage-btn.active,
html[data-theme="light"] .percentage-btn.active {
  background: #1890ff !important;
  border-color: #1890ff !important;
  color: #ffffff !important;
}

/* 收益卡片主题切换 */
[data-theme="light"] .profit-card,
html[data-theme="light"] .profit-card {
  background: linear-gradient(135deg, #f5f5f5, #ffffff) !important;
  border: 1px solid #e8e8e8 !important;
}

[data-theme="light"] .profit-card .label,
html[data-theme="light"] .profit-card .label {
  color: #666666 !important;
}

[data-theme="light"] .profit-card .value,
html[data-theme="light"] .profit-card .value {
  color: #000000 !important;
}

/* 看涨看跌按钮主题切换 */
[data-theme="light"] .direction-buttons .btn,
html[data-theme="light"] .direction-buttons .btn {
  background: #f5f5f5 !important;
  border: 2px solid #e8e8e8 !important;
}

[data-theme="light"] .direction-buttons .btn .direction-text,
html[data-theme="light"] .direction-buttons .btn .direction-text {
  color: #333333 !important;
}

[data-theme="light"] .direction-buttons .btn .profit-text,
html[data-theme="light"] .direction-buttons .btn .profit-text {
  color: #666666 !important;
}

[data-theme="light"] .direction-buttons .btn:hover,
html[data-theme="light"] .direction-buttons .btn:hover {
  background: #e6f7ff !important;
}

/* 🎯 买入期权按钮白天模式强力样式 - 根据选择动态变色 */

/* 看涨期权买入按钮 - 绿色主题白天模式 */
[data-theme="light"] .submit-btn.call-submit,
html[data-theme="light"] .submit-btn.call-submit,
body[data-theme="light"] .submit-btn.call-submit,
[data-theme="light"] .arco-btn.submit-btn.call-submit,
html[data-theme="light"] .arco-btn.submit-btn.call-submit,
body[data-theme="light"] .arco-btn.submit-btn.call-submit {
  background: linear-gradient(135deg, #4CAF50, #66BB6A) !important;
  background-color: #4CAF50 !important;
  color: #ffffff !important;
  border: none !important;
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
  font-weight: 700 !important;
  position: relative !important;
}

/* 移除emoji装饰 - 保持按钮文字清晰 */

[data-theme="light"] .submit-btn.call-submit:hover:not(:disabled),
html[data-theme="light"] .submit-btn.call-submit:hover:not(:disabled),
body[data-theme="light"] .submit-btn.call-submit:hover:not(:disabled),
[data-theme="light"] .arco-btn.submit-btn.call-submit:hover:not(:disabled),
html[data-theme="light"] .arco-btn.submit-btn.call-submit:hover:not(:disabled),
body[data-theme="light"] .arco-btn.submit-btn.call-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #2E7D32, #388E3C) !important;
  background-color: #2E7D32 !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 10px 30px rgba(76, 175, 80, 0.6) !important;
}

/* 看跌期权买入按钮 - 红色主题白天模式 */
[data-theme="light"] .submit-btn.put-submit,
html[data-theme="light"] .submit-btn.put-submit,
body[data-theme="light"] .submit-btn.put-submit,
[data-theme="light"] .arco-btn.submit-btn.put-submit,
html[data-theme="light"] .arco-btn.submit-btn.put-submit,
body[data-theme="light"] .arco-btn.submit-btn.put-submit {
  background: linear-gradient(135deg, #F44336, #EF5350) !important;
  background-color: #F44336 !important;
  color: #ffffff !important;
  border: none !important;
  box-shadow: 0 6px 20px rgba(244, 67, 54, 0.4) !important;
  font-weight: 700 !important;
  position: relative !important;
}

/* 移除emoji装饰 - 保持按钮文字清晰 */

[data-theme="light"] .submit-btn.put-submit:hover:not(:disabled),
html[data-theme="light"] .submit-btn.put-submit:hover:not(:disabled),
body[data-theme="light"] .submit-btn.put-submit:hover:not(:disabled),
[data-theme="light"] .arco-btn.submit-btn.put-submit:hover:not(:disabled),
html[data-theme="light"] .arco-btn.submit-btn.put-submit:hover:not(:disabled),
body[data-theme="light"] .arco-btn.submit-btn.put-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #C62828, #D32F2F) !important;
  background-color: #C62828 !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 10px 30px rgba(244, 67, 54, 0.6) !important;
}

/* 按钮激活状态 */
[data-theme="light"] .submit-btn:active:not(:disabled),
html[data-theme="light"] .submit-btn:active:not(:disabled),
body[data-theme="light"] .submit-btn:active:not(:disabled) {
  transform: translateY(-1px) !important;
  transition: all 0.1s ease !important;
}

/* 禁用状态 */
[data-theme="light"] .submit-btn:disabled,
html[data-theme="light"] .submit-btn:disabled,
body[data-theme="light"] .submit-btn:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
}

/* 倒计时显示主题切换 */
[data-theme="light"] .countdown-card,
html[data-theme="light"] .countdown-card {
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.1), rgba(24, 144, 255, 0.2)) !important;
  border: 1px solid rgba(24, 144, 255, 0.3) !important;
}

[data-theme="light"] .countdown-label,
html[data-theme="light"] .countdown-label {
  color: #666666 !important;
}

[data-theme="light"] .countdown-time,
html[data-theme="light"] .countdown-time {
  color: #1890ff !important;
}

/* 风险提示主题切换 */
[data-theme="light"] .warning-text,
html[data-theme="light"] .warning-text {
  background: linear-gradient(135deg, rgba(250, 173, 20, 0.1), rgba(250, 173, 20, 0.2)) !important;
  border: 1px solid rgba(250, 173, 20, 0.3) !important;
}

[data-theme="light"] .warning-text span,
html[data-theme="light"] .warning-text span {
  color: #000000 !important;
}

[data-theme="light"] .warning-icon,
html[data-theme="light"] .warning-icon {
  color: #faad14 !important;
}

/* 右侧交易面板标题和余额主题切换 */
[data-theme="light"] ._hd,
html[data-theme="light"] ._hd {
  border-bottom: 1px solid #e8e8e8 !important;
}

[data-theme="light"] ._hd .color-gray,
html[data-theme="light"] ._hd .color-gray {
  color: #666666 !important;
}

[data-theme="light"] ._hd .color-primary,
html[data-theme="light"] ._hd .color-primary {
  color: #1890ff !important;
}

[data-theme="light"] .font-16,
html[data-theme="light"] .font-16 {
  color: #000000 !important;
}

/* 期权配置标签文字优化 */
[data-theme="light"] .config-select .font-12.color-gray,
html[data-theme="light"] .config-select .font-12.color-gray,
body[data-theme="light"] .config-select .font-12.color-gray {
  color: #666666 !important;
  font-weight: 600 !important;
  margin-bottom: 8px !important;
  display: block !important;
}

/* 期权配置选择下拉框主题切换强化 */
[data-theme="light"] .config-select .arco-select,
html[data-theme="light"] .config-select .arco-select,
body[data-theme="light"] .config-select .arco-select {
  background: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  border-radius: 6px !important;
}

[data-theme="light"] .config-select .arco-select-view-single,
html[data-theme="light"] .config-select .arco-select-view-single,
body[data-theme="light"] .config-select .arco-select-view-single {
  color: #000000 !important;
  font-weight: 600 !important;
  background: #ffffff !important;
}

/* 通用下拉选项白天模式（避免全局冲突） */
[data-theme="light"] .config-select .arco-select-dropdown,
html[data-theme="light"] .config-select .arco-select-dropdown,
body[data-theme="light"] .config-select .arco-select-dropdown {
  background: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
}

[data-theme="light"] .config-select .arco-select-option,
html[data-theme="light"] .config-select .arco-select-option,
body[data-theme="light"] .config-select .arco-select-option {
  color: #000000 !important;
  background: #ffffff !important;
  font-weight: 500 !important;
}

[data-theme="light"] .config-select .arco-select-option:hover,
html[data-theme="light"] .config-select .arco-select-option:hover,
body[data-theme="light"] .config-select .arco-select-option:hover {
  background: #f5f5f5 !important;
}

[data-theme="light"] .arco-select-option.arco-select-option-selected,
html[data-theme="light"] .arco-select-option.arco-select-option-selected {
  background: #e6f7ff !important;
  color: #1890ff !important;
}

/* Tabs内容区域文字颜色 */
[data-theme="light"] .font-12,
html[data-theme="light"] .font-12 {
  color: #666666 !important;
}

/* 移除硬编码颜色，使用CSS变量系统 */
[data-theme="light"] .color-gray,
html[data-theme="light"] .color-gray {
  color: var(--content-tertiary) !important;
}

[data-theme="light"] .color-black,
html[data-theme="light"] .color-black {
  color: var(--content-primary) !important;
}

/* 期权配置顶部标签主题切换 */
[data-theme="light"] .mb-10,
html[data-theme="light"] .mb-10 {
  color: #666666 !important;
}
</style>

<style>
/* 强制白天模式样式覆盖 - 更高优先级 */

/* 右侧交易面板白天模式 */
html[data-theme="light"] .content_main_right .content_main_right_top,
[data-theme="light"] .content_main_right .content_main_right_top,
body[data-theme="light"] .content_main_right .content_main_right_top {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

/* K线图区域白天模式 */
html[data-theme="light"] .block_kline,
[data-theme="light"] .block_kline,
body[data-theme="light"] .block_kline {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

/* 期权配置区域白天模式 */
html[data-theme="light"] .block_list,
[data-theme="light"] .block_list,
body[data-theme="light"] .block_list {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

/* Tabs白天模式 */
html[data-theme="light"] .arco-tabs-nav,
[data-theme="light"] .arco-tabs-nav,
body[data-theme="light"] .arco-tabs-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #e8e8e8 !important;
}

html[data-theme="light"] .arco-tabs-content,
[data-theme="light"] .arco-tabs-content,
body[data-theme="light"] .arco-tabs-content {
  background: #ffffff !important;
}

html[data-theme="light"] .arco-tabs-tab,
[data-theme="light"] .arco-tabs-tab,
body[data-theme="light"] .arco-tabs-tab {
  color: #666666 !important;
}

html[data-theme="light"] .arco-tabs-tab:hover,
[data-theme="light"] .arco-tabs-tab:hover,
body[data-theme="light"] .arco-tabs-tab:hover {
  color: #000000 !important;
}

html[data-theme="light"] .arco-tabs-tab.arco-tabs-tab-active,
[data-theme="light"] .arco-tabs-tab.arco-tabs-tab-active,
body[data-theme="light"] .arco-tabs-tab.arco-tabs-tab-active {
  color: #1890ff !important;
  background: rgba(24, 144, 255, 0.1) !important;
}

html[data-theme="light"] .arco-tabs-nav-ink,
[data-theme="light"] .arco-tabs-nav-ink,
body[data-theme="light"] .arco-tabs-nav-ink {
  background: #1890ff !important;
}

/* 期权配置项白天模式 */
html[data-theme="light"] .config-header,
[data-theme="light"] .config-header,
body[data-theme="light"] .config-header {
  background: linear-gradient(135deg, #f8f8f8, #f0f0f0) !important;
  border-bottom: 1px solid #e8e8e8 !important;
}

html[data-theme="light"] .config-header span,
[data-theme="light"] .config-header span,
body[data-theme="light"] .config-header span {
  color: #333333 !important;
}

html[data-theme="light"] .config-item,
[data-theme="light"] .config-item,
body[data-theme="light"] .config-item {
  border-bottom: 1px solid #e8e8e8 !important;
}

html[data-theme="light"] .config-item:hover,
[data-theme="light"] .config-item:hover,
body[data-theme="light"] .config-item:hover {
  background: rgba(0, 0, 0, 0.03) !important;
}

html[data-theme="light"] .config-item.active,
[data-theme="light"] .config-item.active,
body[data-theme="light"] .config-item.active {
  background: linear-gradient(90deg, rgba(24, 144, 255, 0.10), rgba(24, 144, 255, 0.15)) !important;
  border-left: 4px solid #1890ff !important;
  box-shadow: inset 0 0 10px rgba(24, 144, 255, 0.15) !important;
}

html[data-theme="light"] .config-item.active::before,
[data-theme="light"] .config-item.active::before,
body[data-theme="light"] .config-item.active::before {
  background: #1890ff !important;
  box-shadow: 0 0 8px rgba(24, 144, 255, 0.4) !important;
}

html[data-theme="light"] .config-duration .font-14,
[data-theme="light"] .config-duration .font-14,
body[data-theme="light"] .config-duration .font-14 {
  color: #000000 !important;
}

html[data-theme="light"] .config-profit,
[data-theme="light"] .config-profit,
body[data-theme="light"] .config-profit {
  color: #666666 !important;
}

/* 活跃订单白天模式 */
html[data-theme="light"] .order-header,
[data-theme="light"] .order-header,
body[data-theme="light"] .order-header {
  background: linear-gradient(135deg, #f8f8f8, #f0f0f0) !important;
  border-bottom: 1px solid #e8e8e8 !important;
}

html[data-theme="light"] .order-header span,
[data-theme="light"] .order-header span,
body[data-theme="light"] .order-header span {
  color: #333333 !important;
}

html[data-theme="light"] .order-item,
[data-theme="light"] .order-item,
body[data-theme="light"] .order-item {
  border-bottom: 1px solid #e8e8e8 !important;
}

html[data-theme="light"] .order-item:hover,
[data-theme="light"] .order-item:hover,
body[data-theme="light"] .order-item:hover {
  background: rgba(0, 0, 0, 0.03) !important;
}

html[data-theme="light"] .order-item .font-12,
[data-theme="light"] .order-item .font-12,
body[data-theme="light"] .order-item .font-12 {
  color: #000000 !important;
}

/* 右侧面板内容白天模式 */
html[data-theme="light"] ._hd,
[data-theme="light"] ._hd,
body[data-theme="light"] ._hd {
  border-bottom: 1px solid #e8e8e8 !important;
}

/* 看涨按钮白天模式 */
html[data-theme="light"] .direction-buttons .call-btn,
[data-theme="light"] .direction-buttons .call-btn,
body[data-theme="light"] .direction-buttons .call-btn {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.08), rgba(76, 175, 80, 0.12)) !important;
  border: 2px solid rgba(76, 175, 80, 0.3) !important;
}

html[data-theme="light"] .direction-buttons .call-btn .direction-text,
[data-theme="light"] .direction-buttons .call-btn .direction-text,
body[data-theme="light"] .direction-buttons .call-btn .direction-text {
  color: #2E7D32 !important;
  font-weight: 700 !important;
}

html[data-theme="light"] .direction-buttons .call-btn .profit-text,
[data-theme="light"] .direction-buttons .call-btn .profit-text,
body[data-theme="light"] .direction-buttons .call-btn .profit-text {
  color: #388E3C !important;
  font-weight: 600 !important;
}

html[data-theme="light"] .direction-buttons .call-btn:hover,
[data-theme="light"] .direction-buttons .call-btn:hover,
body[data-theme="light"] .direction-buttons .call-btn:hover {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.15), rgba(76, 175, 80, 0.2)) !important;
  border-color: rgba(76, 175, 80, 0.5) !important;
}

html[data-theme="light"] .direction-buttons .call-btn.active,
[data-theme="light"] .direction-buttons .call-btn.active,
body[data-theme="light"] .direction-buttons .call-btn.active {
  background: linear-gradient(135deg, #4CAF50, #66BB6A) !important;
  border-color: #4CAF50 !important;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3) !important;
}

html[data-theme="light"] .direction-buttons .call-btn.active .direction-text,
[data-theme="light"] .direction-buttons .call-btn.active .direction-text,
body[data-theme="light"] .direction-buttons .call-btn.active .direction-text {
  color: #ffffff !important;
  font-weight: 800 !important;
}

html[data-theme="light"] .direction-buttons .call-btn.active .profit-text,
[data-theme="light"] .direction-buttons .call-btn.active .profit-text,
body[data-theme="light"] .direction-buttons .call-btn.active .profit-text {
  color: #ffffff !important;
  font-weight: 700 !important;
}

/* 看跌按钮白天模式 */
html[data-theme="light"] .direction-buttons .put-btn,
[data-theme="light"] .direction-buttons .put-btn,
body[data-theme="light"] .direction-buttons .put-btn {
  background: linear-gradient(135deg, rgba(244, 67, 54, 0.08), rgba(244, 67, 54, 0.12)) !important;
  border: 2px solid rgba(244, 67, 54, 0.3) !important;
}

html[data-theme="light"] .direction-buttons .put-btn .direction-text,
[data-theme="light"] .direction-buttons .put-btn .direction-text,
body[data-theme="light"] .direction-buttons .put-btn .direction-text {
  color: #C62828 !important;
  font-weight: 700 !important;
}

html[data-theme="light"] .direction-buttons .put-btn .profit-text,
[data-theme="light"] .direction-buttons .put-btn .profit-text,
body[data-theme="light"] .direction-buttons .put-btn .profit-text {
  color: #D32F2F !important;
  font-weight: 600 !important;
}

html[data-theme="light"] .direction-buttons .put-btn:hover,
[data-theme="light"] .direction-buttons .put-btn:hover,
body[data-theme="light"] .direction-buttons .put-btn:hover {
  background: linear-gradient(135deg, rgba(244, 67, 54, 0.15), rgba(244, 67, 54, 0.2)) !important;
  border-color: rgba(244, 67, 54, 0.5) !important;
}

html[data-theme="light"] .direction-buttons .put-btn.active,
[data-theme="light"] .direction-buttons .put-btn.active,
body[data-theme="light"] .direction-buttons .put-btn.active {
  background: linear-gradient(135deg, #F44336, #EF5350) !important;
  border-color: #F44336 !important;
  box-shadow: 0 4px 15px rgba(244, 67, 54, 0.3) !important;
}

html[data-theme="light"] .direction-buttons .put-btn.active .direction-text,
[data-theme="light"] .direction-buttons .put-btn.active .direction-text,
body[data-theme="light"] .direction-buttons .put-btn.active .direction-text {
  color: #ffffff !important;
  font-weight: 800 !important;
}

html[data-theme="light"] .direction-buttons .put-btn.active .profit-text,
[data-theme="light"] .direction-buttons .put-btn.active .profit-text,
body[data-theme="light"] .direction-buttons .put-btn.active .profit-text {
  color: #ffffff !important;
  font-weight: 700 !important;
}
</style>

<style>
/* 终极强制白天模式覆盖 - 最高优先级 */

/* 当body或html有light主题时 */
body.light .content_main_right .content_main_right_top,
html.light .content_main_right .content_main_right_top,
.light .content_main_right .content_main_right_top,
body[class*="light"] .content_main_right .content_main_right_top {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

body.light .block_kline,
html.light .block_kline,
.light .block_kline,
body[class*="light"] .block_kline {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

body.light .block_list,
html.light .block_list,
.light .block_list,
body[class*="light"] .block_list {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

/* 尝试用通用CSS变量方式 */
:root[data-theme="light"] .content_main_right .content_main_right_top,
:root[data-theme="light"] .block_kline,
:root[data-theme="light"] .block_list {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

/* 强制所有容器白天模式 */
.futures[data-theme="light"] .content_main_right .content_main_right_top,
.futures[data-theme="light"] .block_kline,
.futures[data-theme="light"] .block_list {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
}

/* 直接覆盖所有可能的选择器 */
[data-theme="light"] * .content_main_right_top,
html[data-theme="light"] * .content_main_right_top {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
}

/* 更全面的白天模式样式覆盖 */
body.light,
html.light,
.light,
[data-theme="light"],
html[data-theme="light"],
body[data-theme="light"] {
  
  /* ArcoDesign 输入框白天模式 */
  .arco-input-wrapper,
  .arco-input {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .arco-input::placeholder {
    color: #999999 !important;
  }
  
  /* ArcoDesign 选择框白天模式 */
  .arco-select-view-single {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  /* ArcoDesign 下拉菜单白天模式 */
  .arco-dropdown-content,
  .arco-select-dropdown {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  }
  
  .arco-select-option,
  .arco-dropdown-option {
    color: #333333 !important;
  }
  
  .arco-select-option:hover,
  .arco-dropdown-option:hover {
    background: #f5f5f5 !important;
    color: #333333 !important;
  }
  
  /* ArcoDesign 标签页白天模式 */
  .arco-tabs-nav {
    background: #ffffff !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .arco-tabs-tab {
    color: #666666 !important;
  }
  
  .arco-tabs-tab-active {
    color: #1890ff !important;
  }
  
  .arco-tabs-content {
    background: #ffffff !important;
    color: #333333 !important;
  }
  
  /* 文字颜色白天模式 - 使用CSS变量 */
  .font-12,
  .color-gray,
  .color-black {
    color: var(--content-primary) !important;
  }
  
  /* 配置项白天模式 */
  .config-header,
  .order-header {
    color: #333333 !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .config-item,
  .order-item {
    color: #333333 !important;
    border-bottom: 1px solid #f0f0f0 !important;
  }
  
  .config-item:hover,
  .order-item:hover {
    background: #f5f5f5 !important;
  }
  
  /* 按钮白天模式 */
  .percentage-btn {
    background: #f5f5f5 !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .percentage-btn:hover {
    background: #e6f7ff !important;
    border-color: #91d5ff !important;
  }
  
  /* 提示信息白天模式 */
  .warning-text {
    color: #ff7875 !important;
  }
  
  .warning-text span {
    color: #ff7875 !important;
  }
  
  /* 期权交易特定组件白天模式 */
  ._hd {
    color: #333333 !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .direction-buttons .btn {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .direction-buttons .btn:hover {
    border-color: #40a9ff !important;
  }
  
  .direction-buttons .btn.active.call {
    background: linear-gradient(135deg, #52c41a, #73d13d) !important;
    color: #ffffff !important;
  }
  
  .direction-buttons .btn.active.put {
    background: linear-gradient(135deg, #ff4d4f, #ff7875) !important;
    color: #ffffff !important;
  }
  
  .direction-text,
  .profit-text {
    color: inherit !important;
  }
  
  /* 投资金额区域简洁设计 */
  .amount-input-section {
    background: #ffffff !important;
    border-radius: 8px !important;
    padding: 16px !important;
    border: 1px solid #e8e8e8 !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
    margin: 16px 0 !important;
    width: 100% !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
  }
  
  .amount-label {
    background: transparent !important;
    color: #333333 !important;
  }
  
  .amount-label .label-text {
    color: #333333 !important;
    font-weight: 600 !important;
    font-size: 14px !important;
  }
  
  .amount-label .available-balance {
    color: #666666 !important;
    font-size: 12px !important;
    font-weight: 500 !important;
  }
  
  .amount-input-wrapper {
    background: #ffffff !important;
    border-radius: 6px !important;
    margin: 8px 0 !important;
  }
  
  .amount-input .arco-input-wrapper,
  .amount-input .arco-input {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #000000 !important;
    font-weight: 600 !important;
    font-size: 16px !important;
    border-radius: 6px !important;
    min-height: 48px !important;
    text-align: left !important;
  }
  
  /* 修复输入框后缀容器对齐 */
  .amount-input .arco-input-wrapper {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  
  /* 输入框布局优化 */
  .amount-input .arco-input-wrapper,
  .amount-input-wrapper .arco-input-wrapper,
  .amount-input-section .arco-input-wrapper {
    height: 48px !important;
  }
  
  .amount-input .arco-input,
  .amount-input-wrapper .arco-input,
  .amount-input-section .arco-input {
    height: 46px !important;
    line-height: 46px !important;
    padding-right: 60px !important;
  }
  
  .amount-input .arco-input::placeholder {
    color: #bfbfbf !important;
    font-weight: 500 !important;
    font-size: 18px !important;
  }
  
  /* 移除复杂样式 - 这些会被新的简洁样式替代 */
  
  /* 百分比按钮容器布局修复 */
  .percentage-buttons {
    display: flex !important;
    gap: 8px !important;
    margin-top: 12px !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }
  
  .percentage-btn {
    flex: 1 !important;
    background: #f5f5f5 !important;
    border: 1px solid #d9d9d9 !important;
    color: #666666 !important;
    font-weight: 500 !important;
    border-radius: 4px !important;
    padding: 8px 4px !important;
    margin: 0 !important;
    font-size: 13px !important;
    transition: all 0.2s ease !important;
    text-align: center !important;
    white-space: nowrap !important;
    min-width: 0 !important;
  }
  
  .percentage-btn:hover {
    background: #e6f7ff !important;
    border-color: #91d5ff !important;
    color: #1890ff !important;
  }
  
  .percentage-btn.active {
    background: #1890ff !important;
    border-color: #1890ff !important;
    color: #ffffff !important;
    font-weight: 600 !important;
  }
  
  /* 终极修复 - 确保所有可能的隐藏内容都可见 */
  .content_main_right * {
    color: inherit !important;
  }
  
  .content_main_right .arco-input,
  .content_main_right .arco-input-wrapper,
  .content_main_right .arco-select,
  .content_main_right .arco-select-view {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .content_main_right .arco-btn {
    background: #f5f5f5 !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .content_main_right .arco-btn-primary {
    background: #1890ff !important;
    border-color: #1890ff !important;
    color: #ffffff !important;
  }
  
  /* 特别修复可能的透明或半透明元素 */
  .content_main_right [style*="opacity"],
  .content_main_right [style*="background"],
  .content_main_right [style*="color"] {
    opacity: 1 !important;
  }
  
  /* 强制显示所有隐藏的文本内容 */
  .content_main_right span,
  .content_main_right div,
  .content_main_right p,
  .content_main_right label {
    color: #333333 !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  
  /* 特殊处理可能的白色或浅色文字 */
  .content_main_right .color-white,
  .content_main_right .text-white,
  .content_main_right [style*="color: #fff"],
  .content_main_right [style*="color: white"] {
    color: #333333 !important;
  }
  
  /* 红框标记区域专用修复 - 确保绝对可见 */
  .contract-coin-selector,
  .amount-input-section,
  .content_main_right {
    background: #ffffff !important;
    color: #333333 !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  
  /* 最高优先级修复 - 覆盖所有可能的冲突样式 */
  html[data-theme="light"] .contract-coin-selector .coin-pair,
  html.light .contract-coin-selector .coin-pair,
  body[data-theme="light"] .contract-coin-selector .coin-pair,
  body.light .contract-coin-selector .coin-pair {
    color: #000000 !important;
    font-weight: 800 !important;
    font-size: 16px !important;
    text-shadow: 1px 1px 2px rgba(255,255,255,0.8) !important;
  }
  
  html[data-theme="light"] .amount-input-section,
  html.light .amount-input-section,
  body[data-theme="light"] .amount-input-section,
  body.light .amount-input-section {
    background: #ffffff !important;
    border: 1px solid #e8e8e8 !important;
    color: #333333 !important;
  }
  
  html[data-theme="light"] .amount-input-section *,
  html.light .amount-input-section *,
  body[data-theme="light"] .amount-input-section *,
  body.light .amount-input-section * {
    color: inherit !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  
  /* 倒计时显示白天模式 */
  .countdown-card {
    background: #f5f5f5 !important;
    border: 1px solid #e8e8e8 !important;
    color: #333333 !important;
  }
  
  .countdown-label,
  .countdown-time {
    color: #333333 !important;
  }
  
  /* 收益信息白天模式 */
  .profit-card {
    background: #f5f5f5 !important;
    border: 1px solid #e8e8e8 !important;
    color: #333333 !important;
  }
  
  .profit-card .label,
  .profit-card .value {
    color: #333333 !important;
  }
  
  /* 重复的提交按钮样式已移除 - 使用统一的颜色主题 */
  
  /* 币种选择器白天模式 */
  .contract-coin-selector {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .contract-coin-selector:hover {
    border-color: #40a9ff !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  }
  
  .contract-dropdown {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  }
  
  .coin-item {
    color: #333333 !important;
  }
  
  .coin-item:hover {
    background: #f5f5f5 !important;
    color: #1890ff !important;
  }
  
  .item-pair {
    color: #666666 !important;
  }
  
  /* 期权配置选择框白天模式强化显示 */
  [data-theme="light"] .config-select .arco-select-view-single,
  html[data-theme="light"] .config-select .arco-select-view-single,
  body[data-theme="light"] .config-select .arco-select-view-single {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #000000 !important;
    font-weight: 600 !important;
  }
  
  /* 下拉选项容器白天模式 */
  [data-theme="light"] .config-select .arco-select-dropdown,
  html[data-theme="light"] .config-select .arco-select-dropdown,
  body[data-theme="light"] .config-select .arco-select-dropdown {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15) !important;
  }
  
  /* 下拉选项白天模式 */
  [data-theme="light"] .config-select .arco-select-option,
  html[data-theme="light"] .config-select .arco-select-option,
  body[data-theme="light"] .config-select .arco-select-option {
    color: #000000 !important;
    background: #ffffff !important;
    font-weight: 500 !important;
    padding: 10px 16px !important;
  }
  
  /* 下拉选项悬停白天模式 */
  [data-theme="light"] .config-select .arco-select-option:hover,
  html[data-theme="light"] .config-select .arco-select-option:hover,
  body[data-theme="light"] .config-select .arco-select-option:hover {
    background: #e6f7ff !important;
    color: #1890ff !important;
    font-weight: 600 !important;
  }
  
  /* 选中状态白天模式 */
  [data-theme="light"] .config-select .arco-select-option.arco-select-option-selected,
  html[data-theme="light"] .config-select .arco-select-option.arco-select-option-selected,
  body[data-theme="light"] .config-select .arco-select-option.arco-select-option-selected {
    background: #f0f9ff !important;
    color: #1890ff !important;
    font-weight: 700 !important;
  }
  
  /* 币种选择和价格信息条白天模式 - 最重要的修复 */
  .content_head {
    background: #ffffff !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .content_head .content_head_left {
    background: #ffffff !important;
  }
  
  .content_head .content_head_right {
    background: #ffffff !important;
    color: #333333 !important;
  }
  
  .content_head .contract-coin-selector {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .content_head .main-price-display {
    background: #ffffff !important;
    color: #333333 !important;
  }
  
  .content_head .stats-info {
    background: #ffffff !important;
    color: #333333 !important;
  }
  
  .content_head .stat-item {
    background: #ffffff !important;
  }
  
  .content_head .stat-label {
    color: #999999 !important;
  }
  
  .content_head .stat-value {
    color: #333333 !important;
  }
  
  /* 🎯 热门币种区域白天模式 - 完整修复 */
  .hotCoin {
    background: #ffffff !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .hotCoin .item {
    color: #333333 !important;
    background: #ffffff !important;
  }
  
  .hotCoin .item:hover {
    background: #f5f5f5 !important;
  }
  
  .hotCoin .item .color-black,
  .hotCoin .item span:first-child {
    color: #000000 !important;
    font-weight: 600 !important;
  }
  
  .hotCoin .item .color-green {
    color: #52c41a !important;
    font-weight: 500 !important;
  }
  
  .hotCoin .item .color-red {
    color: #ff4d4f !important;
    font-weight: 500 !important;
  }
  
  /* futures_content 白天模式 */
  .futures_content {
    background: #f8f9fa !important;
  }
  
  /* 期权配置列表区域白天模式 - 更具体的选择器 */
  .block_list {
    background: #ffffff !important;
    border: 1px solid #e8e8e8 !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  }
  
  .block_list .arco-tabs {
    background: #ffffff !important;
  }
  
  .block_list .arco-tabs-nav {
    background: #ffffff !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .block_list .arco-tabs-content {
    background: #ffffff !important;
    color: #333333 !important;
    height: calc(100% - 48px) !important;
    overflow: hidden !important;
  }
  
  .block_list .active-orders,
  .block_list .history-orders {
    background: #ffffff !important;
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
  }
  
  .block_list .config-header,
  .block_list .order-header {
    background: #ffffff !important;
    color: #333333 !important;
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .block_list .config-item,
  .block_list .order-item {
    background: #ffffff !important;
    color: #333333 !important;
    border-bottom: 1px solid #f0f0f0 !important;
  }
  
  .block_list .config-item:hover,
  .block_list .order-item:hover {
    background: #f5f5f5 !important;
  }
  
  .block_list .config-item.active {
    background: #e6f7ff !important;
    border-color: #91d5ff !important;
  }
  
  /* ArcoDesign滚动条在期权配置区域的白天模式 */
  .block_list .arco-scrollbar {
    background: #ffffff !important;
    height: calc(100% - 40px) !important;
    flex: 1 !important;
  }
  
  .block_list .arco-scrollbar-track {
    background: #f5f5f5 !important;
  }
  
  .block_list .arco-scrollbar-thumb {
    background: #d9d9d9 !important;
  }
  
  .block_list .arco-scrollbar-thumb:hover {
    background: #bfbfbf !important;
  }
  
  /* 强制覆盖 - 币种选择器下拉框白天模式 */
  .contract-dropdown {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  }
  
  /* 强制覆盖 - ArcoDesign下拉框内容 */
  .arco-dropdown-content .contract-dropdown {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  }
  
  /* 强制覆盖 - 币种选择器输入框 */
  .contract-dropdown .arco-input-wrapper {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
  }
  
  .contract-dropdown .arco-input {
    background: #ffffff !important;
    color: #333333 !important;
  }
  
  .contract-dropdown .arco-input::placeholder {
    color: #999999 !important;
  }
  
  /* 强制覆盖 - 币种列表 */
  .contract-dropdown .coin-list {
    background: #ffffff !important;
  }
  
  .contract-dropdown .coin-list-container {
    background: #ffffff !important;
  }
  
  /* 🎯 币种选择器项目白天模式 - 无边框干净设计 */
  .contract-dropdown .coin-item {
    background: #ffffff !important;
    color: #333333 !important;
    border: none !important; /* 确保白天模式无边框 */
    border-bottom: none !important; /* 明确移除下边框 */
  }
  
  .contract-dropdown .coin-item:hover {
    background: #f5f5f5 !important;
    color: #1890ff !important;
    border: none !important; /* 悬停时也无边框 */
    border-bottom: none !important;
  }
  
  .contract-dropdown .item-pair {
    color: #666666 !important;
  }
  
  /* 强制覆盖 - 右侧交易面板白天模式 */
  .content_main_right {
    background: #ffffff !important;
  }
  
  .content_main_right .content_main_right_top {
    background: #ffffff !important;
    border: 1px solid #e8e8e8 !important;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1) !important;
  }
  
  .content_main_right ._hd {
    border-bottom: 1px solid #e8e8e8 !important;
    color: #333333 !important;
  }
  
  .content_main_right .balance-info {
    color: #333333 !important;
  }
  
  .content_main_right .trading-form {
    background: #ffffff !important;
  }
  
  .content_main_right .form-item {
    background: #ffffff !important;
    color: #333333 !important;
  }
  
  .content_main_right .form-item label {
    color: #333333 !important;
  }
  
  .content_main_right .arco-input {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .content_main_right .arco-input::placeholder {
    color: #999999 !important;
  }
  
  .content_main_right .arco-btn {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #333333 !important;
  }
  
  .content_main_right .arco-btn-primary {
    background: #1890ff !important;
    border-color: #1890ff !important;
    color: #ffffff !important;
  }
  
  /* 特定区域强制覆盖 - 避免影响K线图 */
  .contract-dropdown *[style*="linear-gradient"] {
    background: #ffffff !important;
  }
  
  .content_main_right *[style*="linear-gradient"] {
    background: #ffffff !important;
  }
  
  /* 终极强制覆盖 - 确保被红框标记的区域一定是白色 */
  .content_head,
  .content_head *,
  .content_head .content_head_left,
  .content_head .content_head_right,
  .content_head .contract-coin-selector,
  .content_head .main-price-display,
  .content_head .stats-info,
  .content_head .stat-item {
    background: #ffffff !important;
    background-color: #ffffff !important;
    background-image: none !important;
  }
  
  .content_head {
    border-bottom: 1px solid #e8e8e8 !important;
  }
  
  .content_head .contract-coin-selector {
    border: 1px solid #d9d9d9 !important;
  }
  
  /* 强制覆盖所有可能的深色渐变背景在content_head区域 */
  .content_head *[style*="linear-gradient"],
  .content_head *[style*="background"],
  .content_head [style*="background"] {
    background: #ffffff !important;
    background-color: #ffffff !important;
    background-image: none !important;
  }
  
  /* 终极修复 - 币种选择器文字看不见问题 */
  .contract-coin-selector,
  .contract-coin-selector *,
  .contract-coin-selector span,
  .contract-coin-selector .coin-pair,
  .content_head .contract-coin-selector,
  .content_head .contract-coin-selector *,
  .content_head .contract-coin-selector span,
  .content_head .contract-coin-selector .coin-pair {
    color: #1a1a1a !important;
    font-weight: 700 !important;
    text-shadow: none !important;
    opacity: 1 !important;
    visibility: visible !important;
    background: transparent !important;
  }
  
  /* 超级强力修复 - 确保币种选择器容器正确显示 */
  .contract-coin-selector {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    border-radius: 6px !important;
    padding: 8px 12px !important;
    min-width: 120px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    cursor: pointer !important;
  }
  
  /* 强制覆盖任何可能的白色文字 */
  .contract-coin-selector[style*="color: white"],
  .contract-coin-selector[style*="color: #fff"],
  .contract-coin-selector[style*="color: #ffffff"],
  .contract-coin-selector *[style*="color: white"],
  .contract-coin-selector *[style*="color: #fff"],
  .contract-coin-selector *[style*="color: #ffffff"] {
    color: #000000 !important;
  }
  
  /* 强力修复 - 确保右侧交易面板所有内容可见 */
  .content_main_right {
    background: #ffffff !important;
    border-radius: 8px !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
  }
  
  .content_main_right .content_main_right_top {
    background: #ffffff !important;
    border: 1px solid #e8e8e8 !important;
    border-radius: 8px !important;
    padding: 20px !important;
  }
  
  .content_main_right ._hd {
    background: transparent !important;
    border-bottom: 1px solid #e8e8e8 !important;
    color: #333333 !important;
    padding-bottom: 16px !important;
    margin-bottom: 20px !important;
  }
  
  .content_main_right ._hd .font-bold {
    color: #000000 !important;
    font-weight: 700 !important;
  }
  
  .content_main_right .balance-info {
    color: #333333 !important;
  }
  
  .content_main_right .balance-info span {
    color: inherit !important;
  }
  
  /* 修复所有可能的灰色区域 */
  .content_main_right ._row {
    background: transparent !important;
    margin-bottom: 16px !important;
  }
  
  .content_main_right label,
  .content_main_right .label-text {
    color: #333333 !important;
    font-weight: 600 !important;
  }
  
  /* 终极内联样式修复 - 最高优先级 */
  .contract-coin-selector[style] {
    color: #1a1a1a !important;
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
  }
  
  .contract-coin-selector .coin-pair[style],
  .contract-coin-selector span[style] {
    color: #1a1a1a !important;
    font-weight: 700 !important;
    font-size: 15px !important;
  }
  
  /* 温和修复 - 币种文字可见性 */
  .contract-coin-selector .coin-pair,
  .content_head .contract-coin-selector .coin-pair {
    color: #1a1a1a !important;
    opacity: 1 !important;
    visibility: visible !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    background: transparent !important;
  }
  
  /* 强力CSS修复 - 确保币种选择器完全可见 */
  .contract-coin-selector {
    background: #ffffff !important;
    background-color: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    border-radius: 6px !important;
    color: #1a1a1a !important;
    padding: 8px 12px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
    min-width: 120px !important;
  }
  
  /* 强力修复币种名称文字 */
  .contract-coin-selector .coin-pair,
  .contract-coin-selector span.coin-pair {
    color: #1a1a1a !important;
    font-weight: 700 !important;
    font-size: 15px !important;
    opacity: 1 !important;
    visibility: visible !important;
    display: inline-block !important;
    background: transparent !important;
    text-shadow: none !important;
  }
  
  /* 确保币种图标可见 */
  .contract-coin-selector .coin-logo,
  .contract-coin-selector img.coin-logo {
    opacity: 1 !important;
    display: inline-block !important;
    width: 20px !important;
    height: 20px !important;
    filter: none !important;
  }
  
  /* 确保下拉箭头可见 */
  .contract-coin-selector .arrow-down {
    color: #666666 !important;
    opacity: 1 !important;
    display: inline-block !important;
  }
  
  /* 覆盖任何可能的隐藏样式 */
  .contract-coin-selector * {
    color: inherit !important;
    opacity: 1 !important;
    visibility: visible !important;
  }
  
  /* 特别强化：针对Vue渲染的文本节点 */
  .content_head .contract-coin-selector {
    background: #ffffff !important;
    color: #1a1a1a !important;
  }
  
  .content_head .contract-coin-selector .coin-pair {
    color: #000000 !important;
    font-weight: 800 !important;
    font-size: 16px !important;
  }
  
  /* 币种选择器简洁设计 */
  .contract-coin-selector {
    position: relative !important;
    z-index: 10 !important;
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    border-radius: 6px !important;
    padding: 8px 12px !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
    min-width: 120px !important;
    min-height: 36px !important;
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }
  
  .contract-coin-selector .coin-pair {
    color: #333333 !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    text-decoration: none !important;
  }
  
  /* 币种图标简洁设计 */
  .contract-coin-selector .coin-logo {
    width: 20px !important;
    height: 20px !important;
    opacity: 1 !important;
    border-radius: 50% !important;
    flex-shrink: 0 !important;
  }
  
  /* 下拉箭头简洁设计 */
  .contract-coin-selector .arrow-down {
    color: #999999 !important;
    font-size: 12px !important;
    opacity: 1 !important;
    flex-shrink: 0 !important;
  }
  
  /* Vue数据绑定的币种名称修复 - 最终版本 */
  .coin-pair,
  .contract-coin-selector .coin-pair {
    color: #000000 !important;
    font-weight: 800 !important;
    font-size: 16px !important;
    opacity: 1 !important;
    visibility: visible !important;
    background: transparent !important;
    text-decoration: none !important;
    border: none !important;
    outline: none !important;
  }
  
  /* 确保在任何情况下都可见 */
  .contract-coin-selector:hover .coin-pair,
  .contract-coin-selector:focus .coin-pair,
  .contract-coin-selector:active .coin-pair {
    color: #000000 !important;
    font-weight: 800 !important;
  }
  
  /* 确保币种图标也可见 */
  .coin-logo,
  img.coin-logo,
  .contract-coin-selector img.coin-logo {
    opacity: 1 !important;
    filter: none !important;
    display: inline-block !important;
    width: 20px !important;
    height: 20px !important;
  }
}




body.light .kline,
body.light .chart-container,
body.light .tradingview-widget,
body.light .echart-container {
  background: #ffffff !important;
  background-color: #ffffff !important;
}





/* 白天模式文字颜色全面优化 - 使用CSS变量 */

/* 1. 基础文字颜色 - 移除硬编码，使用CSS变量 */
.color-black {
  color: var(--content-primary) !important;
}

.color-gray {
  color: var(--content-tertiary) !important;
}

.color-white {
  color: var(--content-primary) !important;
}

/* 2. 期权配置区域文字优化 */
.config-header span,
.order-header span {
  color: #333333 !important;
  font-weight: 500 !important;
}

.config-item .config-duration span,
.config-item .config-profit span,
.config-item .config-fee span {
  color: #1a1a1a !important;
  font-weight: 500 !important;
}

.order-item .order-pair,
.order-item .order-direction,
.order-item .order-amount,
.order-item .order-status {
  color: #1a1a1a !important;
}

/* 3. 价格显示区域文字优化 */
.main-price-display .price-value {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

.main-price-display .price-change {
  font-weight: 500 !important;
}

.stats-info .stat-label {
  color: #666666 !important;
  font-weight: 400 !important;
}

.stats-info .stat-value {
  color: #1a1a1a !important;
  font-weight: 500 !important;
}

/* 4. 币种选择器文字优化 - 强制深色文字 */
.contract-coin-selector {
  color: #1a1a1a !important;
}

.contract-coin-selector .coin-pair {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

.contract-coin-selector .arrow-down {
  color: #666666 !important;
}

.contract-coin-selector * {
  color: #1a1a1a !important;
}

/* 特别针对币种选择器的强制文字颜色 */
.content_head .contract-coin-selector,
.content_head .contract-coin-selector *,
.content_head .contract-coin-selector .coin-pair,
.content_head .contract-coin-selector span {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

/* 修复币种选择器图标显示 */
.contract-coin-selector .coin-logo {
  opacity: 1 !important;
  filter: none !important;
}

/* 5. 交易面板文字优化 */
.content_main_right ._hd .font-bold {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

.balance-info .font-12 {
  color: #666666 !important;
}

.balance-info .font-14 {
  color: #1a1a1a !important;
  font-weight: 500 !important;
}

/* 6. 输入框和表单文字优化 */
.trading-form label,
.form-item label {
  color: #333333 !important;
  font-weight: 500 !important;
}

.arco-input {
  color: #1a1a1a !important;
}

.arco-input::placeholder {
  color: #999999 !important;
}

/* 7. 按钮文字优化 */
.arco-btn {
  color: #333333 !important;
  font-weight: 500 !important;
}

.arco-btn-primary {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* 8. 标签页文字优化 */
.arco-tabs-tab {
  color: #666666 !important;
}

.arco-tabs-tab-active {
  color: #1890ff !important;
  font-weight: 600 !important;
}

/* 9. 热门币种区域文字优化 */
.hotCoin .item span {
  font-weight: 500 !important;
}

.hotCoin .color-black {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

/* 10. 通用字体大小对应的颜色优化 */
.font-12 {
  color: #666666 !important;
}

.font-14 {
  color: #333333 !important;
}

.font-16 {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

/* 11. 特殊状态文字颜色 */
.text-green,
.color-green {
  color: #52c41a !important;
  font-weight: 500 !important;
}

.text-red,
.color-red {
  color: #ff4d4f !important;
  font-weight: 500 !important;
}

.color-primary {
  color: #1890ff !important;
  font-weight: 500 !important;
}

.color-blue {
  color: #1890ff !important;
  font-weight: 500 !important;
}

/* 12. 倒计时和状态文字 */
.countdown-display {
  color: #1a1a1a !important;
  font-weight: 600 !important;
  font-size: 24px !important;
}

.profit-display {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

/* 13. 确保所有文字都有最小对比度 */
* {
  color: inherit;
}

/* 14. 强制覆盖可能的浅色文字 */
span, div, p, label, input, button, a {
  color: inherit !important;
}

/* 15. 特别优化小字体的可读性 */
.font-10, .font-11, .font-12 {
  color: #666666 !important;
  font-weight: 500 !important;
}

.font-13, .font-14, .font-15, .font-16 {
  color: #333333 !important;
  font-weight: 500 !important;
}

.font-18, .font-20, .font-24 {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

/* ✨ 简洁清爽的白天模式样式 */
[data-theme="light"] .contract-coin-selector,
html[data-theme="light"] .contract-coin-selector,
body[data-theme="light"] .contract-coin-selector {
  background: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
}

[data-theme="light"] .amount-input-section,
html[data-theme="light"] .amount-input-section,
body[data-theme="light"] .amount-input-section {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05) !important;
}

[data-theme="light"] .contract-coin-selector .coin-pair,
html[data-theme="light"] .contract-coin-selector .coin-pair,
body[data-theme="light"] .contract-coin-selector .coin-pair {
  color: #333333 !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

[data-theme="light"] .amount-input .arco-input,
html[data-theme="light"] .amount-input .arco-input,
body[data-theme="light"] .amount-input .arco-input {
  color: #333333 !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  border: 1px solid #d9d9d9 !important;
  background: #ffffff !important;
}

/* 🎯 期权配置选择框终极修复 - 最高优先级 */
[data-theme="light"] .config-select,
html[data-theme="light"] .config-select,
body[data-theme="light"] .config-select {
  background: transparent !important;
}

[data-theme="light"] .config-select .arco-select,
html[data-theme="light"] .config-select .arco-select,
body[data-theme="light"] .config-select .arco-select,
[data-theme="light"] .config-select .arco-select-view,
html[data-theme="light"] .config-select .arco-select-view,
body[data-theme="light"] .config-select .arco-select-view {
  background: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  color: #000000 !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
}

[data-theme="light"] .config-select .arco-select-view-value,
html[data-theme="light"] .config-select .arco-select-view-value,
body[data-theme="light"] .config-select .arco-select-view-value {
  color: #000000 !important;
  font-weight: 700 !important;
  opacity: 1 !important;
  visibility: visible !important;
}

/* 期权配置标签文字强化显示 */
[data-theme="light"] .config-select span.font-12,
html[data-theme="light"] .config-select span.font-12,
body[data-theme="light"] .config-select span.font-12,
[data-theme="light"] .config-select .color-gray,
html[data-theme="light"] .config-select .color-gray,
body[data-theme="light"] .config-select .color-gray {
  color: #333333 !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  margin-bottom: 10px !important;
  display: block !important;
}

/* 期权配置下拉选项内容强化 */
[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option,
html[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option,
body[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option {
  color: #000000 !important;
  background: #ffffff !important;
  padding: 12px 16px !important;
  font-weight: 500 !important;
  border-bottom: 1px solid #f0f0f0 !important;
}

[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option:hover,
html[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option:hover,
body[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option:hover {
  background: #e6f7ff !important;
  color: #1890ff !important;
  font-weight: 600 !important;
}

[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option.arco-select-option-selected,
html[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option.arco-select-option-selected,
body[data-theme="light"] .config-select .arco-select-dropdown .arco-select-option.arco-select-option-selected {
  background: #f0f9ff !important;
  color: #1890ff !important;
  font-weight: 700 !important;
}

/* 🎨 USDT后缀简洁设计 */
.amount-input .arco-input-suffix,
.amount-input-wrapper .arco-input-suffix,
.amount-input-section .arco-input-suffix,
[data-theme="light"] .amount-input .arco-input-suffix,
[data-theme="light"] .amount-input-wrapper .arco-input-suffix,
[data-theme="light"] .amount-input-section .arco-input-suffix {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 8px !important;
  margin: 0 !important;
  height: 100% !important;
  background: transparent !important;
  border: none !important;
}

.amount-input .input-suffix,
.amount-input-wrapper .input-suffix,
.amount-input-section .input-suffix,
[data-theme="light"] .amount-input .input-suffix,
[data-theme="light"] .amount-input-wrapper .input-suffix,
[data-theme="light"] .amount-input-section .input-suffix {
  color: #999999 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  line-height: normal !important;
  text-align: center !important;
}

/* 🚀 买入期权按钮全局强力样式 - 确保ArcoDesign样式被完全覆盖 */

/* 看涨期权买入按钮 - 全局绿色主题 */
.submit-btn.call-submit.arco-btn,
.arco-btn.submit-btn.call-submit,
.submit-btn.call-submit {
  background: linear-gradient(135deg, #4CAF50, #66BB6A) !important;
  background-color: #4CAF50 !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.4) !important;
  position: relative !important;
}

.submit-btn.call-submit.arco-btn:hover:not(:disabled),
.arco-btn.submit-btn.call-submit:hover:not(:disabled),
.submit-btn.call-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #388E3C, #4CAF50) !important;
  background-color: #388E3C !important;
  border: none !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(76, 175, 80, 0.5) !important;
}

/* 看跌期权买入按钮 - 全局红色主题 */
.submit-btn.put-submit.arco-btn,
.arco-btn.submit-btn.put-submit,
.submit-btn.put-submit {
  background: linear-gradient(135deg, #F44336, #EF5350) !important;
  background-color: #F44336 !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 4px 15px rgba(244, 67, 54, 0.4) !important;
  position: relative !important;
}

.submit-btn.put-submit.arco-btn:hover:not(:disabled),
.arco-btn.submit-btn.put-submit:hover:not(:disabled),
.submit-btn.put-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #D32F2F, #F44336) !important;
  background-color: #D32F2F !important;
  border: none !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(244, 67, 54, 0.5) !important;
}

/* 确保按钮文字和图标清晰可见 */
.submit-btn.call-submit .arco-btn-text,
.submit-btn.put-submit .arco-btn-text,
.submit-btn.call-submit,
.submit-btn.put-submit {
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 700 !important;
}

/* 禁用状态覆盖 */
.submit-btn:disabled.arco-btn,
.arco-btn.submit-btn:disabled,
.submit-btn:disabled {
  opacity: 0.4 !important;
  cursor: not-allowed !important;
  transform: none !important;
  box-shadow: none !important;
  background: #cccccc !important;
  border: none !important;
}

/* 移除ArcoDesign默认的主要按钮样式 */
.submit-btn.arco-btn-primary,
.arco-btn-primary.submit-btn {
  background: none !important;
  border: none !important;
}

.submit-btn.arco-btn-primary.call-submit,
.arco-btn-primary.submit-btn.call-submit {
  background: linear-gradient(135deg, #4CAF50, #66BB6A) !important;
  background-color: #4CAF50 !important;
}

.submit-btn.arco-btn-primary.put-submit,
.arco-btn-primary.submit-btn.put-submit {
  background: linear-gradient(135deg, #F44336, #EF5350) !important;
  background-color: #F44336 !important;
}

/* 按钮激活和聚焦状态 */
.submit-btn:active:not(:disabled),
.submit-btn:focus:not(:disabled) {
  outline: none !important;
  box-shadow: inherit !important;
}

.submit-btn.call-submit:active:not(:disabled) {
  background: linear-gradient(135deg, #2E7D32, #388E3C) !important;
  transform: translateY(0) !important;
}

.submit-btn.put-submit:active:not(:disabled) {
  background: linear-gradient(135deg, #C62828, #D32F2F) !important;
  transform: translateY(0) !important;
}

/* 🚀 终极修复：确保币种选择器无任何边框 - 避免双下划线 */
.contract-dropdown *,
.contract-dropdown *::before,
.contract-dropdown *::after {
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  outline: none !important;
}

/* 币种选择器项目绝对无边框 - 最高优先级 */
body .contract-dropdown .coin-item,
html .contract-dropdown .coin-item,
.contract-dropdown .coin-item,
.contract-dropdown .coin-item:hover,
.contract-dropdown .coin-item:focus,
.contract-dropdown .coin-item:active,
.contract-dropdown .coin-item:visited,
.contract-dropdown .coin-item:link {
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  outline: none !important;
  box-shadow: none !important;
  text-decoration: none !important;
}

/* 确保白天模式也无边框 */
[data-theme="light"] .contract-dropdown *,
html[data-theme="light"] .contract-dropdown *,
body[data-theme="light"] .contract-dropdown *,
[data-theme="light"] .contract-dropdown .coin-item,
html[data-theme="light"] .contract-dropdown .coin-item,
body[data-theme="light"] .contract-dropdown .coin-item {
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  outline: none !important;
}

/* 防止任何可能的边框继承 */
.contract-dropdown {
  border-collapse: separate !important;
}

.contract-dropdown .coin-list,
.contract-dropdown .coin-list-container {
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
}

/* 🎯 超级强力边框移除 - 使用最高特异性 */
body div.contract-dropdown div.coin-list div.coin-list-container div.coin-item,
html div.contract-dropdown div.coin-list div.coin-list-container div.coin-item,
div.contract-dropdown div.coin-list div.coin-list-container div.coin-item {
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  outline: none !important;
  text-decoration: none !important;
  box-shadow: none !important;
  background-clip: padding-box !important;
}

/* 移除任何可能的list-style */
.contract-dropdown .coin-item {
  list-style: none !important;
  list-style-type: none !important;
  list-style-image: none !important;
  list-style-position: outside !important;
}

/* 确保没有下划线或装饰线 */
.contract-dropdown .coin-item,
.contract-dropdown .coin-item *,
.contract-dropdown .item-pair,
.contract-dropdown .item-logo {
  text-decoration: none !important;
  text-decoration-line: none !important;
  text-decoration-color: transparent !important;
  text-decoration-style: none !important;
  text-underline-offset: 0 !important;
}

/* 移除任何可能的分隔符 */
.contract-dropdown .coin-item:not(:last-child)::after,
.contract-dropdown .coin-item::after,
.contract-dropdown .coin-item::before {
  content: none !important;
  display: none !important;
  border: none !important;
  background: none !important;
  height: 0 !important;
  width: 0 !important;
}

/* 🔥 超级强力样式 - 覆盖所有可能的ArcoDesign边框 */
.arco-dropdown-content .contract-dropdown .coin-item,
.arco-dropdown .contract-dropdown .coin-item,
body .arco-dropdown-content .contract-dropdown .coin-item,
html .arco-dropdown-content .contract-dropdown .coin-item,
[class*="arco"] .contract-dropdown .coin-item,
div[class*="arco"] .contract-dropdown .coin-item {
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  outline: none !important;
  box-shadow: none !important;
  text-decoration: none !important;
  background-image: none !important;
}

/* 移除所有可能的边框样式 - 全局覆盖 */
* .contract-dropdown .coin-item,
*[id] .contract-dropdown .coin-item,
*[class] .contract-dropdown .coin-item {
  border: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  border-bottom: 0 !important;
  border-bottom-width: 0 !important;
  border-bottom-style: none !important;
  border-bottom-color: transparent !important;
}

/* 强制移除任何可能的分隔线CSS */
.contract-dropdown .coin-item {
  background-image: none !important;
  background-position: bottom !important;
  background-size: 0 !important;
  background-repeat: no-repeat !important;
  background-attachment: scroll !important;
  border-image: none !important;
  border-image-source: none !important;
  border-image-slice: 0 !important;
  border-image-width: 0 !important;
  border-image-outset: 0 !important;
  border-image-repeat: stretch !important;
}

/* 使用important覆盖任何内联样式 */
.contract-dropdown .coin-item[style*="border"] {
  border: none !important;
  border-bottom: none !important;
}

/* 强制设置为块级元素避免下划线 */
.contract-dropdown .coin-item {
  display: flex !important;
  text-decoration: none !important;
  text-decoration-line: none !important;
  text-decoration-style: none !important;
  text-decoration-color: transparent !important;
  text-underline-position: unset !important;
  text-underline-offset: 0 !important;
  border-collapse: separate !important;
}

/* 终极解决方案 - 覆盖一切可能的边框 */
body .futures .contract-dropdown .coin-item,
html .futures .contract-dropdown .coin-item,
.futures .contract-dropdown .coin-item,
.futures .arco-dropdown-content .contract-dropdown .coin-item,
body .futures .arco-dropdown-content .contract-dropdown .coin-item {
  border: 0px solid transparent !important;
  border-width: 0px !important;
  border-style: none !important;
  border-bottom: 0px solid transparent !important;
  border-bottom-width: 0px !important;
  border-bottom-style: none !important;
  border-bottom-color: transparent !important;
  box-shadow: none !important;
  outline: 0px solid transparent !important;
  outline-width: 0px !important;
  outline-style: none !important;
  text-decoration: none !important;
  background-image: none !important;
}

/* 超级强制 - 使用最高权重选择器 */
html body div.futures div.arco-dropdown-content div.contract-dropdown div.coin-list div.coin-list-container div.coin-item {
  border: none !important;
  border-bottom: none !important;
  outline: none !important;
  text-decoration: none !important;
  box-shadow: none !important;
  background-image: none !important;
  background-position: unset !important;
  background-size: unset !important;
  background-repeat: unset !important;
}

/* 🚨 最终核心武器 - 强制覆盖一切边框样式 */
.contract-dropdown .coin-item {
  border: 0 !important;
  border-bottom: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
}

.contract-dropdown .coin-item:hover {
  border: 0 !important;
  border-bottom: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
}

/* 强制移除所有可能的边框属性 */
.contract-dropdown .coin-item,
.contract-dropdown .coin-item:hover,
.contract-dropdown .coin-item:focus,
.contract-dropdown .coin-item:active {
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  border-bottom-width: 0 !important;
  border-bottom-style: none !important;
  border-bottom-color: transparent !important;
  border-top-width: 0 !important;
  border-top-style: none !important;
  border-top-color: transparent !important;
  border-left-width: 0 !important;
  border-left-style: none !important;
  border-left-color: transparent !important;
  border-right-width: 0 !important;
  border-right-style: none !important;
  border-right-color: transparent !important;
  outline-width: 0 !important;
  outline-style: none !important;
  outline-color: transparent !important;
  text-decoration: none !important;
  text-decoration-line: none !important;
  text-decoration-style: none !important;
  text-decoration-color: transparent !important;
  text-decoration-thickness: 0 !important;
  box-shadow: none !important;
  background-image: none !important;
}

/* 确保没有任何分隔线 - 全面封杀 */
.contract-dropdown .coin-item::before,
.contract-dropdown .coin-item::after {
  display: none !important;
  content: none !important;
  border: none !important;
  background: transparent !important;
  background-image: none !important;
  height: 0 !important;
  width: 0 !important;
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

/* 最后的努力 - 移除可能的CSS变量影响 */
.contract-dropdown {
  --border-color: transparent !important;
  --border-width: 0 !important;
  --border-style: none !important;
}

.contract-dropdown .coin-item {
  --arco-border-color: transparent !important;
  --arco-border-width: 0 !important;
  --arco-border-style: none !important;
}

/* 🚨 终极强制样式 - 使用!important和最高权重选择器 */
html body div.futures div[class*="arco-dropdown"] div.contract-dropdown div.coin-list div.coin-list-container div.coin-item,
html body .futures .arco-dropdown-content .contract-dropdown .coin-list .coin-list-container .coin-item,
body .futures .contract-dropdown .coin-item,
.futures .contract-dropdown .coin-item {
  border: 0px solid transparent !important;
  border-bottom: 0px solid transparent !important;
  border-top: 0px solid transparent !important;
  border-left: 0px solid transparent !important;
  border-right: 0px solid transparent !important;
  border-width: 0px !important;
  border-style: none !important;
  border-color: transparent !important;
  text-decoration: none !important;
  text-decoration-line: none !important;
  text-decoration-style: none !important;
  text-decoration-color: transparent !important;
  text-decoration-thickness: 0px !important;
  outline: 0px solid transparent !important;
  outline-width: 0px !important;
  outline-style: none !important;
  outline-color: transparent !important;
  box-shadow: none !important;
  background-image: none !important;
  background-position: unset !important;
  background-size: unset !important;
  background-repeat: unset !important;
  background-attachment: unset !important;
  border-image: none !important;
  border-image-source: none !important;
  border-image-slice: 0 !important;
  border-image-width: 0 !important;
  border-image-outset: 0 !important;
  border-image-repeat: stretch !important;
  list-style: none !important;
  list-style-type: none !important;
  list-style-image: none !important;
  list-style-position: outside !important;
}

/* 覆盖可能的伪元素 */
html body div.futures div[class*="arco-dropdown"] div.contract-dropdown div.coin-list div.coin-list-container div.coin-item::before,
html body div.futures div[class*="arco-dropdown"] div.contract-dropdown div.coin-list div.coin-list-container div.coin-item::after,
html body .futures .arco-dropdown-content .contract-dropdown .coin-list .coin-list-container .coin-item::before,
html body .futures .arco-dropdown-content .contract-dropdown .coin-list .coin-list-container .coin-item::after,
body .futures .contract-dropdown .coin-item::before,
body .futures .contract-dropdown .coin-item::after,
.futures .contract-dropdown .coin-item::before,
.futures .contract-dropdown .coin-item::after {
  display: none !important;
  content: none !important;
  border: none !important;
  border-bottom: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  background: transparent !important;
  background-image: none !important;
  background-color: transparent !important;
  height: 0px !important;
  width: 0px !important;
  position: absolute !important;
  top: 0px !important;
  left: 0px !important;
  right: 0px !important;
  bottom: 0px !important;
  opacity: 0 !important;
  visibility: hidden !important;
  z-index: -1 !important;
}

/* 强制移除任何继承的样式 */
.contract-dropdown .coin-item,
.contract-dropdown .coin-item *,
.contract-dropdown .coin-item span,
.contract-dropdown .coin-item img {
  border: none !important;
  border-bottom: none !important;
  text-decoration: none !important;
  background-image: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 最终保险措施 - 使用attribute选择器 */
div[class*="contract-dropdown"] div[class*="coin-item"],
div[class="contract-dropdown"] div[class="coin-item"] {
  border: 0 !important;
  border-bottom: 0 !important;
  text-decoration: none !important;
}

/* 🎯 期权币种选择器样式 - 完全无边框设计 */
.option-coin-item,
.contract-dropdown .option-coin-item,
html .contract-dropdown .option-coin-item,
body .contract-dropdown .option-coin-item,
div.contract-dropdown .option-coin-item {
  border: 0 !important;
  border-bottom: 0 !important;
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  text-decoration: none !important;
  text-decoration-line: none !important;
  text-decoration-style: none !important;
  text-decoration-color: transparent !important;
  text-decoration-thickness: 0 !important;
  text-underline-offset: 0 !important;
  outline: 0 !important;
  outline-width: 0 !important;
  outline-style: none !important;
  outline-color: transparent !important;
  box-shadow: none !important;
  background-image: none !important;
  background-position: unset !important;
  background-size: unset !important;
  background-repeat: unset !important;
  background-attachment: unset !important;
  border-image: none !important;
  border-image-source: none !important;
  border-image-slice: 0 !important;
  border-image-width: 0 !important;
  border-image-outset: 0 !important;
  border-image-repeat: stretch !important;
  list-style: none !important;
  list-style-type: none !important;
  list-style-image: none !important;
  list-style-position: outside !important;
}

/* 期权币种项目的伪元素也要移除 */
.option-coin-item::before,
.option-coin-item::after,
.contract-dropdown .option-coin-item::before,
.contract-dropdown .option-coin-item::after {
  display: none !important;
  content: none !important;
  border: none !important;
  background: transparent !important;
  background-image: none !important;
  height: 0 !important;
  width: 0 !important;
  opacity: 0 !important;
  visibility: hidden !important;
}

/* 覆盖任何可能的继承样式 */
.option-coin-item *,
.option-coin-item span,
.option-coin-item img {
  border: none !important;
  border-bottom: none !important;
  text-decoration: none !important;
  outline: none !important;
  box-shadow: none !important;
}

/* 确保在所有状态下都无边框 */
.option-coin-item:hover,
.option-coin-item:focus,
.option-coin-item:active,
.option-coin-item:visited {
  border: 0 !important;
  border-bottom: 0 !important;
  text-decoration: none !important;
  outline: 0 !important;
  box-shadow: none !important;
}

/* 🌟 期权币种项目 Logo 样式 */
.option-coin-logo {
  width: 28px !important;
  height: 28px !important;
  border-radius: 50% !important;
  border: 2px solid rgba(255, 255, 255, 0.1) !important;
  flex-shrink: 0 !important;
}

/* 🌟 期权币种项目文字样式 - 暗色模式 */
.option-coin-pair {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  flex: 1 !important;
  text-align: left !important;
}

/* 🌟 白天模式下的期权币种项目 - 完整样式覆盖 */
[data-theme="light"] .option-coin-item,
html[data-theme="light"] .option-coin-item,
body[data-theme="light"] .option-coin-item {
  border: 0 !important;
  border-bottom: 0 !important;
  text-decoration: none !important;
  outline: 0 !important;
  background: transparent !important;
}

[data-theme="light"] .option-coin-item:hover,
html[data-theme="light"] .option-coin-item:hover,
body[data-theme="light"] .option-coin-item:hover {
  border: 0 !important;
  border-bottom: 0 !important;
  text-decoration: none !important;
  outline: 0 !important;
  background: rgba(0, 0, 0, 0.06) !important;
}

/* 🌟 白天模式下的期权币种项目文字颜色 */
[data-theme="light"] .option-coin-pair,
html[data-theme="light"] .option-coin-pair,
body[data-theme="light"] .option-coin-pair {
  color: #333333 !important;
  font-weight: 600 !important;
}

[data-theme="light"] .option-coin-item:hover .option-coin-pair,
html[data-theme="light"] .option-coin-item:hover .option-coin-pair,
body[data-theme="light"] .option-coin-item:hover .option-coin-pair {
  color: #1890ff !important;
  font-weight: 700 !important;
}

/* 🌟 白天模式下的期权币种Logo边框 */
[data-theme="light"] .option-coin-logo,
html[data-theme="light"] .option-coin-logo,
body[data-theme="light"] .option-coin-logo {
  border: 2px solid rgba(0, 0, 0, 0.1) !important;
}

/* 🎯 订单倒计时样式 */
.countdown-text {
  font-family: 'Courier New', monospace !important;
  font-weight: 700 !important;
  font-size: 13px !important;
  display: inline-block !important;
  min-width: 40px !important;
  text-align: center !important;
}

.color-orange {
  color: #ff9500 !important;
}

/* 白天模式下的倒计时颜色 */
[data-theme="light"] .color-orange,
html[data-theme="light"] .color-orange,
body[data-theme="light"] .color-orange {
  color: #ff9500 !important;
  font-weight: 700 !important;
}

/* 🎯 历史订单样式 */
.history-orders {
  .order-header,
  .order-list {
    /* 继承活跃订单的样式 */
    display: block;
  }
  
  .loading-state {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    height: 150px !important;
    gap: 12px !important;
    
    .loading-icon {
      font-size: 24px !important;
      color: #1890ff !important;
      animation: spin 1s linear infinite !important;
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  }
}

/* 订单结果颜色优化 */
.order-result {
  text-align: center !important;
  
  .color-green {
    color: #52c41a !important;
    font-weight: 700 !important;
  }
  
  .color-red {
    color: #ff4d4f !important;
    font-weight: 700 !important;
  }
  
  .color-gray {
    color: #8c8c8c !important;
    font-weight: 500 !important;
  }
}

/* 🎯 活跃订单和历史订单表头设计 */
.active-orders .order-header,
.history-orders .order-header {
  display: flex !important;
  padding: 14px 16px !important;
  background: linear-gradient(135deg, #2d2d2d, #353535) !important;
  border-bottom: 1px solid #3a3a3a !important;
}

.active-orders .order-header span,
.history-orders .order-header span {
  flex: 1 !important;
  text-align: center !important;
  font-size: 12px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  color: #ffffff !important;
}

/* 订单数据行布局 */
.active-orders .order-item,
.history-orders .order-item {
  display: flex !important;
  align-items: center !important;
  padding: 12px 16px !important;
  border-bottom: 1px solid #3a3a3a !important;
  transition: all 0.3s ease !important;
}

.active-orders .order-item:hover,
.history-orders .order-item:hover {
  background: rgba(255, 255, 255, 0.05) !important;
}

.active-orders .order-item > div,
.history-orders .order-item > div {
  flex: 1 !important;
  text-align: center !important;
  font-size: 12px !important;
}

/* 优化列宽 - 确保价格字段有足够空间 */
.order-symbol {
  flex: 0.5 !important;
  font-weight: 600 !important;
  min-width: 50px !important;
}

.order-direction {
  flex: 0.6 !important;
  min-width: 50px !important;
}

.order-amount {
  flex: 0.8 !important;
  font-weight: 600 !important;
  min-width: 80px !important;
}

.order-price,
.order-open-price {
  flex: 1.2 !important;
  font-weight: 500 !important;
  color: #1890ff !important;
  min-width: 80px !important;
  text-align: center !important;
}

.order-close-price {
  flex: 1.2 !important;
  font-weight: 500 !important;
  color: #722ed1 !important;
  min-width: 80px !important;
  text-align: center !important;
}

.order-countdown {
  flex: 0.8 !important;
  min-width: 60px !important;
}

.order-result {
  flex: 0.6 !important;
  font-weight: 600 !important;
  min-width: 50px !important;
}

.order-status {
  flex: 0.6 !important;
  min-width: 50px !important;
}

.order-time {
  flex: 1 !important;
  font-size: 11px !important;
  min-width: 70px !important;
}

/* 🎨 活跃订单颜色样式 */
.active-orders .color-green {
  color: #00ff88 !important;
}

.active-orders .color-red {
  color: #ff4757 !important;
}

.active-orders .color-gray {
  color: #8b949e !important;
}

.active-orders .color-orange {
  color: #ff9500 !important;
}

.active-orders .color-blue {
  color: #1890ff !important;
}

/* 🌙 深色模式下的活跃订单颜色 */
[data-theme="dark"] .active-orders .color-green,
html[data-theme="dark"] .active-orders .color-green,
body[data-theme="dark"] .active-orders .color-green {
  color: #00ff88 !important;
}

[data-theme="dark"] .active-orders .color-red,
html[data-theme="dark"] .active-orders .color-red,
body[data-theme="dark"] .active-orders .color-red {
  color: #ff4757 !important;
}

[data-theme="dark"] .active-orders .color-gray,
html[data-theme="dark"] .active-orders .color-gray,
body[data-theme="dark"] .active-orders .color-gray {
  color: #8b949e !important;
}

[data-theme="dark"] .active-orders .color-orange,
html[data-theme="dark"] .active-orders .color-orange,
body[data-theme="dark"] .active-orders .color-orange {
  color: #ff9500 !important;
}

[data-theme="dark"] .active-orders .color-blue,
html[data-theme="dark"] .active-orders .color-blue,
body[data-theme="dark"] .active-orders .color-blue {
  color: #1890ff !important;
}

/* ☀️ 浅色模式下的活跃订单颜色 */
[data-theme="light"] .active-orders .color-green,
html[data-theme="light"] .active-orders .color-green,
body[data-theme="light"] .active-orders .color-green {
  color: #00d470 !important;
}

[data-theme="light"] .active-orders .color-red,
html[data-theme="light"] .active-orders .color-red,
body[data-theme="light"] .active-orders .color-red {
  color: #ff3742 !important;
}

[data-theme="light"] .active-orders .color-gray,
html[data-theme="light"] .active-orders .color-gray,
body[data-theme="light"] .active-orders .color-gray {
  color: #666666 !important;
}

[data-theme="light"] .active-orders .color-orange,
html[data-theme="light"] .active-orders .color-orange,
body[data-theme="light"] .active-orders .color-orange {
  color: #ff8c00 !important;
}

[data-theme="light"] .active-orders .color-blue,
html[data-theme="light"] .active-orders .color-blue,
body[data-theme="light"] .active-orders .color-blue {
  color: #1890ff !important;
}

/* 价格文本样式 - 确保清晰显示 */
.order-open-price span,
.order-close-price span,
.order-price span {
  display: block !important;
  word-break: keep-all !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding: 2px 4px !important;
  border-radius: 4px !important;
  background: rgba(24, 144, 255, 0.1) !important;
}

.order-close-price span {
  background: rgba(114, 46, 209, 0.1) !important;
}

/* 白天模式下的价格颜色 */
[data-theme="light"] .order-price,
[data-theme="light"] .order-open-price,
html[data-theme="light"] .order-price,
html[data-theme="light"] .order-open-price,
body[data-theme="light"] .order-price,
body[data-theme="light"] .order-open-price {
  color: #1890ff !important;
}

[data-theme="light"] .order-close-price,
html[data-theme="light"] .order-close-price,
body[data-theme="light"] .order-close-price {
  color: #722ed1 !important;
}

/* 白天模式 */
[data-theme="light"] .active-orders .order-header,
[data-theme="light"] .history-orders .order-header,
html[data-theme="light"] .active-orders .order-header,
html[data-theme="light"] .history-orders .order-header,
body[data-theme="light"] .active-orders .order-header,
body[data-theme="light"] .history-orders .order-header {
  background: linear-gradient(135deg, #f8f8f8, #f0f0f0) !important;
  border-bottom: 1px solid #e8e8e8 !important;
}

[data-theme="light"] .active-orders .order-header span,
[data-theme="light"] .history-orders .order-header span,
html[data-theme="light"] .active-orders .order-header span,
html[data-theme="light"] .history-orders .order-header span,
body[data-theme="light"] .active-orders .order-header span,
body[data-theme="light"] .history-orders .order-header span {
  color: #333333 !important;
}

[data-theme="light"] .active-orders .order-item,
[data-theme="light"] .history-orders .order-item,
html[data-theme="light"] .active-orders .order-item,
html[data-theme="light"] .history-orders .order-item,
body[data-theme="light"] .active-orders .order-item,
body[data-theme="light"] .history-orders .order-item {
  border-bottom: 1px solid #e8e8e8 !important;
}

[data-theme="light"] .active-orders .order-item:hover,
[data-theme="light"] .history-orders .order-item:hover,
html[data-theme="light"] .active-orders .order-item:hover,
html[data-theme="light"] .history-orders .order-item:hover,
body[data-theme="light"] .active-orders .order-item:hover,
body[data-theme="light"] .history-orders .order-item:hover {
  background: rgba(0, 0, 0, 0.03) !important;
}

/* 白天模式下的订单结果颜色 */
[data-theme="light"] .order-result .color-green,
html[data-theme="light"] .order-result .color-green,
body[data-theme="light"] .order-result .color-green {
  color: #52c41a !important;
  font-weight: 700 !important;
}

[data-theme="light"] .order-result .color-red,
html[data-theme="light"] .order-result .color-red,
body[data-theme="light"] .order-result .color-red {
  color: #ff4d4f !important;
  font-weight: 700 !important;
}

[data-theme="light"] .order-result .color-gray,
html[data-theme="light"] .order-result .color-gray,
body[data-theme="light"] .order-result .color-gray {
  color: #8c8c8c !important;
  font-weight: 500 !important;
}

/* 深色模式下的历史订单颜色样式 */
[data-theme="dark"] .history-orders .order-item .color-green,
html[data-theme="dark"] .history-orders .order-item .color-green,
body[data-theme="dark"] .history-orders .order-item .color-green {
  color: #52c41a !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .history-orders .order-item .color-red,
html[data-theme="dark"] .history-orders .order-item .color-red,
body[data-theme="dark"] .history-orders .order-item .color-red {
  color: #ff4d4f !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .history-orders .order-item .color-black,
html[data-theme="dark"] .history-orders .order-item .color-black,
body[data-theme="dark"] .history-orders .order-item .color-black {
  color: #ffffff !important;
  font-weight: 500 !important;
}

/* 深色模式下的订单方向标签颜色 */
[data-theme="dark"] .history-orders .order-direction .color-green,
html[data-theme="dark"] .history-orders .order-direction .color-green,
body[data-theme="dark"] .history-orders .order-direction .color-green {
  color: #52c41a !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .history-orders .order-direction .color-red,
html[data-theme="dark"] .history-orders .order-direction .color-red,
body[data-theme="dark"] .history-orders .order-direction .color-red {
  color: #ff4d4f !important;
  font-weight: 700 !important;
}

  /* 🎯 币种选择器主体白天模式样式 - 强制深色文字 */
  [data-theme="light"] .contract-coin-selector,
  html[data-theme="light"] .contract-coin-selector,
  body[data-theme="light"] .contract-coin-selector {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    color: #000000 !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  }
  
  [data-theme="light"] .contract-coin-selector .coin-pair,
  html[data-theme="light"] .contract-coin-selector .coin-pair,
  body[data-theme="light"] .contract-coin-selector .coin-pair,
  [data-theme="light"] .coin-pair,
  html[data-theme="light"] .coin-pair,
  body[data-theme="light"] .coin-pair {
    color: #000000 !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    text-shadow: none !important;
    opacity: 1 !important;
  }
  
  [data-theme="light"] .contract-coin-selector:hover,
  html[data-theme="light"] .contract-coin-selector:hover,
  body[data-theme="light"] .contract-coin-selector:hover {
    border-color: #1890ff !important;
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3) !important;
  }
  
  /* 修复币种选择器内所有文字 */
  [data-theme="light"] .contract-coin-selector *,
  html[data-theme="light"] .contract-coin-selector *,
  body[data-theme="light"] .contract-coin-selector * {
    color: #000000 !important;
  }

  /* 🎯 白天模式下的下拉框背景 - 完整样式 */
  [data-theme="light"] .contract-dropdown,
  html[data-theme="light"] .contract-dropdown,
  body[data-theme="light"] .contract-dropdown {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  }
  
  /* 白天模式下拉框内的搜索输入框 */
  [data-theme="light"] .contract-dropdown .arco-input-wrapper,
  html[data-theme="light"] .contract-dropdown .arco-input-wrapper,
  body[data-theme="light"] .contract-dropdown .arco-input-wrapper {
    background: #ffffff !important;
    border: 1px solid #d9d9d9 !important;
  }
  
  [data-theme="light"] .contract-dropdown .arco-input,
  html[data-theme="light"] .contract-dropdown .arco-input,
  body[data-theme="light"] .contract-dropdown .arco-input {
    background: #ffffff !important;
    color: #000000 !important;
  }
  
  /* 🎯 修复白天模式下拉选项文字和双下滑线问题 */
  [data-theme="light"] .contract-dropdown .option-coin-item,
  html[data-theme="light"] .contract-dropdown .option-coin-item,
  body[data-theme="light"] .contract-dropdown .option-coin-item {
    background: #ffffff !important;
    border: none !important;
    border-bottom: none !important;
    text-decoration: none !important;
  }
  
  [data-theme="light"] .contract-dropdown .option-coin-item:hover,
  html[data-theme="light"] .contract-dropdown .option-coin-item:hover,
  body[data-theme="light"] .contract-dropdown .option-coin-item:hover {
  background: #f5f5f5 !important;
    border: none !important;
    border-bottom: none !important;
    text-decoration: none !important;
  }
  
  [data-theme="light"] .contract-dropdown .option-coin-pair,
  html[data-theme="light"] .contract-dropdown .option-coin-pair,
  body[data-theme="light"] .contract-dropdown .option-coin-pair {
    color: #000000 !important;
    font-weight: 600 !important;
  }
  
  [data-theme="light"] .contract-dropdown .option-coin-item:hover .option-coin-pair,
  html[data-theme="light"] .contract-dropdown .option-coin-item:hover .option-coin-pair,
  body[data-theme="light"] .contract-dropdown .option-coin-item:hover .option-coin-pair {
  color: #1890ff !important;
    font-weight: 700 !important;
}
</style>

<!-- 期权交易面板专业样式 - 参考图片优化 -->
<style scoped>
/* 期权交易面板样式 */
.option-trading-panel {
  background-color: var(--background-primary) !important;
  border-radius: 8px;
  border: 1px solid var(--border-strength-100);
  height: 100%;
  overflow: hidden;
}

.option-header {
  background: transparent;
  border-bottom: 1px solid var(--border-strength-100);
  padding: 0 16px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title h2 {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.balance-display {
  display: flex;
  align-items: center;
  gap: 8px;
}

.balance-label {
  color: #8b949e;
  font-size: 12px;
}

.balance-amount {
  color: #00d4aa;
  font-size: 14px;
  font-weight: 600;
}

.transfer-icon {
  color: #00d4aa;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  padding: 4px 8px;
  border: 1px solid #00d4aa;
  border-radius: 4px;
  background: rgba(0, 212, 170, 0.1);
}

.transfer-icon:hover {
  background: rgba(0, 212, 170, 0.2);
  transform: translateY(-1px);
}







.option-content {
  padding: 15px 15px 14px;
  height: calc(100% - 40px);
  overflow-y: auto;
  background: transparent;
}

/* 看涨看跌按钮 - 紧凑优化版本 */
.direction-buttons {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.direction-btn {
  flex: 1;
  background: var(--background-secondary);
  border: 1px solid var(--border-strength-100);
  border-radius: 8px;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  min-height: 60px;
}

.direction-btn .btn-content {
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  height: 100%;
  position: relative;
}

.direction-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

/* 看涨按钮激活状态 */
.direction-btn.call-btn.active {
  background: linear-gradient(135deg, #00ff88 0%, #00d470 100%);
  border-color: #00ff88;
  box-shadow: 0 4px 20px rgba(0, 255, 136, 0.4);
}

.direction-btn.call-btn.active .btn-content * {
  color: #00ff88 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 看跌按钮激活状态 */
.direction-btn.put-btn.active {
  background: linear-gradient(135deg, #ff4757 0%, #ff3742 100%);
  border-color: #ff4757;
  box-shadow: 0 4px 20px rgba(255, 71, 87, 0.4);
}

.direction-btn.put-btn.active .btn-content * {
  color: #ff4757 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 看涨按钮非激活状态 */
.direction-btn.call-btn:not(.active) {
  border-color: rgba(0, 255, 136, 0.4);
  background: rgba(0, 255, 136, 0.05);
}

.direction-btn.call-btn:not(.active) .btn-content * {
  color: #00ff88 !important;
}

/* 看跌按钮非激活状态 */
.direction-btn.put-btn:not(.active) {
  border-color: rgba(255, 71, 87, 0.4);
  background: rgba(255, 71, 87, 0.05);
}

.direction-btn.put-btn:not(.active) .btn-content * {
  color: #ff4757 !important;
}

.btn-icon {
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  transition: transform 0.3s ease;
}

.direction-btn:hover .btn-icon {
  transform: scale(1.05);
}

.btn-text {
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.3px;
}

.btn-rate {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.9;
  line-height: 1;
}

/* 新版主题适配 - 最高优先级 */
.futures[data-theme="dark"] .direction-btn,
.futures[data-theme="light"] .direction-btn,
[data-theme="dark"] .futures .direction-btn,
[data-theme="light"] .futures .direction-btn,
html[data-theme="dark"] .futures .direction-btn,
html[data-theme="light"] .futures .direction-btn,
body[data-theme="dark"] .futures .direction-btn,
body[data-theme="light"] .futures .direction-btn {
  background: var(--background-secondary) !important;
  border: 1px solid var(--border-strength-100) !important;
  border-radius: 8px !important;
}

/* 深色主题非激活状态 */
.futures[data-theme="dark"] .direction-btn.call-btn:not(.active),
[data-theme="dark"] .futures .direction-btn.call-btn:not(.active),
html[data-theme="dark"] .futures .direction-btn.call-btn:not(.active),
body[data-theme="dark"] .futures .direction-btn.call-btn:not(.active) {
  border-color: rgba(0, 255, 136, 0.4) !important;
  background: rgba(0, 255, 136, 0.05) !important;
}

.futures[data-theme="dark"] .direction-btn.put-btn:not(.active),
[data-theme="dark"] .futures .direction-btn.put-btn:not(.active),
html[data-theme="dark"] .futures .direction-btn.put-btn:not(.active),
body[data-theme="dark"] .futures .direction-btn.put-btn:not(.active) {
  border-color: rgba(255, 71, 87, 0.4) !important;
  background: rgba(255, 71, 87, 0.05) !important;
}

/* 浅色主题非激活状态 */
.futures[data-theme="light"] .direction-btn.call-btn:not(.active),
[data-theme="light"] .futures .direction-btn.call-btn:not(.active),
html[data-theme="light"] .futures .direction-btn.call-btn:not(.active),
body[data-theme="light"] .futures .direction-btn.call-btn:not(.active) {
  border-color: rgba(0, 255, 136, 0.4) !important;
  background: rgba(0, 255, 136, 0.05) !important;
}

.futures[data-theme="light"] .direction-btn.put-btn:not(.active),
[data-theme="light"] .futures .direction-btn.put-btn:not(.active),
html[data-theme="light"] .futures .direction-btn.put-btn:not(.active),
body[data-theme="light"] .futures .direction-btn.put-btn:not(.active) {
  border-color: rgba(255, 71, 87, 0.4) !important;
  background: rgba(255, 71, 87, 0.05) !important;
}

/* 激活状态 - 所有主题通用 */
.futures[data-theme="dark"] .direction-btn.call-btn.active,
.futures[data-theme="light"] .direction-btn.call-btn.active,
[data-theme="dark"] .futures .direction-btn.call-btn.active,
[data-theme="light"] .futures .direction-btn.call-btn.active,
html[data-theme="dark"] .futures .direction-btn.call-btn.active,
html[data-theme="light"] .futures .direction-btn.call-btn.active,
body[data-theme="dark"] .futures .direction-btn.call-btn.active,
body[data-theme="light"] .futures .direction-btn.call-btn.active {
  background: linear-gradient(135deg, #00ff88 0%, #00d470 100%) !important;
  border-color: #00ff88 !important;
  box-shadow: 0 4px 20px rgba(0, 255, 136, 0.4) !important;
}

.futures[data-theme="dark"] .direction-btn.put-btn.active,
.futures[data-theme="light"] .direction-btn.put-btn.active,
[data-theme="dark"] .futures .direction-btn.put-btn.active,
[data-theme="light"] .futures .direction-btn.put-btn.active,
html[data-theme="dark"] .futures .direction-btn.put-btn.active,
html[data-theme="light"] .futures .direction-btn.put-btn.active,
body[data-theme="dark"] .futures .direction-btn.put-btn.active,
body[data-theme="light"] .futures .direction-btn.put-btn.active {
  background: linear-gradient(135deg, #ff4757 0%, #ff3742 100%) !important;
  border-color: #ff4757 !important;
  box-shadow: 0 4px 20px rgba(255, 71, 87, 0.4) !important;
}

/* 文字颜色 - 最高优先级覆盖 */
.futures[data-theme="dark"] .direction-btn.call-btn.active .btn-content *,
.futures[data-theme="light"] .direction-btn.call-btn.active .btn-content *,
[data-theme="dark"] .futures .direction-btn.call-btn.active .btn-content *,
[data-theme="light"] .futures .direction-btn.call-btn.active .btn-content *,
html[data-theme="dark"] .futures .direction-btn.call-btn.active .btn-content *,
html[data-theme="light"] .futures .direction-btn.call-btn.active .btn-content *,
body[data-theme="dark"] .futures .direction-btn.call-btn.active .btn-content *,
body[data-theme="light"] .futures .direction-btn.call-btn.active .btn-content * {
  color: #00ff88 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

.futures[data-theme="dark"] .direction-btn.put-btn.active .btn-content *,
.futures[data-theme="light"] .direction-btn.put-btn.active .btn-content *,
[data-theme="dark"] .futures .direction-btn.put-btn.active .btn-content *,
[data-theme="light"] .futures .direction-btn.put-btn.active .btn-content *,
html[data-theme="dark"] .futures .direction-btn.put-btn.active .btn-content *,
html[data-theme="light"] .futures .direction-btn.put-btn.active .btn-content *,
body[data-theme="dark"] .futures .direction-btn.put-btn.active .btn-content *,
body[data-theme="light"] .futures .direction-btn.put-btn.active .btn-content * {
  color: #ff4757 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

.futures[data-theme="dark"] .direction-btn.call-btn:not(.active) .btn-content *,
.futures[data-theme="light"] .direction-btn.call-btn:not(.active) .btn-content *,
[data-theme="dark"] .futures .direction-btn.call-btn:not(.active) .btn-content *,
[data-theme="light"] .futures .direction-btn.call-btn:not(.active) .btn-content *,
html[data-theme="dark"] .futures .direction-btn.call-btn:not(.active) .btn-content *,
html[data-theme="light"] .futures .direction-btn.call-btn:not(.active) .btn-content *,
body[data-theme="dark"] .futures .direction-btn.call-btn:not(.active) .btn-content *,
body[data-theme="light"] .futures .direction-btn.call-btn:not(.active) .btn-content * {
  color: #00ff88 !important;
}

.futures[data-theme="dark"] .direction-btn.put-btn:not(.active) .btn-content *,
.futures[data-theme="light"] .direction-btn.put-btn:not(.active) .btn-content *,
[data-theme="dark"] .futures .direction-btn.put-btn:not(.active) .btn-content *,
[data-theme="light"] .futures .direction-btn.put-btn:not(.active) .btn-content *,
html[data-theme="dark"] .futures .direction-btn.put-btn:not(.active) .btn-content *,
html[data-theme="light"] .futures .direction-btn.put-btn:not(.active) .btn-content *,
body[data-theme="dark"] .futures .direction-btn.put-btn:not(.active) .btn-content *,
body[data-theme="light"] .futures .direction-btn.put-btn:not(.active) .btn-content * {
  color: #ff4757 !important;
}

/* 终极覆盖 - 确保样式生效 */
.futures .direction-btn {
  border: 1px solid var(--border-strength-100) !important;
  border-radius: 8px !important;
  padding: 0 !important;
  min-height: 60px !important;
  overflow: hidden !important;
}

.futures .direction-btn .btn-content {
  padding: 12px 8px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 4px !important;
  height: 100% !important;
}

.futures .direction-btn.call-btn.active {
  background: linear-gradient(135deg, #00ff88 0%, #00d470 100%) !important;
  border-color: #00ff88 !important;
  box-shadow: 0 4px 20px rgba(0, 255, 136, 0.4) !important;
}

.futures .direction-btn.put-btn.active {
  background: linear-gradient(135deg, #ff4757 0%, #ff3742 100%) !important;
  border-color: #ff4757 !important;
  box-shadow: 0 4px 20px rgba(255, 71, 87, 0.4) !important;
}

.futures .direction-btn.call-btn:not(.active) {
  border-color: rgba(0, 255, 136, 0.4) !important;
  background: rgba(0, 255, 136, 0.05) !important;
}

.futures .direction-btn.put-btn:not(.active) {
  border-color: rgba(255, 71, 87, 0.4) !important;
  background: rgba(255, 71, 87, 0.05) !important;
}

.futures .direction-btn.call-btn.active .btn-content * {
  color: #00ff88 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

.futures .direction-btn.put-btn.active .btn-content * {
  color: #ff4757 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

.futures .direction-btn.call-btn:not(.active) .btn-content * {
  color: #00ff88 !important;
}

.futures .direction-btn.put-btn:not(.active) .btn-content * {
  color: #ff4757 !important;
}

/* ==================== 超级强制背景样式 ==================== */
/* 多层选择器确保样式生效 */
.futures .option-trading-panel .direction-buttons .direction-btn.call-btn.active,
.futures .option-content .direction-buttons .direction-btn.call-btn.active,
.futures .futures_content .direction-buttons .direction-btn.call-btn.active,
.futures .direction-buttons .direction-btn.call-btn.active,
.futures .direction-btn.call-btn.active {
  background: #00ff88 !important;
  background-color: #00ff88 !important;
  background-image: linear-gradient(135deg, #00ff88 0%, #00d470 100%) !important;
  border-color: #00ff88 !important;
  box-shadow: 0 4px 20px rgba(0, 255, 136, 0.4) !important;
}

.futures .option-trading-panel .direction-buttons .direction-btn.put-btn.active,
.futures .option-content .direction-buttons .direction-btn.put-btn.active,
.futures .futures_content .direction-buttons .direction-btn.put-btn.active,
.futures .direction-buttons .direction-btn.put-btn.active,
.futures .direction-btn.put-btn.active {
  background: #ff4757 !important;
  background-color: #ff4757 !important;
  background-image: linear-gradient(135deg, #ff4757 0%, #ff3742 100%) !important;
  border-color: #ff4757 !important;
  box-shadow: 0 4px 20px rgba(255, 71, 87, 0.4) !important;
}

/* 针对具体元素的强制样式 */
.futures .direction-btn[class*="call-btn"][class*="active"] {
  background: #00ff88 !important;
  background-color: #00ff88 !important;
  background-image: linear-gradient(135deg, #00ff88 0%, #00d470 100%) !important;
}

.futures .direction-btn[class*="put-btn"][class*="active"] {
  background: #ff4757 !important;
  background-color: #ff4757 !important;
  background-image: linear-gradient(135deg, #ff4757 0%, #ff3742 100%) !important;
}

/* 终极强制样式 - 紧凑版本 */
.futures .direction-buttons .direction-btn {
  flex: 1 !important;
  background: var(--background-secondary) !important;
  border: 1px solid var(--border-strength-100) !important;
  border-radius: 8px !important;
  padding: 0 !important;
  cursor: pointer !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  overflow: hidden !important;
  min-height: 60px !important;
}

.futures .direction-buttons .direction-btn .btn-content {
  padding: 12px 8px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 4px !important;
  height: 100% !important;
  position: relative !important;
}

.futures .direction-buttons .direction-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15) !important;
}

/* 看涨按钮激活状态 - 强制应用 */
.futures .direction-buttons .direction-btn.call-btn.active {
  background: linear-gradient(135deg, #00ff88 0%, #00d470 100%) !important;
  border-color: #00ff88 !important;
  box-shadow: 0 4px 20px rgba(0, 255, 136, 0.4) !important;
}

.futures .direction-buttons .direction-btn.call-btn.active .btn-content {
  color: #00ff88 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

.futures .direction-buttons .direction-btn.call-btn.active .btn-content * {
  color: #00ff88 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

/* 看跌按钮激活状态 - 强制应用 */
.futures .direction-buttons .direction-btn.put-btn.active {
  background: linear-gradient(135deg, #ff4757 0%, #ff3742 100%) !important;
  border-color: #ff4757 !important;
  box-shadow: 0 4px 20px rgba(255, 71, 87, 0.4) !important;
}

.futures .direction-buttons .direction-btn.put-btn.active .btn-content {
  color: #ff4757 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

.futures .direction-buttons .direction-btn.put-btn.active .btn-content * {
  color: #ff4757 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5) !important;
}

/* 看涨按钮非激活状态 - 强制应用 */
.futures .direction-buttons .direction-btn.call-btn:not(.active) {
  border-color: rgba(0, 255, 136, 0.4) !important;
  background: rgba(0, 255, 136, 0.05) !important;
}

.futures .direction-buttons .direction-btn.call-btn:not(.active) .btn-content {
  color: #00ff88 !important;
}

.futures .direction-buttons .direction-btn.call-btn:not(.active) .btn-content * {
  color: #00ff88 !important;
}

/* 看跌按钮非激活状态 - 强制应用 */
.futures .direction-buttons .direction-btn.put-btn:not(.active) {
  border-color: rgba(255, 71, 87, 0.4) !important;
  background: rgba(255, 71, 87, 0.05) !important;
}

.futures .direction-buttons .direction-btn.put-btn:not(.active) .btn-content {
  color: #ff4757 !important;
}

.futures .direction-buttons .direction-btn.put-btn:not(.active) .btn-content * {
  color: #ff4757 !important;
}

/* 提交按钮样式 */
.submit-btn {
  width: 100%;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  border: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.submit-btn.call-submit {
  background: linear-gradient(135deg, #00ff88 0%, #00d470 100%);
  color: #000000;
  box-shadow: 0 6px 20px rgba(0, 255, 136, 0.4);
}

.submit-btn.call-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #00e07a 0%, #00c266 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 255, 136, 0.5);
}

.submit-btn.put-submit {
  background: linear-gradient(135deg, #ff4757 0%, #ff3742 100%);
  color: #ffffff;
  box-shadow: 0 6px 20px rgba(255, 71, 87, 0.4);
}

.submit-btn.put-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #ff3742 0%, #ff2735 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 71, 87, 0.5);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* ==================== 最终背景色强制覆盖 ==================== */
/* 使用最高特异性确保样式生效 */
html body .futures .direction-btn.call-btn.active {
  background: #00ff88 !important;
  background-color: #00ff88 !important;
  background-image: linear-gradient(135deg, #00ff88 0%, #00d470 100%) !important;
  border-color: #00ff88 !important;
}

html body .futures .direction-btn.put-btn.active {
  background: #ff4757 !important;
  background-color: #ff4757 !important;
  background-image: linear-gradient(135deg, #ff4757 0%, #ff3742 100%) !important;
  border-color: #ff4757 !important;
}

/* 针对CSS变量可能的覆盖 */
.futures .direction-btn.call-btn.active {
  --background-secondary: #00ff88 !important;
  --background-primary: #00ff88 !important;
  --card-bg: #00ff88 !important;
}

.futures .direction-btn.put-btn.active {
  --background-secondary: #ff4757 !important;
  --background-primary: #ff4757 !important;
  --card-bg: #ff4757 !important;
}

/* ==================== 合约页面完整样式 ==================== */
.futures .content_head {
  width: 100%;
  height: 64px;
  border-radius: 8px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: var(--background-primary);
}

.futures .content_head_left {
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.futures .content_head_left::after {
  position: absolute;
  right: 0;
  content: "";
  display: inline-block;
  width: 1px;
  height: 20px;
  background-color: var(--color-seperateLine);
}

.futures .coinSelectBox {
  display: flex;
  align-items: center;
  font-size: 18px;
}

.futures .coinImage {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.futures .coinInfo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-inline-end: 16px;
  border-inline-end: 1px solid var(--border-strength-100);
}

.futures .coinInfo .row {
  display: flex;
  align-items: center;
}

.futures .caretDown {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--background-tertiary-1);
  color: var(--content-primary);
}

.futures .coinInfo .desc {
  margin-top: 3px;
  font-size: 12px;
  color: var(--text-secondary);
}

.futures .content_head_right {
  width: calc(100% - 160px);
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.futures .content_head_right_info {
  display: flex;
  align-items: center;
}



/* 市场下拉菜单样式 */
.market-wrap {
  width: 380px;
  height: 589px;
  padding: 10px;
  border-radius: 8px;
  background-color: var(--card-bg);
  box-shadow: 0px 0px 32px 0px var(--shadow-color);
  overflow: hidden;
}

.market-wrap .input {
  height: 40px;
  font-size: 14px;
  border-radius: 60px;
  background: var(--background-secondary);
  border: 1px solid var(--border-strength-100);
  color: var(--content-primary);
}

.market-wrap .input:focus-within {
  border-color: var(--color-primary);
}

.market-wrap .market_tab {
  margin: 10px 0;
}

.market-wrap .market_tab div {
  height: 28px;
  border-radius: 28px;
}

.market-wrap .market_tab div span {
  color: var(--content-tertiary);
}

.market-wrap .market_tab .active {
  background: var(--background-secondary);
}

.market-wrap .market_tab .active span {
  font-weight: 600;
  color: var(--content-primary);
}

.market-wrap .market_tab_main .sub_tab {
  height: 38px;
}

.market-wrap .market_tab_main .scrollbar {
  height: 440px;
  overflow: auto;
}

.market-wrap .market_tab_main .scrollbar .sub_cell {
  height: 38px;
  padding: 0 10px;
  box-sizing: border-box;
}

.market-wrap .market_tab_main .scrollbar .sub_cell:first-of-type {
  margin-top: 10px;
}

.market-wrap .market_tab_main .scrollbar .sub_cell:last-of-type {
  margin-bottom: 30px;
}

.market-wrap .market_tab_main .sub_tab > div:first-of-type,
.market-wrap .market_tab_main .sub_cell > div:first-of-type {
  width: 45%;
}

.market-wrap .market_tab_main .sub_tab > div:nth-of-type(2),
.market-wrap .market_tab_main .sub_tab > div:nth-of-type(3),
.market-wrap .market_tab_main .sub_cell > div:nth-of-type(2),
.market-wrap .market_tab_main .sub_cell > div:nth-of-type(3) {
  width: 25%;
}

.market-wrap .market_tab_main .sub_cell {
  cursor: pointer;
  height: 40px;
}

.market-wrap .market_tab_main .sub_cell:hover {
  background: var(--hover-bg);
  border-radius: 8px;
}

.market-wrap .market_tab_main .sub_cell img {
  width: 12px;
  height: 12px;
  margin-bottom: 2px;
}

/* CSS变量支持 */
.futures {
  --border-color: var(--border-strength-100);
  --shadow-color: rgba(0, 0, 0, 0.1);
  --hover-bg: var(--background-tertiary);
  --background-tertiary-1: var(--background-tertiary);
  --text-secondary: var(--content-secondary);
  --card-bg: var(--background-primary);
  --color-seperateLine: var(--border-strength-100);
}

[data-theme="dark"] .futures {
  --shadow-color: rgba(0, 0, 0, 0.3);
  --color-seperateLine: rgba(255, 255, 255, 0.1);
}

/* 通用flex样式 */
.flex {
  display: flex;
}

.flex-column {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.align-center {
  align-items: center;
}

.align-start {
  align-items: flex-start;
}

.jus-center {
  justify-content: center;
}

.jus-bet {
  justify-content: space-between;
}

.jus-end {
  justify-content: flex-end;
}

.pointer {
  cursor: pointer;
}

.mr-5 {
  margin-right: 5px;
}

.mr-10 {
  margin-right: 10px;
}

.mr-12 {
  margin-right: 12px;
}

.mt-5 {
  margin-top: 5px;
}

.pad-lr-15 {
  padding-left: 15px;
  padding-right: 15px;
}

.font-12 {
  font-size: 12px;
}

.font-18 {
  font-size: 18px;
}

.font-bold {
  font-weight: bold;
}

.color-black {
  color: var(--content-primary);
}

.color-gray {
  color: var(--content-secondary);
}

.color-green {
  color: #00ff88;
}

.color-red {
  color: #ff4757;
}

.color-always-white {
  color: #ffffff !important;
}

.dotted {
  border-bottom: 1px dotted currentColor;
}

/* ==================== 最终样式覆盖 - 完全匹配合约页面 ==================== */
.futures .futures_content {
  width: 100% !important;
  height: auto !important;
  padding: 0 8px !important;
  box-sizing: border-box !important;
  background: var(--background-secondary) !important;
}

.futures .hotCoin {
  width: 100% !important;
  height: 28px !important;
  padding: 2px 16px !important;
  box-sizing: border-box !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  color: var(--content-primary) !important;
  background: transparent !important;
  border: none !important;
  overflow: hidden !important;
  position: relative !important;
}

.futures .content_head {
  width: 100% !important;
  height: 64px !important;
  border-radius: 8px !important;
  padding: 0 12px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  background: var(--background-primary) !important;
  border-bottom: none !important;
}

.btn-rate {
  color: #8b949e;
  font-size: 10px;
}

.direction-btn.active .btn-rate {
  color: rgba(255, 255, 255, 0.9);
}

/* 期权配置 - 超紧凑版本 */
.config-section {
  margin-bottom: 10px;
}

.config-label {
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 4px;
}

.config-select {
  width: 100%;
  background: var(--background-secondary);
  border: 1px solid var(--border-strength-100);
  border-radius: 4px;
  font-size: 12px;
}

/* 投资金额输入 - 超紧凑版本 */
.amount-section {
  margin-bottom: 10px;
}

.amount-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.amount-label span:first-child {
  color: #ffffff;
  font-size: 12px;
  font-weight: 500;
}

.amount-label .available {
  color: #8b949e;
  font-size: 10px;
}

.amount-input-wrapper {
  position: relative;
  background: var(--background-secondary);
  border: 1px solid var(--border-strength-100);
  border-radius: 4px;
  overflow: hidden;
}

.amount-input {
  width: 100%;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 45px 8px 10px;
  outline: none;
}

.amount-input::placeholder {
  color: #6b7280;
}

.input-suffix {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #8b949e;
  font-size: 11px;
  pointer-events: none;
}

/* 百分比选择 - 超紧凑版本 */
.percentage-row {
  display: flex;
  gap: 4px;
  margin-top: 6px;
}

.percentage-btn {
  flex: 1;
  background: var(--background-secondary);
  border: 1px solid var(--border-strength-100);
  border-radius: 4px;
  padding: 4px 6px;
  text-align: center;
  color: var(--content-secondary);
  font-size: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.percentage-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

.percentage-btn.active {
  background: #00d4aa;
  border-color: #00d4aa;
  color: #ffffff;
}

/* 倒计时 - 迷你版本 */
.countdown-section {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  padding: 2px 4px;
  text-align: center;
  margin-bottom: 4px;
  display: inline-block;
  width: 100%;
  min-height: auto;
}

.countdown-label {
  color: #8b949e;
  font-size: 7px;
  margin-bottom: 0px;
  line-height: 1;
}

.countdown-time {
  color: #fbbf24;
  font-size: 4px;
  font-weight: 600;
  font-family: 'Courier New', monospace;
  line-height: 1;
  margin: 0;
}

/* 提交按钮 - 超紧凑版本 */
.submit-section {
  margin-bottom: 10px;
}

.submit-btn {
  width: 100%;
  height: 32px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  transition: all 0.3s ease;
}

.submit-btn.call-submit {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: #ffffff;
}

.submit-btn.call-submit:hover {
  background: linear-gradient(135deg, #16a34a 0%, #15803d 100%);
  box-shadow: 0 4px 16px rgba(34, 197, 94, 0.4);
}

.submit-btn.put-submit {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: #ffffff;
}

.submit-btn.put-submit:hover {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  box-shadow: 0 4px 16px rgba(239, 68, 68, 0.4);
}

/* 风险提示 - 超紧凑版本 */
.risk-warning {
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.2);
  border-radius: 4px;
  padding: 6px;
}

.warning-content {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #fbbf24;
  font-size: 10px;
}

.warning-icon {
  font-size: 10px;
}

/* 投资信息 - 紧凑版本 */
.profit-info-compact {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 4px;
  padding: 6px 8px;
  margin-bottom: 6px;
}

.profit-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 0;
}

.profit-item .label {
  color: #8b949e;
  font-size: 10px;
  font-weight: 500;
}

.profit-item .value {
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
}

.profit-item .value.fee {
  color: #f87171;
}

.profit-item .value.profit {
  font-weight: 700;
}

.profit-item.total {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 4px;
  margin-top: 2px;
}

.profit-item.total .label,
.profit-item.total .value {
  font-weight: 700;
  font-size: 11px;
}

/* 上下分层布局 - 优化版本 */
.content_main {
  height: calc(100vh - 130px);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.content_main_top {
  display: flex;
  gap: 12px;
  height: calc(70% + 30px);
  align-items: stretch;
}

.content_main_left {
  flex: 7 !important;
  min-width: 500px;
  width: 70% !important;
}

.content_main_right {
  flex: 3 !important;
  min-width: 300px;
  width: 30% !important;
  max-width: 400px;
}

.content_main_bottom {
  height: calc(30% - 30px);
  min-height: 350px;
  margin-top: 12px;
  background: linear-gradient(145deg, #1a1d29 0%, #252836 100%);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.content_main_orders {
  height: 100%;
}

/* 订单管理区域优化 */
.content_main_bottom .block_list {
  height: 100%;
  background: transparent;
  border: none;
}

.content_main_bottom .arco-tabs {
  height: 100%;
}

.content_main_bottom .arco-tabs-content {
  height: calc(100% - 48px);
}

.content_main_bottom .active-orders,
.content_main_bottom .history-orders {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content_main_bottom .order-header {
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  display: grid;
  grid-template-columns: 1fr 1fr 1.2fr 1.2fr 1.2fr 1fr 1.5fr;
  gap: 12px;
  font-weight: 600;
  color: #8b949e;
}

.content_main_bottom .order-item {
  padding: 10px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  display: grid;
  grid-template-columns: 1fr 1fr 1.2fr 1.2fr 1.2fr 1fr 1.5fr;
  gap: 12px;
  align-items: center;
}

.content_main_bottom .arco-scrollbar {
  height: calc(100% - 48px);
}

/* 原生滚动容器样式 */
.order-list-native {
  height: calc(100% - 48px) !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding-right: 8px !important;
  margin-right: -8px !important;
}

/* 原生滚动条样式 - 深色主题 */
.order-list-native::-webkit-scrollbar {
  width: 6px !important;
}

.order-list-native::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 3px !important;
}

.order-list-native::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.15) !important;
  border-radius: 3px !important;
}

.order-list-native::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.25) !important;
}

/* 原生滚动条样式 - 白天主题 */
[data-theme="light"] .order-list-native::-webkit-scrollbar-track,
html[data-theme="light"] .order-list-native::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05) !important;
}

[data-theme="light"] .order-list-native::-webkit-scrollbar-thumb,
html[data-theme="light"] .order-list-native::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15) !important;
}

[data-theme="light"] .order-list-native::-webkit-scrollbar-thumb:hover,
html[data-theme="light"] .order-list-native::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.25) !important;
}

.block_kline, .option-trading-panel, .block_list {
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

/* K线图优化 */
.block_kline {
  background: linear-gradient(145deg, #0a0e1a 0%, #1a1f2e 100%);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

/* 期权交易面板基础样式 */
.option-trading-panel {
  border-radius: 12px;
  overflow: hidden;
}

/* 期权交易面板主题适配 */
[data-theme="light"] .option-trading-panel,
html[data-theme="light"] .option-trading-panel {
  background-color: var(--background-primary) !important;
  border: 1px solid var(--border-strength-100) !important;
  color: var(--content-primary) !important;
}

/* 黑夜模式专用优化 */
[data-theme="dark"] .option-trading-panel,
html[data-theme="dark"] .option-trading-panel {
  background-color: var(--background-primary) !important;
  border: 1px solid var(--border-strength-100) !important;
  color: var(--content-primary) !important;
}

/* 白天模式期权内容 */
[data-theme="light"] .option-content,
html[data-theme="light"] .option-content,
.option-content {
  background: rgba(248, 249, 250, 0.5) !important;
  color: #333333 !important;
}

/* 白天模式方向按钮 */
[data-theme="light"] .direction-btn,
html[data-theme="light"] .direction-btn,
.direction-btn {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  color: #333333 !important;
}

[data-theme="light"] .direction-btn:hover,
html[data-theme="light"] .direction-btn:hover {
  background: #f5f5f5 !important;
  border-color: #d9d9d9 !important;
}

/* 黑夜模式期权内容 */
[data-theme="dark"] .option-content,
html[data-theme="dark"] .option-content {
  background: rgba(0, 0, 0, 0.2) !important;
  color: #ffffff !important;
}

[data-theme="dark"] .direction-btn,
html[data-theme="dark"] .direction-btn {
  background: rgba(255, 255, 255, 0.03) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
  color: #ffffff !important;
}

[data-theme="dark"] .direction-btn:hover,
html[data-theme="dark"] .direction-btn:hover {
  background: rgba(255, 255, 255, 0.05) !important;
}

/* 订单列表优化 */
.block_list {
  background: linear-gradient(145deg, #1a1d29 0%, #252836 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

/* 订单表格样式优化 */
.order-header {
  background: rgba(255, 255, 255, 0.02);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding: 12px 16px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 8px;
  font-weight: 600;
}

.order-item {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.03);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 8px;
  align-items: center;
  transition: background 0.2s ease;
}

.order-item:hover {
  background: rgba(255, 255, 255, 0.02);
}

/* 加载和空状态 */
.loading-container, .empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  color: #8b949e;
}

.loading-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ==================== 黑夜模式整体优化 ==================== */

/* 页面整体黑夜模式深色背景 */
[data-theme="dark"] .futures,
html[data-theme="dark"] .futures {
          background: linear-gradient(145deg, var(--background-primary) 0%, var(--background-secondary) 100%);
  color: #ffffff;
}

[data-theme="dark"] .content_main,
html[data-theme="dark"] .content_main {
  background: transparent;
}

/* K线图黑夜模式 */
[data-theme="dark"] .block_kline,
html[data-theme="dark"] .block_kline {
  background: linear-gradient(145deg, #0a0e1a 0%, #141821 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.04) !important;
}

/* 历史订单区域黑夜模式 */
[data-theme="dark"] .content_main_bottom,
html[data-theme="dark"] .content_main_bottom {
  background: linear-gradient(145deg, #0f1319 0%, #1a1f2b 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
}

/* 期权交易面板内ArcoDesign组件白天模式 */
[data-theme="light"] .option-trading-panel .arco-input,
[data-theme="light"] .option-trading-panel .arco-select,
[data-theme="light"] .option-trading-panel .arco-button,
html[data-theme="light"] .option-trading-panel .arco-input,
html[data-theme="light"] .option-trading-panel .arco-select,
html[data-theme="light"] .option-trading-panel .arco-button,
.option-trading-panel .arco-input,
.option-trading-panel .arco-select,
.option-trading-panel .arco-button {
  background: #ffffff !important;
  border-color: #e8e8e8 !important;
  color: #333333 !important;
}

[data-theme="light"] .option-trading-panel .arco-input-wrapper,
html[data-theme="light"] .option-trading-panel .arco-input-wrapper,
.option-trading-panel .arco-input-wrapper {
  background: #ffffff !important;
  border-color: #e8e8e8 !important;
}

/* 期权交易面板黑夜模式加深 */
[data-theme="dark"] .option-trading-panel,
html[data-theme="dark"] .option-trading-panel {
  background: linear-gradient(145deg, #0d1117 0%, #161b22 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.06) !important;
}

[data-theme="dark"] .option-trading-panel .arco-input,
[data-theme="dark"] .option-trading-panel .arco-select,
[data-theme="dark"] .option-trading-panel .arco-button,
html[data-theme="dark"] .option-trading-panel .arco-input,
html[data-theme="dark"] .option-trading-panel .arco-select,
html[data-theme="dark"] .option-trading-panel .arco-button {
  background: rgba(255, 255, 255, 0.03) !important;
  border-color: rgba(255, 255, 255, 0.06) !important;
  color: #ffffff !important;
}

/* 整体页面背景强化 */
[data-theme="dark"] body,
html[data-theme="dark"] body {
  background: #0a0c10 !important;
}

/* 强制覆盖JavaScript设置的白色背景 */
[data-theme="dark"] .content_head,
html[data-theme="dark"] .content_head {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

[data-theme="dark"] .kline_box,
html[data-theme="dark"] .kline_box {
  background: transparent !important;
  background-color: transparent !important;
}

/* 🔥 确保K线图容器背景透明，让KLineChartPro自己控制背景 */
[data-theme="dark"] #optionChartBox,
[data-theme="dark"] .chartBox,
html[data-theme="dark"] #optionChartBox,
html[data-theme="dark"] .chartBox {
  background: transparent !important;
  background-color: transparent !important;
  
  :deep(.klinecharts-pro) {
    background: transparent !important;
  }
  
  canvas {
    background: transparent !important;
  }
}

[data-theme="dark"] #optionKlineCanvas,
html[data-theme="dark"] #optionKlineCanvas {
  background: #0a0e1a !important;
  background-color: #0a0e1a !important;
}

[data-theme="dark"] .content_main_left,
html[data-theme="dark"] .content_main_left {
  background: transparent !important;
  background-color: transparent !important;
}

[data-theme="dark"] .content_main_right,
html[data-theme="dark"] .content_main_right {
  background: transparent !important;
  background-color: transparent !important;
}

/* 强制深色模式所有容器 */
[data-theme="dark"] .block_kline *,
[data-theme="dark"] .option-trading-panel *,
[data-theme="dark"] .block_list *,
html[data-theme="dark"] .block_kline *,
html[data-theme="dark"] .option-trading-panel *,
html[data-theme="dark"] .block_list * {
  background: inherit !important;
}

/* 强制ArcoVue组件深色模式 */
[data-theme="dark"] .arco-tabs,
[data-theme="dark"] .arco-tabs-nav,
[data-theme="dark"] .arco-tabs-content,
[data-theme="dark"] .arco-tabs-tab,
[data-theme="dark"] .arco-tabs-pane,
html[data-theme="dark"] .arco-tabs,
html[data-theme="dark"] .arco-tabs-nav,
html[data-theme="dark"] .arco-tabs-content,
html[data-theme="dark"] .arco-tabs-tab,
html[data-theme="dark"] .arco-tabs-pane {
  background: transparent !important;
  background-color: transparent !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff !important;
}

/* 订单管理区域强制深色 */
[data-theme="dark"] .content_main_bottom,
[data-theme="dark"] .content_main_bottom *,
html[data-theme="dark"] .content_main_bottom,
html[data-theme="dark"] .content_main_bottom * {
  background: transparent !important;
  background-color: transparent !important;
  color: #ffffff !important;
}

/* 订单列表强制深色 */
[data-theme="dark"] .active-orders,
[data-theme="dark"] .history-orders,
[data-theme="dark"] .order-header,
[data-theme="dark"] .order-item,
html[data-theme="dark"] .active-orders,
html[data-theme="dark"] .history-orders,
html[data-theme="dark"] .order-header,
html[data-theme="dark"] .order-item {
  background: transparent !important;
  background-color: transparent !important;
  color: #ffffff !important;
}

/* 强制覆盖JavaScript设置的所有白色背景 */
[data-theme="dark"] .hotCoin,
[data-theme="dark"] .content_head,
[data-theme="dark"] .content_head_left,
[data-theme="dark"] .content_head_right,
[data-theme="dark"] .futures,
html[data-theme="dark"] .hotCoin,
html[data-theme="dark"] .content_head,
html[data-theme="dark"] .content_head_left,
html[data-theme="dark"] .content_head_right,
html[data-theme="dark"] .futures {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  color: #ffffff !important;
}

/* 顶部币种滚动区域强制深色 */
[data-theme="dark"] .hotCoin *,
[data-theme="dark"] .hotCoin .item,
html[data-theme="dark"] .hotCoin *,
html[data-theme="dark"] .hotCoin .item {
  background: transparent !important;
  background-color: transparent !important;
  color: #ffffff !important;
}

/* 页面主容器强制深色 */
[data-theme="dark"] .futures[style],
[data-theme="dark"] .content_head[style],
[data-theme="dark"] .hotCoin[style],
html[data-theme="dark"] .futures[style],
html[data-theme="dark"] .content_head[style],
html[data-theme="dark"] .hotCoin[style] {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
}

/* 覆盖所有内联样式设置的白色背景 */
[data-theme="dark"] [style*="background: #ffffff"],
[data-theme="dark"] [style*="background-color: #ffffff"],
[data-theme="dark"] [style*="background: rgb(255, 255, 255)"],
html[data-theme="dark"] [style*="background: #ffffff"],
html[data-theme="dark"] [style*="background-color: #ffffff"],
html[data-theme="dark"] [style*="background: rgb(255, 255, 255)"] {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
}

/* ==================== 深色主题文字颜色修复 ==================== */

/* 核心文字颜色 - 深色主题下 color-black 应该显示为白色 */
[data-theme="dark"] .color-black,
html[data-theme="dark"] .color-black,
body[data-theme="dark"] .color-black {
  color: #ffffff !important;
}

/* 灰色文字在深色主题下调整为更亮的灰色 */
[data-theme="dark"] .color-gray,
html[data-theme="dark"] .color-gray,
body[data-theme="dark"] .color-gray {
  color: #8b949e !important;
}

/* 白色文字在深色主题下保持白色 */
[data-theme="dark"] .color-white,
html[data-theme="dark"] .color-white,
body[data-theme="dark"] .color-white {
  color: #ffffff !important;
}

/* 小字体文字颜色修复 */
[data-theme="dark"] .font-12,
html[data-theme="dark"] .font-12,
body[data-theme="dark"] .font-12 {
  color: #ffffff !important;
}

/* 订单历史表格文字颜色 */
[data-theme="dark"] .order-item span,
[data-theme="dark"] .order-header span,
html[data-theme="dark"] .order-item span,
html[data-theme="dark"] .order-header span {
  color: #ffffff !important;
}

/* 期权交易面板内的所有文字 */
[data-theme="dark"] .option-trading-panel span,
[data-theme="dark"] .option-trading-panel p,
[data-theme="dark"] .option-trading-panel div,
html[data-theme="dark"] .option-trading-panel span,
html[data-theme="dark"] .option-trading-panel p,
html[data-theme="dark"] .option-trading-panel div {
  color: #ffffff !important;
}

/* 热门币种区域文字颜色 */
[data-theme="dark"] .hotCoin .color-black,
html[data-theme="dark"] .hotCoin .color-black {
  color: #ffffff !important;
}

/* 配置区域文字颜色 */
[data-theme="dark"] .config-header span,
[data-theme="dark"] .config-item span,
html[data-theme="dark"] .config-header span,
html[data-theme="dark"] .config-item span {
  color: #ffffff !important;
}

/* K线图区域文字颜色 */
[data-theme="dark"] .block_kline span,
[data-theme="dark"] .block_kline p,
[data-theme="dark"] .block_kline div,
html[data-theme="dark"] .block_kline span,
html[data-theme="dark"] .block_kline p,
html[data-theme="dark"] .block_kline div {
  color: #ffffff !important;
}

/* 通用文字元素强制白色 */
[data-theme="dark"] span.color-black,
[data-theme="dark"] div.color-black,
[data-theme="dark"] p.color-black,
html[data-theme="dark"] span.color-black,
html[data-theme="dark"] div.color-black,
html[data-theme="dark"] p.color-black {
  color: #ffffff !important;
}

/* ==================== 期权页面深色主题优化补丁 ==================== */

/* 1. 顶部飘窗币种价格优化 */
/* 只让币种名称显示白色，不影响涨跌幅颜色 */
[data-theme="dark"] .hotCoin .item span.color-black,
html[data-theme="dark"] .hotCoin .item span.color-black {
  color: #ffffff !important;
}

/* 确保涨跌幅在深色主题下有正确的颜色 */
[data-theme="dark"] .hotCoin .item .color-green,
html[data-theme="dark"] .hotCoin .item .color-green {
  color: #00ff88 !important; /* 亮绿色涨幅 */
}

[data-theme="dark"] .hotCoin .item .color-red,
html[data-theme="dark"] .hotCoin .item .color-red {
  color: #ff4757 !important; /* 亮红色跌幅 */
}

/* 浅色主题下的顶部飘窗涨跌幅颜色 */
[data-theme="light"] .hotCoin .item .color-green,
html[data-theme="light"] .hotCoin .item .color-green {
  color: #28a745 !important; /* 标准绿色涨幅 */
}

[data-theme="light"] .hotCoin .item .color-red,
html[data-theme="light"] .hotCoin .item .color-red {
  color: #dc3545 !important; /* 标准红色跌幅 */
}

/* ==================== 顶部飘窗涨跌幅颜色强制修复 ==================== */

/* 最高优先级样式 - 确保涨跌幅颜色正确显示 */
.hotCoin .item span.color-green,
[data-theme="dark"] .hotCoin .item span.color-green,
[data-theme="light"] .hotCoin .item span.color-green,
html[data-theme="dark"] .hotCoin .item span.color-green,
html[data-theme="light"] .hotCoin .item span.color-green,
body[data-theme="dark"] .hotCoin .item span.color-green,
body[data-theme="light"] .hotCoin .item span.color-green {
  color: #00ff88 !important; /* 强制亮绿色涨幅 */
  font-weight: 600 !important;
}

.hotCoin .item span.color-red,
[data-theme="dark"] .hotCoin .item span.color-red,
[data-theme="light"] .hotCoin .item span.color-red,
html[data-theme="dark"] .hotCoin .item span.color-red,
html[data-theme="light"] .hotCoin .item span.color-red,
body[data-theme="dark"] .hotCoin .item span.color-red,
body[data-theme="light"] .hotCoin .item span.color-red {
  color: #ff4757 !important; /* 强制亮红色跌幅 */
  font-weight: 600 !important;
}

/* 浅色主题使用标准颜色 */
[data-theme="light"] .hotCoin .item span.color-green,
html[data-theme="light"] .hotCoin .item span.color-green,
body[data-theme="light"] .hotCoin .item span.color-green {
  color: #28a745 !important; /* 标准绿色 */
}

[data-theme="light"] .hotCoin .item span.color-red,
html[data-theme="light"] .hotCoin .item span.color-red,
body[data-theme="light"] .hotCoin .item span.color-red {
  color: #dc3545 !important; /* 标准红色 */
}

/* ==================== 强制调试样式 ==================== */

/* 移除调试边框 - 保持清洁的外观 */
.hotCoin .item span.color-green,
.hotCoin .item span.color-red {
  border-left: none !important;
  padding-left: 0 !important;
}

/* 覆盖任何可能的内联样式 */
.hotCoin .item span[class*="color-"] {
  background: transparent !important;
}

/* 确保hover状态不会影响颜色 */
.hotCoin .item:hover span.color-green {
  color: #00ff88 !important;
}

.hotCoin .item:hover span.color-red {
  color: #ff4757 !important;
}

[data-theme="light"] .hotCoin .item:hover span.color-green {
  color: #28a745 !important;
}

[data-theme="light"] .hotCoin .item:hover span.color-red {
  color: #dc3545 !important;
}

/* ==================== 浅色主题文字对比度全面修复 ==================== */

/* 1. 基础文字颜色 - 浅色主题 */
[data-theme="light"] .color-black,
html[data-theme="light"] .color-black,
body[data-theme="light"] .color-black {
  color: #1a1a1a !important; /* 深黑色确保对比度 */
}

[data-theme="light"] .color-gray,
html[data-theme="light"] .color-gray,
body[data-theme="light"] .color-gray {
  color: #495057 !important; /* 深灰色确保可读性 */
}

[data-theme="light"] .color-white,
html[data-theme="light"] .color-white,
body[data-theme="light"] .color-white {
  color: #1a1a1a !important; /* 在浅色主题下显示为深色 */
}

/* 2. 小字体文字颜色修复 - 浅色主题 */
[data-theme="light"] .font-12,
html[data-theme="light"] .font-12,
body[data-theme="light"] .font-12 {
  color: #333333 !important; /* 深色小字体 */
}

/* 3. 订单历史表格文字颜色 - 浅色主题 */
[data-theme="light"] .order-item span,
[data-theme="light"] .order-header span,
html[data-theme="light"] .order-item span,
html[data-theme="light"] .order-header span {
  color: #1a1a1a !important; /* 深黑色表格文字 */
}

/* 4. 期权交易面板内的所有文字 - 浅色主题 */
[data-theme="light"] .option-trading-panel span,
[data-theme="light"] .option-trading-panel p,
[data-theme="light"] .option-trading-panel div,
html[data-theme="light"] .option-trading-panel span,
html[data-theme="light"] .option-trading-panel p,
html[data-theme="light"] .option-trading-panel div {
  color: #1a1a1a !important; /* 深色面板文字 */
}

/* 5. 热门币种区域文字颜色 - 浅色主题 */
[data-theme="light"] .hotCoin .color-black,
html[data-theme="light"] .hotCoin .color-black {
  color: #1a1a1a !important; /* 深黑色币种名称 */
}

/* 6. 配置区域文字颜色 - 浅色主题 */
[data-theme="light"] .config-header span,
[data-theme="light"] .config-item span,
html[data-theme="light"] .config-header span,
html[data-theme="light"] .config-item span {
  color: #1a1a1a !important; /* 深黑色配置文字 */
}

/* 7. K线图区域文字颜色 - 浅色主题 */
[data-theme="light"] .block_kline span,
[data-theme="light"] .block_kline p,
[data-theme="light"] .block_kline div,
html[data-theme="light"] .block_kline span,
html[data-theme="light"] .block_kline p,
html[data-theme="light"] .block_kline div {
  color: #1a1a1a !important; /* 深黑色K线文字 */
}

/* 8. 价格显示优化 - 浅色主题 */
[data-theme="light"] .balance-amount,
[data-theme="light"] .order-price span,
[data-theme="light"] .order-amount span,
[data-theme="light"] .order-symbol span,
html[data-theme="light"] .balance-amount,
html[data-theme="light"] .order-price span,
html[data-theme="light"] .order-amount span,
html[data-theme="light"] .order-symbol span {
  color: #1a1a1a !important; /* 深黑色价格文字 */
  font-weight: 600 !important;
}

/* 9. 币种选择器价格显示 - 浅色主题 */
[data-theme="light"] .contract-coin-selector .coin-pair,
html[data-theme="light"] .contract-coin-selector .coin-pair {
  color: #1a1a1a !important; /* 深黑色币种对 */
  font-weight: 600 !important;
}

/* 10. 倒计时文字 - 浅色主题 */
[data-theme="light"] .countdown-text,
html[data-theme="light"] .countdown-text {
  color: #dc3545 !important; /* 红色倒计时在浅色主题下 */
  font-weight: 600 !important;
}

/* 11. 订单状态标签 - 浅色主题 */
[data-theme="light"] .order-status .color-blue,
html[data-theme="light"] .order-status .color-blue {
  color: #007bff !important; /* 蓝色状态在浅色主题下 */
  font-weight: 500 !important;
}

/* 12. 期权配置下拉菜单 - 浅色主题 */
[data-theme="light"] .config-select .arco-select-view-value,
html[data-theme="light"] .config-select .arco-select-view-value {
  color: #1a1a1a !important; /* 深黑色下拉文字 */
}

/* 13. 投资金额输入框 - 浅色主题 */
[data-theme="light"] .amount-input,
html[data-theme="light"] .amount-input {
  color: #1a1a1a !important; /* 深黑色输入文字 */
  background: #ffffff !important;
  border-color: #dee2e6 !important;
}

[data-theme="light"] .amount-input::placeholder,
html[data-theme="light"] .amount-input::placeholder {
  color: #6c757d !important; /* 深灰色占位符 */
}

/* 14. 标签和标题 - 浅色主题 */
[data-theme="light"] .amount-label,
[data-theme="light"] .config-label,
[data-theme="light"] .balance-label,
html[data-theme="light"] .amount-label,
html[data-theme="light"] .config-label,
html[data-theme="light"] .balance-label {
  color: #1a1a1a !important; /* 深黑色标签 */
  font-weight: 600 !important;
}

/* 15. 统计信息 - 浅色主题 */
[data-theme="light"] .stat-label,
html[data-theme="light"] .stat-label {
  color: #6c757d !important; /* 深灰色统计标签 */
}

[data-theme="light"] .stat-value,
html[data-theme="light"] .stat-value {
  color: #1a1a1a !important; /* 深黑色统计值 */
  font-weight: 600 !important;
}

/* 确保涨跌幅颜色在深色主题下更鲜明 */
[data-theme="dark"] .color-green,
html[data-theme="dark"] .color-green {
  color: #00ff88 !important; /* 更亮的绿色 */
}

[data-theme="dark"] .color-red,
html[data-theme="dark"] .color-red {
  color: #ff4757 !important; /* 更亮的红色 */
}

/* 2. 看涨看跌按钮深色主题优化 */
[data-theme="dark"] .direction-btn,
html[data-theme="dark"] .direction-btn {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #ffffff !important;
  transition: all 0.3s ease !important;
}

[data-theme="dark"] .direction-btn:hover,
html[data-theme="dark"] .direction-btn:hover {
  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3) !important;
}

/* 看涨按钮激活状态 - 绿色主题 */
[data-theme="dark"] .direction-btn.call-btn.active,
html[data-theme="dark"] .direction-btn.call-btn.active {
  background: linear-gradient(135deg, #00ff88 0%, #00d674 100%) !important;
  border-color: #00ff88 !important;
  color: #000000 !important;
  box-shadow: 0 6px 20px rgba(0, 255, 136, 0.3) !important;
}

/* 看跌按钮激活状态 - 红色主题 */
[data-theme="dark"] .direction-btn.put-btn.active,
html[data-theme="dark"] .direction-btn.put-btn.active {
  background: linear-gradient(135deg, #ff4757 0%, #ff3742 100%) !important;
  border-color: #ff4757 !important;
  color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(255, 71, 87, 0.3) !important;
}

/* 按钮文字颜色 */
[data-theme="dark"] .direction-btn .btn-text,
[data-theme="dark"] .direction-btn .btn-rate,
[data-theme="dark"] .direction-btn .btn-icon,
html[data-theme="dark"] .direction-btn .btn-text,
html[data-theme="dark"] .direction-btn .btn-rate,
html[data-theme="dark"] .direction-btn .btn-icon {
  color: inherit !important;
}

/* 3. 历史订单区域滚动优化 */
[data-theme="dark"] .block_list,
html[data-theme="dark"] .block_list {
  max-height: 400px !important;
  overflow-y: auto !important;
  background: linear-gradient(145deg, #0f1319 0%, #1a1f2b 100%) !important;
}

/* 历史订单列表容器 */
[data-theme="dark"] .order-list-native,
html[data-theme="dark"] .order-list-native {
  max-height: 300px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding-right: 4px !important;
}

/* 自定义滚动条样式 */
[data-theme="dark"] .order-list-native::-webkit-scrollbar,
html[data-theme="dark"] .order-list-native::-webkit-scrollbar {
  width: 6px !important;
}

[data-theme="dark"] .order-list-native::-webkit-scrollbar-track,
html[data-theme="dark"] .order-list-native::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 3px !important;
}

[data-theme="dark"] .order-list-native::-webkit-scrollbar-thumb,
html[data-theme="dark"] .order-list-native::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 3px !important;
  transition: background 0.3s ease !important;
}

[data-theme="dark"] .order-list-native::-webkit-scrollbar-thumb:hover,
html[data-theme="dark"] .order-list-native::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3) !important;
}

/* 4. 价格显示优化 */
[data-theme="dark"] .balance-amount,
[data-theme="dark"] .order-price span,
[data-theme="dark"] .order-amount span,
[data-theme="dark"] .order-symbol span,
html[data-theme="dark"] .balance-amount,
html[data-theme="dark"] .order-price span,
html[data-theme="dark"] .order-amount span,
html[data-theme="dark"] .order-symbol span {
  color: #ffffff !important;
  font-weight: 500 !important;
}

/* 5. 币种选择器价格显示优化 */
[data-theme="dark"] .contract-coin-selector .coin-pair,
html[data-theme="dark"] .contract-coin-selector .coin-pair {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* 6. 倒计时文字优化 */
[data-theme="dark"] .countdown-text,
html[data-theme="dark"] .countdown-text {
  color: #ffd700 !important; /* 金黄色倒计时 */
  font-weight: 600 !important;
}

/* 7. 订单状态标签优化 */
[data-theme="dark"] .order-status .color-blue,
html[data-theme="dark"] .order-status .color-blue {
  color: #00a8ff !important;
  font-weight: 500 !important;
}

/* 8. 期权配置下拉菜单优化 */
[data-theme="dark"] .config-select .arco-select-view-value,
html[data-theme="dark"] .config-select .arco-select-view-value {
  color: #ffffff !important;
}

/* 9. 投资金额输入框优化 */
[data-theme="dark"] .amount-input,
html[data-theme="dark"] .amount-input {
  color: #ffffff !important;
  background: rgba(255, 255, 255, 0.05) !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

[data-theme="dark"] .amount-input::placeholder,
html[data-theme="dark"] .amount-input::placeholder {
  color: rgba(255, 255, 255, 0.4) !important;
}

/* 10. 标签和标题优化 */
[data-theme="dark"] .amount-label,
[data-theme="dark"] .config-label,
[data-theme="dark"] .balance-label,
html[data-theme="dark"] .amount-label,
html[data-theme="dark"] .config-label,
html[data-theme="dark"] .balance-label {
  color: #ffffff !important;
  font-weight: 500 !important;
}

/* ==================== 浅色主题看涨看跌按钮优化 ==================== */

/* 浅色主题看涨看跌按钮基础样式 */
[data-theme="light"] .direction-btn,
html[data-theme="light"] .direction-btn {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
  border: 1px solid #dee2e6 !important;
  color: #333333 !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

[data-theme="light"] .direction-btn:hover,
html[data-theme="light"] .direction-btn:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%) !important;
  border-color: #adb5bd !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12) !important;
}

/* 看涨按钮激活状态 - 绿色主题 */
[data-theme="light"] .direction-btn.call-btn.active,
html[data-theme="light"] .direction-btn.call-btn.active {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%) !important;
  border-color: #28a745 !important;
  color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3) !important;
}

/* 看跌按钮激活状态 - 红色主题 */
[data-theme="light"] .direction-btn.put-btn.active,
html[data-theme="light"] .direction-btn.put-btn.active {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%) !important;
  border-color: #dc3545 !important;
  color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.3) !important;
}

/* 浅色主题按钮文字颜色 */
[data-theme="light"] .direction-btn .btn-text,
[data-theme="light"] .direction-btn .btn-rate,
[data-theme="light"] .direction-btn .btn-icon,
html[data-theme="light"] .direction-btn .btn-text,
html[data-theme="light"] .direction-btn .btn-rate,
html[data-theme="light"] .direction-btn .btn-icon {
  color: inherit !important;
}

/* ==================== 通用历史订单滚动优化 ==================== */

/* 浅色主题历史订单滚动 */
[data-theme="light"] .block_list,
html[data-theme="light"] .block_list {
  max-height: 400px !important;
  overflow-y: auto !important;
}

[data-theme="light"] .order-list-native,
html[data-theme="light"] .order-list-native {
  max-height: 300px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding-right: 4px !important;
}

/* 浅色主题滚动条样式 */
[data-theme="light"] .order-list-native::-webkit-scrollbar,
html[data-theme="light"] .order-list-native::-webkit-scrollbar {
  width: 6px !important;
}

[data-theme="light"] .order-list-native::-webkit-scrollbar-track,
html[data-theme="light"] .order-list-native::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05) !important;
  border-radius: 3px !important;
}

[data-theme="light"] .order-list-native::-webkit-scrollbar-thumb,
html[data-theme="light"] .order-list-native::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2) !important;
  border-radius: 3px !important;
  transition: background 0.3s ease !important;
}

[data-theme="light"] .order-list-native::-webkit-scrollbar-thumb:hover,
html[data-theme="light"] .order-list-native::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3) !important;
}

/* ==================== 通用滚动优化 ==================== */

/* 确保所有订单列表都可以滚动 */
.order-list-native {
  max-height: 300px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* 通用滚动条优化 */
.order-list-native::-webkit-scrollbar {
  width: 6px !important;
}

.order-list-native::-webkit-scrollbar-track {
  background: var(--background-secondary) !important;
  border-radius: 3px !important;
}

.order-list-native::-webkit-scrollbar-thumb {
  background: var(--content-tertiary) !important;
  border-radius: 3px !important;
  transition: background 0.3s ease !important;
}

.order-list-native::-webkit-scrollbar-thumb:hover {
  background: var(--content-primary) !important;
}

/* ==================== 价格显示区域优化 ==================== */

/* 深色主题价格显示优化 */
[data-theme="dark"] .main-price-display .price-value,
html[data-theme="dark"] .main-price-display .price-value {
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 28px !important;
}

[data-theme="dark"] .main-price-display .price-change,
html[data-theme="dark"] .main-price-display .price-change {
  font-weight: 600 !important;
}

/* 价格变化颜色优化 */
[data-theme="dark"] .text-green,
html[data-theme="dark"] .text-green {
  color: #00ff88 !important;
}

[data-theme="dark"] .text-red,
html[data-theme="dark"] .text-red {
  color: #ff4757 !important;
}

/* 统计信息优化 */
[data-theme="dark"] .stat-label,
html[data-theme="dark"] .stat-label {
  color: #8b949e !important;
  font-size: 12px !important;
}

[data-theme="dark"] .stat-value,
html[data-theme="dark"] .stat-value {
  color: #ffffff !important;
  font-weight: 600 !important;
}

/* 浅色主题价格显示优化 */
[data-theme="light"] .main-price-display .price-value,
html[data-theme="light"] .main-price-display .price-value {
  color: #1a1a1a !important;
  font-weight: 700 !important;
  font-size: 28px !important;
}

[data-theme="light"] .text-green,
html[data-theme="light"] .text-green {
  color: #28a745 !important;
}

[data-theme="light"] .text-red,
html[data-theme="light"] .text-red {
  color: #dc3545 !important;
}

[data-theme="light"] .stat-label,
html[data-theme="light"] .stat-label {
  color: #6c757d !important;
}

[data-theme="light"] .stat-value,
html[data-theme="light"] .stat-value {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

/* ==================== 币种下拉菜单价格优化 ==================== */

/* 深色主题币种下拉菜单 */
[data-theme="dark"] .contract-dropdown .coin-item .coin-symbol,
html[data-theme="dark"] .contract-dropdown .coin-item .coin-symbol {
  color: #ffffff !important;
  font-weight: 600 !important;
}

[data-theme="dark"] .contract-dropdown .coin-item .coin-price,
html[data-theme="dark"] .contract-dropdown .coin-item .coin-price {
  color: #ffffff !important;
}

[data-theme="dark"] .contract-dropdown .coin-item .coin-change,
html[data-theme="dark"] .contract-dropdown .coin-item .coin-change {
  font-weight: 500 !important;
}

/* 浅色主题币种下拉菜单 */
[data-theme="light"] .contract-dropdown .coin-item .coin-symbol,
html[data-theme="light"] .contract-dropdown .coin-item .coin-symbol {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

[data-theme="light"] .contract-dropdown .coin-item .coin-price,
html[data-theme="light"] .contract-dropdown .coin-item .coin-price {
  color: #333333 !important;
}

/* ==================== 期权余额显示优化 ==================== */

[data-theme="dark"] .balance-display .balance-amount,
html[data-theme="dark"] .balance-display .balance-amount {
  color: #ffd700 !important; /* 金色余额显示 */
  font-weight: 700 !important;
  font-size: 16px !important;
}

[data-theme="light"] .balance-display .balance-amount,
html[data-theme="light"] .balance-display .balance-amount {
  color: #007bff !important; /* 蓝色余额显示 */
  font-weight: 700 !important;
  font-size: 16px !important;
}

/* ==================== 下单按钮优化 ==================== */

[data-theme="dark"] .trade-button,
html[data-theme="dark"] .trade-button {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
  color: #ffffff !important;
  border: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

[data-theme="dark"] .trade-button:hover,
html[data-theme="dark"] .trade-button:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 123, 255, 0.3) !important;
}

/* ==================== 浅色主题按钮和交互元素优化 ==================== */

/* 下单按钮 - 浅色主题 */
[data-theme="light"] .trade-button,
html[data-theme="light"] .trade-button {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
  color: #ffffff !important;
  border: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

[data-theme="light"] .trade-button:hover,
html[data-theme="light"] .trade-button:hover {
  background: linear-gradient(135deg, #0056b3 0%, #004085 100%) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px rgba(0, 123, 255, 0.3) !important;
}

/* ==================== 浅色主题通用文字增强 ==================== */

/* 确保所有span元素在浅色主题下都有足够的对比度 */
[data-theme="light"] span:not(.color-green):not(.color-red),
html[data-theme="light"] span:not(.color-green):not(.color-red) {
  color: #1a1a1a !important;
}

/* 确保所有p元素在浅色主题下都有足够的对比度 */
[data-theme="light"] p,
html[data-theme="light"] p {
  color: #1a1a1a !important;
}

/* 确保所有div中的文字在浅色主题下都有足够的对比度 */
[data-theme="light"] div:not(.direction-btn):not(.color-green):not(.color-red),
html[data-theme="light"] div:not(.direction-btn):not(.color-green):not(.color-red) {
  color: #1a1a1a !important;
}

/* ==================== 浅色主题背景确保 ==================== */

/* 确保期权交易面板在浅色主题下有正确的背景 */
[data-theme="light"] .option-trading-panel,
html[data-theme="light"] .option-trading-panel {
  background-color: var(--background-primary) !important;
  border: 1px solid var(--border-strength-100) !important;
}

/* 确保历史订单区域在浅色主题下有正确的背景 */
[data-theme="light"] .block_list,
html[data-theme="light"] .block_list {
  background: #ffffff !important;
  border: 1px solid #dee2e6 !important;
}

/* 确保K线图区域在浅色主题下有正确的背景 */
[data-theme="light"] .block_kline,
html[data-theme="light"] .block_kline {
  background: #ffffff !important;
  border: 1px solid #dee2e6 !important;
}

/* ==================== 浅色主题ArcoDesign组件优化 ==================== */

/* ArcoDesign选择器在浅色主题下的优化 */
[data-theme="light"] .arco-select-view-value,
html[data-theme="light"] .arco-select-view-value {
  color: #1a1a1a !important;
}

[data-theme="light"] .arco-input,
html[data-theme="light"] .arco-input {
  color: #1a1a1a !important;
  background: #ffffff !important;
  border-color: #dee2e6 !important;
}

[data-theme="light"] .arco-tabs-tab-title,
html[data-theme="light"] .arco-tabs-tab-title {
  color: #495057 !important;
}

[data-theme="light"] .arco-tabs-tab-active .arco-tabs-tab-title,
html[data-theme="light"] .arco-tabs-tab-active .arco-tabs-tab-title {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

/* ==================== 调试边框移除 ==================== */

/* 移除调试边框以获得更清洁的外观 */
[data-theme="light"] .hotCoin .item span.color-green {
  border-left: none !important;
  padding-left: 0 !important;
}

[data-theme="light"] .hotCoin .item span.color-red {
  border-left: none !important;
  padding-left: 0 !important;
}

/* ==================== 浅色主题最终优化补丁 ==================== */

/* 确保期权余额在浅色主题下清晰可见 */
[data-theme="light"] .balance-display .balance-amount,
html[data-theme="light"] .balance-display .balance-amount {
  color: #007bff !important; /* 蓝色余额在浅色背景下 */
  font-weight: 700 !important;
  text-shadow: none !important;
}

/* 期权配置选择器在浅色主题下的文字优化 */
[data-theme="light"] .config-section .config-label,
html[data-theme="light"] .config-section .config-label {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

/* 投资金额区域在浅色主题下的文字优化 */
[data-theme="light"] .amount-section .amount-label,
html[data-theme="light"] .amount-section .amount-label {
  color: #1a1a1a !important;
  font-weight: 600 !important;
}

[data-theme="light"] .amount-section .available,
html[data-theme="light"] .amount-section .available {
  color: #6c757d !important;
}

/* 快速金额按钮在浅色主题下的优化 */
[data-theme="light"] .quick-amount-btn,
html[data-theme="light"] .quick-amount-btn {
  background: #f8f9fa !important;
  border: 1px solid #dee2e6 !important;
  color: #495057 !important;
}

[data-theme="light"] .quick-amount-btn:hover,
html[data-theme="light"] .quick-amount-btn:hover {
  background: #e9ecef !important;
  color: #1a1a1a !important;
}

/* 期权倒计时在浅色主题下的优化 */
[data-theme="light"] .countdown-display,
html[data-theme="light"] .countdown-display {
  background: #f8f9fa !important;
  border: 1px solid #dee2e6 !important;
}

[data-theme="light"] .countdown-label,
html[data-theme="light"] .countdown-label {
  color: #495057 !important;
}

[data-theme="light"] .countdown-time,
html[data-theme="light"] .countdown-time {
  color: #dc3545 !important;
  font-weight: 700 !important;
}

/* 确保所有重要文字元素在浅色主题下都足够深 */
[data-theme="light"] .futures *:not(.color-green):not(.color-red):not(.direction-btn):not(.arco-button),
html[data-theme="light"] .futures *:not(.color-green):not(.color-red):not(.direction-btn):not(.arco-button) {
  color: #1a1a1a !important;
}

/* 表格头部在浅色主题下的优化 */
[data-theme="light"] .order-header,
html[data-theme="light"] .order-header {
  background: #f8f9fa !important;
  border-bottom: 2px solid #dee2e6 !important;
}

/* 表格行在浅色主题下的优化 */
[data-theme="light"] .order-item,
html[data-theme="light"] .order-item {
  border-bottom: 1px solid #e9ecef !important;
}

[data-theme="light"] .order-item:hover,
html[data-theme="light"] .order-item:hover {
  background: #f8f9fa !important;
}

/* ==================== 币种选择下拉框主题适配 ==================== */

/* 深色主题下拉框样式 */
[data-theme="dark"] .contract-dropdown,
html[data-theme="dark"] .contract-dropdown {
  background: #1e1e1e !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  padding: 12px !important;
  max-height: 300px !important;
  overflow-y: auto !important;
}

/* 浅色主题下拉框样式 */
[data-theme="light"] .contract-dropdown,
html[data-theme="light"] .contract-dropdown {
  background: #ffffff !important;
  border: 1px solid #dee2e6 !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
  padding: 12px !important;
  max-height: 300px !important;
  overflow-y: auto !important;
}

/* 深色主题搜索框样式 */
[data-theme="dark"] .contract-dropdown .arco-input,
[data-theme="dark"] .contract-dropdown .arco-input-wrapper,
html[data-theme="dark"] .contract-dropdown .arco-input,
html[data-theme="dark"] .contract-dropdown .arco-input-wrapper {
  background: #2a2a2a !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
}

[data-theme="dark"] .contract-dropdown .arco-input::placeholder,
html[data-theme="dark"] .contract-dropdown .arco-input::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* 浅色主题搜索框样式 */
[data-theme="light"] .contract-dropdown .arco-input,
[data-theme="light"] .contract-dropdown .arco-input-wrapper,
html[data-theme="light"] .contract-dropdown .arco-input,
html[data-theme="light"] .contract-dropdown .arco-input-wrapper {
  background: #ffffff !important;
  border-color: #dee2e6 !important;
  color: #1a1a1a !important;
}

[data-theme="light"] .contract-dropdown .arco-input::placeholder,
html[data-theme="light"] .contract-dropdown .arco-input::placeholder {
  color: #6c757d !important;
}

/* 深色主题币种选项样式 */
[data-theme="dark"] .contract-dropdown .coin-item,
html[data-theme="dark"] .contract-dropdown .coin-item {
  background: transparent !important;
  color: #ffffff !important;
  padding: 8px 12px !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

[data-theme="dark"] .contract-dropdown .coin-item:hover,
html[data-theme="dark"] .contract-dropdown .coin-item:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

/* 浅色主题币种选项样式 */
[data-theme="light"] .contract-dropdown .coin-item,
html[data-theme="light"] .contract-dropdown .coin-item {
  background: transparent !important;
  color: #1a1a1a !important;
  padding: 8px 12px !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

[data-theme="light"] .contract-dropdown .coin-item:hover,
html[data-theme="light"] .contract-dropdown .coin-item:hover {
  background: #f8f9fa !important;
}

/* 深色主题币种信息文字 */
[data-theme="dark"] .contract-dropdown .coin-symbol,
[data-theme="dark"] .contract-dropdown .coin-price,
[data-theme="dark"] .contract-dropdown .coin-change,
html[data-theme="dark"] .contract-dropdown .coin-symbol,
html[data-theme="dark"] .contract-dropdown .coin-price,
html[data-theme="dark"] .contract-dropdown .coin-change {
  color: #ffffff !important;
}

/* 浅色主题币种信息文字 */
[data-theme="light"] .contract-dropdown .coin-symbol,
[data-theme="light"] .contract-dropdown .coin-price,
[data-theme="light"] .contract-dropdown .coin-change,
html[data-theme="light"] .contract-dropdown .coin-symbol,
html[data-theme="light"] .contract-dropdown .coin-price,
html[data-theme="light"] .contract-dropdown .coin-change {
  color: #1a1a1a !important;
}

/* 下拉框滚动条样式 - 深色主题 */
[data-theme="dark"] .contract-dropdown::-webkit-scrollbar,
html[data-theme="dark"] .contract-dropdown::-webkit-scrollbar {
  width: 6px !important;
}

[data-theme="dark"] .contract-dropdown::-webkit-scrollbar-track,
html[data-theme="dark"] .contract-dropdown::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05) !important;
  border-radius: 3px !important;
}

[data-theme="dark"] .contract-dropdown::-webkit-scrollbar-thumb,
html[data-theme="dark"] .contract-dropdown::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2) !important;
  border-radius: 3px !important;
}

/* 下拉框滚动条样式 - 浅色主题 */
[data-theme="light"] .contract-dropdown::-webkit-scrollbar,
html[data-theme="light"] .contract-dropdown::-webkit-scrollbar {
  width: 6px !important;
}

[data-theme="light"] .contract-dropdown::-webkit-scrollbar-track,
html[data-theme="light"] .contract-dropdown::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05) !important;
  border-radius: 3px !important;
}

[data-theme="light"] .contract-dropdown::-webkit-scrollbar-thumb,
html[data-theme="light"] .contract-dropdown::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2) !important;
  border-radius: 3px !important;
}

[data-theme="light"] .contract-dropdown::-webkit-scrollbar-thumb:hover,
html[data-theme="light"] .contract-dropdown::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3) !important;
}

/* ==================== 币种选择器按钮主题适配 ==================== */

/* 深色主题币种选择器按钮 */
[data-theme="dark"] .contract-coin-selector,
html[data-theme="dark"] .contract-coin-selector {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  color: #ffffff !important;
  padding: 12px 16px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
}

[data-theme="dark"] .contract-coin-selector:hover,
html[data-theme="dark"] .contract-coin-selector:hover {
  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2) !important;
}

/* 浅色主题币种选择器按钮 */
[data-theme="light"] .contract-coin-selector,
html[data-theme="light"] .contract-coin-selector {
  background: #ffffff !important;
  border: 1px solid #dee2e6 !important;
  color: #1a1a1a !important;
  padding: 12px 16px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
}

[data-theme="light"] .contract-coin-selector:hover,
html[data-theme="light"] .contract-coin-selector:hover {
  background: #f8f9fa !important;
  border-color: #adb5bd !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}

/* 币种选择器内的图标和文字 - 深色主题 */
[data-theme="dark"] .contract-coin-selector .coin-logo,
html[data-theme="dark"] .contract-coin-selector .coin-logo {
  width: 24px !important;
  height: 24px !important;
  border-radius: 50% !important;
}

[data-theme="dark"] .contract-coin-selector .coin-pair,
html[data-theme="dark"] .contract-coin-selector .coin-pair {
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 16px !important;
}

[data-theme="dark"] .contract-coin-selector .arrow-down,
html[data-theme="dark"] .contract-coin-selector .arrow-down {
  color: #ffffff !important;
  opacity: 0.7 !important;
}

/* 币种选择器内的图标和文字 - 浅色主题 */
[data-theme="light"] .contract-coin-selector .coin-logo,
html[data-theme="light"] .contract-coin-selector .coin-logo {
  width: 24px !important;
  height: 24px !important;
  border-radius: 50% !important;
}

[data-theme="light"] .contract-coin-selector .coin-pair,
html[data-theme="light"] .contract-coin-selector .coin-pair {
  color: #1a1a1a !important;
  font-weight: 600 !important;
  font-size: 16px !important;
}

[data-theme="light"] .contract-coin-selector .arrow-down,
html[data-theme="light"] .contract-coin-selector .arrow-down {
  color: #495057 !important;
  opacity: 0.8 !important;
}

/* 确保下拉框弹出时覆盖层的样式 */
[data-theme="light"] .arco-trigger-popup,
html[data-theme="light"] .arco-trigger-popup {
  background: transparent !important;
}

[data-theme="dark"] .arco-trigger-popup,
html[data-theme="dark"] .arco-trigger-popup {
  background: transparent !important;
}

/* ArcoDesign下拉组件的浅色主题适配 */
[data-theme="light"] .arco-dropdown,
html[data-theme="light"] .arco-dropdown {
  background: #ffffff !important;
  border: 1px solid #dee2e6 !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

[data-theme="light"] .arco-dropdown-option,
html[data-theme="light"] .arco-dropdown-option {
  color: #1a1a1a !important;
}

[data-theme="light"] .arco-dropdown-option:hover,
html[data-theme="light"] .arco-dropdown-option:hover {
  background: #f8f9fa !important;
}

/* ==================== 修复硬编码样式的主题适配 ==================== */

/* 深色主题下拉菜单适配 */
[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown,
html[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown {
  background: linear-gradient(145deg, #1e1e1e 0%, #2a2a2a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
  box-shadow: 
    0 16px 40px rgba(0, 0, 0, 0.7),
    0 0 20px rgba(0, 168, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
}

[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input-wrapper,
html[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input-wrapper {
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.2) !important;
}

[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown .coin-item:hover,
html[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown .coin-item:hover {
  background: linear-gradient(135deg, #2a2a2a 0%, #3a3a3a 100%) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

/* 浅色主题下拉菜单适配 */
[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown,
html[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown {
  background: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.2) !important;
  box-shadow: 
    0 16px 40px rgba(0, 0, 0, 0.1),
    0 0 20px rgba(0, 168, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.8) !important;
}

[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input-wrapper,
html[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input-wrapper {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
  border: 1px solid rgba(0, 168, 255, 0.3) !important;
}

[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input,
html[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input {
  color: #1a1a1a !important;
}

[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input::placeholder,
html[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input::placeholder {
  color: #6c757d !important;
}

[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown .coin-item:hover,
html[data-theme="light"] :deep(.arco-dropdown-content) .contract-dropdown .coin-item:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #f8f9fa 100%) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* 深色主题币种信息文字 */
[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input,
html[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input {
  color: #ffffff !important;
}

[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input::placeholder,
html[data-theme="dark"] :deep(.arco-dropdown-content) .contract-dropdown .arco-input::placeholder {
  color: #888888 !important;
}

/* 强制刷新组件状态的样式 */
[data-theme="light"] .futures,
html[data-theme="light"] .futures {
  color-scheme: light !important;
}

[data-theme="dark"] .futures,
html[data-theme="dark"] .futures {
  color-scheme: dark !important;
}

/* 强制刷新ArcoDesign组件主题 */
[data-theme="light"] .arco-layout,
[data-theme="light"] .arco-layout-content,
[data-theme="light"] .arco-dropdown,
html[data-theme="light"] .arco-layout,
html[data-theme="light"] .arco-layout-content,
html[data-theme="light"] .arco-dropdown {
  color-scheme: light !important;
  transition: all 0.3s ease !important;
}

[data-theme="dark"] .arco-layout,
[data-theme="dark"] .arco-layout-content,  
[data-theme="dark"] .arco-dropdown,
html[data-theme="dark"] .arco-layout,
html[data-theme="dark"] .arco-layout-content,
html[data-theme="dark"] .arco-dropdown {
  color-scheme: dark !important;
  transition: all 0.3s ease !important;
}

/* ==================== 图表画布主题适配 ==================== */

/* 深色主题图表画布 */
[data-theme="dark"] .kline-chart-canvas,
html[data-theme="dark"] .kline-chart-canvas {
  background: linear-gradient(180deg, #0a0e1a 0%, #0f1419 50%, #1a1f2e 100%) !important;
  border: 1px solid rgba(255,255,255,0.06) !important;
}

/* 浅色主题图表画布 */
[data-theme="light"] .kline-chart-canvas,
html[data-theme="light"] .kline-chart-canvas {
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%) !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
}

/* ==================== 主要容器主题适配 ==================== */

/* 深色主题容器背景 */
[data-theme="dark"] .futures_content,
[data-theme="dark"] .hotCoin,
[data-theme="dark"] .content_head,
html[data-theme="dark"] .futures_content,
html[data-theme="dark"] .hotCoin,
html[data-theme="dark"] .content_head {
  background: #0a0c10 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  transition: all 0.3s ease !important;
}

[data-theme="dark"] .content_main_right,
html[data-theme="dark"] .content_main_right {
  background: #0a0c10 !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  transition: all 0.3s ease !important;
}

/* 浅色主题容器背景 */
[data-theme="light"] .futures_content,
html[data-theme="light"] .futures_content {
  background: #f8f9fa !important;
  transition: all 0.3s ease !important;
}

[data-theme="light"] .hotCoin,
[data-theme="light"] .content_head,
html[data-theme="light"] .hotCoin,
html[data-theme="light"] .content_head {
  background: #ffffff !important;
  border-bottom: 1px solid #e8e8e8 !important;
  transition: all 0.3s ease !important;
}

[data-theme="light"] .content_main_right,
html[data-theme="light"] .content_main_right {
  background: #ffffff !important;
  border: 1px solid #e8e8e8 !important;
  transition: all 0.3s ease !important;
}

/* ==================== 强制覆盖所有深色硬编码样式 ==================== */

/* 浅色主题下强制覆盖所有深色背景 */
[data-theme="light"] .amount-input :deep(.arco-input-wrapper),
[data-theme="light"] .config-select .arco-select,
[data-theme="light"] .arco-input-wrapper,
[data-theme="light"] .arco-select,
[data-theme="light"] .arco-select-view,
[data-theme="light"] .contract-dropdown,
[data-theme="light"] .trade-panel,
[data-theme="light"] .order-history,
[data-theme="light"] .flash-option-panel,
[data-theme="light"] .content_main_right,
[data-theme="light"] .block_list,
[data-theme="light"] .kline_box,
[data-theme="light"] .option-coin-item,
html[data-theme="light"] .amount-input :deep(.arco-input-wrapper),
html[data-theme="light"] .config-select .arco-select,
html[data-theme="light"] .arco-input-wrapper,
html[data-theme="light"] .arco-select,
html[data-theme="light"] .arco-select-view,
html[data-theme="light"] .contract-dropdown,
html[data-theme="light"] .trade-panel,
html[data-theme="light"] .order-history,
html[data-theme="light"] .flash-option-panel,
html[data-theme="light"] .content_main_right,
html[data-theme="light"] .block_list,
html[data-theme="light"] .kline_box,
html[data-theme="light"] .option-coin-item {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  border-color: #dee2e6 !important;
  color: #1a1a1a !important;
}

/* 浅色主题下的输入框样式强制覆盖 */
[data-theme="light"] .amount-input :deep(.arco-input-wrapper):hover,
[data-theme="light"] .config-select .arco-select:hover,
[data-theme="light"] .arco-input-wrapper:hover,
[data-theme="light"] .arco-select:hover,
html[data-theme="light"] .amount-input :deep(.arco-input-wrapper):hover,
html[data-theme="light"] .config-select .arco-select:hover,
html[data-theme="light"] .arco-input-wrapper:hover,
html[data-theme="light"] .arco-select:hover {
  background: #f8f9fa !important;
  background-color: #f8f9fa !important;
  background-image: none !important;
  border-color: #007bff !important;
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.15) !important;
}

/* 浅色主题下的输入框焦点状态强制覆盖 */
[data-theme="light"] .amount-input :deep(.arco-input-wrapper):focus-within,
[data-theme="light"] .config-select .arco-select:focus-within,
[data-theme="light"] .arco-input-wrapper:focus-within,
[data-theme="light"] .arco-select:focus-within,
html[data-theme="light"] .amount-input :deep(.arco-input-wrapper):focus-within,
html[data-theme="light"] .config-select .arco-select:focus-within,
html[data-theme="light"] .arco-input-wrapper:focus-within,
html[data-theme="light"] .arco-select:focus-within {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  border-color: #007bff !important;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25) !important;
}

/* 浅色主题下的文字颜色强制覆盖 */
[data-theme="light"] .amount-input :deep(.arco-input),
[data-theme="light"] .config-select .arco-select-view,
[data-theme="light"] .arco-input,
[data-theme="light"] .arco-select-view,
[data-theme="light"] .option-coin-pair,
[data-theme="light"] .coin-pair,
html[data-theme="light"] .amount-input :deep(.arco-input),
html[data-theme="light"] .config-select .arco-select-view,
html[data-theme="light"] .arco-input,
html[data-theme="light"] .arco-select-view,
html[data-theme="light"] .option-coin-pair,
html[data-theme="light"] .coin-pair {
  color: #1a1a1a !important;
}

/* 浅色主题下的占位符文字颜色强制覆盖 */
[data-theme="light"] .amount-input :deep(.arco-input)::placeholder,
[data-theme="light"] .arco-input::placeholder,
html[data-theme="light"] .amount-input :deep(.arco-input)::placeholder,
html[data-theme="light"] .arco-input::placeholder {
  color: #6c757d !important;
}

/* 深色主题下确保所有元素都有正确的深色样式 */
[data-theme="dark"] .amount-input :deep(.arco-input-wrapper),
[data-theme="dark"] .config-select .arco-select,
[data-theme="dark"] .arco-input-wrapper,
[data-theme="dark"] .arco-select,
[data-theme="dark"] .arco-select-view,
[data-theme="dark"] .contract-dropdown,
[data-theme="dark"] .trade-panel,
[data-theme="dark"] .order-history,
[data-theme="dark"] .flash-option-panel,
[data-theme="dark"] .content_main_right,
[data-theme="dark"] .block_list,
[data-theme="dark"] .kline_box,
[data-theme="dark"] .option-coin-item,
html[data-theme="dark"] .amount-input :deep(.arco-input-wrapper),
html[data-theme="dark"] .config-select .arco-select,
html[data-theme="dark"] .arco-input-wrapper,
html[data-theme="dark"] .arco-select,
html[data-theme="dark"] .arco-select-view,
html[data-theme="dark"] .contract-dropdown,
html[data-theme="dark"] .trade-panel,
html[data-theme="dark"] .order-history,
html[data-theme="dark"] .flash-option-panel,
html[data-theme="dark"] .content_main_right,
html[data-theme="dark"] .block_list,
html[data-theme="dark"] .kline_box,
html[data-theme="dark"] .option-coin-item {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
  background-color: #1a1a1a !important;
  border-color: rgba(0, 168, 255, 0.3) !important;
  color: #ffffff !important;
}

/* 深色主题下的文字颜色确保 */
[data-theme="dark"] .amount-input :deep(.arco-input),
[data-theme="dark"] .config-select .arco-select-view,
[data-theme="dark"] .arco-input,
[data-theme="dark"] .arco-select-view,
[data-theme="dark"] .option-coin-pair,
[data-theme="dark"] .coin-pair,
html[data-theme="dark"] .amount-input :deep(.arco-input),
html[data-theme="dark"] .config-select .arco-select-view,
html[data-theme="dark"] .arco-input,
html[data-theme="dark"] .arco-select-view,
html[data-theme="dark"] .option-coin-pair,
html[data-theme="dark"] .coin-pair {
  color: #ffffff !important;
}

/* 深色主题下的占位符文字颜色确保 */
[data-theme="dark"] .amount-input :deep(.arco-input)::placeholder,
[data-theme="dark"] .arco-input::placeholder,
html[data-theme="dark"] .amount-input :deep(.arco-input)::placeholder,
html[data-theme="dark"] .arco-input::placeholder {
  color: #888888 !important;
}

/* 强制刷新ArcoDesign组件的主题 - 排除头部导航栏容器 */
[data-theme="light"] .arco-layout,
[data-theme="light"] .arco-layout-content,
[data-theme="light"] .futures,
html[data-theme="light"] .arco-layout,
html[data-theme="light"] .arco-layout-content,
html[data-theme="light"] .futures {
  background: #f8f9fa !important;
  color: #1a1a1a !important;
  color-scheme: light !important;
}

/* 浅色主题下头部导航栏容器 - 强制透明 */
[data-theme="light"] .futures .arco-layout-header,
html[data-theme="light"] .futures .arco-layout-header,
body[data-theme="light"] .futures .arco-layout-header {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  backdrop-filter: none !important;
  border: none !important;
  box-shadow: none !important;
}

[data-theme="dark"] .arco-layout,
[data-theme="dark"] .arco-layout-content,
[data-theme="dark"] .futures,
html[data-theme="dark"] .arco-layout,
html[data-theme="dark"] .arco-layout-content,
html[data-theme="dark"] .futures {
  background: #0a0c10 !important;
  color: #ffffff !important;
  color-scheme: dark !important;
}

/* 深色主题下头部导航栏容器 - 强制透明 */
[data-theme="dark"] .futures .arco-layout-header,
html[data-theme="dark"] .futures .arco-layout-header,
body[data-theme="dark"] .futures .arco-layout-header {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  backdrop-filter: none !important;
  border: none !important;
  box-shadow: none !important;
}

/* ==================== 最终强制修复所有可能的样式冲突 ==================== */

/* 超强力覆盖 - 浅色主题下清除所有深色背景 */
[data-theme="light"] *[style*="background: linear-gradient"],
[data-theme="light"] *[style*="background-color: #1a1a1a"],
[data-theme="light"] *[style*="background-color: #2a2a2a"],
[data-theme="light"] *[style*="background-color: #0a0c10"],
[data-theme="light"] *[style*="background-color: #0a0e1a"],
[data-theme="light"] *[style*="background: #1a1a1a"],
[data-theme="light"] *[style*="background: #2a2a2a"],
[data-theme="light"] *[style*="background: #0a0c10"],
[data-theme="light"] *[style*="background: #0a0e1a"],
html[data-theme="light"] *[style*="background: linear-gradient"],
html[data-theme="light"] *[style*="background-color: #1a1a1a"],
html[data-theme="light"] *[style*="background-color: #2a2a2a"],
html[data-theme="light"] *[style*="background-color: #0a0c10"],
html[data-theme="light"] *[style*="background-color: #0a0e1a"],
html[data-theme="light"] *[style*="background: #1a1a1a"],
html[data-theme="light"] *[style*="background: #2a2a2a"],
html[data-theme="light"] *[style*="background: #0a0c10"],
html[data-theme="light"] *[style*="background: #0a0e1a"] {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
}

/* 超强力K线图表背景修复 - 浅色主题 */
/* 🔥 K线图容器背景透明，让KLineChartPro自己控制背景 */
[data-theme="light"] #optionChartBox,
[data-theme="light"] .chartBox,
html[data-theme="light"] #optionChartBox,
html[data-theme="light"] .chartBox {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  
  :deep(.klinecharts-pro) {
    background: transparent !important;
  }
  
  canvas {
    background: transparent !important;
  }
}

[data-theme="light"] #optionKlineCanvas,
[data-theme="light"] .kline-chart-canvas,
[data-theme="light"] .kline_box,
[data-theme="light"] .block_kline,
[data-theme="light"] .chart-container,
html[data-theme="light"] #optionKlineCanvas,
html[data-theme="light"] .kline-chart-canvas,
html[data-theme="light"] .kline_box,
html[data-theme="light"] .block_kline,
html[data-theme="light"] .chart-container {
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%) !important;
  background-color: #ffffff !important;
  background-image: linear-gradient(180deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%) !important;
  border: 1px solid rgba(0,0,0,0.1) !important;
}

/* 强制覆盖所有可能的深色元素 - 浅色主题 */
[data-theme="light"] .futures *,
[data-theme="light"] .futures-content *,
[data-theme="light"] .content_main_right *,
[data-theme="light"] .hotCoin *,
[data-theme="light"] .content_head *,
[data-theme="light"] .block_kline *,
[data-theme="light"] .kline_box *,
html[data-theme="light"] .futures *,
html[data-theme="light"] .futures-content *,
html[data-theme="light"] .content_main_right *,
html[data-theme="light"] .hotCoin *,
html[data-theme="light"] .content_head *,
html[data-theme="light"] .block_kline *,
html[data-theme="light"] .kline_box * {
  color: inherit !important;
}

/* 浅色主题下的顶层容器强制白色背景 - 排除头部导航栏容器 */
[data-theme="light"] .futures,
[data-theme="light"] .futures .arco-layout,
[data-theme="light"] .futures .arco-layout-content,
[data-theme="light"] .futures_content,
[data-theme="light"] .content_main_right,
[data-theme="light"] .hotCoin,
[data-theme="light"] .content_head,
html[data-theme="light"] .futures,
html[data-theme="light"] .futures .arco-layout,
html[data-theme="light"] .futures .arco-layout-content,
html[data-theme="light"] .futures_content,
html[data-theme="light"] .content_main_right,
html[data-theme="light"] .hotCoin,
html[data-theme="light"] .content_head {
  background: #f8f9fa !important;
  background-color: #f8f9fa !important;
  background-image: none !important;
}

/* 特殊处理：热门币种区域为纯白色，导航栏容器保持透明 */
[data-theme="light"] .hotCoin,
html[data-theme="light"] .hotCoin {
  background: #ffffff !important;
  background-color: #ffffff !important;
}

/* ==================== 终极强制修复 - 覆盖一切可能的深色样式 ==================== */

/* 浅色主题下的绝对强制覆盖 - 最高优先级 */
body[data-theme="light"] .futures,
html[data-theme="light"] body .futures,
[data-theme="light"] .futures {
  background: #f8f9fa !important;
  color: #1a1a1a !important;
}

/* 🔥 确保K线图容器背景透明，让KLineChartPro自己控制背景 */
body[data-theme="light"] #optionChartBox,
body[data-theme="light"] .chartBox,
html[data-theme="light"] body #optionChartBox,
html[data-theme="light"] body .chartBox,
[data-theme="light"] #optionChartBox,
[data-theme="light"] .chartBox {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  
  :deep(.klinecharts-pro) {
    background: transparent !important;
  }
  
  canvas {
    background: transparent !important;
  }
}

body[data-theme="light"] #optionKlineCanvas,
html[data-theme="light"] body #optionKlineCanvas,
[data-theme="light"] #optionKlineCanvas,
body[data-theme="light"] .kline-chart-canvas,
html[data-theme="light"] body .kline-chart-canvas,
[data-theme="light"] .kline-chart-canvas {
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%) !important;
  border: 1px solid rgba(0,0,0,0.1) !important;
}

body[data-theme="light"] .content_main_right,
html[data-theme="light"] body .content_main_right,
[data-theme="light"] .content_main_right,
body[data-theme="light"] .futures_content,
html[data-theme="light"] body .futures_content,
[data-theme="light"] .futures_content,
body[data-theme="light"] .hotCoin,
html[data-theme="light"] body .hotCoin,
[data-theme="light"] .hotCoin,
body[data-theme="light"] .content_head,
html[data-theme="light"] body .content_head,
[data-theme="light"] .content_head,
body[data-theme="light"] .block_kline,
html[data-theme="light"] body .block_kline,
[data-theme="light"] .block_kline,
body[data-theme="light"] .kline_box,
html[data-theme="light"] body .kline_box,
[data-theme="light"] .kline_box {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  border-color: #dee2e6 !important;
  color: #1a1a1a !important;
}

/* 强制覆盖所有ArcoDesign组件 - 浅色主题 */
body[data-theme="light"] .arco-layout,
html[data-theme="light"] body .arco-layout,
[data-theme="light"] .arco-layout,
body[data-theme="light"] .arco-layout-content,
html[data-theme="light"] body .arco-layout-content,
[data-theme="light"] .arco-layout-content,
body[data-theme="light"] .arco-select,
html[data-theme="light"] body .arco-select,
[data-theme="light"] .arco-select {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  border-color: #dee2e6 !important;
  color: #1a1a1a !important;
}

/* 最终保险 - 使用属性选择器强制覆盖内联样式 */
[data-theme="light"] *[style*="background"][style*="#1a1a1a"],
[data-theme="light"] *[style*="background"][style*="#2a2a2a"],
[data-theme="light"] *[style*="background"][style*="#0a0c10"],
[data-theme="light"] *[style*="background"][style*="#0a0e1a"],
[data-theme="light"] *[style*="background"][style*="linear-gradient"],
html[data-theme="light"] *[style*="background"][style*="#1a1a1a"],
html[data-theme="light"] *[style*="background"][style*="#2a2a2a"],
html[data-theme="light"] *[style*="background"][style*="#0a0c10"],
html[data-theme="light"] *[style*="background"][style*="#0a0e1a"],
html[data-theme="light"] *[style*="background"][style*="linear-gradient"] {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
}

/* 特殊处理K线图表 */
[data-theme="light"] canvas[id="optionKlineCanvas"],
[data-theme="light"] canvas.kline-chart-canvas,
html[data-theme="light"] canvas[id="optionKlineCanvas"],
html[data-theme="light"] canvas.kline-chart-canvas {
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 50%, #e9ecef 100%) !important;
  border: 1px solid rgba(0,0,0,0.06) !important;
}

/* ==================== 强制修复顶部导航栏和热门币种区域主题 ==================== */

/* 头部导航栏 #nav - 浅色主题强制半透明 */
[data-theme="light"] .futures #nav,
html[data-theme="light"] .futures #nav,
body[data-theme="light"] .futures #nav {
  background: rgba(255, 255, 255, 0.8) !important;
  background-color: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  width: 100% !important;
  height: 64px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 24px !important;
  box-sizing: border-box !important;
  position: sticky !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 1000 !important;
  border: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
}

/* 浅色主题下头部导航栏容器保持透明 */
[data-theme="light"] .arco-layout-header,
html[data-theme="light"] .arco-layout-header {
  background: transparent !important;
  background-color: transparent !important;
}

/* 浅色主题下导航栏内部元素 */
[data-theme="light"] #nav *,
[data-theme="light"] .arco-layout-header *,
html[data-theme="light"] #nav *,
html[data-theme="light"] .arco-layout-header * {
  color: #1a1a1a !important;
}

/* 浅色主题下导航栏链接和按钮 */
[data-theme="light"] #nav .nav-menu-item,
[data-theme="light"] #nav .menu-text,
[data-theme="light"] #nav .logo,
html[data-theme="light"] #nav .nav-menu-item,
html[data-theme="light"] #nav .menu-text,
html[data-theme="light"] #nav .logo {
  color: #1a1a1a !important;
}

/* 浅色主题下热门币种区域强制白色背景 */
[data-theme="light"] .hotCoin,
html[data-theme="light"] .hotCoin {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  border-bottom: 1px solid #e9ecef !important;
  padding: 12px 20px !important;
}

/* 浅色主题下热门币种每个item */
[data-theme="light"] .hotCoin .item,
[data-theme="light"] .hotCoin .item *,
html[data-theme="light"] .hotCoin .item,
html[data-theme="light"] .hotCoin .item * {
  color: #1a1a1a !important;
}

/* 深色主题下导航栏 #nav - 强制半透明 */
[data-theme="dark"] .futures #nav,
html[data-theme="dark"] .futures #nav,
body[data-theme="dark"] .futures #nav {
  background: rgba(31, 31, 31, 0.8) !important;
  background-color: rgba(31, 31, 31, 0.8) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  width: 100% !important;
  height: 64px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 24px !important;
  box-sizing: border-box !important;
  position: sticky !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 1000 !important;
  border: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
}

/* 深色主题下头部导航栏容器保持透明 */
[data-theme="dark"] .arco-layout-header,
html[data-theme="dark"] .arco-layout-header {
  background: transparent !important;
  background-color: transparent !important;
}

/* 深色主题下导航栏内部元素 */
[data-theme="dark"] #nav *,
[data-theme="dark"] .arco-layout-header *,
html[data-theme="dark"] #nav *,
html[data-theme="dark"] .arco-layout-header * {
  color: #ffffff !important;
}

/* 深色主题下热门币种区域 */
[data-theme="dark"] .hotCoin,
html[data-theme="dark"] .hotCoin {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 12px 20px !important;
}

/* 深色主题下热门币种每个item */
[data-theme="dark"] .hotCoin .item,
[data-theme="dark"] .hotCoin .item *,
html[data-theme="dark"] .hotCoin .item,
html[data-theme="dark"] .hotCoin .item * {
  color: #ffffff !important;
}

/* 强制覆盖可能的全局样式 */
body[data-theme="light"] #nav,
body[data-theme="light"] .arco-layout-header,
body[data-theme="light"] .hotCoin {
  background: #ffffff !important;
  color: #1a1a1a !important;
}

body[data-theme="dark"] #nav,
body[data-theme="dark"] .arco-layout-header,
body[data-theme="dark"] .hotCoin {
  background: #0a0c10 !important;
  color: #ffffff !important;
}

/* ==================== 终极导航栏主题修复 - 最高优先级 ==================== */

/* 浅色主题 - 终极覆盖 */
html[data-theme="light"] body #nav,
html[data-theme="light"] body .arco-layout-header,
html[data-theme="light"] body .hotCoin,
body[data-theme="light"] #nav,
body[data-theme="light"] .arco-layout-header,
body[data-theme="light"] .hotCoin,
.futures[data-theme="light"] #nav,
.futures[data-theme="light"] .arco-layout-header,
.futures[data-theme="light"] .hotCoin {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  color: #1a1a1a !important;
  border-bottom: 1px solid #e9ecef !important;
  --home-nav-transparent-bg: #ffffff !important;
  --content-primary: #1a1a1a !important;
  --hover-primary: #f8f9fa !important;
}

/* 浅色主题内部元素 - 终极覆盖 */
html[data-theme="light"] body #nav *,
html[data-theme="light"] body .arco-layout-header *,
html[data-theme="light"] body .hotCoin *,
body[data-theme="light"] #nav *,
body[data-theme="light"] .arco-layout-header *,
body[data-theme="light"] .hotCoin *,
.futures[data-theme="light"] #nav *,
.futures[data-theme="light"] .arco-layout-header *,
.futures[data-theme="light"] .hotCoin * {
  color: #1a1a1a !important;
}

/* 深色主题 - 终极覆盖 */
html[data-theme="dark"] body #nav,
html[data-theme="dark"] body .arco-layout-header,
html[data-theme="dark"] body .hotCoin,
body[data-theme="dark"] #nav,
body[data-theme="dark"] .arco-layout-header,
body[data-theme="dark"] .hotCoin,
.futures[data-theme="dark"] #nav,
.futures[data-theme="dark"] .arco-layout-header,
.futures[data-theme="dark"] .hotCoin {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  background-image: none !important;
  color: #ffffff !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  --home-nav-transparent-bg: #0a0c10 !important;
  --content-primary: #ffffff !important;
  --hover-primary: rgba(255, 255, 255, 0.1) !important;
}

/* 深色主题内部元素 - 终极覆盖 */
html[data-theme="dark"] body #nav *,
html[data-theme="dark"] body .arco-layout-header *,
html[data-theme="dark"] body .hotCoin *,
body[data-theme="dark"] #nav *,
body[data-theme="dark"] .arco-layout-header *,
body[data-theme="dark"] .hotCoin *,
.futures[data-theme="dark"] #nav *,
.futures[data-theme="dark"] .arco-layout-header *,
.futures[data-theme="dark"] .hotCoin * {
  color: #ffffff !important;
}

/* 确保导航栏菜单项正确显示 */
html[data-theme="light"] .nav-menu-item,
html[data-theme="light"] .menu-text,
body[data-theme="light"] .nav-menu-item,
body[data-theme="light"] .menu-text {
  color: #1a1a1a !important;
}

html[data-theme="dark"] .nav-menu-item,
html[data-theme="dark"] .menu-text,
body[data-theme="dark"] .nav-menu-item,
body[data-theme="dark"] .menu-text {
  color: #ffffff !important;
}

/* ==================== 终极全页面主题修复 - 覆盖所有可能的残留 ==================== */

/* 浅色主题 - 覆盖所有可能的容器和元素 */
[data-theme="light"] *,
[data-theme="light"] *:before,
[data-theme="light"] *:after,
html[data-theme="light"] *,
html[data-theme="light"] *:before,
html[data-theme="light"] *:after,
body[data-theme="light"] *,
body[data-theme="light"] *:before,
body[data-theme="light"] *:after {
  /* 只修复明显的深色背景，避免破坏其他样式 */
  box-sizing: border-box;
}

/* 浅色主题 - 强制覆盖所有可能的深色容器 */
[data-theme="light"] .arco-layout,
[data-theme="light"] .arco-layout-content,
[data-theme="light"] .arco-layout-header,
[data-theme="light"] .arco-layout-sider,
[data-theme="light"] .arco-card,
[data-theme="light"] .arco-card-body,
[data-theme="light"] .arco-modal,
[data-theme="light"] .arco-modal-content,
[data-theme="light"] .arco-drawer,
[data-theme="light"] .arco-drawer-content,
[data-theme="light"] .arco-panel,
[data-theme="light"] .content_main_right,
[data-theme="light"] .trade-panel,
[data-theme="light"] .trading-panel,
[data-theme="light"] .right-panel,
[data-theme="light"] .side-panel,
[data-theme="light"] .flash-option-panel,
[data-theme="light"] .option-trading-panel,
html[data-theme="light"] .arco-layout,
html[data-theme="light"] .arco-layout-content,
html[data-theme="light"] .arco-layout-header,
html[data-theme="light"] .arco-layout-sider,
html[data-theme="light"] .arco-card,
html[data-theme="light"] .arco-card-body,
html[data-theme="light"] .arco-modal,
html[data-theme="light"] .arco-modal-content,
html[data-theme="light"] .arco-drawer,
html[data-theme="light"] .arco-drawer-content,
html[data-theme="light"] .arco-panel,
html[data-theme="light"] .content_main_right,
html[data-theme="light"] .trade-panel,
html[data-theme="light"] .trading-panel,
html[data-theme="light"] .right-panel,
html[data-theme="light"] .side-panel,
html[data-theme="light"] .flash-option-panel,
html[data-theme="light"] .option-trading-panel {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  border-color: #dee2e6 !important;
  color: #1a1a1a !important;
}

/* 浅色主题 - 特殊背景色容器 */
[data-theme="light"] .futures_content,
[data-theme="light"] .main-content,
[data-theme="light"] .content-wrapper,
html[data-theme="light"] .futures_content,
html[data-theme="light"] .main-content,
html[data-theme="light"] .content-wrapper {
  background: #f8f9fa !important;
  background-color: #f8f9fa !important;
  background-image: none !important;
}

/* 浅色主题 - 强制覆盖任何可能的深色背景 */
[data-theme="light"] [style*="background: #0"],
[data-theme="light"] [style*="background: #1"],
[data-theme="light"] [style*="background: #2"],
[data-theme="light"] [style*="background: #3"],
[data-theme="light"] [style*="background-color: #0"],
[data-theme="light"] [style*="background-color: #1"],
[data-theme="light"] [style*="background-color: #2"],
[data-theme="light"] [style*="background-color: #3"],
[data-theme="light"] [style*="background: rgb(0"],
[data-theme="light"] [style*="background: rgb(1"],
[data-theme="light"] [style*="background: rgb(2"],
[data-theme="light"] [style*="background: rgb(3"],
html[data-theme="light"] [style*="background: #0"],
html[data-theme="light"] [style*="background: #1"],
html[data-theme="light"] [style*="background: #2"],
html[data-theme="light"] [style*="background: #3"],
html[data-theme="light"] [style*="background-color: #0"],
html[data-theme="light"] [style*="background-color: #1"],
html[data-theme="light"] [style*="background-color: #2"],
html[data-theme="light"] [style*="background-color: #3"] {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
}

/* 浅色主题 - 滚动条样式 */
[data-theme="light"] ::-webkit-scrollbar,
html[data-theme="light"] ::-webkit-scrollbar {
  width: 6px !important;
  height: 6px !important;
}

[data-theme="light"] ::-webkit-scrollbar-track,
html[data-theme="light"] ::-webkit-scrollbar-track {
  background: #f8f9fa !important;
  border-radius: 3px !important;
}

[data-theme="light"] ::-webkit-scrollbar-thumb,
html[data-theme="light"] ::-webkit-scrollbar-thumb {
  background: #dee2e6 !important;
  border-radius: 3px !important;
}

[data-theme="light"] ::-webkit-scrollbar-thumb:hover,
html[data-theme="light"] ::-webkit-scrollbar-thumb:hover {
  background: #adb5bd !important;
}

/* 浅色主题 - 确保所有文字都是深色 */
[data-theme="light"] .futures *,
[data-theme="light"] .content_main_right *,
[data-theme="light"] .trade-panel *,
[data-theme="light"] .arco-card *,
[data-theme="light"] .arco-layout *,
html[data-theme="light"] .futures *,
html[data-theme="light"] .content_main_right *,
html[data-theme="light"] .trade-panel *,
html[data-theme="light"] .arco-card *,
html[data-theme="light"] .arco-layout * {
  color: #1a1a1a !important;
}

/* 深色主题确保 */
[data-theme="dark"] .arco-layout,
[data-theme="dark"] .arco-layout-content,
[data-theme="dark"] .arco-layout-header,
[data-theme="dark"] .arco-layout-sider,
[data-theme="dark"] .arco-card,
[data-theme="dark"] .arco-card-body,
[data-theme="dark"] .content_main_right,
[data-theme="dark"] .trade-panel,
html[data-theme="dark"] .arco-layout,
html[data-theme="dark"] .arco-layout-content,
html[data-theme="dark"] .arco-layout-header,
html[data-theme="dark"] .arco-layout-sider,
html[data-theme="dark"] .arco-card,
html[data-theme="dark"] .arco-card-body,
html[data-theme="dark"] .content_main_right,
html[data-theme="dark"] .trade-panel {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  color: #ffffff !important;
}

/* ==================== 全局下拉菜单和弹出组件主题修复 - 超高优先级 ==================== */

/* 浅色主题 - 超强力全局ArcoDesign组件覆盖 */
html[data-theme="light"] body .arco-dropdown,
html[data-theme="light"] body .arco-dropdown-list,
html[data-theme="light"] body .arco-dropdown-option,
html[data-theme="light"] body .arco-menu,
html[data-theme="light"] body .arco-menu-item,
html[data-theme="light"] body .arco-menu-submenu,
html[data-theme="light"] body .arco-trigger-popup,
html[data-theme="light"] body .arco-select-dropdown,
html[data-theme="light"] body .arco-select-option,
html[data-theme="light"] body .arco-popover,
html[data-theme="light"] body .arco-popover-content,
html[data-theme="light"] body .arco-tooltip,
html[data-theme="light"] body .arco-tooltip-content,
html[data-theme="light"] .arco-dropdown,
html[data-theme="light"] .arco-dropdown-list,
html[data-theme="light"] .arco-dropdown-option,
html[data-theme="light"] .arco-menu,
html[data-theme="light"] .arco-menu-item,
html[data-theme="light"] .arco-menu-submenu,
html[data-theme="light"] .arco-trigger-popup,
html[data-theme="light"] .arco-select-dropdown,
html[data-theme="light"] .arco-select-option,
html[data-theme="light"] .arco-popover,
html[data-theme="light"] .arco-popover-content,
html[data-theme="light"] .arco-tooltip,
html[data-theme="light"] .arco-tooltip-content,
body[data-theme="light"] .arco-dropdown,
body[data-theme="light"] .arco-dropdown-list,
body[data-theme="light"] .arco-dropdown-option,
body[data-theme="light"] .arco-menu,
body[data-theme="light"] .arco-menu-item,
body[data-theme="light"] .arco-menu-submenu,
body[data-theme="light"] .arco-trigger-popup,
body[data-theme="light"] .arco-select-dropdown,
body[data-theme="light"] .arco-select-option,
body[data-theme="light"] .arco-popover,
body[data-theme="light"] .arco-popover-content,
body[data-theme="light"] .arco-tooltip,
body[data-theme="light"] .arco-tooltip-content {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  color: #1a1a1a !important;
  border-color: #dee2e6 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  transition: none !important;
  animation: none !important;
}

/* 浅色主题 - 全局Portal组件覆盖（通常挂载到body下） */
body > .arco-dropdown,
body > .arco-trigger-popup,
body > .arco-select-dropdown,
body > .arco-menu,
body > .arco-popover,
body > .arco-tooltip,
body > div[class*="dropdown"],
body > div[class*="popup"],
body > div[class*="menu"],
body > div[class*="popover"] {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  color: #1a1a1a !important;
  border-color: #dee2e6 !important;
}

/* 浅色主题 - 用户菜单特殊处理 */
html[data-theme="light"] .user-menu,
html[data-theme="light"] .user-dropdown,
html[data-theme="light"] .profile-menu,
html[data-theme="light"] .account-menu,
body[data-theme="light"] .user-menu,
body[data-theme="light"] .user-dropdown,
body[data-theme="light"] .profile-menu,
body[data-theme="light"] .account-menu,
body > .user-menu,
body > .user-dropdown,
body > .profile-menu,
body > .account-menu {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  color: #1a1a1a !important;
  border: 1px solid #dee2e6 !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

/* 浅色主题 - 用户菜单项 */
html[data-theme="light"] .user-menu-item,
html[data-theme="light"] .user-dropdown-item,
html[data-theme="light"] .profile-menu-item,
html[data-theme="light"] .account-menu-item,
body[data-theme="light"] .user-menu-item,
body[data-theme="light"] .user-dropdown-item,
body[data-theme="light"] .profile-menu-item,
body[data-theme="light"] .account-menu-item {
  background: transparent !important;
  color: #1a1a1a !important;
  padding: 12px 16px !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
}

/* 浅色主题 - 用户菜单项悬停 */
html[data-theme="light"] .user-menu-item:hover,
html[data-theme="light"] .user-dropdown-item:hover,
html[data-theme="light"] .profile-menu-item:hover,
html[data-theme="light"] .account-menu-item:hover,
html[data-theme="light"] .arco-dropdown-option:hover,
html[data-theme="light"] .arco-menu-item:hover,
body[data-theme="light"] .user-menu-item:hover,
body[data-theme="light"] .user-dropdown-item:hover,
body[data-theme="light"] .profile-menu-item:hover,
body[data-theme="light"] .account-menu-item:hover,
body[data-theme="light"] .arco-dropdown-option:hover,
body[data-theme="light"] .arco-menu-item:hover {
  background: #f8f9fa !important;
  background-color: #f8f9fa !important;
  color: #1a1a1a !important;
}

/* 深色主题确保 - 超强力全局组件覆盖 */
html[data-theme="dark"] body .arco-dropdown,
html[data-theme="dark"] body .arco-dropdown-list,
html[data-theme="dark"] body .arco-dropdown-option,
html[data-theme="dark"] body .arco-menu,
html[data-theme="dark"] body .arco-menu-item,
html[data-theme="dark"] body .arco-trigger-popup,
html[data-theme="dark"] body .arco-select-dropdown,
html[data-theme="dark"] body .arco-popover,
html[data-theme="dark"] body .arco-tooltip,
html[data-theme="dark"] .arco-dropdown,
html[data-theme="dark"] .arco-dropdown-list,
html[data-theme="dark"] .arco-dropdown-option,
html[data-theme="dark"] .arco-menu,
html[data-theme="dark"] .arco-menu-item,
html[data-theme="dark"] .arco-trigger-popup,
html[data-theme="dark"] .arco-select-dropdown,
html[data-theme="dark"] .arco-popover,
html[data-theme="dark"] .arco-tooltip,
body[data-theme="dark"] .arco-dropdown,
body[data-theme="dark"] .arco-dropdown-list,
body[data-theme="dark"] .arco-dropdown-option,
body[data-theme="dark"] .arco-menu,
body[data-theme="dark"] .arco-menu-item,
body[data-theme="dark"] .arco-trigger-popup,
body[data-theme="dark"] .arco-select-dropdown,
body[data-theme="dark"] .arco-popover,
body[data-theme="dark"] .arco-tooltip {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
  transition: none !important;
  animation: none !important;
}

/* 全局CSS变量覆盖 */
html[data-theme="light"] {
  --arco-color-bg-popup: #ffffff !important;
  --arco-color-text-1: #1a1a1a !important;
  --arco-color-border: #dee2e6 !important;
  --arco-color-bg-2: #f8f9fa !important;
  --arco-color-fill-2: #f8f9fa !important;
}

html[data-theme="dark"] {
  --arco-color-bg-popup: #0a0c10 !important;
  --arco-color-text-1: #ffffff !important;
  --arco-color-border: rgba(255, 255, 255, 0.1) !important;
  --arco-color-bg-2: rgba(255, 255, 255, 0.05) !important;
  --arco-color-fill-2: rgba(255, 255, 255, 0.05) !important;
}

/* ==================== 终极用户菜单修复 - 防止闪动 ==================== */

/* 禁用所有Portal组件的过渡和动画，防止闪动 */
html[data-theme="light"] .arco-dropdown,
html[data-theme="light"] .arco-trigger-popup,
html[data-theme="light"] .arco-menu,
html[data-theme="light"] .arco-popover,
html[data-theme="dark"] .arco-dropdown,
html[data-theme="dark"] .arco-trigger-popup,
html[data-theme="dark"] .arco-menu,
html[data-theme="dark"] .arco-popover {
  transition: none !important;
  animation: none !important;
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  -ms-transition: none !important;
}

/* 终极用户菜单修复 - 直接针对body下的Portal */
body > div[class*="arco"],
body > div[class*="dropdown"],
body > div[class*="popup"],
body > div[class*="menu"] {
  transition: none !important;
  animation: none !important;
}

/* 浅色主题下的body Portal组件强制白色 */
html[data-theme="light"] body > div[class*="arco"],
html[data-theme="light"] body > div[class*="dropdown"],
html[data-theme="light"] body > div[class*="popup"],
html[data-theme="light"] body > div[class*="menu"] {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #1a1a1a !important;
  border-color: #dee2e6 !important;
}

/* 深色主题下的body Portal组件强制深色 */
html[data-theme="dark"] body > div[class*="arco"],
html[data-theme="dark"] body > div[class*="dropdown"],
html[data-theme="dark"] body > div[class*="popup"],
html[data-theme="dark"] body > div[class*="menu"] {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* 禁用所有可能导致闪动的CSS属性 */
html[data-theme="light"] *[class*="arco"],
html[data-theme="dark"] *[class*="arco"] {
  transition: none !important;
  animation: none !important;
  -webkit-animation: none !important;
  -moz-animation: none !important;
  -o-animation: none !important;
  -ms-animation: none !important;
}

/* ==================== 最终用户菜单修复 - 兜底方案 ==================== */

/* 使用属性选择器强制覆盖所有可能的用户菜单 */
html[data-theme="light"] [style*="position: fixed"],
html[data-theme="light"] [style*="position: absolute"],
html[data-theme="light"] [class*="menu"][style*="background"],
html[data-theme="light"] [class*="dropdown"][style*="background"],
html[data-theme="light"] [class*="popup"][style*="background"],
html[data-theme="light"] [class*="arco"][style*="background"] {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #1a1a1a !important;
  border-color: #dee2e6 !important;
}

html[data-theme="dark"] [style*="position: fixed"],
html[data-theme="dark"] [style*="position: absolute"], 
html[data-theme="dark"] [class*="menu"][style*="background"],
html[data-theme="dark"] [class*="dropdown"][style*="background"],
html[data-theme="dark"] [class*="popup"][style*="background"],
html[data-theme="dark"] [class*="arco"][style*="background"] {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* 强制覆盖任何带有深色背景的元素在浅色主题下 */
html[data-theme="light"] [style*="background: rgb(10"],
html[data-theme="light"] [style*="background: rgb(26"],
html[data-theme="light"] [style*="background: rgb(42"],
html[data-theme="light"] [style*="background: #0"],
html[data-theme="light"] [style*="background: #1"],
html[data-theme="light"] [style*="background: #2"],
html[data-theme="light"] [style*="background-color: rgb(10"],
html[data-theme="light"] [style*="background-color: rgb(26"],
html[data-theme="light"] [style*="background-color: rgb(42"],
html[data-theme="light"] [style*="background-color: #0"],
html[data-theme="light"] [style*="background-color: #1"],
html[data-theme="light"] [style*="background-color: #2"] {
  background: #ffffff !important;
  background-color: #ffffff !important;
  color: #1a1a1a !important;
}

/* 终极强制覆盖 - 针对任何可能的Portal组件 */
html[data-theme="light"] body > div,
html[data-theme="light"] body > div div,
html[data-theme="light"] body > div div div {
  transition: none !important;
  animation: none !important;
}

html[data-theme="light"] body > div[class*="arco"]:not([style*="display: none"]),
html[data-theme="light"] body > div[class*="dropdown"]:not([style*="display: none"]),
html[data-theme="light"] body > div[class*="popup"]:not([style*="display: none"]),
html[data-theme="light"] body > div[class*="menu"]:not([style*="display: none"]) {
  background: #ffffff !important;
  background-color: #ffffff !important;
  background-image: none !important;
  color: #1a1a1a !important;
  border-color: #dee2e6 !important;
}

html[data-theme="dark"] body > div[class*="arco"]:not([style*="display: none"]),
html[data-theme="dark"] body > div[class*="dropdown"]:not([style*="display: none"]),
html[data-theme="dark"] body > div[class*="popup"]:not([style*="display: none"]),
html[data-theme="dark"] body > div[class*="menu"]:not([style*="display: none"]) {
  background: #0a0c10 !important;
  background-color: #0a0c10 !important;
  background-image: none !important;
  color: #ffffff !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* ================================ */
/* 🔥 深色主题全局文字可见性修复 */
/* ================================ */

/* 全局修复所有在深色主题下不可见的文字 */
[data-theme="dark"] {
  /* 覆盖所有硬编码的黑色文字 */
  .futures * {
    &[style*="color: #000"],
    &[style*="color: black"],
    &[style*="color:#000"],
    &[style*="color:black"] {
      color: var(--content-primary) !important;
    }
  }

  /* 确保所有文字使用正确的主题色 */
  .futures,
  .option-trading-panel,
  .option-content,
  .trade-panel,
  .trading-panel,
  .content_head,
  .hotCoin,
  .contract-coin-selector,
  .arco-input,
  .arco-select,
  .arco-button,
  .arco-tabs,
  .arco-table {
    color: var(--content-primary) !important;
    
    *, span, div, p, label, input, button {
      color: var(--content-primary) !important;
    }
  }

  /* 表单元素背景色修复 */
  .arco-input-wrapper,
  .arco-select-view,
  .arco-button {
    background-color: var(--background-secondary) !important;
    border-color: var(--border-color) !important;
  }

  /* 页面背景修复 */
  .futures,
  .futures_content,
  .content_main,
  .block_kline,
  .kline_box {
    background-color: var(--background-primary) !important;
  }
}

/* 强制修复：所有带有硬编码黑色的元素 */
[data-theme="dark"] [style*="color: #000"],
[data-theme="dark"] [style*="color: black"],
[data-theme="dark"] [style*="color:#000"],
[data-theme="dark"] [style*="color:black"] {
  color: var(--content-primary) !important;
}

html[data-theme="dark"] [style*="color: #000"],
html[data-theme="dark"] [style*="color: black"],
html[data-theme="dark"] [style*="color:#000"],
html[data-theme="dark"] [style*="color:black"] {
  color: var(--content-primary) !important;
}

/* 🔧 期权页面背景色超级强力修复 - 最高优先级覆盖所有深色背景 */
html body .futures,
html body .futures *,
html body [data-theme="dark"] .futures,
html body [data-theme="dark"] .futures *,
html[data-theme="dark"] body .futures,
html[data-theme="dark"] body .futures * {
  /* 超级强力覆盖规则 - 最高优先级 */
  background: var(--background-primary) !important;
  background-color: var(--background-primary) !important;
  
  /* 针对内容区域使用次级背景 */
  &.futures_content,
  &.content_main_right,
  &.arco-layout-content {
    background: var(--background-secondary) !important;
    background-color: var(--background-secondary) !important;
  }
  
  /* 针对头部区域使用主背景 */
  &.content_head {
    background: var(--background-primary) !important;
    background-color: var(--background-primary) !important;
  }
  
  /* 头部导航栏容器保持透明 */
  &.arco-layout-header {
    background: transparent !important;
    background-color: transparent !important;
  }
  
  /* 针对热门币种条使用透明背景 */
  &.hotCoin {
    background: transparent !important;
    background-color: transparent !important;
  }
}

/* 强制覆盖所有内联样式 */
html body .futures[style],
html body .futures *[style] {
  background: var(--background-primary) !important;
  background-color: var(--background-primary) !important;
  background-image: none !important;
}

/* 专门针对内容区域 */
html body .futures_content[style],
html body .futures .futures_content[style],
html body .futures_content *[style] {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
}

/* 超级强力覆盖 - 针对所有可能的选择器组合 */
html.dark body .futures,
html[data-theme="dark"] body .futures,
body.dark .futures,
body[data-theme="dark"] .futures,
.futures[data-theme="dark"],
[data-theme="dark"] .futures {
  background: var(--background-primary) !important;
  background-color: var(--background-primary) !important;
  
  .futures_content,
  > .futures_content {
    background: var(--background-secondary) !important;
    background-color: var(--background-secondary) !important;
  }
}

/* 最终杀手锏 - 覆盖所有硬编码颜色值 */
.futures,
.futures * {
  /* 任何#0a0c10都改为主题变量 */
  &[style*="#0a0c10"] {
    background: var(--background-primary) !important;
    background-color: var(--background-primary) !important;
  }
  
  /* 任何#1a1a1a都改为主题变量 */
  &[style*="#1a1a1a"] {
    background: var(--background-primary) !important;
    background-color: var(--background-primary) !important;
  }
  
  /* 任何#0f0f0f都改为主题变量 */
  &[style*="#0f0f0f"] {
    background: var(--background-primary) !important;
    background-color: var(--background-primary) !important;
  }
}

/* 🚨 期权页面背景色最终解决方案 - 超级无敌覆盖规则 */
/* 这个规则放在最后，确保最高优先级 */
.futures.futures.futures,
.futures.futures.futures *,
html .futures.futures.futures,
html .futures.futures.futures *,
body .futures.futures.futures,
body .futures.futures.futures *,
html body .futures.futures.futures,
html body .futures.futures.futures * {
  /* 三重选择器确保最高优先级 */
  background: var(--background-primary) !important;
  background-color: var(--background-primary) !important;
  background-image: none !important;
}

/* 针对内容区域的特殊处理 */
.futures.futures.futures .futures_content,
html body .futures.futures.futures .futures_content,
.futures_content.futures_content.futures_content {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
}

/* 强制覆盖任何深色硬编码值 */
.futures[style*="#0a0c10"].futures.futures,
.futures[style*="#1a1a1a"].futures.futures,
.futures[style*="#0f0f0f"].futures.futures,
*[style*="#0a0c10"].futures *,
*[style*="#1a1a1a"].futures *,
*[style*="#0f0f0f"].futures * {
  background: var(--background-primary) !important;
  background-color: var(--background-primary) !important;
}

/* 确保页面加载后立即应用 */
html.loaded .futures,
html.loaded .futures *,
body.loaded .futures,
body.loaded .futures * {
  background: var(--background-primary) !important;
  background-color: var(--background-primary) !important;
}

/* 针对 Arco Design 组件的特殊处理 */
.futures .arco-layout,
.futures .arco-layout-content {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
}

/* 头部导航栏容器 - 重置 */
.futures .arco-layout-header {
  all: unset !important;
  display: block !important;
}

/* 🚨 最终杀手锏 - 最强优先级覆盖所有深色背景 */
.futures,
.futures *,
html.loaded .futures,
html.loaded .futures *,
body.loaded .futures,
body.loaded .futures *,
[data-theme="dark"] .futures,
[data-theme="dark"] .futures *,
html[data-theme="dark"] .futures,
html[data-theme="dark"] .futures * {
  background: var(--background-primary) !important;
  background-color: var(--background-primary) !important;
  background-image: none !important;
}

/* 确保内容区域使用次级背景 */
.futures_content,
.futures .futures_content,
html.loaded .futures_content,
html.loaded .futures .futures_content,
body.loaded .futures_content,
body.loaded .futures .futures_content,
[data-theme="dark"] .futures_content,
[data-theme="dark"] .futures .futures_content,
html[data-theme="dark"] .futures_content,
html[data-theme="dark"] .futures .futures_content {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
  background-image: none !important;
}

/* 强制重置所有背景图片和渐变 */
.futures,
.futures *,
.futures_content,
.futures_content * {
  background-image: none !important;
}

/* 🚨🚨🚨 终极强力修复 - 直接使用rgba值确保半透明效果 🚨🚨🚨 */
.futures #nav[id="nav"],
.futures #nav[id="nav"],
.futures #nav[id="nav"],
html .futures #nav[id="nav"],
html .futures #nav[id="nav"],
html .futures #nav[id="nav"],
body .futures #nav[id="nav"],
body .futures #nav[id="nav"],
body .futures #nav[id="nav"],
[data-theme] .futures #nav[id="nav"],
[data-theme] .futures #nav[id="nav"],
[data-theme] .futures #nav[id="nav"] {
  background: rgba(255, 255, 255, 0.8) !important;
  background-color: rgba(255, 255, 255, 0.8) !important;
  background-image: none !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  opacity: 1 !important;
}

/* 深色主题下的半透明背景 */
[data-theme="dark"] .futures #nav[id="nav"],
html[data-theme="dark"] .futures #nav[id="nav"],
body[data-theme="dark"] .futures #nav[id="nav"] {
  background: rgba(31, 31, 31, 0.8) !important;
  background-color: rgba(31, 31, 31, 0.8) !important;
  background-image: none !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  opacity: 1 !important;
}

/* 🚨🚨🚨 超级强力修复 - 头部导航栏容器透明 🚨🚨🚨 */
.futures .arco-layout-header[class*="arco-layout-header"],
.futures .arco-layout-header[class*="arco-layout-header"],
.futures .arco-layout-header[class*="arco-layout-header"],
html .futures .arco-layout-header[class*="arco-layout-header"],
html .futures .arco-layout-header[class*="arco-layout-header"],
html .futures .arco-layout-header[class*="arco-layout-header"],
body .futures .arco-layout-header[class*="arco-layout-header"],
body .futures .arco-layout-header[class*="arco-layout-header"],
body .futures .arco-layout-header[class*="arco-layout-header"] {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

/* 🚨 头部导航栏容器 - 完全透明，不干扰内部#nav */
.futures .arco-layout-header,
.futures .arco-layout-header,
.futures .arco-layout-header {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  backdrop-filter: none !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
  box-shadow: none !important;
  position: relative !important;
  z-index: auto !important;
}

/* 🚨 头部导航栏#nav - 强制使用直接rgba值 */
.futures #nav,
.futures #nav,
.futures #nav {
  background: rgba(255, 255, 255, 0.8) !important;
  background-color: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  width: 100% !important;
  height: 64px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 24px !important;
  box-sizing: border-box !important;
  position: sticky !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 1000 !important;
  border-bottom: none !important;
}

/* 深色主题下的#nav */
[data-theme="dark"] .futures #nav,
html[data-theme="dark"] .futures #nav,
body[data-theme="dark"] .futures #nav {
  background: rgba(31, 31, 31, 0.8) !important;
  background-color: rgba(31, 31, 31, 0.8) !important;
}

/* 🔧 修复期权页面顶部行情背景 - 添加实际背景色（与合约页面视觉效果一致） */
.futures .hotCoin,
.futures .hotCoin[style],
html .futures .hotCoin,
body .futures .hotCoin {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
  background-image: none !important;
  border: none !important;
  padding: 2px 16px !important;
  height: 28px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  color: var(--content-primary) !important;
  overflow: hidden !important;
  position: relative !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  margin-bottom: 0 !important;
  border-radius: 0 !important;
}

.futures .hotCoin .item {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  height: 24px !important;
  font-size: 11px !important;
  margin-right: 20px !important;
  cursor: pointer !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  background: transparent !important;
  transition: opacity 0.2s ease !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
  border: none !important;
}

.futures .hotCoin .item:hover {
  opacity: 0.8 !important;
  background: var(--background-primary) !important;
  border-radius: 4px !important;
}

/* 深色主题下的hotCoin样式 */
[data-theme="dark"] .futures .hotCoin,
[data-theme="dark"] .futures .hotCoin[style],
html[data-theme="dark"] .futures .hotCoin,
body[data-theme="dark"] .futures .hotCoin {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
  background-image: none !important;
  border: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

[data-theme="dark"] .futures .hotCoin .item:hover,
html[data-theme="dark"] .futures .hotCoin .item:hover {
  opacity: 0.8 !important;
  background: var(--background-primary) !important;
  border-radius: 4px !important;
}

/* 浅色主题下的hotCoin样式 */
[data-theme="light"] .futures .hotCoin,
[data-theme="light"] .futures .hotCoin[style],
html[data-theme="light"] .futures .hotCoin,
body[data-theme="light"] .futures .hotCoin {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
  background-image: none !important;
  border: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

[data-theme="light"] .futures .hotCoin .item:hover,
html[data-theme="light"] .futures .hotCoin .item:hover {
  opacity: 0.8 !important;
  background: var(--background-primary) !important;
  border-radius: 4px !important;
}

/* 🔧 修复期权页面hotCoin内部文字样式 - 完全参考合约页面 */
.futures .hotCoin .item span {
  line-height: 1 !important;
  display: inline !important;
  vertical-align: baseline !important;
  font-size: 11px !important;
}

.futures .hotCoin .item .coin-name {
  margin-right: 4px !important;
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: 400 !important;
  font-size: 11px !important;
}

.futures .hotCoin .item .coin-price {
  margin-right: 2px !important;
  font-weight: 500 !important;
  font-size: 11px !important;
}

.futures .hotCoin .item .coin-change {
  font-weight: 500 !important;
  font-size: 10px !important;
  margin-left: 1px !important;
}

/* 涨跌颜色优化 - 适配深色背景（与合约页面完全一致） */
.futures .hotCoin .item .coin-price.color-green,
.futures .hotCoin .item .coin-change.color-green {
  color: #00ff88 !important;
}

.futures .hotCoin .item .coin-price.color-red,
.futures .hotCoin .item .coin-change.color-red {
  color: #ff4444 !important;
}

.futures .hotCoin .item .coin-price.color-gray,
.futures .hotCoin .item .coin-change.color-gray {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* 🔧 期权页面滚动样式 - 参考市场行情页面 */
.futures .hotCoin .ticker-scroll {
  width: calc(100% - 22px) !important;
  overflow: hidden !important;
}

.futures .hotCoin .ticker-scroll .scroll-content {
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  flex-wrap: nowrap !important;
  white-space: nowrap !important;
  animation: marquee 15s linear infinite !important;
}

.futures .hotCoin .ticker-scroll .scroll-content:hover {
  animation-play-state: paused !important;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 🔧 修复期权页面hotCoin火焰图标样式 - 与合约页面一致 */
.futures .hotCoin img {
  width: 12px !important;
  height: 12px !important;
  margin-right: 10px !important;
}

/* 🔧 最终强制修复 - 确保hotCoin背景不透明 */
.futures .hotCoin:not(.prevent-flash) {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
}

.futures.prevent-flash .hotCoin,
.futures:not(.prevent-flash) .hotCoin {
  background: var(--background-secondary) !important;
  background-color: var(--background-secondary) !important;
}

/* 🔧 修复深色模式下看涨看跌按钮颜色 - 超级强力覆盖样式 */
.futures[data-theme="dark"] .direction-btn.call-btn.active,
.futures .direction-btn.call-btn.active[data-theme="dark"],
[data-theme="dark"] .futures .direction-btn.call-btn.active,
html[data-theme="dark"] .futures .direction-btn.call-btn.active,
body[data-theme="dark"] .futures .direction-btn.call-btn.active,
.futures.futures.futures .direction-btn.call-btn.active {
  background: linear-gradient(135deg, #00ff88, #00e676) !important;
  background-color: #00ff88 !important;
  border: 2px solid #00ff88 !important;
  color: #000000 !important;
  box-shadow: 0 6px 20px rgba(0, 255, 136, 0.4) !important;
  font-weight: 700 !important;
}

.futures[data-theme="dark"] .direction-btn.put-btn.active,
.futures .direction-btn.put-btn.active[data-theme="dark"],
[data-theme="dark"] .futures .direction-btn.put-btn.active,
html[data-theme="dark"] .futures .direction-btn.put-btn.active,
body[data-theme="dark"] .futures .direction-btn.put-btn.active,
.futures.futures.futures .direction-btn.put-btn.active {
  background: linear-gradient(135deg, #ff4757, #ff3742) !important;
  background-color: #ff4757 !important;
  border: 2px solid #ff4757 !important;
  color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(255, 71, 87, 0.4) !important;
  font-weight: 700 !important;
}

/* 强制文字颜色 */
.futures[data-theme="dark"] .direction-btn.call-btn.active .btn-text,
.futures .direction-btn.call-btn.active[data-theme="dark"] .btn-text,
[data-theme="dark"] .futures .direction-btn.call-btn.active .btn-text,
html[data-theme="dark"] .futures .direction-btn.call-btn.active .btn-text,
body[data-theme="dark"] .futures .direction-btn.call-btn.active .btn-text,
.futures.futures.futures .direction-btn.call-btn.active .btn-text {
  color: #000000 !important;
  font-weight: 700 !important;
}

.futures[data-theme="dark"] .direction-btn.put-btn.active .btn-text,
.futures .direction-btn.put-btn.active[data-theme="dark"] .btn-text,
[data-theme="dark"] .futures .direction-btn.put-btn.active .btn-text,
html[data-theme="dark"] .futures .direction-btn.put-btn.active .btn-text,
body[data-theme="dark"] .futures .direction-btn.put-btn.active .btn-text,
.futures.futures.futures .direction-btn.put-btn.active .btn-text {
  color: #ffffff !important;
  font-weight: 700 !important;
}

/* 深色模式下非激活状态的按钮 */
[data-theme="dark"] .direction-btn.call-btn:not(.active),
html[data-theme="dark"] .direction-btn.call-btn:not(.active),
body[data-theme="dark"] .direction-btn.call-btn:not(.active) {
  background: var(--background-secondary) !important;
  border: 1px solid rgba(0, 255, 136, 0.3) !important;
  color: #00ff88 !important;
}

[data-theme="dark"] .direction-btn.put-btn:not(.active),
html[data-theme="dark"] .direction-btn.put-btn:not(.active),
body[data-theme="dark"] .direction-btn.put-btn:not(.active) {
  background: var(--background-secondary) !important;
  border: 1px solid rgba(255, 71, 87, 0.3) !important;
  color: #ff4757 !important;
}

/* 深色模式下非激活状态按钮的文字颜色 */
[data-theme="dark"] .direction-btn.call-btn:not(.active) .btn-text,
html[data-theme="dark"] .direction-btn.call-btn:not(.active) .btn-text,
body[data-theme="dark"] .direction-btn.call-btn:not(.active) .btn-text {
  color: #00ff88 !important;
}

[data-theme="dark"] .direction-btn.put-btn:not(.active) .btn-text,
html[data-theme="dark"] .direction-btn.put-btn:not(.active) .btn-text,
body[data-theme="dark"] .direction-btn.put-btn:not(.active) .btn-text {
  color: #ff4757 !important;
}

/* 深色模式下悬停效果 */
[data-theme="dark"] .direction-btn.call-btn:not(.active):hover,
html[data-theme="dark"] .direction-btn.call-btn:not(.active):hover,
body[data-theme="dark"] .direction-btn.call-btn:not(.active):hover {
  background: rgba(0, 255, 136, 0.1) !important;
  border: 1px solid rgba(0, 255, 136, 0.5) !important;
  color: #00ff88 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(0, 255, 136, 0.2) !important;
}

[data-theme="dark"] .direction-btn.put-btn:not(.active):hover,
html[data-theme="dark"] .direction-btn.put-btn:not(.active):hover,
body[data-theme="dark"] .direction-btn.put-btn:not(.active):hover {
  background: rgba(255, 71, 87, 0.1) !important;
  border: 1px solid rgba(255, 71, 87, 0.5) !important;
  color: #ff4757 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 15px rgba(255, 71, 87, 0.2) !important;
}

/* 确保浅色模式下的颜色也是正确的 */
[data-theme="light"] .direction-btn.call-btn.active,
html[data-theme="light"] .direction-btn.call-btn.active,
body[data-theme="light"] .direction-btn.call-btn.active {
  background: linear-gradient(135deg, #28a745, #20c997) !important;
  background-color: #28a745 !important;
  border: 2px solid #28a745 !important;
  color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.3) !important;
  font-weight: 700 !important;
}

[data-theme="light"] .direction-btn.put-btn.active,
html[data-theme="light"] .direction-btn.put-btn.active,
body[data-theme="light"] .direction-btn.put-btn.active {
  background: linear-gradient(135deg, #dc3545, #c82333) !important;
  background-color: #dc3545 !important;
  border: 2px solid #dc3545 !important;
  color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(220, 53, 69, 0.3) !important;
  font-weight: 700 !important;
}

[data-theme="light"] .direction-btn.call-btn.active .btn-text,
html[data-theme="light"] .direction-btn.call-btn.active .btn-text,
body[data-theme="light"] .direction-btn.call-btn.active .btn-text {
  color: #ffffff !important;
  font-weight: 700 !important;
}

[data-theme="light"] .direction-btn.put-btn.active .btn-text,
html[data-theme="light"] .direction-btn.put-btn.active .btn-text,
body[data-theme="light"] .direction-btn.put-btn.active .btn-text {
  color: #ffffff !important;
  font-weight: 700 !important;
}

/* 深色模式下买入期权按钮颜色修复 */
[data-theme="dark"] .submit-btn.call-submit,
html[data-theme="dark"] .submit-btn.call-submit,
body[data-theme="dark"] .submit-btn.call-submit {
  background: linear-gradient(135deg, #00ff88, #00e676) !important;
  background-color: #00ff88 !important;
  border: none !important;
  color: #000000 !important;
  box-shadow: 0 6px 20px rgba(0, 255, 136, 0.4) !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .submit-btn.call-submit:hover:not(:disabled),
html[data-theme="dark"] .submit-btn.call-submit:hover:not(:disabled),
body[data-theme="dark"] .submit-btn.call-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #00e676, #00c853) !important;
  background-color: #00e676 !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 10px 30px rgba(0, 255, 136, 0.5) !important;
}

[data-theme="dark"] .submit-btn.put-submit,
html[data-theme="dark"] .submit-btn.put-submit,
body[data-theme="dark"] .submit-btn.put-submit {
  background: linear-gradient(135deg, #ff4757, #ff3742) !important;
  background-color: #ff4757 !important;
  border: none !important;
  color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(255, 71, 87, 0.4) !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .submit-btn.put-submit:hover:not(:disabled),
html[data-theme="dark"] .submit-btn.put-submit:hover:not(:disabled),
body[data-theme="dark"] .submit-btn.put-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #ff3742, #ff1744) !important;
  background-color: #ff3742 !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 10px 30px rgba(255, 71, 87, 0.5) !important;
}

/* 确保深色模式下其他相关元素的颜色也正确 */
[data-theme="dark"] .arco-btn.submit-btn.call-submit,
html[data-theme="dark"] .arco-btn.submit-btn.call-submit,
body[data-theme="dark"] .arco-btn.submit-btn.call-submit {
  background: linear-gradient(135deg, #00ff88, #00e676) !important;
  color: #000000 !important;
}

[data-theme="dark"] .arco-btn.submit-btn.put-submit,
html[data-theme="dark"] .arco-btn.submit-btn.put-submit,
body[data-theme="dark"] .arco-btn.submit-btn.put-submit {
  background: linear-gradient(135deg, #ff4757, #ff3742) !important;
  color: #ffffff !important;
}

/* 深色模式下期权交易面板相关文字颜色 */
[data-theme="dark"] .option-trading-panel .direction-label,
html[data-theme="dark"] .option-trading-panel .direction-label,
body[data-theme="dark"] .option-trading-panel .direction-label {
  color: var(--content-primary) !important;
}

/* 强制覆盖任何可能的冲突样式 */
.futures[data-theme="dark"] .direction-btn.call-btn.active,
.futures[data-theme="dark"] .direction-btn.put-btn.active {
  border-width: 2px !important;
  font-weight: 700 !important;
}

.futures[data-theme="dark"] .direction-btn.call-btn.active {
  background: linear-gradient(135deg, #00ff88, #00e676) !important;
  border-color: #00ff88 !important;
  color: #000000 !important;
}

.futures[data-theme="dark"] .direction-btn.put-btn.active {
  background: linear-gradient(135deg, #ff4757, #ff3742) !important;
  border-color: #ff4757 !important;
  color: #ffffff !important;
}

/* 🚨🚨🚨 超级强力修复看跌按钮黑色问题 - 终极优先级 🚨🚨🚨 */
.direction-btn.put-btn.active,
.direction-btn.put-btn.active[style],
div.direction-btn.put-btn.active,
.futures div.direction-btn.put-btn.active,
.option-trading-panel .direction-btn.put-btn.active,
.futures .direction-btn.put-btn.active,
.futures.futures .direction-btn.put-btn.active,
.futures.futures.futures .direction-btn.put-btn.active,
html .futures .direction-btn.put-btn.active,
body .futures .direction-btn.put-btn.active,
div.futures div.direction-btn.put-btn.active,
.a-layout .futures .direction-btn.put-btn.active,
[data-theme] .futures .direction-btn.put-btn.active,
[data-theme="dark"] .futures .direction-btn.put-btn.active,
[data-theme="light"] .futures .direction-btn.put-btn.active {
  background: #ff4757 !important;
  background-color: #ff4757 !important;
  background-image: linear-gradient(135deg, #ff4757, #ff3742) !important;
  border: 2px solid #ff4757 !important;
  border-color: #ff4757 !important;
  color: #ffffff !important;
  box-shadow: 0 6px 20px rgba(255, 71, 87, 0.4) !important;
  font-weight: 700 !important;
}

.direction-btn.put-btn.active .btn-text,
.direction-btn.put-btn.active[style] .btn-text,
div.direction-btn.put-btn.active .btn-text,
.futures div.direction-btn.put-btn.active .btn-text,
.option-trading-panel .direction-btn.put-btn.active .btn-text {
  color: #ffffff !important;
  font-weight: 700 !important;
}

/* 🚨🚨🚨 超级强力修复看涨按钮 - 确保绿色 🚨🚨🚨 */
.direction-btn.call-btn.active,
.direction-btn.call-btn.active[style],
div.direction-btn.call-btn.active,
.futures div.direction-btn.call-btn.active,
.option-trading-panel .direction-btn.call-btn.active,
.futures .direction-btn.call-btn.active,
.futures.futures .direction-btn.call-btn.active,
.futures.futures.futures .direction-btn.call-btn.active,
html .futures .direction-btn.call-btn.active,
body .futures .direction-btn.call-btn.active,
div.futures div.direction-btn.call-btn.active,
.a-layout .futures .direction-btn.call-btn.active,
[data-theme] .futures .direction-btn.call-btn.active,
[data-theme="dark"] .futures .direction-btn.call-btn.active,
[data-theme="light"] .futures .direction-btn.call-btn.active {
  background: #00ff88 !important;
  background-color: #00ff88 !important;
  background-image: linear-gradient(135deg, #00ff88, #00e676) !important;
  border: 2px solid #00ff88 !important;
  border-color: #00ff88 !important;
  color: #000000 !important;
  box-shadow: 0 6px 20px rgba(0, 255, 136, 0.4) !important;
  font-weight: 700 !important;
}

.direction-btn.call-btn.active .btn-text,
.direction-btn.call-btn.active[style] .btn-text,
div.direction-btn.call-btn.active .btn-text,
.futures div.direction-btn.call-btn.active .btn-text,
.option-trading-panel .direction-btn.call-btn.active .btn-text {
  color: #000000 !important;
  font-weight: 700 !important;
}

/* 🚨🚨🚨 超级强力修复深色模式历史订单颜色问题 🚨🚨🚨 */
[data-theme="dark"] .history-orders .order-item span.color-green,
html[data-theme="dark"] .history-orders .order-item span.color-green,
body[data-theme="dark"] .history-orders .order-item span.color-green,
[data-theme="dark"] .history-orders .order-item .color-green,
html[data-theme="dark"] .history-orders .order-item .color-green,
body[data-theme="dark"] .history-orders .order-item .color-green {
  color: #52c41a !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .history-orders .order-item span.color-red,
html[data-theme="dark"] .history-orders .order-item span.color-red,
body[data-theme="dark"] .history-orders .order-item span.color-red,
[data-theme="dark"] .history-orders .order-item .color-red,
html[data-theme="dark"] .history-orders .order-item .color-red,
body[data-theme="dark"] .history-orders .order-item .color-red {
  color: #ff4d4f !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .history-orders .order-item span.color-black,
html[data-theme="dark"] .history-orders .order-item span.color-black,
body[data-theme="dark"] .history-orders .order-item span.color-black,
[data-theme="dark"] .history-orders .order-item .color-black,
html[data-theme="dark"] .history-orders .order-item .color-black,
body[data-theme="dark"] .history-orders .order-item .color-black {
  color: #ffffff !important;
  font-weight: 500 !important;
}

/* 深色模式历史订单各列具体颜色 */
[data-theme="dark"] .history-orders .order-open-price span.color-green,
[data-theme="dark"] .history-orders .order-close-price span.color-green,
[data-theme="dark"] .history-orders .order-yield span.color-green,
[data-theme="dark"] .history-orders .order-result span.color-green {
  color: #52c41a !important;
  font-weight: 700 !important;
}

/* 深色模式活跃订单各列具体颜色 */
[data-theme="dark"] .active-orders .order-yield span.color-green,
[data-theme="dark"] .active-orders .order-expected-profit span.color-green,
[data-theme="dark"] .active-orders .order-fee span.color-orange {
  color: #52c41a !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .active-orders .order-yield span.color-red,
[data-theme="dark"] .active-orders .order-expected-profit span.color-red {
  color: #ff4d4f !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .active-orders .order-yield span.color-black,
[data-theme="dark"] .active-orders .order-expected-profit span.color-black,
[data-theme="dark"] .active-orders .order-fee span.color-gray {
  color: #ffffff !important;
  font-weight: 500 !important;
}

/* 深色模式活跃订单其他字段颜色 */
[data-theme="dark"] .active-orders .order-amount span.color-blue {
  color: #1890ff !important;
  font-weight: 600 !important;
}

[data-theme="dark"] .active-orders .order-price span.color-orange {
  color: #ff9500 !important;
  font-weight: 600 !important;
}

[data-theme="dark"] .active-orders .order-direction span.color-green {
  color: #52c41a !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .active-orders .order-direction span.color-red {
  color: #ff4d4f !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .active-orders .order-countdown span.color-blue {
  color: #1890ff !important;
  font-weight: 600 !important;
}

[data-theme="dark"] .active-orders .order-countdown span.color-red {
  color: #ff4d4f !important;
  font-weight: 600 !important;
}

[data-theme="dark"] .active-orders .order-status span.color-blue {
  color: #1890ff !important;
  font-weight: 600 !important;
}

[data-theme="dark"] .active-orders .order-status span.color-gray {
  color: #8b949e !important;
  font-weight: 500 !important;
}

[data-theme="dark"] .history-orders .order-open-price span.color-red,
[data-theme="dark"] .history-orders .order-close-price span.color-red,
[data-theme="dark"] .history-orders .order-yield span.color-red,
[data-theme="dark"] .history-orders .order-result span.color-red {
  color: #ff4d4f !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .history-orders .order-open-price span.color-black,
[data-theme="dark"] .history-orders .order-close-price span.color-black,
[data-theme="dark"] .history-orders .order-yield span.color-black,
[data-theme="dark"] .history-orders .order-result span.color-black {
  color: #ffffff !important;
  font-weight: 500 !important;
}

/* 深色模式订单方向标签强制颜色 */
[data-theme="dark"] .history-orders .order-direction .color-green,
html[data-theme="dark"] .history-orders .order-direction .color-green,
body[data-theme="dark"] .history-orders .order-direction .color-green {
  color: #52c41a !important;
  font-weight: 700 !important;
}

[data-theme="dark"] .history-orders .order-direction .color-red,
html[data-theme="dark"] .history-orders .order-direction .color-red,
body[data-theme="dark"] .history-orders .order-direction .color-red {
  color: #ff4d4f !important;
  font-weight: 700 !important;
}

/* 期权订单成功弹窗美化样式 */
.option-success-modal .arco-modal {
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
}

.option-success-modal .arco-modal-body {
  padding: 0 !important;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
}

[data-theme="dark"] .option-success-modal .arco-modal-body {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
}

.success-content {
  padding: 32px 24px;
  text-align: center;
}

.success-icon {
  margin-bottom: 20px;
  animation: successPulse 0.6s ease-in-out;
}

.success-title {
  font-size: 20px;
  font-weight: 700;
  color: #52c41a;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}



.success-details {
  background: rgba(82, 196, 26, 0.05);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
  border: 1px solid rgba(82, 196, 26, 0.1);
}

[data-theme="dark"] .success-details {
  background: rgba(82, 196, 26, 0.1);
  border: 1px solid rgba(82, 196, 26, 0.2);
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
}

.detail-item:last-child {
  margin-bottom: 0;
}

.detail-item .label {
  color: #666;
  font-weight: 500;
}

[data-theme="dark"] .detail-item .label {
  color: #a6a6a6;
}

.detail-item .value {
  font-weight: 600;
  color: #333;
}

[data-theme="dark"] .detail-item .value {
  color: #ffffff;
}

.success-actions {
  margin-top: 8px;
}

.confirm-btn {
  width: 100% !important;
  height: 48px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg, #1890ff, #096dd9) !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3) !important;
  transition: all 0.3s ease !important;
}

.confirm-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(24, 144, 255, 0.4) !important;
}

/* 期权订单失败弹窗样式 */
.option-error-modal .arco-modal {
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
}

.option-error-modal .arco-modal-body {
  padding: 0 !important;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
}

[data-theme="dark"] .option-error-modal .arco-modal-body {
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%) !important;
}

.error-content {
  padding: 32px 24px;
  text-align: center;
}

.error-icon {
  margin-bottom: 20px;
  animation: errorShake 0.6s ease-in-out;
}

.error-title {
  font-size: 20px;
  font-weight: 700;
  color: #ff4d4f;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}

.error-message {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  font-weight: 500;
  line-height: 1.5;
}

[data-theme="dark"] .error-message {
  color: #a6a6a6;
}

.error-actions {
  margin-top: 8px;
}

/* 动画效果 */
@keyframes successPulse {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes errorShake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}

/* 弹窗遮罩层美化 */
.option-success-modal-wrap .arco-modal-mask,
.option-error-modal-wrap .arco-modal-mask {
  background: rgba(0, 0, 0, 0.6) !important;
  backdrop-filter: blur(4px) !important;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .success-content,
  .error-content {
    padding: 24px 16px;
  }
  
  .success-title,
  .error-title {
    font-size: 18px;
  }
  
  .success-details {
    padding: 16px;
  }
  
  .detail-item {
    font-size: 13px;
  }
  
  .confirm-btn {
    height: 44px !important;
    font-size: 15px !important;
  }
}



</style>
